var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _g, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiptsNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M9.84 46.71 52 38.92a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.27.5 2.48 2.04-.17 2.72L29.61 60.5a7.62 7.62 0 0 1-6.5-1.29L9.34 48.85c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "m9.84 46.71 42.15-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.27.5 2.48 2.05-.16 2.73L29.6 60.48a7.62 7.62 0 0 1-6.5-1.28L9.34 48.85c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#FDFDFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "m9.84 46.7 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.27.5 2.47 2.05-.16 2.73L29.6 60.48a7.62 7.62 0 0 1-6.5-1.28L9.34 48.85c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "m9.84 46.7 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.26.5 2.47 2.05-.16 2.73L29.6 60.48a7.62 7.62 0 0 1-6.5-1.29L9.34 48.85c-1.46-1.1-.52-1.96.5-2.14Z",
    fill: "#FBFCFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "m9.84 46.7 42.15-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.26.5 2.46 2.06-.16 2.73L29.6 60.47a7.62 7.62 0 0 1-6.5-1.28L9.34 48.84c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#FAFBFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "m9.84 46.7 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.25.5 2.45 2.06-.16 2.73L29.6 60.47a7.62 7.62 0 0 1-6.5-1.28L9.34 48.84c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#F9FAFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "m9.84 46.7 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.25.49 2.45 2.06-.16 2.72L29.6 60.47a7.62 7.62 0 0 1-6.5-1.29L9.34 48.83c-1.47-1.1-.52-1.95.5-2.13Z",
    fill: "#F8F9FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M9.83 46.7 52 38.9a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.24.49 2.44 2.06-.16 2.72L29.6 60.47a7.62 7.62 0 0 1-6.5-1.29L9.34 48.83c-1.47-1.1-.52-1.95.5-2.13Z",
    fill: "#F7F8FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M9.83 46.69 52 38.89a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.24.48 2.43 2.06-.16 2.73L29.6 60.46a7.62 7.62 0 0 1-6.5-1.29L9.34 48.83c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#F6F7FA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M9.83 46.69 52 38.89a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.23.49 2.42 2.06-.16 2.73L29.6 60.46a7.62 7.62 0 0 1-6.5-1.29L9.34 48.83c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#F5F7FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.83 46.68 52 38.88a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.23.49 2.42 2.07-.16 2.73L29.6 60.45a7.62 7.62 0 0 1-6.5-1.28L9.34 48.82c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#F4F6F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M9.83 46.68 52 38.88a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.22.47 2.41 2.06-.16 2.72L29.6 60.45a7.62 7.62 0 0 1-6.5-1.28L9.34 48.82c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#F3F5F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M9.83 46.68 52 38.88a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.21.48 2.4 2.07-.17 2.72L29.6 60.45a7.62 7.62 0 0 1-6.5-1.29L9.34 48.82c-1.47-1.1-.53-1.96.5-2.14Z",
    fill: "#F2F4F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M9.83 46.67 52 38.88a6.24 6.24 0 0 1 3.41.33l18.2 7.1c1.21.48 2.4 2.08-.17 2.73L29.6 60.44a7.62 7.62 0 0 1-6.5-1.28L9.34 48.81c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#F1F3F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M9.83 46.67 52 38.87a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.2.47 2.39 2.07-.17 2.72L29.6 60.44a7.62 7.62 0 0 1-6.5-1.28L9.34 48.8c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#F0F2F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M9.83 46.67 52 38.87a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.2.47 2.38 2.08-.17 2.73L29.6 60.44a7.62 7.62 0 0 1-6.5-1.29L9.34 48.81c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#EFF1F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M9.83 46.67 52 38.87a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.2.47 2.37 2.08-.17 2.73L29.6 60.44a7.62 7.62 0 0 1-6.5-1.29L9.34 48.81c-1.47-1.1-.53-1.96.5-2.14Z",
    fill: "#EEF1F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "m9.83 46.66 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.19.46 2.36 2.07-.17 2.72L29.6 60.43a7.62 7.62 0 0 1-6.5-1.28L9.34 48.8c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#EDF0F6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "m9.83 46.66 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.18.47 2.36 2.08-.17 2.73L29.6 60.43a7.62 7.62 0 0 1-6.5-1.29L9.34 48.8c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#ECEFF5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "m9.83 46.66 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.18.46 2.35 2.08-.17 2.73L29.6 60.43a7.62 7.62 0 0 1-6.5-1.29L9.34 48.8c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#EBEEF5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "m9.83 46.65 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.17.46 2.34 2.08-.17 2.72L29.6 60.42a7.62 7.62 0 0 1-6.5-1.28L9.34 48.79c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#EAEDF4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m9.83 46.65 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.17.46 2.34 2.09-.17 2.73L29.6 60.42a7.62 7.62 0 0 1-6.5-1.29L9.34 48.8c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#E9ECF4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "m9.83 46.64 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.2 7.11c1.16.45 2.33 2.09-.17 2.72L29.6 60.42a7.62 7.62 0 0 1-6.5-1.29L9.34 48.78c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#E8ECF3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "m9.83 46.64 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.17.45 2.33 2.09-.16 2.72L29.59 60.42a7.62 7.62 0 0 1-6.5-1.29L9.33 48.78c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#E7EBF3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "m9.83 46.64 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.16.45 2.33 2.09-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.33 48.78c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#E6EAF2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "m9.83 46.64 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.16.45 2.32 2.1-.16 2.73L29.59 60.4a7.62 7.62 0 0 1-6.5-1.29L9.33 48.78c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#E5E9F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m9.83 46.63 42.15-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.15.45 2.31 2.1-.16 2.73L29.59 60.4a7.62 7.62 0 0 1-6.5-1.28L9.33 48.77c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#E4E8F1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "m9.83 46.63 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.15.45 2.3 2.1-.16 2.73L29.59 60.4a7.62 7.62 0 0 1-6.5-1.28L9.33 48.77c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#E3E7F1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "m9.82 46.63 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.14.44 2.3 2.1-.16 2.72L29.59 60.4a7.62 7.62 0 0 1-6.5-1.29L9.33 48.77c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#E2E7F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "m9.82 46.63 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.14.44 2.3 2.1-.16 2.73L29.59 60.4a7.62 7.62 0 0 1-6.5-1.29L9.33 48.77c-1.47-1.1-.52-1.96.5-2.14Z",
    fill: "#E1E6F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "m9.82 46.62 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.13.44 2.28 2.1-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.33 48.76c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#E0E5EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "m9.82 46.62 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.13.44 2.28 2.11-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.33 48.76c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#DFE4EF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m9.82 46.62 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.12.43 2.27 2.11-.16 2.72L29.59 60.4a7.62 7.62 0 0 1-6.5-1.29L9.33 48.75c-1.47-1.1-.53-1.95.5-2.13Z",
    fill: "#DEE3EE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "m9.82 46.61 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c1.11.44 2.26 2.12-.17 2.73L29.6 60.38a7.62 7.62 0 0 1-6.5-1.28L9.33 48.75c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#DDE2EE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "m9.82 46.6 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.1.43 2.26 2.12-.17 2.73L29.6 60.38a7.62 7.62 0 0 1-6.5-1.29L9.33 48.75c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#DCE1ED"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "m9.82 46.6 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.1.43 2.25 2.12-.17 2.72L29.6 60.38a7.62 7.62 0 0 1-6.5-1.29L9.33 48.74c-1.47-1.1-.53-1.95.5-2.13Z",
    fill: "#DBE1ED"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "m9.82 46.6 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.1.42 2.24 2.12-.17 2.72L29.6 60.37a7.62 7.62 0 0 1-6.5-1.28L9.33 48.74c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#DAE0EC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "m9.82 46.6 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.1.43 2.24 2.13-.17 2.73L29.6 60.37a7.62 7.62 0 0 1-6.5-1.28L9.33 48.74c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#D9DFEC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "m9.82 46.6 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.1c1.09.43 2.23 2.13-.17 2.73L29.6 60.36a7.62 7.62 0 0 1-6.5-1.28L9.33 48.74c-1.47-1.11-.53-1.96.5-2.15Z",
    fill: "#D8DEEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m9.82 46.6 42.16-7.8a6.24 6.24 0 0 1 3.41.32l18.2 7.12c1.08.42 2.22 2.12-.17 2.72L29.6 60.36a7.62 7.62 0 0 1-6.5-1.28L9.32 48.73c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D7DDEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "m9.82 46.59 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.08.42 2.21 2.13-.17 2.73L29.6 60.36a7.62 7.62 0 0 1-6.5-1.28L9.32 48.73c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D6DCEA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "m9.82 46.59 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.07.42 2.2 2.13-.17 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.33 48.73c-1.46-1.1-.52-1.96.5-2.14Z",
    fill: "#D5DCEA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "m9.82 46.58 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.1c1.07.42 2.2 2.14-.17 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.33 48.72c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D4DBE9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m9.82 46.58 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.07.41 2.2 2.14-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.32 48.72c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D3DAE9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "m9.82 46.58 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.07.41 2.2 2.14-.16 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.32 48.72c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D2D9E8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "m9.82 46.57 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.06.4 2.19 2.13-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.32 48.7c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D1D8E8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "m9.82 46.57 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.06.4 2.18 2.13-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.32 48.7c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#D0D7E7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "m9.82 46.57 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.05.4 2.18 2.14-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.32 48.71c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#CFD6E7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "m9.82 46.56 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.1c1.04.41 2.17 2.15-.16 2.73L29.58 60.34a7.62 7.62 0 0 1-6.5-1.29L9.32 48.7c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#CED6E6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "m9.82 46.56 42.15-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.04.4 2.16 2.15-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.32 48.7c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#CDD5E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "m9.81 46.56 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.03.4 2.15 2.15-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.32 48.7c-1.47-1.1-.52-1.96.5-2.14Z",
    fill: "#CCD4E5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "m9.81 46.55 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.03.4 2.14 2.15-.16 2.72L29.58 60.33a7.62 7.62 0 0 1-6.5-1.29L9.32 48.7c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#CBD3E5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "m9.81 46.55 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.02.39 2.14 2.15-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.32 48.69c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#CAD2E4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m9.81 46.55 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.02.4 2.13 2.16-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.32 48.69c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#C9D1E4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m9.81 46.55 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.01.39 2.12 2.16-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.32 48.7c-1.47-1.1-.53-1.96.5-2.14Z",
    fill: "#C9D1E3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "m9.81 46.54 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1 .39 2.12 2.16-.17 2.73L29.58 60.3a7.62 7.62 0 0 1-6.5-1.28L9.32 48.68c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#C8D0E3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "m9.81 46.54 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1 .39 2.1 2.17-.17 2.73L29.58 60.3a7.62 7.62 0 0 1-6.5-1.28L9.32 48.68c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#C7CFE2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "m9.81 46.54 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1 .38 2.1 2.17-.17 2.72L29.58 60.31a7.62 7.62 0 0 1-6.5-1.29L9.32 48.67c-1.47-1.1-.53-1.95.49-2.13Z",
    fill: "#C6CEE2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "m9.81 46.53 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c1 .39 2.1 2.18-.17 2.73L29.58 60.3a7.62 7.62 0 0 1-6.5-1.28L9.32 48.67c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#C5CDE1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "m9.81 46.53 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c.99.37 2.09 2.17-.17 2.72L29.58 60.3a7.62 7.62 0 0 1-6.5-1.28L9.32 48.67c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#C4CCE1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "m9.8 46.53 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.99.38 2.09 2.17-.16 2.72L29.58 60.3a7.62 7.62 0 0 1-6.5-1.29L9.32 48.67c-1.47-1.1-.53-1.96.49-2.14Z",
    fill: "#C3CCE0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "m9.8 46.52 42.16-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c.98.38 2.08 2.18-.16 2.73L29.57 60.3a7.62 7.62 0 0 1-6.5-1.28L9.33 48.66c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#C2CBE0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "m9.8 46.52 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.98.38 2.08 2.18-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.33 48.66c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#C1CADF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "m9.8 46.52 42.17-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.96.37 2.06 2.18-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.66c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#C0C9DF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m9.8 46.51 42.17-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c.96.36 2.05 2.18-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.65c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#BFC8DE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "m9.8 46.51 42.17-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c.95.36 2.05 2.18-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.65c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#BEC7DE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "m9.8 46.5 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.96.37 2.05 2.19-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.31 48.65c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#BDC6DD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "m9.8 46.5 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.95.36 2.04 2.19-.16 2.72L29.57 60.28a7.62 7.62 0 0 1-6.5-1.29L9.31 48.65c-1.46-1.11-.52-1.96.5-2.14Z",
    fill: "#BCC6DD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "m9.8 46.5 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c.95.36 2.03 2.18-.16 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.64c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#BBC5DC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "m9.8 46.5 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.94.36 2.03 2.2-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.31 48.64c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#BAC4DC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "m9.8 46.5 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.94.36 2.02 2.2-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.31 48.64c-1.47-1.1-.52-1.96.5-2.14Z",
    fill: "#B9C3DB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "m9.8 46.5 42.16-7.8a6.24 6.24 0 0 1 3.42.32l18.19 7.12c.93.35 2.01 2.2-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.31 48.63c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#B8C2DB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "m9.8 46.49 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.93.35 2 2.2-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.31 48.63c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#B7C1DA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "m9.8 46.48 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.1c.92.36 2 2.2-.16 2.73L29.57 60.26a7.62 7.62 0 0 1-6.5-1.29L9.31 48.62c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#B6C1DA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "m9.8 46.48 42.16-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c.92.35 2 2.2-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.31 48.62c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#B5C0D9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m9.8 46.48 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c.91.34 1.99 2.2-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.31 48.62c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#B4BFD9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "m9.8 46.48 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.9.34 1.98 2.2-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.31 48.62c-1.47-1.11-.53-1.96.5-2.14Z",
    fill: "#B3BED8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "m9.8 46.47 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c.9.35 1.97 2.22-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.31 48.6c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#B2BDD8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "m9.8 46.47 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.9.34 1.96 2.21-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.31 48.6c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#B1BCD7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "m9.8 46.47 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.89.34 1.96 2.21-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.61c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#B0BBD7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "m9.8 46.46 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.88.33 1.95 2.21-.17 2.72L29.57 60.24a7.62 7.62 0 0 1-6.5-1.29L9.3 48.6c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#AFBBD6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m9.8 46.46 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.88.34 1.94 2.22-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.6c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#AEBAD6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "m9.8 46.46 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.88.33 1.95 2.22-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.6c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#ADB9D5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "m9.8 46.45 42.15-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c.88.34 1.94 2.23-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.59c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#ACB8D5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "m9.8 46.45 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c.87.32 1.93 2.22-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.59c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#ABB7D4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "m9.8 46.45 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.87.32 1.92 2.23-.16 2.72L29.56 60.22a7.62 7.62 0 0 1-6.5-1.29L9.3 48.58c-1.46-1.1-.52-1.95.5-2.13Z",
    fill: "#AAB6D4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m9.8 46.44 42.15-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c.86.33 1.92 2.23-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.58c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#A9B6D3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "m9.8 46.44 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c.86.32 1.91 2.23-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.58c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#A8B5D3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "m9.8 46.44 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.85.32 1.9 2.23-.16 2.73L29.56 60.2a7.62 7.62 0 0 1-6.5-1.29L9.3 48.58c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#A7B4D2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "m9.8 46.44 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.85.32 1.9 2.23-.16 2.72L29.56 60.21a7.62 7.62 0 0 1-6.5-1.29L9.3 48.57c-1.46-1.1-.52-1.95.5-2.13Z",
    fill: "#A6B3D2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "m9.8 46.43 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.84.32 1.89 2.24-.16 2.73L29.56 60.2a7.62 7.62 0 0 1-6.5-1.28L9.3 48.57c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#A5B2D1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "m9.8 46.43 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.84.32 1.88 2.24-.16 2.73L29.56 60.2a7.62 7.62 0 0 1-6.5-1.28L9.3 48.57c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#A4B1D1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "m9.8 46.43 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.83.31 1.88 2.24-.16 2.72L29.56 60.2a7.62 7.62 0 0 1-6.5-1.29L9.3 48.57c-1.47-1.1-.52-1.96.5-2.14Z",
    fill: "#A3B1D0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "m9.8 46.42 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c.82.3 1.87 2.24-.16 2.72L29.56 60.2a7.62 7.62 0 0 1-6.5-1.29L9.3 48.56c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#A2B0D0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "m9.8 46.42 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.82.3 1.86 2.25-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.56c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#A1AFCF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "m9.8 46.42 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.82.3 1.85 2.25-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.56c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#A0AECF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "m9.8 46.41 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.1c.81.31 1.85 2.26-.16 2.73L29.56 60.2a7.62 7.62 0 0 1-6.5-1.29L9.3 48.55c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#9FADCE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "m9.8 46.41 42.15-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.8.3 1.84 2.25-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.55c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#9EACCE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "m9.79 46.4 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.8.3 1.83 2.26-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.55c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#9DABCD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "m9.79 46.4 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c.8.3 1.82 2.25-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.54c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#9CABCD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "m9.8 46.4 42.15-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c.79.29 1.82 2.25-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.54c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#9BAACC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "m9.79 46.4 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.78.3 1.81 2.26-.17 2.72L29.56 60.17a7.62 7.62 0 0 1-6.5-1.29L9.3 48.54c-1.47-1.1-.53-1.96.49-2.14Z",
    fill: "#9AA9CC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "m9.79 46.4 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.1c.78.3 1.8 2.27-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.53c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#99A8CB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "m9.79 46.4 42.16-7.8a6.24 6.24 0 0 1 3.41.32l18.2 7.12c.77.28 1.8 2.26-.17 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.53c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#98A7CB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "m9.79 46.39 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c.77.29 1.79 2.27-.17 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.52c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#97A6CA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "m9.79 46.39 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c.77.29 1.8 2.27-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.53c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#96A6CA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "m9.79 46.38 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c.76.28 1.79 2.27-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.3 48.52c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#95A5C9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "m9.79 46.38 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.2 7.11c.75.28 1.77 2.27-.17 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 48.52c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#94A4C9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m9.79 46.37 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.2 7.11c.75.28 1.76 2.27-.17 2.72L29.55 60.15a7.62 7.62 0 0 1-6.5-1.29L9.3 48.51c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#93A3C8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m9.79 48.6 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.2 7.11c1.27.5 2.48 2.04-.17 2.72L29.55 62.38a7.62 7.62 0 0 1-6.5-1.29L9.3 50.74c-1.46-1.1-.52-1.95.5-2.13Z",
    fill: "#3C69AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m9.78 48.56 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.3 50.7c-1.47-1.1-.52-1.96.5-2.14Z",
    fill: "#3D6AAB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m9.78 48.5 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.29 50.65c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#3E6BAC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m9.78 48.46 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.48 2.04-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.29 50.6c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#3F6BAD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m9.78 48.41 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.5 2.03-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.28 50.55c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#406CAE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m9.77 48.36 42.16-7.8a6.24 6.24 0 0 1 3.42.34L73.54 48c1.28.51 2.49 2.05-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.28 50.5c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#416DAF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m9.77 48.31 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c1.28.51 2.48 2.05-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.28 50.45c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#426EB0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m9.77 48.27 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.27.5 2.48 2.04-.17 2.72L29.54 62.04a7.62 7.62 0 0 1-6.5-1.29L9.27 50.4c-1.46-1.1-.52-1.95.5-2.13Z",
    fill: "#436FB1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m9.77 48.22 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.27 50.36c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#446FB2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m9.76 48.17 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.27 50.31c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#4570B3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m9.76 48.12 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.27 50.26c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#4671B3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m9.76 48.07 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.5 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.26 50.2c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#4772B4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m9.75 48.02 42.16-7.8a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.28.51 2.49 2.05-.16 2.73L29.52 61.8a7.62 7.62 0 0 1-6.5-1.28L9.26 50.16c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#4873B5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m9.75 47.97 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.17 2.72L29.52 61.75a7.62 7.62 0 0 1-6.5-1.29L9.26 50.11c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#4974B6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m9.75 47.92 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.27.5 2.48 2.04-.17 2.72L29.51 61.7a7.62 7.62 0 0 1-6.5-1.28L9.26 50.06c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#4A74B7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m9.75 47.87 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.72L29.5 61.65a7.62 7.62 0 0 1-6.5-1.29L9.25 50.01c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#4B75B8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m9.74 47.82 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.1c1.28.51 2.49 2.05-.16 2.73L29.5 61.6a7.62 7.62 0 0 1-6.5-1.29L9.25 49.96c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#4C76B9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m9.74 47.78 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.25 49.92c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#4D77BA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m9.74 47.73 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.27.5 2.48 2.04-.17 2.72L29.5 61.5a7.62 7.62 0 0 1-6.5-1.28L9.25 49.87c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#4E78BB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m9.74 47.68 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73L29.5 61.45a7.62 7.62 0 0 1-6.5-1.28L9.24 49.82c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#4F78BC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m9.73 47.63 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c1.28.51 2.49 2.05-.16 2.73L29.5 61.4a7.62 7.62 0 0 1-6.5-1.28L9.24 49.77c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#5079BD"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m9.73 47.58 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.2 7.1c1.27.51 2.48 2.05-.17 2.73L29.5 61.35a7.62 7.62 0 0 1-6.5-1.28L9.24 49.72c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#517ABE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m9.73 47.54 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.72L29.49 61.31a7.62 7.62 0 0 1-6.5-1.29L9.23 49.67c-1.46-1.1-.52-1.95.5-2.13Z",
    fill: "#527BBF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m9.72 47.49 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.23 49.63c-1.47-1.11-.52-1.96.5-2.14Z",
    fill: "#537CC0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m9.72 47.44 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73L29.5 61.2a7.62 7.62 0 0 1-6.5-1.29L9.23 49.58c-1.47-1.1-.53-1.96.49-2.14Z",
    fill: "#547CC1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m9.72 47.39 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.23 49.53c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#557DC2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m9.72 47.34 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73L29.48 61.1a7.62 7.62 0 0 1-6.5-1.28L9.22 49.48c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#567EC3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m9.71 47.29 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.22 49.43c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#577FC4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m9.71 47.24 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.48 2.04-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.22 49.38c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#5880C4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7 47.2 42.16-7.8a6.24 6.24 0 0 1 3.42.32l18.19 7.12c1.28.5 2.5 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.22 49.33c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#5981C5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7 47.14 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.72L29.47 60.92a7.62 7.62 0 0 1-6.5-1.29L9.21 49.28c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#5A81C6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7 47.1 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.16 2.72L29.47 60.87a7.62 7.62 0 0 1-6.5-1.29L9.21 49.24c-1.47-1.1-.53-1.96.5-2.14Z",
    fill: "#5B82C7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7 47.05 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.2 49.19c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#5C83C8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7 47 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.49 2.03-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.2 49.14c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#5D84C9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7 46.95 42.15-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.49 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.2 49.09c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#5E85CA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m9.69 46.9 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.48 2.04-.17 2.72l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.2 49.04c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#5F85CB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m9.69 46.85 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.5 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.2 48.99c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#6086CC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 46.8 51.84 39a6.24 6.24 0 0 1 3.42.34l18.19 7.1c1.28.51 2.49 2.05-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.2 48.94c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#6187CD"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m9.68 46.75 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.1c1.28.51 2.49 2.05-.16 2.73L29.45 60.53a7.62 7.62 0 0 1-6.5-1.29L9.2 48.89c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#6188CE"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m9.68 46.7 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.19 48.85c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#6289CF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m9.68 46.66 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.19 48.8c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#6389D0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m9.67 46.6 42.16-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.18 48.75c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#648AD1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m9.67 46.56 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.18 48.7c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#658BD2"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m9.67 46.51 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.5 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.18 48.65c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#668CD3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m9.67 46.46 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.49 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.17 48.6c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#678DD4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m9.66 46.41 42.16-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.1c1.28.51 2.49 2.05-.16 2.73L29.43 60.2a7.62 7.62 0 0 1-6.5-1.29L9.17 48.55c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#688DD5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m9.66 46.37 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.17 48.51c-1.47-1.1-.53-1.96.49-2.14Z",
    fill: "#698ED6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m9.66 46.32 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.18 48.46c-1.47-1.1-.53-1.96.49-2.14Z",
    fill: "#6A8FD6"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m9.65 46.27 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.72L29.42 60.04a7.62 7.62 0 0 1-6.5-1.29L9.16 48.4c-1.47-1.1-.52-1.95.5-2.13Z",
    fill: "#6B90D7"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m9.65 46.22 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.16 48.36c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#6C91D8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m9.65 46.17 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.15 48.3c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#6D92D9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m9.65 46.12 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.5 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.16 48.26c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#6E92DA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m9.64 46.07 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.49 2.04-.16 2.72L29.4 59.84a7.62 7.62 0 0 1-6.5-1.28L9.15 48.2c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#6F93DB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m9.64 46.02 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c1.28.51 2.48 2.05-.17 2.73L29.41 59.8a7.62 7.62 0 0 1-6.5-1.28L9.15 48.16c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#7094DC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m9.64 45.97 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.72L29.4 59.75a7.62 7.62 0 0 1-6.5-1.29L9.15 48.11c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#7195DD"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m9.63 45.93 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.72L29.4 59.7a7.62 7.62 0 0 1-6.5-1.29L9.14 48.07c-1.47-1.1-.52-1.96.5-2.14Z",
    fill: "#7296DE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m9.63 45.88 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.16 2.73L29.4 59.65a7.62 7.62 0 0 1-6.5-1.28L9.14 48.02c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#7396DF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m9.63 45.83 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.48 2.03-.17 2.72L29.4 59.6a7.62 7.62 0 0 1-6.5-1.28L9.14 47.97c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#7497E0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m9.63 45.78 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.5 2.04-.16 2.72L29.4 59.55a7.62 7.62 0 0 1-6.5-1.28L9.14 47.92c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#7598E1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m9.62 45.73 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.12c1.28.5 2.49 2.04-.16 2.72L29.39 59.5a7.62 7.62 0 0 1-6.5-1.28L9.13 47.87c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#7699E2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m9.62 45.68 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.49 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.13 47.82c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#779AE3"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m9.62 45.63 42.16-7.8a6.24 6.24 0 0 1 3.41.34l18.2 7.1c1.28.51 2.48 2.05-.17 2.73L29.4 59.4a7.62 7.62 0 0 1-6.5-1.28L9.12 47.77c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#789AE4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m9.62 45.58 42.15-7.79a6.24 6.24 0 0 1 3.42.33l18.19 7.1c1.28.51 2.49 2.05-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.12 47.72c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#799BE5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m9.61 45.54 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.49 2.04-.16 2.73L29.38 59.3a7.62 7.62 0 0 1-6.5-1.29L9.12 47.68c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#7A9CE6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m9.61 45.49 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.12 47.63c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#7B9DE7"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.44 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.73L29.37 59.2a7.62 7.62 0 0 1-6.5-1.28L9.13 47.58c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#7C9EE7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.4 42.16-7.8a6.24 6.24 0 0 1 3.42.32l18.19 7.12c1.28.5 2.49 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.11 47.53c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#7D9FE8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.34 42.16-7.8a6.24 6.24 0 0 1 3.41.33L73.37 45c1.28.5 2.49 2.04-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.11 47.48c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#7E9FE9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.3 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.1c1.28.51 2.48 2.05-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.28L9.1 47.43c-1.47-1.1-.53-1.95.49-2.14Z",
    fill: "#7FA0EA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.25 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.5 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.29L9.1 47.4c-1.46-1.11-.52-1.96.5-2.14Z",
    fill: "#80A1EB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.2 42.15-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.72L29.36 58.97a7.62 7.62 0 0 1-6.5-1.29L9.1 47.33c-1.47-1.1-.52-1.95.5-2.13Z",
    fill: "#81A2EC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m9.6 45.14 42.15-7.79a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.72L29.36 58.92a7.62 7.62 0 0 1-6.5-1.29L9.1 47.28c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#82A3ED"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m9.59 45.1 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.11c1.28.5 2.48 2.04-.17 2.73l-43.83 11.4a7.62 7.62 0 0 1-6.5-1.29L9.09 47.24c-1.46-1.1-.52-1.95.5-2.14Z",
    fill: "#83A3EE"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m9.58 45.05 42.16-7.8a6.24 6.24 0 0 1 3.42.33l18.19 7.11c1.28.5 2.49 2.04-.16 2.73l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.1 47.19c-1.47-1.1-.52-1.95.5-2.14Z",
    fill: "#84A4EF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m9.58 45 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.49 2.03-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.09 47.14c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#85A5F0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m11 44.98 38.82-7.18a3.52 3.52 0 0 0 2.77-4.23L46.4 6.1a2.84 2.84 0 0 0-3.06-2.24L2.63 7.81a2.87 2.87 0 0 0-2.48 3.4L6.97 42.2A3.49 3.49 0 0 0 11 44.98Z",
    fill: "#5576B7"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m11.03 44.97 38.8-7.17a3.52 3.52 0 0 0 2.77-4.24L46.39 6.1a2.84 2.84 0 0 0-3.06-2.23L2.66 7.8a2.87 2.87 0 0 0-2.5 3.41L6.98 42.2a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#5677B8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m11.04 44.97 38.79-7.17a3.52 3.52 0 0 0 2.77-4.24L46.4 6.1a2.84 2.84 0 0 0-3.06-2.23L2.67 7.8a2.87 2.87 0 0 0-2.49 3.4L7 42.19a3.5 3.5 0 0 0 4.04 2.79Z",
    fill: "#5778B9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m11.06 44.96 38.77-7.17a3.52 3.52 0 0 0 2.78-4.24L46.4 6.1a2.84 2.84 0 0 0-3.07-2.23L2.7 7.8A2.87 2.87 0 0 0 .2 11.2l6.82 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#5879BA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m11.08 44.95 38.76-7.17a3.52 3.52 0 0 0 2.77-4.23l-6.2-27.46a2.84 2.84 0 0 0-3.06-2.24L2.7 7.78a2.87 2.87 0 0 0-2.49 3.41l6.82 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#597ABB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m11.1 44.95 38.74-7.17a3.52 3.52 0 0 0 2.78-4.23l-6.2-27.46a2.84 2.84 0 0 0-3.07-2.24L2.73 7.78a2.87 2.87 0 0 0-2.49 3.41l6.82 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#5A7BBC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m11.11 44.94 38.74-7.16a3.52 3.52 0 0 0 2.77-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.06-2.23L2.75 7.77a2.87 2.87 0 0 0-2.5 3.41l6.82 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#5A7CBD"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m11.13 44.94 38.72-7.17a3.52 3.52 0 0 0 2.77-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.06-2.23L2.76 7.76a2.86 2.86 0 0 0-2.49 3.42L7.1 42.15a3.49 3.49 0 0 0 4.04 2.79Z",
    fill: "#5B7CBE"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m11.15 44.93 38.7-7.16a3.52 3.52 0 0 0 2.78-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.07-2.23L2.78 7.76A2.86 2.86 0 0 0 .3 11.17L7.1 42.14a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#5C7DBF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m11.17 44.92 38.69-7.16a3.52 3.52 0 0 0 2.77-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.06-2.23L2.8 7.75a2.86 2.86 0 0 0-2.5 3.41l6.82 30.98a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#5D7EC0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m11.18 44.91 38.68-7.15a3.52 3.52 0 0 0 2.78-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.06-2.23L2.82 7.74a2.86 2.86 0 0 0-2.5 3.41l6.82 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#5E7FC1"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m11.2 44.91 38.67-7.15a3.52 3.52 0 0 0 2.77-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.06-2.23L2.84 7.73a2.86 2.86 0 0 0-2.5 3.42l6.82 30.97a3.49 3.49 0 0 0 4.04 2.79Z",
    fill: "#5F80C2"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m11.22 44.9 38.65-7.15a3.52 3.52 0 0 0 2.78-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.06-2.23L2.85 7.72a2.86 2.86 0 0 0-2.49 3.42l6.82 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#6081C3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m11.24 44.9 38.64-7.15a3.52 3.52 0 0 0 2.77-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.06-2.23L2.87 7.72a2.86 2.86 0 0 0-2.49 3.42L7.2 42.1a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#6182C4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 44.89 38.63-7.15a3.52 3.52 0 0 0 2.78-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.06-2.23L2.9 7.71a2.86 2.86 0 0 0-2.5 3.42L7.21 42.1a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#6283C5"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m11.27 44.88 38.62-7.14a3.52 3.52 0 0 0 2.77-4.24l-6.2-27.46A2.84 2.84 0 0 0 43.4 3.8L2.91 7.7a2.86 2.86 0 0 0-2.5 3.41L7.24 42.1a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#6384C6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m11.29 44.88 38.6-7.14a3.52 3.52 0 0 0 2.77-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.05-2.24L2.92 7.7a2.86 2.86 0 0 0-2.49 3.42l6.81 30.97a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#6385C7"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m11.3 44.87 38.6-7.14a3.52 3.52 0 0 0 2.77-4.23l-6.2-27.47A2.84 2.84 0 0 0 43.4 3.8L2.94 7.7a2.86 2.86 0 0 0-2.5 3.41L7.27 42.1a3.5 3.5 0 0 0 4.04 2.78Z",
    fill: "#6486C8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m11.32 44.86 38.58-7.14a3.52 3.52 0 0 0 2.77-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.05-2.23L2.96 7.7a2.86 2.86 0 0 0-2.5 3.41l6.82 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#6587C9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m11.34 44.86 38.56-7.14a3.52 3.52 0 0 0 2.78-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.06-2.23L2.98 7.69a2.86 2.86 0 0 0-2.5 3.4L7.3 42.08a3.49 3.49 0 0 0 4.04 2.79Z",
    fill: "#6687CA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m11.36 44.85 38.55-7.13a3.52 3.52 0 0 0 2.77-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.05-2.24L3 7.68a2.86 2.86 0 0 0-2.5 3.41l6.81 30.98a3.48 3.48 0 0 0 4.05 2.78Z",
    fill: "#6788CB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m11.37 44.84 38.54-7.13a3.52 3.52 0 0 0 2.78-4.23L46.49 6a2.84 2.84 0 0 0-3.06-2.23L3.02 7.67a2.86 2.86 0 0 0-2.5 3.41l6.81 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#6889CC"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m11.4 44.84 38.52-7.13a3.52 3.52 0 0 0 2.77-4.24L46.49 6a2.84 2.84 0 0 0-3.05-2.23l-40.4 3.9a2.86 2.86 0 0 0-2.5 3.4l6.8 30.98a3.48 3.48 0 0 0 4.05 2.79Z",
    fill: "#698ACD"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m11.41 44.83 38.51-7.13a3.52 3.52 0 0 0 2.78-4.23L46.5 6a2.84 2.84 0 0 0-3.06-2.23L3.05 7.66a2.86 2.86 0 0 0-2.5 3.41l6.82 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#6A8BCE"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m11.43 44.83 38.5-7.13a3.52 3.52 0 0 0 2.77-4.23L46.5 6a2.84 2.84 0 0 0-3.06-2.23L3.07 7.66a2.86 2.86 0 0 0-2.5 3.4l6.81 30.98a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#6B8CCF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "m11.44 44.82 38.49-7.13a3.52 3.52 0 0 0 2.77-4.23L46.5 5.99a2.84 2.84 0 0 0-3.05-2.23L3.09 7.65a2.86 2.86 0 0 0-2.5 3.41L7.4 42.03a3.49 3.49 0 0 0 4.04 2.79Z",
    fill: "#6C8DD0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m11.46 44.81 38.48-7.12a3.52 3.52 0 0 0 2.77-4.23L46.5 5.99a2.84 2.84 0 0 0-3.05-2.23L3.1 7.64a2.86 2.86 0 0 0-2.49 3.41l6.8 30.98a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#6C8ED1"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m11.48 44.8 38.46-7.12a3.52 3.52 0 0 0 2.77-4.23L46.52 5.98a2.84 2.84 0 0 0-3.06-2.23L3.12 7.63a2.86 2.86 0 0 0-2.5 3.42l6.82 30.97a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#6D8FD2"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m11.5 44.8 38.44-7.12a3.52 3.52 0 0 0 2.78-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.05-2.23L3.14 7.63a2.86 2.86 0 0 0-2.5 3.41l6.81 30.98a3.48 3.48 0 0 0 4.05 2.78Z",
    fill: "#6E90D3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m11.51 44.8 38.44-7.13a3.52 3.52 0 0 0 2.77-4.23L46.53 5.97a2.84 2.84 0 0 0-3.06-2.23L3.16 7.62a2.86 2.86 0 0 0-2.5 3.41l6.81 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#6F91D4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m11.53 44.79 38.43-7.12a3.52 3.52 0 0 0 2.77-4.23l-6.2-27.47a2.84 2.84 0 0 0-3.05-2.23L3.18 7.62a2.87 2.87 0 0 0-2.5 3.4L7.48 42a3.48 3.48 0 0 0 4.05 2.79Z",
    fill: "#7092D5"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m11.55 44.78 38.41-7.11a3.52 3.52 0 0 0 2.77-4.24L46.54 5.97a2.84 2.84 0 0 0-3.05-2.23L3.19 7.6A2.87 2.87 0 0 0 .7 11L7.5 42a3.48 3.48 0 0 0 4.05 2.78Z",
    fill: "#7192D5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m11.57 44.77 38.4-7.1a3.52 3.52 0 0 0 2.76-4.24L46.55 5.97a2.84 2.84 0 0 0-3.06-2.24L3.21 7.6a2.87 2.87 0 0 0-2.5 3.41L7.53 42a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#7293D6"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "m11.58 44.77 38.38-7.11a3.52 3.52 0 0 0 2.78-4.24l-6.2-27.46a2.84 2.84 0 0 0-3.05-2.23L3.23 7.6A2.87 2.87 0 0 0 .73 11l6.8 30.98a3.5 3.5 0 0 0 4.05 2.79Z",
    fill: "#7394D7"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m11.6 44.76 38.37-7.1a3.52 3.52 0 0 0 2.77-4.24L46.55 5.95a2.84 2.84 0 0 0-3.05-2.23L3.24 7.6A2.87 2.87 0 0 0 .75 11l6.8 30.98a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#7495D8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "m11.62 44.75 38.35-7.1a3.52 3.52 0 0 0 2.78-4.23L46.56 5.95a2.84 2.84 0 0 0-3.06-2.23L3.26 7.58A2.87 2.87 0 0 0 .77 11l6.8 30.98a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#7496D9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m11.63 44.75 38.35-7.1a3.52 3.52 0 0 0 2.77-4.24L46.57 5.94a2.84 2.84 0 0 0-3.06-2.23L3.29 7.58a2.87 2.87 0 0 0-2.5 3.4l6.8 30.98a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#7597DA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M11.65 44.74 50 37.64a3.52 3.52 0 0 0 2.77-4.23L46.57 5.94a2.84 2.84 0 0 0-3.06-2.23L3.31 7.57a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#7698DB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m11.67 44.74 38.32-7.1a3.52 3.52 0 0 0 2.77-4.24L46.58 5.93a2.84 2.84 0 0 0-3.06-2.23L3.32 7.56a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.48 3.48 0 0 0 4.05 2.79Z",
    fill: "#7799DC"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m11.69 44.73 38.3-7.1a3.52 3.52 0 0 0 2.78-4.23L46.58 5.93a2.84 2.84 0 0 0-3.05-2.23L3.33 7.56a2.87 2.87 0 0 0-2.49 3.41l6.8 30.97a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#789ADD"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m11.7 44.72 38.3-7.1a3.52 3.52 0 0 0 2.77-4.22L46.6 5.93a2.84 2.84 0 0 0-3.06-2.23L3.36 7.55a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.48 3.48 0 0 0 4.05 2.78Z",
    fill: "#799BDE"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M11.72 44.72 50 37.62a3.52 3.52 0 0 0 2.77-4.23L46.6 5.92a2.84 2.84 0 0 0-3.06-2.23L3.37 7.54a2.87 2.87 0 0 0-2.5 3.42l6.8 30.97a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#7A9CDF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M11.74 44.71 50 37.62a3.52 3.52 0 0 0 2.77-4.23L46.6 5.92a2.84 2.84 0 0 0-3.06-2.23L3.39 7.54a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#7B9CE0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M11.76 44.7 50 37.61a3.52 3.52 0 0 0 2.77-4.23L46.6 5.91a2.84 2.84 0 0 0-3.06-2.23L3.41 7.53a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.49 3.49 0 0 0 4.05 2.78Z",
    fill: "#7C9DE1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m11.77 44.7 38.24-7.09a3.52 3.52 0 0 0 2.78-4.23L46.6 5.9a2.84 2.84 0 0 0-3.06-2.23L3.43 7.53a2.87 2.87 0 0 0-2.5 3.4l6.8 30.98a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#7D9EE2"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m11.8 44.69 38.22-7.08a3.52 3.52 0 0 0 2.77-4.24L46.61 5.9a2.84 2.84 0 0 0-3.05-2.23L3.44 7.52a2.87 2.87 0 0 0-2.49 3.4l6.8 30.98a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#7D9FE3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m11.8 44.69 38.23-7.09a3.52 3.52 0 0 0 2.77-4.23L46.62 5.9a2.84 2.84 0 0 0-3.06-2.23L3.46 7.5a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.49 3.49 0 0 0 4.05 2.79Z",
    fill: "#7EA0E4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m11.83 44.68 38.2-7.08a3.52 3.52 0 0 0 2.77-4.24L46.62 5.9a2.84 2.84 0 0 0-3.05-2.23L3.48 7.51a2.87 2.87 0 0 0-2.5 3.4l6.8 30.98a3.48 3.48 0 0 0 4.05 2.79Z",
    fill: "#7FA1E5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m11.84 44.67 38.2-7.08a3.52 3.52 0 0 0 2.77-4.23L46.63 5.89a2.84 2.84 0 0 0-3.06-2.23L3.5 7.5A2.87 2.87 0 0 0 1 10.9l6.8 30.98a3.49 3.49 0 0 0 4.04 2.8Z",
    fill: "#80A2E6"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m11.86 44.66 38.18-7.07a3.52 3.52 0 0 0 2.77-4.23L46.63 5.89a2.84 2.84 0 0 0-3.05-2.24L3.5 7.5a2.87 2.87 0 0 0-2.49 3.41l6.8 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#81A3E7"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m11.88 44.66 38.16-7.08a3.52 3.52 0 0 0 2.78-4.23L46.64 5.88a2.84 2.84 0 0 0-3.06-2.23L3.54 7.48a2.87 2.87 0 0 0-2.5 3.42l6.8 30.97a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#82A4E8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9 44.65 38.15-7.07a3.52 3.52 0 0 0 2.77-4.23L46.64 5.88a2.84 2.84 0 0 0-3.06-2.24L3.55 7.48a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#83A5E9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m11.91 44.65 38.14-7.08a3.52 3.52 0 0 0 2.77-4.23L46.65 5.87a2.84 2.84 0 0 0-3.06-2.23L3.57 7.47a2.87 2.87 0 0 0-2.5 3.42l6.8 30.97a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#84A6EA"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m11.93 44.64 38.13-7.07a3.52 3.52 0 0 0 2.77-4.23L46.65 5.87a2.84 2.84 0 0 0-3.05-2.24L3.59 7.46a2.87 2.87 0 0 0-2.5 3.41l6.8 30.98a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#85A7EB"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m11.95 44.63 38.11-7.06a3.52 3.52 0 0 0 2.77-4.24L46.66 5.86a2.84 2.84 0 0 0-3.06-2.23l-40 3.83a2.86 2.86 0 0 0-2.49 3.4l6.8 30.99a3.48 3.48 0 0 0 4.04 2.78Z",
    fill: "#86A7EC"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m11.97 44.63 38.1-7.07a3.52 3.52 0 0 0 2.77-4.23L46.66 5.86a2.84 2.84 0 0 0-3.05-2.24L3.62 7.45a2.86 2.86 0 0 0-2.5 3.41l6.8 30.98a3.48 3.48 0 0 0 4.05 2.79Z",
    fill: "#86A8ED"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m11.98 44.62 38.1-7.06a3.52 3.52 0 0 0 2.76-4.24L46.67 5.85a2.84 2.84 0 0 0-3.06-2.23L3.64 7.45a2.86 2.86 0 0 0-2.5 3.4l6.8 30.98a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#87A9EE"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m12 44.61 38.07-7.06a3.52 3.52 0 0 0 2.78-4.23L46.67 5.85a2.84 2.84 0 0 0-3.06-2.23L3.66 7.44a2.86 2.86 0 0 0-2.5 3.41l6.8 30.98A3.49 3.49 0 0 0 12 44.6Z",
    fill: "#88AAEF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m12.02 44.6 38.06-7.05a3.52 3.52 0 0 0 2.77-4.23L46.68 5.84a2.84 2.84 0 0 0-3.06-2.23L3.68 7.44a2.86 2.86 0 0 0-2.5 3.4l6.8 30.98a3.48 3.48 0 0 0 4.04 2.79Z",
    fill: "#89ABF0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m12.04 44.6 38.04-7.06a3.52 3.52 0 0 0 2.78-4.23L46.68 5.84a2.84 2.84 0 0 0-3.05-2.23L3.69 7.43a2.86 2.86 0 0 0-2.5 3.4L8 41.82a3.48 3.48 0 0 0 4.05 2.79Z",
    fill: "#8AACF1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m12.05 44.6 38.04-7.06a3.52 3.52 0 0 0 2.77-4.23L46.69 5.84a2.84 2.84 0 0 0-3.06-2.24L3.71 7.42a2.86 2.86 0 0 0-2.5 3.41l6.8 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#8BADF2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m12.05 44.6 38.04-7.06a3.52 3.52 0 0 0 2.77-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L3.71 7.42a2.86 2.86 0 0 0-2.5 3.41l6.8 30.98a3.49 3.49 0 0 0 4.04 2.78Z",
    fill: "#8BADF2"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m12.66 43.9 37.3-6.92a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L4.47 7.35a2.86 2.86 0 0 0-2.5 3.4l6.66 30.36a3.47 3.47 0 0 0 4.03 2.79Z",
    fill: "#8CAEF2"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m13.27 43.2 36.56-6.78a3.52 3.52 0 0 0 2.78-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L5.23 7.28a2.86 2.86 0 0 0-2.5 3.4l6.53 29.73a3.45 3.45 0 0 0 4 2.79Z",
    fill: "#8DAEF2"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m13.88 42.5 35.83-6.63a3.52 3.52 0 0 0 2.77-4.23l-5.8-25.8a2.84 2.84 0 0 0-3.05-2.24L5.99 7.2a2.86 2.86 0 0 0-2.5 3.41l6.4 29.1a3.44 3.44 0 0 0 3.99 2.8Z",
    fill: "#8EAFF2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m14.49 41.81 35.1-6.5a3.52 3.52 0 0 0 2.77-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L6.75 7.13a2.86 2.86 0 0 0-2.5 3.41l6.26 28.48a3.42 3.42 0 0 0 3.98 2.8Z",
    fill: "#8FB0F2"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "m15.1 41.11 34.36-6.35a3.52 3.52 0 0 0 2.77-4.23l-5.54-24.7a2.84 2.84 0 0 0-3.06-2.23L7.51 7.06a2.86 2.86 0 0 0-2.5 3.4l6.13 27.86a3.4 3.4 0 0 0 3.96 2.8Z",
    fill: "#90B0F2"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7 40.42 33.63-6.22a3.52 3.52 0 0 0 2.77-4.23L46.7 5.84a2.84 2.84 0 0 0-3.06-2.24L8.27 6.98a2.86 2.86 0 0 0-2.5 3.42l6 27.22a3.39 3.39 0 0 0 3.94 2.8Z",
    fill: "#91B1F3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m16.31 39.73 32.9-6.08a3.52 3.52 0 0 0 2.77-4.23l-5.3-23.59a2.84 2.84 0 0 0-3.05-2.23L9.03 6.91a2.86 2.86 0 0 0-2.5 3.41l5.86 26.6c.37 1.9 2.05 3.15 3.92 2.8Z",
    fill: "#92B1F3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "m16.92 39.03 32.16-5.94a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L9.79 6.84a2.86 2.86 0 0 0-2.5 3.4l5.73 25.98c.37 1.9 2.03 3.16 3.9 2.8Z",
    fill: "#93B2F3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m17.53 38.33 31.42-5.8a3.52 3.52 0 0 0 2.78-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L10.55 6.76a2.86 2.86 0 0 0-2.5 3.41l5.6 25.36c.37 1.88 2 3.15 3.88 2.8Z",
    fill: "#94B3F3"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m18.14 37.64 30.69-5.66a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L11.31 6.7a2.86 2.86 0 0 0-2.5 3.41l5.47 24.73c.36 1.89 1.99 3.16 3.86 2.8Z",
    fill: "#95B3F3"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "m18.75 36.94 29.95-5.52a3.52 3.52 0 0 0 2.78-4.23l-4.8-21.36a2.84 2.84 0 0 0-3.05-2.23L12.07 6.62a2.86 2.86 0 0 0-2.5 3.4l5.33 24.1c.37 1.9 1.98 3.17 3.85 2.82Z",
    fill: "#96B4F3"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "m19.36 36.25 29.22-5.38a3.52 3.52 0 0 0 2.77-4.23l-4.66-20.8a2.84 2.84 0 0 0-3.06-2.24l-30.8 2.94a2.86 2.86 0 0 0-2.5 3.42l5.2 23.47c.37 1.9 1.96 3.17 3.83 2.82Z",
    fill: "#97B5F3"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m19.97 35.55 28.48-5.24a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L13.59 6.47a2.86 2.86 0 0 0-2.5 3.41l5.06 22.85c.37 1.9 1.94 3.17 3.82 2.82Z",
    fill: "#98B5F3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m20.58 34.86 27.75-5.1a3.52 3.52 0 0 0 2.77-4.24L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L14.35 6.4a2.86 2.86 0 0 0-2.5 3.41l4.93 22.22c.37 1.9 1.92 3.17 3.8 2.83Z",
    fill: "#99B6F3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m21.19 34.16 27-4.96a3.52 3.52 0 0 0 2.78-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L15.11 6.32a2.86 2.86 0 0 0-2.5 3.42l4.8 21.6c.37 1.89 1.9 3.17 3.78 2.82Z",
    fill: "#9AB7F3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m21.8 33.47 26.27-4.83a3.52 3.52 0 0 0 2.78-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L15.87 6.25a2.86 2.86 0 0 0-2.5 3.41l4.67 20.98c.36 1.89 1.88 3.17 3.76 2.83Z",
    fill: "#9BB7F3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m22.4 32.77 25.55-4.68a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23l-27 2.58a2.86 2.86 0 0 0-2.5 3.41l4.53 20.35c.37 1.9 1.87 3.18 3.75 2.83Z",
    fill: "#9CB8F4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m23.01 32.07 24.81-4.54a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L17.39 6.1a2.86 2.86 0 0 0-2.5 3.42l4.4 19.72c.37 1.9 1.85 3.18 3.72 2.83Z",
    fill: "#9DB8F4"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m23.62 31.38 24.07-4.4a3.52 3.52 0 0 0 2.78-4.23L46.68 5.84a2.84 2.84 0 0 0-3.05-2.24L18.14 6.04a2.86 2.86 0 0 0-2.49 3.4l4.26 19.1c.37 1.9 1.84 3.19 3.71 2.84Z",
    fill: "#9EB9F4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m24.23 30.69 23.34-4.27a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L18.91 5.96a2.86 2.86 0 0 0-2.5 3.41l4.13 18.47c.37 1.9 1.82 3.2 3.7 2.85Z",
    fill: "#9FBAF4"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m24.84 29.99 22.6-4.13a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L19.67 5.9a2.86 2.86 0 0 0-2.5 3.4l4 17.86c.37 1.89 1.8 3.19 3.67 2.84Z",
    fill: "#A0BAF4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m25.45 29.3 21.87-4a3.52 3.52 0 0 0 2.77-4.22L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23l-23.2 2.21a2.86 2.86 0 0 0-2.5 3.42l3.87 17.22c.36 1.89 1.78 3.2 3.65 2.84Z",
    fill: "#A0BBF4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m26.06 28.6 21.13-3.85a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L21.2 5.74a2.86 2.86 0 0 0-2.5 3.41l3.73 16.6c.37 1.9 1.76 3.2 3.64 2.85Z",
    fill: "#A1BCF4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m26.67 27.9 20.4-3.7a3.52 3.52 0 0 0 2.77-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L21.95 5.67a2.86 2.86 0 0 0-2.5 3.4l3.6 15.98c.37 1.9 1.74 3.2 3.62 2.85Z",
    fill: "#A2BCF4"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "m27.28 27.2 19.66-3.56a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23l-20.92 2A2.86 2.86 0 0 0 20.2 9l3.47 15.35c.37 1.9 1.72 3.2 3.6 2.86Z",
    fill: "#A3BDF4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m27.89 26.51 18.92-3.43a3.52 3.52 0 0 0 2.78-4.23l-2.9-13.02a2.84 2.84 0 0 0-3.06-2.23L23.47 5.52a2.86 2.86 0 0 0-2.5 3.41l3.34 14.72c.36 1.9 1.7 3.2 3.58 2.86Z",
    fill: "#A4BEF4"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5 25.82 18.19-3.3a3.52 3.52 0 0 0 2.77-4.22L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23l-19.4 1.85a2.86 2.86 0 0 0-2.5 3.41l3.2 14.1c.37 1.89 1.7 3.2 3.57 2.86Z",
    fill: "#A5BEF4"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m29.1 25.12 17.46-3.15a3.52 3.52 0 0 0 2.77-4.23L46.7 5.84a2.84 2.84 0 0 0-3.06-2.24L24.99 5.38a2.86 2.86 0 0 0-2.5 3.4l3.07 13.48c.36 1.9 1.67 3.2 3.54 2.86Z",
    fill: "#A6BFF5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "m29.71 24.43 16.73-3.01a3.52 3.52 0 0 0 2.77-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L25.75 5.3a2.86 2.86 0 0 0-2.5 3.41l2.93 12.85c.37 1.9 1.66 3.21 3.53 2.87Z",
    fill: "#A7BFF5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m30.32 23.73 15.99-2.87a3.52 3.52 0 0 0 2.77-4.23l-2.4-10.8a2.84 2.84 0 0 0-3.05-2.23L26.5 5.23A2.86 2.86 0 0 0 24 8.64l2.8 12.22c.37 1.9 1.64 3.22 3.51 2.87Z",
    fill: "#A8C0F5"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "m30.93 23.03 15.25-2.73a3.52 3.52 0 0 0 2.78-4.23L46.69 5.83a2.84 2.84 0 0 0-3.06-2.23L27.26 5.16a2.86 2.86 0 0 0-2.5 3.4l2.68 11.6c.36 1.9 1.61 3.22 3.49 2.87Z",
    fill: "#A9C1F5"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "m31.54 22.34 14.52-2.6a3.52 3.52 0 0 0 2.77-4.22L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23l-15.6 1.48a2.86 2.86 0 0 0-2.5 3.41l2.53 10.98c.37 1.89 1.6 3.22 3.48 2.87Z",
    fill: "#AAC1F5"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "m32.15 21.65 13.78-2.46a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L28.79 5.01a2.86 2.86 0 0 0-2.5 3.41l2.4 10.35c.37 1.9 1.58 3.22 3.46 2.88Z",
    fill: "#ABC2F5"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "m32.76 20.95 13.05-2.31a3.52 3.52 0 0 0 2.77-4.24l-1.9-8.57a2.84 2.84 0 0 0-3.05-2.23L29.55 4.94a2.86 2.86 0 0 0-2.5 3.4l2.27 9.73c.37 1.9 1.56 3.23 3.44 2.88Z",
    fill: "#ACC3F5"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "m33.37 20.25 12.31-2.17a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23L30.31 4.86a2.86 2.86 0 0 0-2.5 3.42l2.14 9.1c.36 1.89 1.54 3.22 3.42 2.87Z",
    fill: "#ADC3F5"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "m33.98 19.56 11.58-2.04a3.52 3.52 0 0 0 2.77-4.23l-1.64-7.46a2.84 2.84 0 0 0-3.06-2.23L31.07 4.8a2.86 2.86 0 0 0-2.5 3.4l2 8.47c.37 1.9 1.53 3.24 3.4 2.89Z",
    fill: "#AEC4F5"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "m34.58 18.86 10.85-1.9a3.52 3.52 0 0 0 2.77-4.22l-1.51-6.9a2.84 2.84 0 0 0-3.06-2.24l-11.8 1.12a2.86 2.86 0 0 0-2.5 3.4l1.87 7.86c.37 1.89 1.51 3.23 3.38 2.88Z",
    fill: "#AFC5F5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m35.2 18.17 10.1-1.76a3.52 3.52 0 0 0 2.78-4.23l-1.4-6.35a2.84 2.84 0 0 0-3.05-2.23L32.58 4.65a2.86 2.86 0 0 0-2.5 3.4l1.74 7.23c.37 1.89 1.5 3.24 3.37 2.89Z",
    fill: "#B0C5F5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "m35.8 17.47 9.38-1.61a3.52 3.52 0 0 0 2.77-4.24L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23l-10.28.97a2.86 2.86 0 0 0-2.5 3.41l1.6 6.6c.37 1.9 1.48 3.24 3.35 2.9Z",
    fill: "#B1C6F6"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "m36.41 16.78 8.64-1.48a3.52 3.52 0 0 0 2.77-4.23L46.7 5.83a2.84 2.84 0 0 0-3.06-2.23l-9.53.9a2.86 2.86 0 0 0-2.5 3.41l1.48 5.97c.36 1.9 1.46 3.24 3.33 2.9Z",
    fill: "#B2C6F6"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "m37.02 16.08 7.9-1.34a3.52 3.52 0 0 0 2.78-4.23l-1.01-4.68a2.84 2.84 0 0 0-3.06-2.23l-8.77.83a2.86 2.86 0 0 0-2.49 3.4l1.33 5.35c.37 1.9 1.45 3.25 3.32 2.9Z",
    fill: "#B3C7F6"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "m37.63 15.39 7.17-1.2a3.52 3.52 0 0 0 2.77-4.23l-.88-4.13a2.84 2.84 0 0 0-3.06-2.23l-8 .75a2.86 2.86 0 0 0-2.5 3.41l1.2 4.73c.37 1.89 1.42 3.24 3.3 2.9Z",
    fill: "#B4C8F6"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "m38.24 14.7 6.43-1.07a3.52 3.52 0 0 0 2.77-4.23l-.75-3.57a2.84 2.84 0 0 0-3.06-2.23l-7.25.68a2.86 2.86 0 0 0-2.5 3.41l1.08 4.1c.37 1.89 1.4 3.25 3.28 2.9Z",
    fill: "#B5C8F6"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m38.85 14 5.7-.93a3.52 3.52 0 0 0 2.77-4.23l-.63-3a2.84 2.84 0 0 0-3.06-2.24l-6.49.6a2.86 2.86 0 0 0-2.49 3.42l.94 3.47c.36 1.9 1.38 3.25 3.26 2.9Z",
    fill: "#B6C9F6"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "m12.1 43.18 37.05-6.84a3.21 3.21 0 0 0 2.52-3.86l-5.86-25.8A2.53 2.53 0 0 0 43.1 4.7L4.17 8.47a2.55 2.55 0 0 0-2.22 3.04l6.47 29.13a3.18 3.18 0 0 0 3.69 2.54Z",
    fill: "#F1F5FD"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "m9.58 45 42.16-7.8a6.24 6.24 0 0 1 3.41.33l18.2 7.12c1.28.5 2.49 2.03-.16 2.72l-43.84 11.4a7.62 7.62 0 0 1-6.5-1.28L9.09 47.14c-1.47-1.1-.53-1.95.5-2.14Z",
    fill: "#85A5F0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "m10.16 44.9 41.57-7.7a6.25 6.25 0 0 1 3.42.33l17.93 7.01c1.27.5 2.46 2.01-.16 2.69L29.67 58.49a7.51 7.51 0 0 1-6.42-1.27L9.67 47c-1.44-1.1-.51-1.93.5-2.12Z",
    fill: "#86A6F0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m10.74 44.78 40.98-7.57a6.3 6.3 0 0 1 3.42.31l17.67 6.92c1.26.49 2.43 1.98-.15 2.65l-42.68 11.1c-2.18.57-4.5.11-6.32-1.25l-13.4-10.07c-1.43-1.08-.51-1.9.48-2.09Z",
    fill: "#87A6F0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "m11.32 44.68 40.39-7.47a6.29 6.29 0 0 1 3.43.32l17.4 6.8c1.24.49 2.4 1.96-.14 2.62L30.3 57.91c-2.16.56-4.45.1-6.24-1.24l-13.22-9.93c-1.4-1.06-.5-1.88.48-2.06Z",
    fill: "#88A7F0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9 44.57 39.8-7.36a6.32 6.32 0 0 1 3.43.31l17.15 6.71c1.22.47 2.37 1.93-.14 2.58l-41.52 10.8c-2.13.56-4.4.11-6.16-1.22L11.43 46.6c-1.39-1.05-.5-1.85.47-2.03Z",
    fill: "#89A8F0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "m12.48 44.47 39.2-7.25c1.12-.2 2.31-.13 3.45.3l16.9 6.6c1.2.48 2.32 1.91-.15 2.55L30.94 57.32a7.1 7.1 0 0 1-6.07-1.2l-12.85-9.66c-1.37-1.02-.5-1.82.46-2Z",
    fill: "#8AA9F1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m13.06 44.36 38.62-7.14c1.1-.2 2.3-.14 3.44.3l16.64 6.5c1.18.46 2.3 1.88-.15 2.5L31.25 57.04c-2.07.54-4.27.1-5.98-1.19L12.6 46.33c-1.35-1.02-.48-1.8.46-1.97Z",
    fill: "#8BA9F1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m13.64 44.25 38.03-7.03c1.1-.2 2.3-.15 3.45.3l16.37 6.4c1.17.45 2.27 1.85-.14 2.47L31.57 56.74c-2.04.53-4.2.1-5.9-1.17L13.2 46.2c-1.34-1-.48-1.78.45-1.95Z",
    fill: "#8CAAF1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m14.21 44.15 37.44-6.93c1.1-.2 2.3-.15 3.46.3l16.12 6.3c1.14.44 2.23 1.82-.14 2.43l-39.2 10.2a6.8 6.8 0 0 1-5.82-1.15l-12.3-9.24c-1.31-.99-.47-1.75.44-1.91Z",
    fill: "#8DABF1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "m14.8 44.04 36.85-6.81a6.4 6.4 0 0 1 3.46.28l15.85 6.2c1.14.44 2.2 1.8-.14 2.4L32.2 56.16c-1.98.51-4.08.1-5.72-1.14l-12.12-9.1c-1.3-.97-.46-1.71.43-1.88Z",
    fill: "#8EABF1"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "m15.37 43.93 36.27-6.7a6.37 6.37 0 0 1 3.46.28l15.6 6.1c1.11.43 2.16 1.76-.14 2.36l-38.04 9.9a6.6 6.6 0 0 1-5.64-1.12l-11.94-8.96c-1.27-.96-.45-1.7.43-1.86Z",
    fill: "#8FACF1"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "m15.95 43.82 35.67-6.59a6.37 6.37 0 0 1 3.48.28l15.33 6c1.1.42 2.13 1.73-.13 2.32l-37.46 9.75a6.5 6.5 0 0 1-5.56-1.1l-11.75-8.83c-1.26-.94-.45-1.66.42-1.83Z",
    fill: "#90ADF1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "m16.53 43.72 35.08-6.49a6.4 6.4 0 0 1 3.48.27l15.08 5.9c1.08.42 2.1 1.71-.14 2.29l-36.88 9.6c-1.9.49-3.9.09-5.47-1.1L16.1 45.53c-1.23-.93-.44-1.65.42-1.8Z",
    fill: "#91AEF1"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "m17.1 43.61 34.5-6.37a6.4 6.4 0 0 1 3.49.27l14.81 5.78c1.07.42 2.07 1.7-.13 2.26L33.47 55a6.3 6.3 0 0 1-5.39-1.07L16.7 45.38c-1.22-.91-.44-1.61.4-1.77Z",
    fill: "#92AEF2"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "m17.69 43.5 33.9-6.26c1.05-.2 2.27-.2 3.49.26l14.56 5.69c1.04.4 2.03 1.66-.13 2.22l-35.73 9.3a6.2 6.2 0 0 1-5.3-1.06l-11.2-8.4c-1.2-.9-.42-1.6.4-1.75Z",
    fill: "#93AFF2"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "m18.26 43.4 33.32-6.16c1.04-.2 2.26-.21 3.5.26l14.3 5.58c1.02.4 1.99 1.63-.14 2.19L34.1 54.4a6.1 6.1 0 0 1-5.21-1.03L17.87 45.1c-1.18-.88-.42-1.56.4-1.72Z",
    fill: "#94B0F2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "m18.84 43.3 32.73-6.06a6.42 6.42 0 0 1 3.5.26l14.04 5.48c1.01.4 1.96 1.6-.13 2.15l-34.56 9a6 6 0 0 1-5.13-1.02l-10.84-8.13c-1.15-.87-.4-1.54.4-1.69Z",
    fill: "#95B1F2"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m19.42 43.18 32.14-5.94a6.42 6.42 0 0 1 3.5.26l13.78 5.38c1 .39 1.93 1.58-.12 2.1l-33.99 8.85a5.9 5.9 0 0 1-5.04-1l-10.65-7.99c-1.14-.86-.4-1.51.38-1.66Z",
    fill: "#96B1F2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "m20 43.08 31.55-5.83a6.42 6.42 0 0 1 3.51.25l13.52 5.27c.98.39 1.9 1.56-.12 2.08l-33.4 8.7a5.8 5.8 0 0 1-4.96-1l-10.47-7.84c-1.12-.85-.4-1.5.37-1.63Z",
    fill: "#97B2F2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "m20.58 42.97 30.96-5.72c1-.2 2.24-.24 3.51.24l13.26 5.18c.96.37 1.87 1.52-.12 2.04l-32.83 8.54a5.7 5.7 0 0 1-4.86-.97l-10.3-7.71c-1.09-.82-.38-1.46.38-1.6Z",
    fill: "#98B3F2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "m21.16 42.86 30.37-5.6c1-.2 2.24-.25 3.52.23l13 5.07c.94.37 1.83 1.5-.12 2l-32.25 8.4A5.6 5.6 0 0 1 30.9 52l-10.1-7.57c-1.08-.82-.39-1.44.36-1.58Z",
    fill: "#99B3F2"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "m21.74 42.76 29.78-5.5c1-.2 2.23-.26 3.52.23l12.74 4.97c.93.36 1.8 1.47-.11 1.97L36 52.67a5.5 5.5 0 0 1-4.7-.93l-9.92-7.44c-1.06-.8-.38-1.4.36-1.54Z",
    fill: "#9AB4F3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "m22.32 42.65 29.19-5.4a6.46 6.46 0 0 1 3.53.24l12.48 4.86c.91.36 1.77 1.45-.11 1.94l-31.1 8.09a5.4 5.4 0 0 1-4.6-.92l-9.74-7.3c-1.04-.78-.37-1.38.35-1.51Z",
    fill: "#9BB5F3"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m22.9 42.54 28.6-5.28a6.46 6.46 0 0 1 3.54.22l12.21 4.77c.9.35 1.74 1.42-.1 1.9l-30.52 7.94a5.3 5.3 0 0 1-4.52-.9l-9.56-7.16c-1.02-.77-.36-1.36.35-1.49Z",
    fill: "#9CB6F3"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m23.48 42.43 28-5.17a6.48 6.48 0 0 1 3.55.22L67 42.14c.88.35 1.7 1.4-.1 1.87l-29.94 7.78a5.2 5.2 0 0 1-4.44-.88l-9.37-7.01c-1-.76-.36-1.34.34-1.47Z",
    fill: "#9DB6F3"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m24.05 42.33 27.43-5.07a6.47 6.47 0 0 1 3.54.22l11.7 4.56c.86.34 1.67 1.37-.1 1.83L37.27 51.5c-1.5.4-3.1.08-4.35-.86l-9.2-6.88c-.98-.74-.35-1.3.33-1.43Z",
    fill: "#9EB7F3"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m24.63 42.22 26.84-4.96a6.47 6.47 0 0 1 3.55.22l11.44 4.46c.84.32 1.64 1.33-.1 1.78l-28.78 7.5a5 5 0 0 1-4.26-.85l-9-6.75c-.97-.72-.35-1.28.31-1.4Z",
    fill: "#9EB8F3"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m25.21 42.11 26.25-4.84c.95-.19 2.2-.3 3.55.2l11.18 4.36c.83.33 1.6 1.32-.1 1.76L37.9 50.92a4.9 4.9 0 0 1-4.18-.83l-8.83-6.6c-.94-.71-.33-1.26.32-1.38Z",
    fill: "#9FB8F3"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8 42 25.65-4.73c.94-.18 2.2-.3 3.56.2l10.92 4.26c.81.32 1.57 1.28-.1 1.72l-27.61 7.18a4.8 4.8 0 0 1-4.1-.81l-8.64-6.47c-.92-.7-.33-1.23.31-1.34Z",
    fill: "#A0B9F3"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m26.37 41.9 25.07-4.63a6.5 6.5 0 0 1 3.56.2l10.66 4.15c.8.31 1.54 1.26-.1 1.68l-27.03 7.04a4.7 4.7 0 0 1-4-.8l-8.46-6.32c-.9-.68-.33-1.2.3-1.32Z",
    fill: "#A1BAF3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "m26.95 41.8 24.48-4.53c.93-.18 2.19-.31 3.57.2l10.4 4.05c.77.3 1.5 1.23-.1 1.65l-26.45 6.88a4.6 4.6 0 0 1-3.92-.78l-8.28-6.19c-.88-.66-.32-1.18.3-1.29Z",
    fill: "#A2BBF4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "m27.53 41.69 23.89-4.41c.92-.18 2.19-.33 3.57.19l10.14 3.95c.76.3 1.47 1.2-.09 1.6l-25.87 6.74a4.5 4.5 0 0 1-3.84-.76l-8.1-6.05c-.86-.65-.3-1.16.3-1.26Z",
    fill: "#A3BBF4"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "m28.1 41.58 23.3-4.3a6.47 6.47 0 0 1 3.59.19l9.88 3.84c.74.3 1.44 1.18-.09 1.57l-25.3 6.59a4.4 4.4 0 0 1-3.75-.75l-7.9-5.9c-.86-.64-.31-1.13.28-1.24Z",
    fill: "#A4BCF4"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m28.69 41.47 22.7-4.2c.91-.17 2.19-.33 3.59.19l9.62 3.74c.73.29 1.4 1.15-.08 1.54L39.8 49.17a4.3 4.3 0 0 1-3.67-.73l-7.72-5.77c-.83-.62-.3-1.1.28-1.2Z",
    fill: "#A5BDF4"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m29.26 41.36 22.12-4.08c.9-.18 2.18-.34 3.6.18l9.36 3.64c.7.28 1.37 1.13-.09 1.5l-24.13 6.28a4.2 4.2 0 0 1-3.58-.7l-7.55-5.64c-.8-.6-.29-1.07.27-1.18Z",
    fill: "#A6BDF4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "m29.84 41.26 21.53-3.98c.9-.17 2.17-.35 3.6.18l9.1 3.54c.7.27 1.35 1.1-.08 1.46L40.43 48.6a4.1 4.1 0 0 1-3.5-.69l-7.35-5.5c-.8-.59-.28-1.04.26-1.14Z",
    fill: "#A7BEF4"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "m30.42 41.15 20.94-3.86a6.46 6.46 0 0 1 3.6.16l8.85 3.45c.67.26 1.3 1.07-.08 1.42L40.75 48.3c-1.18.3-2.43.06-3.4-.67l-7.18-5.36c-.78-.58-.28-1.02.25-1.12Z",
    fill: "#A8BFF4"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "m31 41.04 20.35-3.75a6.45 6.45 0 0 1 3.61.16l8.59 3.34c.65.26 1.27 1.05-.08 1.4L41.07 48a3.9 3.9 0 0 1-3.32-.66l-7-5.21c-.75-.57-.27-1 .25-1.1Z",
    fill: "#A9C0F4"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "m31.58 40.94 19.76-3.65a6.44 6.44 0 0 1 3.61.16l8.33 3.24c.64.25 1.24 1.02-.08 1.36l-21.82 5.67c-1.11.3-2.3.06-3.23-.64l-6.81-5.07c-.74-.56-.27-.98.24-1.07Z",
    fill: "#AAC0F5"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "m32.16 40.83 19.17-3.53a6.45 6.45 0 0 1 3.62.15l8.07 3.14c.62.24 1.2.98-.08 1.32L41.7 47.43a3.69 3.69 0 0 1-3.15-.62l-6.63-4.94c-.71-.54-.26-.95.24-1.04Z",
    fill: "#ABC1F5"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "m32.74 40.72 18.58-3.42a6.46 6.46 0 0 1 3.63.15l7.8 3.03c.6.24 1.18.96-.07 1.28l-20.66 5.38a3.6 3.6 0 0 1-3.07-.6l-6.44-4.81c-.7-.52-.25-.92.23-1Z",
    fill: "#ACC2F5"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m33.32 40.62 18-3.32c.84-.17 2.14-.4 3.62.15l7.55 2.93c.59.23 1.14.93-.08 1.25l-20.08 5.22a3.49 3.49 0 0 1-2.97-.59l-6.27-4.66c-.67-.51-.24-.9.23-.98Z",
    fill: "#ADC3F5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m33.9 40.5 17.4-3.2c.84-.17 2.14-.4 3.63.14l7.29 2.83c.57.22 1.11.9-.07 1.21l-19.5 5.08c-1 .26-2.07.05-2.9-.58l-6.08-4.52c-.65-.5-.23-.87.22-.95Z",
    fill: "#AEC3F5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "m34.47 40.4 16.82-3.1c.84-.17 2.14-.4 3.64.14l7.02 2.73c.56.21 1.08.88-.06 1.17l-18.92 4.93c-.98.25-2 .05-2.81-.56l-5.9-4.38c-.63-.48-.22-.85.21-.93Z",
    fill: "#AFC4F5"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m35.05 40.3 16.23-3a6.39 6.39 0 0 1 3.64.14l6.77 2.63c.54.2 1.04.85-.07 1.14l-18.34 4.77c-.94.25-1.94.05-2.72-.54l-5.72-4.25c-.6-.46-.21-.82.21-.9Z",
    fill: "#B0C5F5"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m35.63 40.19 15.64-2.88a6.42 6.42 0 0 1 3.65.13l6.5 2.52c.52.2 1.01.83-.06 1.1L43.6 45.68c-.91.24-1.88.05-2.64-.52l-5.53-4.1c-.6-.45-.21-.8.2-.87Z",
    fill: "#B1C5F5"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2 40.08 15.06-2.77a6.4 6.4 0 0 1 3.65.12l6.25 2.42c.5.2.98.8-.06 1.07L43.9 45.4c-.88.23-1.81.05-2.54-.5l-5.35-3.97c-.58-.43-.2-.77.19-.84Z",
    fill: "#B2C6F6"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m36.79 39.97 14.46-2.66c.8-.16 2.12-.44 3.66.12l5.99 2.32c.48.2.94.77-.06 1.03l-16.6 4.32a2.9 2.9 0 0 1-2.47-.49l-5.17-3.83c-.55-.41-.2-.74.19-.8Z",
    fill: "#B3C7F6"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "m37.37 39.86 13.87-2.55c.8-.16 2.11-.44 3.66.12l5.73 2.21c.47.19.91.75-.06 1L44.55 44.8c-.83.21-1.7.04-2.38-.47l-4.99-3.7c-.53-.4-.18-.7.19-.78Z",
    fill: "#B4C8F6"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m37.95 39.76 13.28-2.45c.8-.16 2.11-.45 3.67.12l5.47 2.11c.45.18.88.72-.06.96l-15.44 4.02c-.8.2-1.64.04-2.3-.46l-4.8-3.55c-.51-.39-.18-.69.18-.75Z",
    fill: "#B5C8F6"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "m38.52 39.65 12.7-2.33c.78-.16 2.1-.46 3.67.1l5.21 2.02c.44.17.85.69-.05.92l-14.87 3.87c-.76.2-1.57.04-2.2-.44l-4.62-3.41c-.5-.38-.18-.67.16-.73Z",
    fill: "#B6C9F6"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "m51.05 40.62 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.18-.08.28l1.32.55c.26.1.7.15.99.1Z",
    fill: "#7791BC"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "m51.05 40.61 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.18-.08.28l1.32.55c.25.1.7.15.99.1Z",
    fill: "#7892BD"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m51.05 40.6 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.18-.08.28l1.32.55c.25.1.7.15.99.1Z",
    fill: "#7993BE"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "m51.05 40.6 2.71-.53c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.55c.25.1.7.15.99.1Z",
    fill: "#7A94BF"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "m51.05 40.58 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.18-.08.28l1.32.55c.25.1.7.15.99.1Z",
    fill: "#7B95C0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.57 2.72-.52c.28-.05.3-.18.04-.28l-1.33-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.33.18-.08.28l1.32.55c.25.1.7.15.98.1Z",
    fill: "#7C96C0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.56 2.71-.52c.28-.05.3-.18.05-.28l-1.33-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.3.05-.33.18-.08.28l1.31.55c.26.1.7.15 1 .1Z",
    fill: "#7D96C1"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.55 2.71-.52c.28-.05.3-.18.05-.28l-1.33-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.3.05-.33.18-.08.28l1.31.55c.26.1.7.15 1 .1Z",
    fill: "#7E97C2"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.54 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.17-.07.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#7F98C3"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.53 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.17-.07.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#8099C4"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.52 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.55c.25.1.7.15.99.1Z",
    fill: "#819AC5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.51 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.1l-2.7.5c-.29.06-.32.18-.08.29l1.32.55c.25.1.7.14.99.1Z",
    fill: "#829BC6"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.5 2.7-.52c.29-.05.3-.18.05-.28l-1.33-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.33.18-.08.28l1.32.55c.25.1.7.14.99.1Z",
    fill: "#839CC7"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m51.04 40.5 2.7-.53c.29-.05.3-.18.05-.28l-1.33-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.33.18-.08.28l1.32.55c.25.1.7.15.99.1Z",
    fill: "#849DC7"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.48 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.3.05-.33.18-.08.28l1.31.55c.26.1.7.14 1 .1Z",
    fill: "#859EC8"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.47 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.29.05-.33.17-.08.28l1.32.55c.25.1.7.14.98.09Z",
    fill: "#869FC9"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.46 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.28.05-.32.18-.07.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#87A0CA"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.45 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.28.05-.32.18-.07.28l1.31.55c.26.1.7.14.99.1Z",
    fill: "#88A0CB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.44 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.28.05-.32.18-.07.28l1.31.55c.26.1.7.14.99.09Z",
    fill: "#89A1CC"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.43 2.7-.52c.29-.05.3-.18.05-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.28.05-.32.18-.07.28l1.31.55c.25.1.7.14.99.09Z",
    fill: "#8AA2CD"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.42 2.7-.52c.29-.05.3-.18.05-.28l-1.33-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.55c.25.1.7.14.99.09Z",
    fill: "#8BA3CE"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.4 2.7-.51c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.55c.25.1.7.14.99.09Z",
    fill: "#8CA4CE"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m51.03 40.4 2.7-.52c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.68-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.31.54c.26.11.7.15 1 .1Z",
    fill: "#8DA5CF"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.38 2.71-.51c.28-.06.3-.18.04-.29l-1.32-.53c-.25-.1-.68-.13-.96-.08l-2.7.5c-.28.04-.32.17-.07.27l1.31.55c.26.11.7.15 1 .1Z",
    fill: "#8EA6D0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.38 2.71-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.28.05-.32.17-.07.28l1.31.55c.26.1.7.14 1 .09Z",
    fill: "#8FA7D1"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.37 2.71-.52c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.68-.14-.96-.1l-2.7.5c-.28.05-.32.18-.07.28l1.3.55c.27.11.71.15 1 .1Z",
    fill: "#90A8D2"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.36 2.71-.52c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.68-.14-.96-.1l-2.7.5c-.28.05-.32.18-.07.28l1.3.55c.27.11.71.15 1 .1Z",
    fill: "#91A9D3"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.35 2.7-.52c.29-.05.3-.18.05-.28l-1.33-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.55c.26.1.7.14.99.09Z",
    fill: "#92AAD4"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.34 2.7-.52c.29-.06.3-.18.05-.28L52.44 39c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.55c.25.1.7.14.99.09Z",
    fill: "#93AAD5"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m51.01 40.33 2.71-.52c.28-.06.3-.18.04-.28L52.44 39c-.25-.1-.68-.14-.95-.09l-2.7.5c-.29.05-.33.17-.08.28l1.31.55c.26.1.7.14 1 .09Z",
    fill: "#94ABD6"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m51.02 40.32 2.7-.52c.28-.06.3-.18.04-.28l-1.32-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.28.05-.32.17-.08.28l1.32.55c.25.1.7.14.99.09Z",
    fill: "#95ACD6"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m51.01 40.3 2.71-.51c.28-.06.3-.18.04-.28l-1.32-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.28.05-.32.17-.08.28l1.32.54c.25.1.7.15.98.1Z",
    fill: "#96ADD7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "m51.01 40.3 2.71-.52c.28-.06.3-.18.04-.28l-1.32-.53c-.25-.1-.67-.14-.95-.09l-2.7.5c-.28.05-.32.17-.08.28l1.32.55c.25.1.7.14.98.09Z",
    fill: "#97AED8"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m51.01 40.28 2.7-.51c.29-.06.3-.18.05-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.69.5c-.29.05-.33.17-.08.28l1.31.55c.26.1.7.14.99.08Z",
    fill: "#98AFD9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m51.01 40.27 2.7-.51c.29-.06.3-.18.05-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.69.5c-.29.05-.33.17-.08.28l1.31.55c.26.1.7.14.99.08Z",
    fill: "#98B0DA"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m51.01 40.27 2.7-.52c.29-.06.3-.18.05-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.7.5c-.28.05-.32.17-.07.28l1.31.55c.26.1.7.14.99.09Z",
    fill: "#99B1DB"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.25 2.71-.51c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.67-.14-.95-.1l-2.7.5c-.28.06-.32.18-.07.29l1.3.54c.27.1.7.15 1 .1Z",
    fill: "#9AB2DC"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.24 2.71-.51c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.67-.14-.95-.1l-2.7.5c-.28.06-.32.18-.07.29l1.3.54c.26.1.7.15 1 .1Z",
    fill: "#9BB3DD"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.23 2.71-.51c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.54c.25.1.7.15.98.1Z",
    fill: "#9CB4DD"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.22 2.71-.51c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.7.5c-.29.05-.32.17-.08.28l1.32.54c.25.1.7.15.98.1Z",
    fill: "#9DB5DE"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.21 2.7-.51c.29-.06.3-.18.05-.28l-1.32-.53c-.25-.1-.68-.14-.96-.09l-2.69.5c-.29.05-.33.17-.08.28l1.31.54c.26.11.7.15 1 .1Z",
    fill: "#9EB5DF"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.2 2.7-.52c.29-.05.3-.17.05-.28l-1.32-.52c-.25-.1-.68-.14-.96-.1l-2.69.5c-.29.05-.33.18-.08.28l1.31.55c.26.1.7.15 1 .1Z",
    fill: "#9FB6E0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.2 2.7-.53c.29-.05.3-.17.05-.28l-1.32-.52c-.25-.1-.68-.14-.96-.1l-2.69.5c-.29.05-.33.18-.08.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#A0B7E1"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.18 2.7-.52c.29-.05.3-.17.05-.28l-1.32-.52c-.25-.1-.68-.14-.96-.1l-2.69.5c-.29.05-.32.18-.08.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#A1B8E2"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.17 2.7-.52c.28-.05.3-.17.04-.28l-1.32-.52c-.25-.1-.67-.14-.95-.1l-2.7.5c-.28.06-.32.18-.07.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#A2B9E3"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.16 2.7-.51c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.67-.14-.95-.1l-2.7.5c-.28.06-.32.18-.07.28l1.31.55c.26.1.7.15.99.1Z",
    fill: "#A3BAE4"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.15 2.7-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.25-.1-.67-.13-.95-.08l-2.7.49c-.28.05-.32.18-.07.28l1.31.55c.25.1.7.15.98.1Z",
    fill: "#A4BBE5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.14 2.7-.51c.28-.06.3-.18.04-.29l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.7.5c-.28.05-.32.17-.07.27l1.31.55c.25.1.7.15.98.1Z",
    fill: "#A5BCE5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.13 2.7-.51c.28-.06.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.28.05-.32.17-.07.28l1.3.54c.26.1.7.15 1 .1Z",
    fill: "#A6BDE6"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "m51 40.12 2.7-.51c.28-.06.3-.18.04-.28l-1.32-.53c-.25-.1-.68-.14-.95-.09l-2.7.5c-.28.05-.32.17-.07.27l1.3.55c.26.1.7.15 1 .1Z",
    fill: "#A7BEE7"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "m50.99 40.11 2.7-.52c.28-.05.3-.17.04-.28l-1.32-.52c-.25-.1-.67-.14-.95-.1l-2.69.5c-.29.05-.32.18-.08.28l1.31.55c.26.1.7.15.99.09Z",
    fill: "#A8BFE8"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "m50.99 40.1 2.7-.51c.28-.06.3-.18.04-.28l-1.32-.53c-.25-.1-.67-.14-.95-.09l-2.69.5c-.29.05-.32.17-.08.27l1.31.55c.26.1.7.15.99.1Z",
    fill: "#A9BFE9"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "m50.99 40.09 2.7-.52c.28-.05.3-.17.04-.28l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.7.5c-.28.04-.32.17-.07.27l1.3.55c.27.1.71.15 1 .09Z",
    fill: "#AAC0EA"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "m50.99 40.08 2.7-.52c.28-.05.3-.17.04-.28l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.69.5c-.29.04-.32.17-.08.27L50 40c.26.1.7.15.99.09Z",
    fill: "#ABC1EB"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "m50.99 40.07 2.7-.52c.28-.05.3-.17.04-.28l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.7.5c-.28.05-.32.17-.07.27l1.3.55c.26.1.7.15 1 .1Z",
    fill: "#ACC2EC"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40.06 2.7-.52c.29-.05.3-.17.05-.28l-1.32-.52c-.25-.1-.68-.14-.95-.09l-2.7.5c-.28.05-.32.17-.07.27l1.3.55c.26.1.7.15 1 .1Z",
    fill: "#ADC3EC"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40.05 2.7-.52c.29-.05.3-.18.05-.28l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.7.49c-.28.05-.32.18-.07.28l1.3.55c.26.1.7.15 1 .09Z",
    fill: "#AEC4ED"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40.04 2.7-.52c.29-.05.3-.18.05-.28l-1.32-.52c-.25-.1-.68-.14-.95-.09l-2.7.49c-.28.05-.32.18-.07.28l1.3.55c.26.1.7.15 1 .09Z",
    fill: "#AFC5EE"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40.03 2.7-.52c.29-.05.3-.17.05-.28l-1.32-.52c-.25-.1-.68-.14-.95-.09l-2.7.49c-.28.05-.32.18-.07.28l1.3.55c.26.1.7.15 1 .09Z",
    fill: "#B0C6EF"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40.02 2.7-.52c.28-.05.3-.17.04-.28l-1.31-.52c-.25-.1-.68-.14-.96-.09l-2.69.5c-.29.04-.32.17-.08.27l1.31.55c.26.1.7.15.99.09Z",
    fill: "#B1C7F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40.01 2.7-.52c.28-.05.3-.17.04-.28l-1.31-.52c-.25-.1-.68-.14-.96-.09l-2.69.5c-.29.04-.32.17-.08.27l1.31.55c.26.1.7.15.99.09Z",
    fill: "#B2C8F1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 40 2.7-.52c.28-.05.3-.18.04-.28l-1.32-.52c-.24-.1-.67-.14-.95-.1l-2.69.5c-.29.05-.32.18-.08.28l1.31.55c.26.1.7.14.99.09Z",
    fill: "#B3C9F2"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "m50.98 39.99 2.7-.52c.28-.05.3-.17.04-.28l-1.32-.52c-.24-.1-.67-.14-.95-.09l-2.69.5c-.29.05-.32.17-.08.27l1.31.55c.26.1.7.15.99.09Z",
    fill: "#B4C9F3"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "m50.97 39.98 2.7-.52c.29-.05.3-.18.05-.28l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.69.49c-.29.05-.32.18-.08.28l1.31.55c.25.1.7.14.98.09Z",
    fill: "#B5CAF3"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m50.97 39.97 2.7-.52c.29-.05.3-.18.05-.28l-1.32-.52c-.25-.1-.67-.14-.95-.09l-2.69.49c-.29.05-.32.18-.08.28l1.31.55c.25.1.7.15.98.09Z",
    fill: "#B6CBF4"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "m50.97 39.96 2.7-.52c.28-.05.3-.18.04-.28l-1.32-.53c-.24-.1-.67-.13-.95-.08l-2.69.49c-.28.05-.32.18-.07.28l1.3.55c.26.1.7.14 1 .09Z",
    fill: "#B7CCF5"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "m50.97 39.95 2.7-.52c.28-.05.3-.18.05-.28l-1.32-.52c-.25-.1-.68-.14-.95-.1l-2.7.5c-.28.05-.32.18-.07.28l1.3.55c.26.1.7.14 1 .09Z",
    fill: "#B8CDF6"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "m50.97 39.94 2.7-.52c.28-.05.3-.18.04-.28l-1.32-.52c-.24-.1-.67-.14-.95-.1l-2.69.5c-.28.05-.32.18-.07.28l1.3.55c.26.1.7.14.99.09Z",
    fill: "#B9CEF7"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.52 2.87-.56c.3-.05.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.14-.98-.09l-2.86.52c-.3.06-.36.2-.11.3l1.3.58c.24.11.7.16 1 .1Z",
    fill: "#7791BC"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.5 2.87-.55c.3-.05.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.15-.98-.1l-2.86.53c-.3.06-.36.19-.11.3l1.3.58c.24.11.7.16 1 .1Z",
    fill: "#7892BD"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.5 2.87-.56c.3-.05.33-.18.07-.3l-1.3-.55c-.26-.1-.7-.14-.99-.09l-2.85.52c-.31.06-.36.2-.12.3l1.3.58c.25.11.7.15 1.02.1Z",
    fill: "#7993BE"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.48 2.87-.55c.3-.05.33-.19.07-.3l-1.3-.55c-.26-.1-.7-.15-.99-.1l-2.85.53c-.31.06-.36.2-.12.3l1.3.58c.25.11.7.15 1.02.1Z",
    fill: "#7A94BF"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.47 2.87-.55c.3-.05.33-.19.07-.3l-1.3-.55c-.25-.1-.7-.14-.99-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.58c.25.11.7.15 1.02.1Z",
    fill: "#7B95C0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.46 2.87-.55c.3-.05.33-.19.07-.3l-1.31-.55c-.25-.1-.68-.14-.98-.09l-2.85.52c-.31.06-.36.2-.12.3l1.3.58c.25.11.7.15 1.01.1Z",
    fill: "#7C96C0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.45 2.87-.55c.3-.05.32-.19.07-.3l-1.31-.55c-.25-.1-.68-.14-.98-.09l-2.85.52c-.31.06-.36.2-.12.3l1.3.58c.25.11.7.15 1.01.1Z",
    fill: "#7D96C1"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.44 2.87-.55c.3-.05.32-.19.07-.3l-1.31-.55c-.25-.1-.68-.14-.98-.09l-2.85.52c-.31.06-.36.2-.12.3l1.3.58c.25.11.7.15 1.01.1Z",
    fill: "#7E97C2"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.43 2.86-.55c.3-.05.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.14-.98-.09l-2.86.52c-.3.06-.35.2-.11.3l1.3.58c.25.1.7.15 1.01.1Z",
    fill: "#7F98C3"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 41.42 2.86-.55c.3-.05.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.14-.98-.09l-2.86.52c-.3.06-.35.2-.11.3l1.3.58c.25.1.7.15 1.01.1Z",
    fill: "#8099C4"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "m46.39 41.41 2.87-.55c.3-.05.33-.19.08-.3l-1.32-.55c-.24-.1-.68-.14-.97-.09l-2.86.52c-.3.06-.36.2-.11.3l1.3.58c.25.1.7.15 1 .1Z",
    fill: "#819AC5"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "m46.39 41.4 2.87-.55c.3-.05.33-.19.08-.3L48.02 40c-.24-.1-.68-.14-.97-.09l-2.86.52c-.3.06-.36.2-.11.3l1.3.58c.25.1.7.15 1 .1Z",
    fill: "#829BC6"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "m46.39 41.4 2.87-.56c.3-.06.33-.19.08-.3L48.02 40c-.24-.1-.68-.15-.97-.1l-2.86.53c-.3.06-.36.2-.11.3l1.3.58c.24.1.7.15 1 .1Z",
    fill: "#839CC7"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "m46.39 41.38 2.87-.55c.3-.06.33-.19.07-.3l-1.3-.55c-.25-.1-.7-.14-.99-.1l-2.85.53c-.3.06-.36.2-.11.3l1.3.58c.24.1.7.15 1 .1Z",
    fill: "#849DC7"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "m46.39 41.37 2.87-.55c.3-.06.33-.19.07-.3l-1.3-.55c-.25-.1-.7-.14-.99-.1l-2.85.53c-.3.06-.36.2-.11.3l1.3.58c.24.1.7.15 1 .1Z",
    fill: "#859EC8"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "m46.39 41.36 2.87-.55c.3-.06.32-.19.07-.3l-1.31-.55c-.25-.1-.68-.15-.98-.1l-2.85.53c-.31.06-.36.19-.12.3l1.3.58c.25.1.7.15 1.02.1Z",
    fill: "#869FC9"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.35 2.87-.55c.3-.06.33-.2.08-.3l-1.31-.55c-.25-.1-.69-.15-.98-.1l-2.86.53c-.3.06-.35.19-.11.3l1.3.57c.25.12.7.16 1.01.1Z",
    fill: "#87A0CA"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.34 2.87-.55c.3-.06.33-.2.08-.3l-1.31-.55c-.25-.1-.69-.15-.98-.1l-2.85.53c-.31.06-.36.19-.12.3l1.3.57a2 2 0 0 0 1.01.1Z",
    fill: "#88A0CB"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.33 2.87-.55c.3-.06.33-.2.08-.3l-1.31-.55c-.25-.1-.69-.15-.98-.1l-2.85.53c-.31.06-.36.19-.12.3l1.3.58a2 2 0 0 0 1.01.09Z",
    fill: "#89A1CC"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.32 2.87-.55c.3-.06.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.15-.98-.1l-2.86.53c-.3.06-.35.2-.11.3l1.3.58c.25.1.7.15 1.01.09Z",
    fill: "#8AA2CD"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.3 2.87-.54c.3-.06.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.15-.98-.1l-2.86.53c-.3.06-.35.19-.11.3l1.3.58c.25.1.7.15 1.01.09Z",
    fill: "#8BA3CE"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.3 2.87-.55c.3-.06.33-.19.08-.3l-1.31-.55c-.25-.1-.69-.14-.98-.1l-2.86.53c-.3.06-.35.2-.11.3l1.3.58c.25.1.7.15 1.01.09Z",
    fill: "#8CA4CE"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.29 2.87-.55c.3-.06.33-.19.07-.3l-1.3-.55c-.25-.1-.7-.15-.99-.1l-2.85.53c-.3.06-.36.19-.11.3l1.3.57c.25.11.7.16 1 .1Z",
    fill: "#8DA5CF"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.28 2.87-.55c.3-.05.33-.19.07-.3l-1.3-.55c-.25-.1-.7-.14-.99-.1l-2.85.53c-.3.06-.36.2-.11.3l1.3.58c.25.1.7.15 1 .09Z",
    fill: "#8EA6D0"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.27 2.87-.55c.3-.06.33-.19.07-.3l-1.3-.55c-.25-.1-.69-.15-.98-.1l-2.86.53c-.3.06-.35.19-.11.3l1.3.57c.24.11.7.16 1 .1Z",
    fill: "#8FA7D1"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.26 2.87-.55c.3-.06.32-.2.07-.3l-1.3-.55c-.25-.1-.7-.15-.99-.1l-2.85.53c-.3.06-.36.19-.11.3l1.3.57c.24.11.7.16 1 .1Z",
    fill: "#90A8D2"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 41.25 2.87-.55c.3-.06.32-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.1l-2.86.53c-.3.06-.35.19-.11.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#91A9D3"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.24 2.87-.55c.3-.06.33-.2.08-.3L48 39.84c-.25-.1-.68-.15-.98-.1l-2.85.53c-.3.05-.36.19-.11.3l1.3.57c.24.11.7.16 1 .1Z",
    fill: "#92AAD4"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.23 2.87-.55c.3-.06.33-.19.08-.3L48 39.83c-.25-.1-.69-.15-.98-.1l-2.85.53c-.3.06-.36.19-.12.3l1.3.57c.25.11.7.16 1.01.1Z",
    fill: "#93AAD5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.22 2.87-.55c.3-.06.33-.19.08-.3L48 39.82c-.25-.1-.69-.15-.98-.1l-2.85.53c-.3.05-.36.19-.12.3l1.3.57c.25.11.7.16 1.01.1Z",
    fill: "#94ABD6"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.2 2.87-.54c.3-.06.33-.2.07-.3l-1.3-.56c-.25-.1-.69-.14-.98-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.17 1.01.1Z",
    fill: "#95ACD6"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.2 2.87-.55c.3-.06.33-.2.07-.3l-1.3-.55a2 2 0 0 0-.98-.1l-2.85.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.16 1.01.1Z",
    fill: "#96ADD7"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.18 2.87-.55c.3-.05.33-.19.07-.3l-1.3-.55c-.25-.1-.69-.14-.98-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.16 1.01.1Z",
    fill: "#97AED8"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.17 2.87-.55c.3-.05.32-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.16 1 .1Z",
    fill: "#98AFD9"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.16 2.87-.55c.3-.05.32-.18.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.16 1 .1Z",
    fill: "#98B0DA"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.15 2.87-.55c.3-.05.32-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.36.19-.12.3l1.3.57c.25.12.7.16 1 .1Z",
    fill: "#99B1DB"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.14 2.86-.55c.3-.05.33-.18.08-.3L48 39.75c-.25-.1-.68-.14-.98-.09l-2.85.52c-.3.06-.36.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#9AB2DC"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.13 2.86-.55c.3-.05.33-.18.08-.3L48 39.75c-.25-.1-.68-.15-.98-.1l-2.85.53c-.3.05-.36.18-.11.3l1.3.57c.24.1.7.15 1 .1Z",
    fill: "#9BB3DD"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37 41.12 2.86-.55c.3-.05.33-.19.08-.3L48 39.73c-.25-.1-.68-.14-.98-.09l-2.85.52c-.3.06-.36.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#9CB4DD"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.11 2.87-.55c.3-.05.33-.19.08-.3L48 39.73a2 2 0 0 0-.98-.1l-2.85.52c-.3.06-.36.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#9DB5DE"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.1 2.87-.55c.3-.05.33-.19.08-.3L48 39.72c-.25-.1-.69-.15-.98-.1l-2.85.52c-.3.06-.36.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#9EB5DF"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.1 2.87-.56c.3-.05.33-.19.08-.3L48 39.7a2 2 0 0 0-.98-.1l-2.85.52c-.3.06-.36.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#9FB6E0"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.08 2.87-.55c.3-.05.32-.19.07-.3L48 39.7a2 2 0 0 0-.98-.1l-2.85.52c-.3.06-.36.2-.12.3l1.3.58a2 2 0 0 0 1.01.1Z",
    fill: "#A0B7E1"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.07 2.87-.55c.3-.05.32-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.57a2 2 0 0 0 1.01.1Z",
    fill: "#A1B8E2"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.06 2.86-.55c.3-.05.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.84.52c-.3.06-.36.2-.12.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#A2B9E3"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.05 2.86-.55c.3-.05.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.84.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.16 1 .1Z",
    fill: "#A3BAE4"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.04 2.86-.55c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.84.52c-.3.06-.36.2-.12.3l1.3.57c.25.12.7.16 1 .1Z",
    fill: "#A4BBE5"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.03 2.86-.55c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.35.2-.11.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#A5BCE5"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41.02 2.86-.55c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.35.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#A6BDE6"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "m46.36 41 2.86-.54c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.35.2-.11.3l1.3.57c.24.12.7.16 1 .1Z",
    fill: "#A7BEE7"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 41 2.87-.55c.3-.06.33-.19.07-.3L48 39.6c-.25-.1-.68-.14-.98-.09l-2.85.52c-.3.06-.35.2-.11.3l1.3.57c.24.11.7.16 1 .1Z",
    fill: "#A8BFE8"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.99 2.87-.55c.3-.06.33-.19.07-.3L48 39.6c-.25-.1-.68-.14-.98-.09l-2.85.52c-.3.06-.35.2-.11.3l1.3.58c.24.1.7.15 1 .09Z",
    fill: "#A9BFE9"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.98 2.87-.55c.3-.06.33-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.35.2-.11.3l1.3.57c.24.11.7.15 1 .1Z",
    fill: "#AAC0EA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.97 2.87-.55c.3-.05.32-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.08l-2.85.52c-.3.05-.36.18-.11.3l1.3.57c.24.1.7.15 1 .09Z",
    fill: "#ABC1EB"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.96 2.87-.55c.3-.06.32-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.36.2-.11.3l1.3.57c.24.11.7.16 1 .1Z",
    fill: "#ACC2EC"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.95 2.86-.55c.3-.06.33-.19.08-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.36.2-.12.3l1.3.57c.25.11.7.16 1.01.1Z",
    fill: "#ADC3EC"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.94 2.86-.55c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.84.52c-.31.06-.36.2-.12.3l1.3.57c.25.11.7.15 1 .1Z",
    fill: "#AEC4ED"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.93 2.86-.55c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.84.52c-.31.06-.36.19-.12.3l1.3.57c.25.11.7.15 1 .1Z",
    fill: "#AFC5EE"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "m46.35 40.92 2.86-.55c.3-.06.33-.19.08-.3l-1.31-.55a2 2 0 0 0-.98-.09l-2.84.52c-.3.06-.36.19-.12.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#B0C6EF"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.9 2.87-.54c.3-.06.33-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.84.52c-.31.06-.36.19-.12.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#B1C7F0"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.9 2.87-.55c.3-.06.33-.19.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.84.52c-.31.06-.36.19-.12.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#B2C8F1"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.88 2.87-.54c.3-.06.33-.2.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.84.52c-.31.06-.36.19-.12.3l1.3.57c.24.11.7.15 1 .1Z",
    fill: "#B3C9F2"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.87 2.87-.54c.3-.06.32-.2.07-.3l-1.3-.55a2 2 0 0 0-.98-.1l-2.85.53c-.3.05-.35.19-.11.3l1.3.57c.24.11.7.15 1 .1Z",
    fill: "#B4C9F3"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.86 2.87-.54c.3-.06.32-.2.07-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.05-.35.19-.11.3l1.3.57c.24.11.7.15 1 .1Z",
    fill: "#B5CAF3"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.85 2.86-.55c.3-.05.33-.18.08-.3l-1.3-.54a2 2 0 0 0-.98-.1l-2.85.53c-.3.05-.35.19-.11.3l1.3.56c.24.12.7.16 1 .1Z",
    fill: "#B6CBF4"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.84 2.86-.55c.3-.05.33-.18.08-.3l-1.3-.54a2 2 0 0 0-.98-.1l-2.85.53c-.3.05-.35.19-.11.3l1.3.56c.24.12.7.16 1 .1Z",
    fill: "#B7CCF5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.83 2.86-.54c.3-.06.33-.2.08-.3l-1.3-.55a2 2 0 0 0-.98-.09l-2.85.52c-.3.06-.35.19-.11.3l1.3.57a2 2 0 0 0 1 .1Z",
    fill: "#B8CDF6"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "m46.34 40.82 2.86-.55c.3-.05.33-.18.08-.29l-1.31-.55a2 2 0 0 0-.97-.09l-2.85.52c-.3.05-.36.19-.11.3l1.29.57c.25.1.7.15 1 .1Z",
    fill: "#B9CEF7"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.46 3.05-.59c.32-.06.37-.2.12-.3l-1.3-.6a2 2 0 0 0-1-.09l-3.03.56c-.33.06-.4.2-.16.32l1.28.6c.25.12.72.16 1.04.1Z",
    fill: "#7791BC"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.45 3.05-.58c.32-.07.37-.2.12-.32l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.33.06-.4.2-.16.32l1.28.6c.25.12.72.16 1.04.1Z",
    fill: "#7892BD"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.44 3.05-.58c.32-.07.37-.2.12-.32l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.33.06-.4.2-.16.32l1.28.6c.25.12.72.16 1.04.1Z",
    fill: "#7993BE"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.43 3.05-.59c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.33.06-.4.2-.16.31l1.28.6c.25.13.71.17 1.04.1Z",
    fill: "#7A94BF"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.42 3.05-.59c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#7B95C0"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.4 3.05-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#7C96C0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.4 3.05-.59c.32-.06.37-.2.12-.3l-1.3-.6a2 2 0 0 0-1-.09l-3.03.56c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#7D96C1"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.39 3.05-.59c.32-.06.36-.2.11-.3l-1.3-.6a2 2 0 0 0-1-.09l-3.02.56c-.33.06-.4.2-.16.31l1.28.6c.25.13.71.17 1.04.1Z",
    fill: "#7E97C2"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.38 3.05-.59c.32-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.13.71.17 1.04.1Z",
    fill: "#7F98C3"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.37 3.05-.59c.32-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.12.71.17 1.04.1Z",
    fill: "#8099C4"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.35 3.05-.58c.31-.06.36-.2.11-.31l-1.3-.59a2 2 0 0 0-1-.1l-3.02.56c-.33.06-.4.2-.16.32l1.28.6c.24.12.71.17 1.04.1Z",
    fill: "#819AC5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.35 3.04-.59c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.32.05-.4.2-.15.3l1.28.61c.25.12.71.17 1.04.1Z",
    fill: "#829BC6"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.33 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.59a2 2 0 0 0-1-.09l-3.03.55c-.32.06-.4.2-.15.32l1.28.6c.24.12.71.17 1.04.1Z",
    fill: "#839CC7"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.32 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.32.05-.4.2-.15.31l1.28.6a2 2 0 0 0 1.04.1Z",
    fill: "#849DC7"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.31 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.56c-.33.05-.4.2-.16.31l1.28.6c.24.12.7.17 1.04.1Z",
    fill: "#859EC8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 42.3 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.56c-.33.05-.4.2-.16.31l1.28.6c.24.12.7.17 1.04.1Z",
    fill: "#869FC9"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.3 3.05-.6c.31-.05.37-.2.12-.3l-1.3-.59a2 2 0 0 0-1-.1l-3.03.56c-.32.06-.4.2-.15.32l1.28.6c.24.12.71.16 1.03.1Z",
    fill: "#87A0CA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.28 3.05-.58c.31-.07.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.03.55c-.32.06-.4.2-.15.32l1.28.6c.24.12.71.16 1.03.1Z",
    fill: "#88A0CB"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.27 3.05-.58c.31-.06.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.03.55c-.32.06-.4.2-.15.32l1.28.6c.24.12.7.16 1.03.1Z",
    fill: "#89A1CC"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.26 3.05-.59c.31-.06.37-.2.12-.3l-1.3-.59a2 2 0 0 0-1-.1l-3.03.56c-.32.06-.39.2-.15.32l1.28.6c.24.12.7.16 1.03.1Z",
    fill: "#8AA2CD"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.25 3.05-.58c.31-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.03.56c-.32.05-.39.2-.15.3l1.28.61c.24.12.7.16 1.03.1Z",
    fill: "#8BA3CE"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.24 3.05-.58c.31-.07.36-.2.11-.32l-1.3-.58a2 2 0 0 0-1-.09l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.12.72.16 1.04.1Z",
    fill: "#8CA4CE"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.23 3.05-.58c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.56c-.33.05-.4.2-.16.31l1.28.6c.25.12.72.16 1.04.1Z",
    fill: "#8DA5CF"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.22 3.05-.58c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.56c-.33.05-.4.2-.16.31l1.28.6c.25.12.71.16 1.04.1Z",
    fill: "#8EA6D0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.2 3.05-.58c.31-.06.36-.2.11-.3l-1.3-.59a2 2 0 0 0-1-.1l-3.02.56c-.33.06-.4.2-.16.32l1.28.6a2 2 0 0 0 1.04.1Z",
    fill: "#8FA7D1"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.2 3.04-.58c.32-.07.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.12.71.16 1.04.1Z",
    fill: "#90A8D2"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.19 3.04-.58c.32-.06.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.12.71.16 1.04.1Z",
    fill: "#91A9D3"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.18 3.04-.58c.32-.06.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.12.71.16 1.04.1Z",
    fill: "#92AAD4"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.17 3.04-.59c.32-.06.37-.2.12-.3l-1.3-.59a2 2 0 0 0-1-.1l-3.02.56c-.33.06-.4.2-.16.32l1.28.6c.25.11.71.16 1.04.1Z",
    fill: "#93AAD5"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.16 3.04-.58c.32-.07.37-.2.12-.32l-1.3-.58a2 2 0 0 0-1-.09l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.11.71.16 1.04.1Z",
    fill: "#94ABD6"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.15 3.04-.58c.31-.07.37-.2.12-.32l-1.3-.58a2 2 0 0 0-1-.09l-3.02.55c-.33.06-.4.2-.16.32l1.28.6c.25.12.71.16 1.04.1Z",
    fill: "#95ACD6"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.14 3.04-.59c.31-.06.36-.2.12-.3l-1.3-.59a2 2 0 0 0-1-.1l-3.02.56c-.33.06-.4.2-.15.31l1.27.6a2 2 0 0 0 1.04.1Z",
    fill: "#96ADD7"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.12 3.04-.58c.31-.06.36-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.56c-.33.06-.4.2-.15.31l1.27.6c.24.12.7.17 1.04.1Z",
    fill: "#97AED8"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.11 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.02.56c-.32.05-.4.2-.16.3l1.28.61c.24.12.71.17 1.04.1Z",
    fill: "#98AFD9"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.1 3.05-.58c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.05-.4.2-.16.3l1.28.61c.24.12.7.17 1.03.1Z",
    fill: "#98B0DA"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.1 3.05-.59c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.3l1.28.61c.24.12.7.17 1.03.1Z",
    fill: "#99B1DB"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.08 3.05-.58c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.32l1.28.6c.24.12.7.16 1.03.1Z",
    fill: "#9AB2DC"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.07 3.05-.58c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.3l1.28.61c.24.12.7.16 1.03.1Z",
    fill: "#9BB3DD"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 42.06 3.04-.58c.31-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.32.05-.4.2-.16.3l1.28.6c.24.13.7.17 1.04.11Z",
    fill: "#9CB4DD"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.05 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.3l1.28.61c.24.12.7.16 1.03.1Z",
    fill: "#9DB5DE"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.04 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.32l1.28.6c.24.12.7.16 1.03.1Z",
    fill: "#9EB5DF"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.03 3.04-.58c.32-.06.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.31l1.28.6c.24.13.7.17 1.03.1Z",
    fill: "#9FB6E0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42.02 3.04-.58c.32-.06.37-.2.12-.32l-1.3-.57a2 2 0 0 0-1-.1L39.3 41c-.33.06-.4.2-.16.31l1.28.6c.24.13.7.17 1.03.1Z",
    fill: "#A0B7E1"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42 3.04-.57c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1L39.3 41c-.33.06-.4.2-.16.31l1.28.6c.24.13.7.17 1.03.1Z",
    fill: "#A1B8E2"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 42 3.04-.58c.31-.06.36-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.02.55c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#A2B9E3"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.99 3.04-.58c.31-.06.36-.2.12-.32l-1.3-.58a2 2 0 0 0-1-.09l-3.02.55c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#A3BAE4"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.98 3.04-.58c.31-.06.36-.2.11-.32l-1.29-.58a2 2 0 0 0-1-.09l-3.02.55c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#A4BBE5"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.97 3.04-.58c.31-.06.36-.2.11-.32l-1.29-.58a2 2 0 0 0-1-.09l-3.02.55c-.32.06-.4.2-.15.31l1.27.6c.25.13.71.17 1.04.1Z",
    fill: "#A5BCE5"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.95 3.04-.58c.3-.06.36-.2.11-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.3l1.28.61c.24.12.71.17 1.04.1Z",
    fill: "#A6BDE6"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.95 3.04-.58c.3-.06.36-.2.11-.32l-1.3-.57a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.31l1.28.6c.24.12.71.17 1.04.1Z",
    fill: "#A7BEE7"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.93 3.04-.58c.31-.05.36-.2.11-.3l-1.3-.59a2 2 0 0 0-1-.1l-3 .56c-.33.06-.4.2-.16.31l1.27.6c.25.12.71.17 1.04.1Z",
    fill: "#A8BFE8"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.92 3.04-.58c.31-.05.36-.2.11-.3l-1.3-.58a2 2 0 0 0-1-.1l-3 .55c-.33.06-.4.2-.16.31l1.27.6a2 2 0 0 0 1.04.1Z",
    fill: "#A9BFE9"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "m41.44 41.91 3.04-.58c.31-.05.36-.2.11-.3l-1.3-.58a2 2 0 0 0-1-.1l-3 .55c-.33.06-.4.2-.16.31l1.27.6a2 2 0 0 0 1.04.1Z",
    fill: "#AAC0EA"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.9 3.04-.58c.32-.05.37-.2.12-.3l-1.3-.58a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.31l1.28.6a2 2 0 0 0 1.03.1Z",
    fill: "#ABC1EB"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.9 3.04-.59c.32-.06.37-.2.12-.3l-1.3-.59a2 2 0 0 0-1-.09l-3.01.55c-.33.06-.4.2-.16.31l1.28.6a2 2 0 0 0 1.03.1Z",
    fill: "#ACC2EC"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.88 3.04-.58c.32-.06.37-.2.12-.3l-1.3-.59a2 2 0 0 0-1-.09l-3.01.55c-.33.06-.4.2-.16.31l1.28.6a2 2 0 0 0 1.03.1Z",
    fill: "#ADC3EC"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.87 3.04-.58c.32-.06.37-.2.12-.31l-1.3-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.3l1.28.61c.24.12.7.16 1.03.1Z",
    fill: "#AEC4ED"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.86 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.02.56c-.32.06-.4.2-.15.31l1.27.6a2 2 0 0 0 1.04.1Z",
    fill: "#AFC5EE"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.85 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.31l1.27.6a2 2 0 0 0 1.04.1Z",
    fill: "#B0C6EF"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.84 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.31l1.27.6c.25.12.72.16 1.04.1Z",
    fill: "#B1C7F0"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.83 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.31l1.27.6c.25.12.72.16 1.04.1Z",
    fill: "#B2C8F1"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.82 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.32l1.27.6c.25.12.71.16 1.04.1Z",
    fill: "#B3C9F2"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.81 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.56c-.33.06-.4.2-.16.3l1.27.61c.25.12.71.16 1.04.1Z",
    fill: "#B4C9F3"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.8 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.32l1.27.6c.25.12.71.16 1.04.1Z",
    fill: "#B5CAF3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.79 3.04-.58c.31-.06.36-.2.11-.31l-1.29-.58a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.31l1.27.6c.25.12.71.17 1.04.1Z",
    fill: "#B6CBF4"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.77 3.04-.57c.31-.06.36-.2.11-.32l-1.29-.57a2 2 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.31l1.27.6c.25.12.71.17 1.04.1Z",
    fill: "#B7CCF5"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.77 3.04-.58c.3-.06.36-.2.11-.31l-1.29-.58a1.98 1.98 0 0 0-1-.1l-3.01.55c-.33.06-.4.2-.16.32l1.28.6c.24.12.7.16 1.03.1Z",
    fill: "#B8CDF6"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "m41.43 41.76 3.03-.58c.32-.06.37-.2.12-.32l-1.3-.57a1.99 1.99 0 0 0-.99-.1l-3.01.55c-.33.06-.4.2-.16.31l1.27.6c.25.12.71.17 1.04.1Z",
    fill: "#B9CEF7"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.47 3.24-.62c.34-.07.4-.22.16-.33l-1.27-.61c-.24-.12-.7-.16-1.04-.1l-3.21.59c-.35.06-.44.21-.2.33l1.25.64a2 2 0 0 0 1.07.1Z",
    fill: "#7791BC"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.46 3.24-.62c.33-.07.4-.21.16-.33l-1.28-.61c-.24-.12-.7-.16-1.03-.1l-3.22.6c-.34.05-.43.2-.2.32l1.25.64a2 2 0 0 0 1.08.1Z",
    fill: "#7892BD"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.45 3.24-.63c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.22.59c-.34.06-.43.2-.2.33l1.25.64c.25.12.73.16 1.08.1Z",
    fill: "#7993BE"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.44 3.24-.63c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.64a2 2 0 0 0 1.07.1Z",
    fill: "#7A94BF"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.43 3.24-.63c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.17-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.64a2 2 0 0 0 1.07.1Z",
    fill: "#7B95C0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.42 3.24-.63c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.64a2 2 0 0 0 1.07.1Z",
    fill: "#7C96C0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.4 3.24-.62c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.64a2 2 0 0 0 1.07.1Z",
    fill: "#7D96C1"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.4 3.24-.63c.33-.06.4-.21.16-.33l-1.28-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.22-.2.34l1.25.63a2 2 0 0 0 1.07.1Z",
    fill: "#7E97C2"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.38 3.24-.62c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.63a2 2 0 0 0 1.07.1Z",
    fill: "#7F98C3"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.37 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.22.59c-.34.06-.43.2-.2.33l1.25.63c.25.12.73.17 1.08.1Z",
    fill: "#8099C4"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.36 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.22.58c-.34.07-.43.22-.2.34l1.25.63c.25.12.73.17 1.08.1Z",
    fill: "#819AC5"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.35 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.22.59c-.34.06-.43.2-.2.33l1.25.63c.25.12.73.17 1.08.1Z",
    fill: "#829BC6"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.34 3.24-.62c.33-.07.4-.21.15-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.22.6c-.34.06-.43.2-.2.32l1.25.64a2 2 0 0 0 1.08.1Z",
    fill: "#839CC7"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.33 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.22.6c-.34.06-.43.2-.2.32l1.25.64c.25.12.73.17 1.08.1Z",
    fill: "#849DC7"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.32 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.22.6c-.34.06-.43.2-.2.32l1.25.64c.25.12.73.17 1.08.1Z",
    fill: "#859EC8"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.31 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.22.6c-.34.06-.43.2-.2.32l1.25.64c.25.12.73.17 1.08.1Z",
    fill: "#869FC9"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.3 3.24-.62c.33-.07.4-.21.15-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.21-.2.33l1.25.63c.24.13.72.17 1.07.1Z",
    fill: "#87A0CA"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.29 3.24-.62c.33-.07.4-.22.15-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.35.06-.45.2-.21.33l1.25.63c.24.13.72.18 1.07.1Z",
    fill: "#88A0CB"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.27 3.24-.62c.33-.06.4-.2.15-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.58c-.35.07-.45.22-.21.33l1.25.64c.24.12.72.17 1.07.1Z",
    fill: "#89A1CC"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.26 3.24-.62c.33-.06.4-.2.15-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.35.06-.45.2-.21.32l1.25.64c.24.13.72.17 1.07.1Z",
    fill: "#8AA2CD"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.26 3.24-.63c.33-.06.4-.2.15-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.35.06-.45.2-.21.32l1.25.64c.24.13.72.17 1.07.1Z",
    fill: "#8BA3CE"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.25 3.24-.63c.33-.06.4-.2.15-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.35.06-.45.2-.21.32l1.25.64c.24.13.72.17 1.07.1Z",
    fill: "#8CA4CE"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.23 3.23-.62c.34-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.21-.2.33l1.24.64c.25.12.73.17 1.08.1Z",
    fill: "#8DA5CF"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.22 3.23-.62c.34-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.21-.2.33l1.24.64c.25.12.73.17 1.08.1Z",
    fill: "#8EA6D0"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22 43.21 3.23-.62c.34-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.21-.2.33l1.25.64c.24.12.72.17 1.07.1Z",
    fill: "#8FA7D1"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.2 3.24-.62c.33-.06.4-.21.16-.33l-1.27-.61c-.24-.11-.7-.16-1.03-.1l-3.21.6c-.35.05-.44.2-.2.32l1.25.64c.24.12.72.17 1.06.1Z",
    fill: "#90A8D2"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.2 3.24-.63c.33-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.21-.2.33l1.25.64c.24.12.72.17 1.06.1Z",
    fill: "#91A9D3"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.18 3.24-.62c.33-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.06-.44.21-.2.33l1.25.64c.24.12.72.17 1.06.1Z",
    fill: "#92AAD4"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.17 3.24-.62c.33-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.21-.2.33l1.25.64c.24.12.72.16 1.06.1Z",
    fill: "#93AAD5"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.16 3.24-.62c.33-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.21.58c-.35.07-.44.21-.2.33l1.25.64c.24.12.72.16 1.06.1Z",
    fill: "#94ABD6"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.15 3.24-.62c.33-.07.4-.22.16-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.63c.24.13.72.17 1.06.1Z",
    fill: "#95ACD6"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.14 3.24-.62c.33-.07.4-.22.16-.33l-1.27-.61c-.24-.11-.7-.16-1.03-.1l-3.21.59c-.35.06-.44.2-.2.33l1.25.64c.24.12.72.16 1.06.1Z",
    fill: "#96ADD7"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.13 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.58c-.35.07-.44.21-.2.33l1.24.64a2 2 0 0 0 1.07.1Z",
    fill: "#97AED8"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.12 3.24-.62c.33-.07.4-.21.15-.33l-1.27-.61c-.24-.11-.7-.16-1.03-.1l-3.2.59c-.35.06-.44.21-.2.33l1.24.64a2 2 0 0 0 1.07.1Z",
    fill: "#98AFD9"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.1 3.24-.61c.33-.07.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.35.06-.44.21-.2.33l1.24.64a2 2 0 0 0 1.07.1Z",
    fill: "#98B0DA"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.1 3.24-.62c.33-.07.4-.22.16-.33l-1.28-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.72.17 1.06.1Z",
    fill: "#99B1DB"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.08 3.24-.61c.33-.07.4-.22.16-.33l-1.28-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.72.17 1.06.1Z",
    fill: "#9AB2DC"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.07 3.24-.61c.33-.07.4-.22.16-.33l-1.28-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.72.17 1.06.1Z",
    fill: "#9BB3DD"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.06 3.24-.62c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.72.17 1.06.1Z",
    fill: "#9CB4DD"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.05 3.24-.62c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.72.17 1.06.1Z",
    fill: "#9DB5DE"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.04 3.24-.62c.33-.06.4-.2.16-.33l-1.28-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.72.17 1.06.1Z",
    fill: "#9EB5DF"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.03 3.24-.62c.33-.06.4-.2.15-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.35.06-.44.2-.2.33l1.24.63c.25.12.73.17 1.07.1Z",
    fill: "#9FB6E0"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43.02 3.24-.62c.33-.06.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.58c-.35.07-.44.21-.2.33l1.24.63c.25.13.73.18 1.07.1Z",
    fill: "#A0B7E1"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43 3.23-.61c.34-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.35.06-.44.21-.2.33l1.24.63c.25.13.73.17 1.07.1Z",
    fill: "#A1B8E2"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 43 3.23-.62c.34-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.35.06-.44.2-.2.33l1.24.63c.25.13.73.17 1.07.1Z",
    fill: "#A2B9E3"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.99 3.23-.62c.34-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.34.06-.44.2-.2.33l1.25.63c.24.13.72.17 1.06.1Z",
    fill: "#A3BAE4"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.98 3.23-.62c.34-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.34.06-.44.2-.2.33l1.25.63c.24.13.72.17 1.06.1Z",
    fill: "#A4BBE5"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.97 3.23-.62c.34-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.34.06-.44.2-.2.33l1.25.63c.24.13.71.17 1.06.1Z",
    fill: "#A5BCE5"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.95 3.23-.61c.34-.07.4-.21.16-.33l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.71.17 1.06.1Z",
    fill: "#A6BDE6"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.94 3.23-.62c.34-.06.4-.2.16-.32l-1.27-.61c-.24-.11-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.24.12.71.17 1.06.1Z",
    fill: "#A7BEE7"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.93 3.23-.62c.34-.06.4-.2.16-.32l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.34.06-.44.2-.2.33l1.25.63c.24.12.71.17 1.06.1Z",
    fill: "#A8BFE8"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.92 3.23-.61c.34-.07.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.34.06-.43.2-.2.33l1.25.63c.23.12.71.17 1.06.1Z",
    fill: "#A9BFE9"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.91 3.23-.62c.34-.06.4-.2.16-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.43.2-.2.33l1.25.63c.23.12.71.17 1.06.1Z",
    fill: "#AAC0EA"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.9 3.23-.62c.33-.06.4-.2.16-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.23.12.71.17 1.06.1Z",
    fill: "#ABC1EB"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.89 3.23-.62c.33-.06.4-.2.16-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.32l1.25.64c.23.12.71.17 1.06.1Z",
    fill: "#ACC2EC"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.88 3.23-.62c.33-.06.4-.2.16-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.32l1.25.64c.23.12.71.17 1.06.1Z",
    fill: "#ADC3EC"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.87 3.23-.62c.33-.06.4-.2.16-.32l-1.27-.61c-.24-.11-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.23.12.71.17 1.06.1Z",
    fill: "#AEC4ED"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.86 3.23-.62c.33-.06.4-.2.16-.32l-1.27-.61c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.23.12.71.16 1.06.1Z",
    fill: "#AFC5EE"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.85 3.23-.62c.33-.06.4-.2.16-.32l-1.27-.6c-.24-.12-.7-.17-1.03-.1l-3.2.58c-.34.06-.44.2-.2.33l1.25.63a2 2 0 0 0 1.06.1Z",
    fill: "#B0C6EF"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.84 3.23-.62c.33-.06.4-.2.16-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.58c-.34.07-.44.21-.2.33l1.25.64c.23.12.71.16 1.06.1Z",
    fill: "#B1C7F0"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.83 3.23-.62c.33-.06.4-.2.16-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63a2 2 0 0 0 1.06.1Z",
    fill: "#B2C8F1"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.82 3.23-.62c.33-.06.4-.2.16-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63a2 2 0 0 0 1.06.1Z",
    fill: "#B3C9F2"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.8 3.23-.61c.33-.06.4-.21.16-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.32l1.25.64a2 2 0 0 0 1.06.1Z",
    fill: "#B4C9F3"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "m36.21 42.8 3.23-.62c.33-.06.4-.2.16-.33l-1.27-.6c-.24-.12-.7-.16-1.03-.1l-3.2.59c-.34.06-.44.2-.2.33l1.25.63c.23.12.71.16 1.06.1Z",
    fill: "#B5CAF3"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2 42.78 3.24-.61c.33-.07.4-.21.15-.33l-1.27-.6c-.24-.12-.7-.16-1.02-.1l-3.2.58c-.35.07-.44.21-.2.33l1.24.64c.24.11.72.16 1.07.1Z",
    fill: "#B6CBF4"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2 42.77 3.24-.61c.33-.07.4-.21.15-.33l-1.27-.6c-.23-.12-.7-.16-1.02-.1l-3.2.58c-.35.07-.44.21-.2.33l1.24.63c.24.12.72.17 1.07.1Z",
    fill: "#B7CCF5"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2 42.76 3.24-.61c.33-.07.4-.21.15-.33l-1.27-.6c-.23-.12-.7-.16-1.02-.1l-3.2.58c-.35.07-.44.21-.2.33l1.24.63c.24.12.72.17 1.07.1Z",
    fill: "#B8CDF6"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2 42.75 3.24-.61c.33-.07.4-.21.15-.33l-1.27-.6c-.23-.12-.7-.16-1.02-.1l-3.2.58c-.35.06-.44.2-.2.33l1.24.63c.24.12.72.17 1.07.1Z",
    fill: "#B9CEF7"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.54 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.71-.16-1.06-.1l-3.42.63c-.37.07-.48.22-.25.35l1.22.67c.23.14.73.18 1.1.11Z",
    fill: "#7791BC"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.53 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.71-.16-1.06-.1l-3.42.63c-.37.07-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.11Z",
    fill: "#7892BD"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.52 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.71-.16-1.06-.1l-3.42.63c-.37.07-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.11Z",
    fill: "#7993BE"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.51 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.71-.16-1.06-.1l-3.42.63c-.37.07-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.11Z",
    fill: "#7A94BF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.5 3.45-.67c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.71-.17-1.06-.1l-3.42.63c-.37.06-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#7B95C0"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.49 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.71-.16-1.06-.1l-3.42.63c-.37.06-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#7C96C0"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.48 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.37.06-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#7D96C1"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.47 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.65c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.37.06-.48.22-.25.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#7E97C2"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.45 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.37.07-.48.23-.25.35l1.22.67c.23.14.73.18 1.1.11Z",
    fill: "#7F98C3"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.44 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.62c-.37.07-.48.23-.25.35l1.22.68c.23.13.73.17 1.1.1Z",
    fill: "#8099C4"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.43 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.62c-.37.07-.48.23-.25.35l1.22.68c.23.13.73.17 1.1.1Z",
    fill: "#819AC5"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.42 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.62c-.37.07-.48.23-.25.35l1.22.68c.23.13.73.17 1.1.1Z",
    fill: "#829BC6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.41 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.37.06-.48.22-.25.34l1.22.68c.23.12.73.17 1.1.1Z",
    fill: "#839CC7"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.4 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#849DC7"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.39 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#859EC8"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.38 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.24.13.73.18 1.1.11Z",
    fill: "#869FC9"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.37 3.45-.67c.36-.06.45-.22.2-.34l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.36.07-.48.22-.25.35l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#87A0CA"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.36 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#88A0CB"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.35 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.24-.12-.7-.17-1.06-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#89A1CC"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.33 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.36.06-.48.22-.25.35l1.22.67c.24.13.73.17 1.1.1Z",
    fill: "#8AA2CD"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.32 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.36.06-.48.22-.25.35l1.22.67c.24.13.73.17 1.1.1Z",
    fill: "#8BA3CE"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.31 3.45-.66c.36-.07.45-.22.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.36.06-.48.22-.25.35l1.22.67c.24.13.73.17 1.1.1Z",
    fill: "#8CA4CE"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.3 3.45-.66c.36-.07.45-.22.2-.34l-1.24-.65c-.24-.12-.7-.16-1.06-.1l-3.42.63c-.36.06-.48.22-.25.35l1.22.67c.24.13.73.17 1.1.1Z",
    fill: "#8DA5CF"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.29 3.45-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.06-.1l-3.41.62c-.37.07-.48.23-.25.35l1.21.67c.24.13.73.18 1.1.11Z",
    fill: "#8EA6D0"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.28 3.45-.66c.36-.07.44-.23.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.41.62c-.37.07-.48.23-.25.35l1.22.67c.23.13.72.18 1.1.11Z",
    fill: "#8FA7D1"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.27 3.45-.66c.36-.07.44-.23.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.41.62c-.37.07-.48.23-.25.35l1.22.67c.23.13.72.18 1.1.11Z",
    fill: "#90A8D2"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.26 3.44-.66c.36-.07.44-.23.2-.35l-1.24-.64c-.24-.12-.7-.16-1.06-.1l-3.41.62c-.37.07-.48.23-.25.35l1.22.67c.23.13.72.18 1.1.11Z",
    fill: "#91A9D3"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.25 3.44-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.23.13.72.18 1.1.1Z",
    fill: "#92AAD4"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.24 3.44-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.23.13.72.18 1.1.1Z",
    fill: "#93AAD5"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.23 3.44-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.42.62c-.36.07-.48.23-.25.35l1.22.67c.23.13.72.18 1.1.1Z",
    fill: "#94ABD6"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.22 3.44-.66c.36-.07.45-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.42.62c-.36.07-.48.22-.25.35l1.22.67c.23.13.72.17 1.1.1Z",
    fill: "#95ACD6"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.2 3.44-.66c.36-.06.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.42.62c-.36.07-.48.22-.25.35l1.22.67c.23.13.72.17 1.1.1Z",
    fill: "#96ADD7"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.2 3.44-.67c.36-.07.45-.22.2-.34l-1.24-.64c-.23-.13-.7-.17-1.05-.1l-3.42.62c-.36.06-.48.22-.25.35l1.22.66c.23.13.72.18 1.1.11Z",
    fill: "#97AED8"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.18 3.45-.66c.36-.07.44-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.06-.1l-3.4.62c-.37.06-.49.22-.26.34l1.22.67c.23.13.73.18 1.1.11Z",
    fill: "#98AFD9"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 44.17 3.45-.66c.36-.07.44-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.06-.1l-3.4.62c-.37.06-.49.22-.26.34l1.22.67c.23.13.73.18 1.1.11Z",
    fill: "#98B0DA"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.16 3.44-.66c.36-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.49.23-.26.35l1.22.67c.23.13.73.18 1.1.11Z",
    fill: "#99B1DB"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.15 3.44-.66c.36-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.49.22-.26.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#9AB2DC"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.14 3.44-.66c.36-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.63c-.37.06-.49.22-.26.34l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#9BB3DD"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.13 3.44-.66c.35-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.49.23-.26.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#9CB4DD"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.11 3.44-.65c.35-.07.44-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.06-.1l-3.4.62c-.37.07-.49.22-.26.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#9DB5DE"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.1 3.44-.65c.35-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.49.23-.26.35l1.22.67c.23.13.73.18 1.1.1Z",
    fill: "#9EB5DF"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.1 3.44-.66c.35-.07.44-.23.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.49.22-.26.35l1.22.67c.23.13.73.17 1.1.1Z",
    fill: "#9FB6E0"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.08 3.44-.66c.35-.06.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.07-.48.22-.26.35l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#A0B7E1"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.07 3.44-.66c.35-.07.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.06-.48.22-.26.35l1.22.66c.24.13.73.18 1.1.11Z",
    fill: "#A1B8E2"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.06 3.44-.66c.35-.07.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.07-.48.22-.26.35l1.22.66c.24.14.73.18 1.1.11Z",
    fill: "#A2B9E3"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.05 3.44-.66c.35-.07.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.07-.48.22-.26.35l1.22.66c.24.14.73.18 1.1.11Z",
    fill: "#A3BAE4"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.04 3.44-.66c.35-.07.45-.22.2-.35l-1.24-.63c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.06-.48.22-.26.34l1.22.67c.24.13.73.18 1.1.11Z",
    fill: "#A4BBE5"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.03 3.44-.66c.35-.07.45-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.05-.1l-3.41.63c-.37.06-.48.22-.26.34l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#A5BCE5"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44.02 3.44-.66c.35-.07.45-.22.2-.35l-1.24-.63c-.23-.13-.7-.17-1.05-.1l-3.41.62c-.37.06-.48.22-.26.34l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#A6BDE6"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44 3.44-.65c.35-.07.45-.22.2-.35l-1.24-.63c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.06-.48.22-.26.34l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#A7BEE7"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 44 3.44-.66c.35-.07.45-.22.2-.35l-1.24-.63c-.23-.12-.7-.17-1.05-.1l-3.41.62c-.37.06-.48.22-.26.34l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#A8BFE8"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.99 3.44-.66c.35-.07.45-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.05-.1l-3.41.62c-.37.07-.48.23-.26.35l1.22.67c.24.13.73.18 1.1.1Z",
    fill: "#A9BFE9"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.98 3.44-.66c.35-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.48.23-.25.35l1.21.67c.24.13.73.17 1.1.1Z",
    fill: "#AAC0EA"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.96 3.44-.65c.36-.07.45-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.05-.1l-3.4.62c-.37.07-.49.23-.26.35l1.22.67c.23.13.72.18 1.1.1Z",
    fill: "#ABC1EB"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.95 3.44-.65c.35-.07.44-.23.2-.35l-1.24-.64c-.23-.12-.7-.17-1.06-.1l-3.4.62c-.37.07-.48.22-.25.35l1.21.66c.24.14.73.18 1.1.11Z",
    fill: "#ACC2EC"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.94 3.44-.65c.35-.07.44-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.06-.1l-3.4.62c-.37.07-.48.22-.25.35l1.22.66c.23.14.72.19 1.1.11Z",
    fill: "#ADC3EC"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.93 3.44-.65c.35-.07.44-.23.2-.35l-1.24-.64c-.23-.12-.7-.16-1.05-.1l-3.4.62c-.37.07-.49.22-.26.35l1.22.66c.23.14.72.18 1.1.11Z",
    fill: "#AEC4ED"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.92 3.44-.66c.35-.06.44-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.49.22-.26.34l1.22.67c.23.13.72.18 1.1.11Z",
    fill: "#AFC5EE"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.9 3.44-.65c.35-.06.44-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.49.22-.26.34l1.22.67c.23.13.72.18 1.1.1Z",
    fill: "#B0C6EF"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.9 3.44-.66c.35-.06.44-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.49.22-.26.34l1.22.67c.23.13.72.18 1.1.1Z",
    fill: "#B1C7F0"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.89 3.44-.66c.35-.06.44-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.49.22-.26.35l1.22.66c.23.13.72.18 1.1.1Z",
    fill: "#B2C8F1"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.88 3.44-.66c.35-.07.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.48.22-.25.35l1.21.66c.23.13.72.18 1.1.1Z",
    fill: "#B3C9F2"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 43.87 3.44-.66c.35-.07.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.48.22-.25.35l1.21.66c.23.13.72.18 1.1.1Z",
    fill: "#B4C9F3"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 43.85 3.43-.65c.35-.07.45-.22.2-.35l-1.24-.63c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.48.22-.25.34l1.21.67c.23.13.72.17 1.1.1Z",
    fill: "#B5CAF3"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 43.85 3.43-.66c.35-.07.45-.22.2-.34l-1.24-.64c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.07-.48.22-.25.35l1.21.66c.23.13.72.18 1.1.1Z",
    fill: "#B6CBF4"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 43.83 3.43-.65c.35-.07.45-.22.2-.35l-1.24-.64c-.23-.12-.7-.16-1.05-.1l-3.4.63c-.37.06-.48.22-.25.34l1.21.67c.23.13.72.18 1.1.1Z",
    fill: "#B7CCF5"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 43.82 3.43-.65c.35-.07.45-.23.2-.35l-1.24-.63c-.23-.12-.7-.17-1.05-.1l-3.4.62c-.37.06-.48.22-.25.34l1.21.67c.24.13.73.17 1.1.1Z",
    fill: "#B8CDF6"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 43.81 3.43-.65c.35-.07.45-.23.2-.35l-1.24-.64c-.23-.12-.7-.16-1.05-.1l-3.4.62c-.37.07-.48.23-.25.35l1.21.67c.24.13.73.17 1.1.1Z",
    fill: "#B9CEF7"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.68 3.68-.7c.38-.08.5-.24.26-.37l-1.2-.68a1.93 1.93 0 0 0-1.1-.1l-3.64.66c-.4.08-.54.24-.31.37l1.18.71c.22.14.73.19 1.13.11Z",
    fill: "#7791BC"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.67 3.69-.7c.38-.08.5-.24.26-.37l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.66c-.4.08-.53.24-.31.37l1.18.71c.23.14.74.19 1.13.11Z",
    fill: "#7892BD"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.66 3.69-.7c.38-.07.5-.24.26-.37l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.66c-.4.08-.53.24-.31.37l1.18.71c.23.14.74.19 1.13.11Z",
    fill: "#7993BE"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.65 3.69-.7c.38-.08.5-.25.26-.38l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.67c-.4.07-.53.24-.31.37l1.18.7c.23.15.74.2 1.13.12Z",
    fill: "#7A94BF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.64 3.69-.7c.38-.08.5-.24.26-.38l-1.22-.67a1.93 1.93 0 0 0-1.09-.1l-3.64.66c-.4.07-.53.24-.31.37l1.18.71c.23.14.74.19 1.13.11Z",
    fill: "#7B95C0"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.63 3.69-.7c.38-.08.5-.25.26-.38l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.67c-.4.07-.53.24-.31.37l1.18.7c.23.14.74.2 1.13.12Z",
    fill: "#7C96C0"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "m24.68 45.62 3.69-.71c.38-.07.5-.24.26-.37l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.67c-.39.07-.53.23-.3.37l1.17.7c.23.15.74.2 1.13.12Z",
    fill: "#7D96C1"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.6 3.68-.7c.38-.07.5-.24.26-.37l-1.21-.68a1.93 1.93 0 0 0-1.1-.1l-3.64.67c-.39.07-.53.23-.3.37l1.17.7c.23.14.74.2 1.14.12Z",
    fill: "#7E97C2"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.6 3.68-.71c.38-.07.5-.24.26-.37l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.67c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.2 1.14.12Z",
    fill: "#7F98C3"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.58 3.68-.7c.38-.07.5-.24.26-.37l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.66c-.39.08-.53.24-.3.37l1.17.71c.23.14.74.2 1.14.11Z",
    fill: "#8099C4"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.57 3.68-.7c.38-.07.5-.24.26-.37l-1.22-.68a1.93 1.93 0 0 0-1.09-.1l-3.64.66c-.39.08-.53.24-.3.37l1.17.71c.23.14.74.2 1.14.11Z",
    fill: "#819AC5"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.56 3.68-.7c.38-.07.5-.24.26-.37l-1.21-.68a1.93 1.93 0 0 0-1.1-.1l-3.64.66c-.39.08-.53.24-.3.37l1.17.71c.23.14.74.19 1.14.11Z",
    fill: "#829BC6"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.55 3.68-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.93 1.93 0 0 0-1.1-.1l-3.64.66c-.39.07-.53.24-.3.37l1.17.7c.24.15.74.2 1.14.12Z",
    fill: "#839CC7"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "m24.69 45.54 3.68-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.93 1.93 0 0 0-1.1-.1l-3.64.66c-.39.07-.53.24-.3.37l1.17.7c.24.15.74.2 1.14.12Z",
    fill: "#849DC7"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.53 3.67-.7c.38-.07.5-.24.26-.37l-1.21-.68a1.93 1.93 0 0 0-1.1-.1l-3.63.66c-.4.08-.53.24-.31.38l1.18.7c.23.14.74.19 1.13.11Z",
    fill: "#859EC8"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.52 3.67-.7c.38-.08.5-.25.26-.38l-1.21-.67a1.93 1.93 0 0 0-1.1-.1l-3.63.66c-.4.07-.53.24-.31.37l1.18.7c.23.14.74.2 1.13.12Z",
    fill: "#869FC9"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.5 3.67-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.93 1.93 0 0 0-1.1-.1l-3.63.66c-.4.07-.54.24-.31.37l1.18.7c.23.14.74.2 1.13.12Z",
    fill: "#87A0CA"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.5 3.67-.71c.38-.07.5-.24.26-.37l-1.21-.67a1.93 1.93 0 0 0-1.1-.1l-3.63.66c-.4.07-.53.24-.31.37l1.18.7c.23.14.74.2 1.13.11Z",
    fill: "#88A0CB"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.48 3.68-.7c.37-.07.49-.24.25-.37l-1.21-.67a1.92 1.92 0 0 0-1.09-.1l-3.64.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.12Z",
    fill: "#89A1CC"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.48 3.68-.7c.37-.08.49-.25.25-.38l-1.21-.67a1.92 1.92 0 0 0-1.09-.1l-3.64.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.19 1.13.12Z",
    fill: "#8AA2CD"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.46 3.68-.7c.37-.07.49-.24.25-.37l-1.21-.68a1.92 1.92 0 0 0-1.09-.1l-3.64.66c-.39.08-.53.24-.3.37l1.17.71c.23.14.74.19 1.13.11Z",
    fill: "#8BA3CE"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.45 3.68-.7c.38-.07.49-.24.25-.37l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.64.66c-.39.08-.53.24-.3.37l1.17.71c.23.14.74.19 1.14.11Z",
    fill: "#8CA4CE"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.44 3.68-.7c.38-.07.49-.24.25-.37l-1.2-.67a1.92 1.92 0 0 0-1.1-.1l-3.64.66c-.39.07-.53.23-.3.37l1.17.7c.23.14.74.19 1.14.11Z",
    fill: "#8DA5CF"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.43 3.68-.7c.38-.08.49-.24.25-.37l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.4.07-.53.24-.31.37l1.17.71c.23.14.74.18 1.14.1Z",
    fill: "#8EA6D0"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.42 3.68-.7c.38-.08.49-.24.25-.37l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.4.07-.53.24-.31.37l1.17.71c.24.13.74.18 1.14.1Z",
    fill: "#8FA7D1"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.4 3.68-.7c.38-.07.49-.24.26-.37l-1.22-.67a1.92 1.92 0 0 0-1.08-.1l-3.64.66c-.4.07-.53.24-.31.37l1.18.7c.23.14.73.19 1.13.12Z",
    fill: "#90A8D2"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.4 3.68-.71c.38-.07.49-.24.26-.37l-1.22-.67a1.92 1.92 0 0 0-1.08-.1l-3.64.66c-.4.07-.53.24-.31.37l1.18.7c.23.14.74.2 1.13.11Z",
    fill: "#91A9D3"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.38 3.68-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.11Z",
    fill: "#92AAD4"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.38 3.68-.71c.38-.07.5-.24.26-.37l-1.21-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.19 1.13.12Z",
    fill: "#93AAD5"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.36 3.68-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#94ABD6"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.35 3.68-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.92 1.92 0 0 0-1.09-.1l-3.64.66c-.39.07-.53.23-.3.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#95ACD6"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.34 3.68-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.92 1.92 0 0 0-1.09-.1l-3.63.67c-.4.07-.53.23-.31.37l1.17.7c.23.14.74.18 1.13.11Z",
    fill: "#96ADD7"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.33 3.68-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.08-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.12Z",
    fill: "#97AED8"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.32 3.68-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.12Z",
    fill: "#98AFD9"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.3 3.68-.7c.38-.07.5-.23.26-.36l-1.21-.68a1.92 1.92 0 0 0-1.09-.1l-3.63.66c-.4.08-.53.24-.31.37l1.17.7c.23.14.74.2 1.14.12Z",
    fill: "#98B0DA"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.3 3.68-.7c.38-.08.5-.25.26-.38l-1.21-.67a1.92 1.92 0 0 0-1.09-.1l-3.63.66c-.4.07-.53.24-.31.37l1.17.7c.23.14.74.2 1.14.11Z",
    fill: "#99B1DB"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.29 3.68-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.92 1.92 0 0 0-1.09-.1l-3.63.66c-.4.07-.53.24-.31.37l1.18.7c.23.14.73.2 1.13.12Z",
    fill: "#9AB2DC"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.27 3.68-.7c.37-.07.49-.23.25-.36l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.4.07-.53.24-.3.37l1.17.7c.23.14.73.19 1.13.11Z",
    fill: "#9BB3DD"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.26 3.68-.7c.37-.07.49-.24.25-.37l-1.2-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.4.07-.53.24-.3.37l1.17.7c.23.14.73.19 1.13.11Z",
    fill: "#9CB4DD"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 45.25 3.68-.7c.38-.07.5-.24.26-.37l-1.2-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.23-.3.36l1.17.7c.23.15.74.2 1.13.12Z",
    fill: "#9DB5DE"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.24 3.68-.7c.38-.07.49-.24.25-.37l-1.2-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.23-.3.36l1.17.7c.23.15.74.2 1.13.12Z",
    fill: "#9EB5DF"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.23 3.67-.7c.38-.07.5-.24.26-.37l-1.2-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.23-.3.36l1.17.7c.23.15.74.2 1.13.12Z",
    fill: "#9FB6E0"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.22 3.67-.7c.38-.08.5-.24.26-.37l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.08-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.12Z",
    fill: "#A0B7E1"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.2 3.68-.7c.38-.07.49-.23.25-.37l-1.2-.67a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.23-.3.37l1.17.7c.23.14.74.2 1.13.11Z",
    fill: "#A1B8E2"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.2 3.68-.7c.38-.08.49-.24.25-.37l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.11Z",
    fill: "#A2B9E3"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.19 3.68-.7c.38-.08.49-.24.25-.37l-1.2-.68a1.92 1.92 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.19 1.13.12Z",
    fill: "#A3BAE4"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 45.17 3.68-.7c.38-.07.49-.24.25-.37l-1.2-.67a1.94 1.94 0 0 0-1.1-.1l-3.63.66c-.39.07-.53.23-.3.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#A4BBE5"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.16 3.67-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.4.07-.53.23-.31.37l1.18.7c.22.14.73.19 1.13.11Z",
    fill: "#A5BCE5"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.15 3.67-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.4.07-.53.24-.3.37l1.17.7c.23.14.73.19 1.13.11Z",
    fill: "#A6BDE6"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.14 3.67-.7c.38-.07.49-.24.25-.37l-1.2-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.4.07-.53.23-.3.36l1.17.7c.23.14.73.2 1.13.12Z",
    fill: "#A7BEE7"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.13 3.67-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.94 1.94 0 0 0-1.09-.1l-3.63.66c-.39.07-.53.23-.3.36l1.17.7c.23.14.73.2 1.13.12Z",
    fill: "#A8BFE8"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.12 3.67-.7c.38-.07.5-.24.26-.37l-1.21-.67a1.93 1.93 0 0 0-1.09-.1l-3.63.66c-.39.07-.53.23-.3.37l1.17.7c.23.14.73.18 1.13.1Z",
    fill: "#A9BFE9"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.1 3.67-.7c.38-.07.5-.23.26-.36l-1.21-.67a1.94 1.94 0 0 0-1.09-.1l-3.63.66c-.39.07-.53.23-.3.36l1.17.7c.23.14.74.2 1.13.12Z",
    fill: "#AAC0EA"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.1 3.67-.7c.38-.08.5-.24.26-.37l-1.21-.68a1.94 1.94 0 0 0-1.09-.1l-3.63.66c-.39.08-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.12Z",
    fill: "#ABC1EB"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.09 3.67-.7c.38-.08.5-.24.26-.37l-1.21-.67a1.94 1.94 0 0 0-1.09-.1l-3.63.65c-.39.08-.53.24-.3.37l1.17.7c.23.14.74.19 1.13.12Z",
    fill: "#ACC2EC"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.07 3.67-.7c.38-.07.5-.23.26-.36l-1.21-.67a1.94 1.94 0 0 0-1.09-.1l-3.63.65c-.39.07-.53.24-.3.37l1.17.7c.23.14.74.2 1.13.11Z",
    fill: "#ADC3EC"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.06 3.67-.7c.38-.07.5-.23.26-.36l-1.2-.67a1.93 1.93 0 0 0-1.1-.1l-3.62.65c-.4.08-.53.24-.3.37l1.17.7c.22.14.73.19 1.12.11Z",
    fill: "#AEC4ED"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.05 3.67-.7c.38-.07.5-.23.26-.36l-1.2-.67a1.93 1.93 0 0 0-1.1-.1l-3.62.65c-.4.07-.53.24-.3.37l1.17.7c.22.14.73.19 1.12.11Z",
    fill: "#AFC5EE"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.04 3.67-.7c.38-.07.5-.23.26-.36l-1.2-.68a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.4.07-.53.24-.3.37l1.17.7c.22.14.73.19 1.12.11Z",
    fill: "#B0C6EF"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 45.03 3.67-.7c.38-.07.5-.24.26-.37l-1.2-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.4.07-.53.23-.3.37l1.17.7c.22.13.73.18 1.12.1Z",
    fill: "#B1C7F0"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 45.02 3.67-.7c.37-.07.49-.24.25-.37l-1.2-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.39.07-.53.23-.3.37l1.17.7c.23.13.73.18 1.13.1Z",
    fill: "#B2C8F1"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 45 3.67-.7c.37-.07.49-.23.25-.36l-1.2-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.39.07-.53.23-.3.36l1.17.7c.23.14.73.2 1.13.11Z",
    fill: "#B3C9F2"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 45 3.67-.7c.37-.08.49-.24.25-.37l-1.2-.67a1.94 1.94 0 0 0-1.1-.1l-3.62.66c-.39.07-.53.23-.3.36l1.17.7c.23.14.73.19 1.13.12Z",
    fill: "#B4C9F3"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 44.99 3.67-.7c.38-.08.49-.24.25-.37l-1.2-.67a1.94 1.94 0 0 0-1.09-.1l-3.63.66c-.39.07-.53.23-.3.36l1.17.7c.23.14.73.19 1.13.12Z",
    fill: "#B5CAF3"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 44.97 3.67-.7c.37-.07.49-.23.25-.36l-1.2-.67a1.94 1.94 0 0 0-1.09-.1l-3.62.65c-.4.08-.53.24-.31.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#B6CBF4"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 44.96 3.66-.7c.38-.07.5-.23.26-.36l-1.2-.67a1.93 1.93 0 0 0-1.1-.1l-3.62.65c-.38.08-.53.24-.3.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#B7CCF5"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 44.95 3.67-.7c.37-.07.49-.23.25-.36l-1.2-.67a1.94 1.94 0 0 0-1.09-.1l-3.62.65c-.4.08-.53.24-.31.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#B8CDF6"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "m24.73 44.94 3.67-.7c.37-.07.49-.23.25-.36l-1.2-.68a1.94 1.94 0 0 0-1.09-.1l-3.62.66c-.4.07-.53.24-.31.37l1.17.7c.23.14.74.19 1.13.11Z",
    fill: "#B9CEF7"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "m18.31 46.9 3.95-.75c.4-.07.54-.25.32-.39l-1.18-.72a1.9 1.9 0 0 0-1.12-.1l-3.9.71c-.41.08-.58.25-.37.4l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#7791BC"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "m18.31 46.9 3.94-.76c.41-.07.55-.25.32-.39l-1.17-.72a1.9 1.9 0 0 0-1.12-.1l-3.9.71c-.41.08-.58.25-.37.4l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#7892BD"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "m18.31 46.88 3.95-.75c.4-.08.54-.25.32-.4l-1.17-.7a1.9 1.9 0 0 0-1.13-.12l-3.89.72c-.42.07-.59.25-.38.4l1.14.74c.22.14.74.2 1.16.11Z",
    fill: "#7993BE"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "m18.31 46.87 3.95-.75c.4-.08.54-.25.32-.4l-1.17-.7a1.9 1.9 0 0 0-1.13-.12l-3.89.72c-.42.08-.59.25-.38.4l1.14.74c.22.14.74.2 1.16.11Z",
    fill: "#7A94BF"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.86 3.94-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.9 1.9 0 0 0-1.12-.12l-3.9.72c-.42.07-.58.25-.37.39l1.13.75c.22.14.74.2 1.17.11Z",
    fill: "#7B95C0"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.85 3.94-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.9 1.9 0 0 0-1.12-.12l-3.9.72c-.41.07-.58.25-.37.39l1.13.75c.22.14.74.2 1.17.11Z",
    fill: "#7C96C0"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.84 3.94-.75c.4-.08.55-.26.32-.4l-1.17-.71a1.9 1.9 0 0 0-1.12-.1l-3.9.7c-.41.08-.58.26-.37.4l1.13.75c.22.14.75.2 1.17.11Z",
    fill: "#7D96C1"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.83 3.94-.76c.4-.07.55-.25.32-.39l-1.17-.71a1.9 1.9 0 0 0-1.12-.11l-3.9.71c-.41.08-.58.25-.37.4l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#7E97C2"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.82 3.94-.76c.4-.07.55-.25.32-.39l-1.17-.71a1.9 1.9 0 0 0-1.12-.11l-3.89.7c-.42.09-.59.26-.38.4l1.14.75c.21.15.74.2 1.16.12Z",
    fill: "#7F98C3"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.8 3.94-.75c.4-.08.55-.25.32-.39l-1.17-.71a1.9 1.9 0 0 0-1.12-.11l-3.89.7c-.42.08-.59.26-.38.4l1.14.75c.22.15.74.2 1.16.12Z",
    fill: "#8099C4"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.8 3.95-.76c.4-.08.54-.25.32-.39l-1.18-.72a1.91 1.91 0 0 0-1.12-.1l-3.89.7c-.42.08-.58.26-.37.4l1.13.75c.22.14.74.2 1.16.12Z",
    fill: "#819AC5"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 46.78 3.95-.75c.4-.08.54-.25.32-.4l-1.18-.7a1.91 1.91 0 0 0-1.12-.12l-3.89.72c-.42.07-.58.25-.37.39l1.13.75c.22.14.74.2 1.16.11Z",
    fill: "#829BC6"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "m18.33 46.77 3.94-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.12l-3.9.72c-.41.07-.58.25-.37.39l1.13.75c.22.14.74.2 1.17.11Z",
    fill: "#839CC7"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "m18.33 46.76 3.94-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.12l-3.9.71c-.41.08-.58.26-.37.4l1.13.75c.22.14.74.2 1.17.11Z",
    fill: "#849DC7"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "m18.33 46.75 3.94-.75c.4-.08.55-.26.32-.4l-1.17-.71a1.91 1.91 0 0 0-1.12-.11l-3.9.71c-.41.08-.58.26-.37.4l1.13.75c.22.14.75.2 1.17.11Z",
    fill: "#859EC8"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "m18.33 46.74 3.94-.76c.4-.07.55-.25.32-.39l-1.17-.7a1.91 1.91 0 0 0-1.12-.12l-3.89.71c-.42.08-.59.26-.38.4l1.14.75c.21.14.74.2 1.16.11Z",
    fill: "#869FC9"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "m18.33 46.73 3.94-.76c.4-.08.55-.25.32-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.11l-3.89.7c-.42.09-.59.26-.38.4l1.14.75c.22.15.74.2 1.16.12Z",
    fill: "#87A0CA"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.72 3.93-.76c.4-.08.55-.25.32-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.11l-3.89.7c-.42.09-.59.26-.38.4l1.14.75c.22.14.74.2 1.17.12Z",
    fill: "#88A0CB"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.7 3.93-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.11l-3.89.7c-.42.08-.59.26-.38.4l1.14.75c.22.14.74.2 1.17.11Z",
    fill: "#89A1CC"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.7 3.93-.76c.4-.07.55-.25.32-.39l-1.17-.71a1.91 1.91 0 0 0-1.12-.11l-3.89.71c-.42.08-.59.25-.37.4l1.13.74c.22.14.74.2 1.17.12Z",
    fill: "#8AA2CD"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.69 3.93-.76c.4-.07.55-.25.32-.39l-1.17-.71a1.91 1.91 0 0 0-1.12-.11l-3.89.71c-.42.08-.59.25-.38.4l1.14.74c.22.14.74.2 1.17.12Z",
    fill: "#8BA3CE"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.67 3.94-.75c.4-.08.54-.25.31-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.11l-3.89.7c-.42.08-.59.26-.37.4l1.13.75c.22.14.75.2 1.17.11Z",
    fill: "#8CA4CE"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.66 3.94-.75c.4-.08.54-.26.31-.4l-1.17-.7a1.91 1.91 0 0 0-1.12-.12l-3.89.72c-.42.07-.59.25-.37.39l1.13.75c.22.14.75.19 1.17.11Z",
    fill: "#8DA5CF"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.65 3.94-.75c.4-.08.54-.26.32-.4l-1.18-.7a1.91 1.91 0 0 0-1.12-.12l-3.88.71c-.42.08-.59.26-.37.4l1.13.75c.21.14.74.19 1.16.1Z",
    fill: "#8EA6D0"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "m18.34 46.64 3.94-.76c.4-.07.54-.25.32-.39l-1.18-.7a1.91 1.91 0 0 0-1.12-.12l-3.88.71c-.42.08-.59.26-.37.4l1.13.74c.22.14.74.2 1.16.12Z",
    fill: "#8FA7D1"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.62 3.93-.75c.4-.07.55-.25.32-.39l-1.17-.71a1.9 1.9 0 0 0-1.12-.11l-3.89.71c-.42.08-.59.25-.37.4l1.13.74c.22.15.74.2 1.17.11Z",
    fill: "#90A8D2"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.62 3.93-.76c.4-.07.55-.25.32-.39l-1.17-.71a1.91 1.91 0 0 0-1.12-.11l-3.89.71c-.42.08-.59.25-.37.4l1.13.74c.22.14.74.2 1.17.12Z",
    fill: "#91A9D3"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.6 3.93-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.89.7c-.42.08-.59.26-.37.4l1.13.74c.22.15.74.2 1.17.12Z",
    fill: "#92AAD4"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.6 3.93-.76c.4-.08.55-.25.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.89.7c-.42.08-.58.26-.37.4l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#93AAD5"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.58 3.93-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.42.08-.59.26-.38.4l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#94ABD6"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.57 3.93-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.12l-3.88.71c-.42.08-.59.26-.38.4l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#95ACD6"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "m18.35 46.56 3.94-.76c.4-.07.54-.25.31-.39l-1.17-.7a1.93 1.93 0 0 0-1.12-.12l-3.88.71c-.42.08-.58.25-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#96ADD7"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.55 3.93-.76c.4-.07.54-.25.32-.39l-1.17-.71a1.93 1.93 0 0 0-1.12-.11l-3.89.7c-.42.09-.58.26-.37.4l1.13.75c.22.15.74.2 1.17.12Z",
    fill: "#97AED8"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.54 3.93-.76c.4-.07.54-.25.32-.39l-1.17-.71a1.93 1.93 0 0 0-1.12-.11l-3.88.71c-.42.08-.59.25-.38.39l1.13.75c.22.14.74.2 1.17.12Z",
    fill: "#98AFD9"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.52 3.93-.75c.4-.08.54-.25.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.11l-3.88.7c-.42.08-.59.26-.38.4l1.13.74c.22.15.74.2 1.17.12Z",
    fill: "#98B0DA"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.51 3.93-.75c.4-.08.54-.25.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.11l-3.88.7c-.42.08-.59.26-.38.4l1.13.74c.22.15.74.2 1.17.12Z",
    fill: "#99B1DB"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.5 3.93-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.42.08-.59.26-.37.4l1.13.74c.21.15.74.2 1.16.12Z",
    fill: "#9AB2DC"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.49 3.93-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.11l-3.88.7c-.42.08-.58.26-.37.4l1.13.74c.21.15.74.2 1.16.12Z",
    fill: "#9BB3DD"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.48 3.93-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#9CB4DD"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 46.47 3.93-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#9DB5DE"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.46 3.93-.75c.4-.08.54-.26.31-.4l-1.17-.7a1.93 1.93 0 0 0-1.11-.11l-3.88.7c-.42.08-.59.26-.38.4l1.13.74c.22.14.74.2 1.17.12Z",
    fill: "#9EB5DF"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.44 3.92-.75c.4-.07.55-.25.32-.39l-1.17-.7a1.93 1.93 0 0 0-1.12-.12l-3.88.71c-.41.08-.58.25-.37.4l1.13.74c.22.14.74.2 1.17.11Z",
    fill: "#9FB6E0"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.43 3.93-.75c.4-.07.54-.25.31-.39l-1.17-.7a1.92 1.92 0 0 0-1.11-.12l-3.88.71c-.42.08-.59.25-.38.4l1.13.74c.22.14.74.2 1.17.11Z",
    fill: "#A0B7E1"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.42 3.93-.75c.4-.07.54-.25.31-.38l-1.17-.71a1.93 1.93 0 0 0-1.11-.11l-3.88.7c-.42.08-.59.26-.38.4l1.13.74c.23.14.75.2 1.17.11Z",
    fill: "#A1B8E2"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.4 3.93-.74c.4-.08.54-.25.32-.39l-1.17-.7a1.92 1.92 0 0 0-1.12-.12l-3.88.71c-.42.08-.59.25-.38.4l1.13.74c.22.14.75.2 1.17.1Z",
    fill: "#A2B9E3"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.4 3.93-.75c.4-.08.54-.25.32-.39l-1.17-.7a1.92 1.92 0 0 0-1.12-.12l-3.88.71c-.41.08-.58.25-.37.4l1.13.74c.22.14.74.19 1.16.11Z",
    fill: "#A3BAE4"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.39 3.93-.75c.4-.08.55-.26.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#A4BBE5"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "m18.37 46.38 3.93-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#A5BCE5"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.36 3.92-.75c.4-.07.55-.25.32-.38l-1.17-.71a1.92 1.92 0 0 0-1.12-.11l-3.87.7c-.42.08-.59.25-.38.4l1.13.74c.22.14.74.2 1.17.11Z",
    fill: "#A6BDE6"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.35 3.92-.75c.4-.07.55-.25.32-.38l-1.17-.71a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.25-.37.4l1.13.74c.22.14.74.2 1.17.11Z",
    fill: "#A7BEE7"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.34 3.92-.75c.4-.08.55-.25.32-.39l-1.17-.7a1.93 1.93 0 0 0-1.12-.12l-3.87.71c-.42.08-.59.25-.38.39l1.13.74c.22.15.75.2 1.17.12Z",
    fill: "#A8BFE8"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.33 3.93-.75c.4-.08.54-.25.31-.39l-1.17-.7a1.92 1.92 0 0 0-1.11-.12l-3.88.71c-.42.08-.59.25-.38.4l1.13.73c.22.15.75.2 1.17.12Z",
    fill: "#A9BFE9"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.32 3.93-.75c.4-.08.54-.25.31-.39l-1.17-.7a1.92 1.92 0 0 0-1.11-.12l-3.88.7c-.42.08-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#AAC0EA"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.3 3.93-.74c.4-.08.54-.25.32-.4l-1.17-.7a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#ABC1EB"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "m18.38 46.3 3.93-.75c.4-.08.54-.25.32-.39l-1.17-.7a1.93 1.93 0 0 0-1.12-.12l-3.88.7c-.41.09-.58.26-.37.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#ACC2EC"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 46.29 3.92-.75c.4-.08.55-.25.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.11l-3.87.7c-.42.08-.59.26-.38.4l1.13.74c.22.15.74.2 1.17.12Z",
    fill: "#ADC3EC"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 46.28 3.92-.75c.4-.08.54-.25.32-.39l-1.17-.71a1.93 1.93 0 0 0-1.12-.11l-3.88.7c-.41.08-.58.26-.37.4l1.13.74c.22.14.74.2 1.17.12Z",
    fill: "#AEC4ED"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 46.26 3.92-.75c.4-.07.55-.25.32-.38l-1.17-.71a1.92 1.92 0 0 0-1.12-.11l-3.87.7c-.42.08-.59.25-.38.4l1.13.74c.22.14.74.2 1.17.11Z",
    fill: "#AFC5EE"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 46.25 3.92-.75c.4-.07.55-.25.32-.38l-1.17-.71a1.92 1.92 0 0 0-1.12-.11l-3.87.7c-.42.08-.59.25-.38.4l1.13.74c.22.14.75.2 1.17.11Z",
    fill: "#B0C6EF"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 46.24 3.92-.75c.4-.07.55-.25.32-.38l-1.17-.71a1.93 1.93 0 0 0-1.12-.11l-3.87.7c-.42.08-.58.25-.37.4l1.13.74c.22.14.74.2 1.16.11Z",
    fill: "#B1C7F0"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 46.23 3.92-.75c.4-.08.55-.25.32-.39l-1.17-.7a1.92 1.92 0 0 0-1.12-.12l-3.87.71c-.42.08-.58.25-.37.4l1.13.73c.22.15.74.2 1.16.12Z",
    fill: "#B2C8F1"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.22 3.92-.75c.4-.08.54-.25.31-.39l-1.17-.7a1.92 1.92 0 0 0-1.11-.12l-3.88.71c-.41.08-.58.25-.37.4l1.13.73c.22.15.74.2 1.16.12Z",
    fill: "#B3C9F2"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.2 3.92-.74c.4-.08.54-.25.31-.39l-1.16-.7a1.92 1.92 0 0 0-1.12-.12l-3.87.7c-.42.09-.59.26-.38.4l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#B4C9F3"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.2 3.92-.75c.4-.08.54-.25.31-.39l-1.16-.7a1.92 1.92 0 0 0-1.12-.12l-3.87.7c-.42.09-.59.26-.37.4l1.13.74c.21.15.73.2 1.16.12Z",
    fill: "#B5CAF3"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.18 3.92-.74c.4-.08.54-.25.31-.4l-1.16-.7a1.92 1.92 0 0 0-1.12-.11l-3.87.7c-.42.08-.59.26-.37.4l1.13.74c.21.14.73.2 1.16.11Z",
    fill: "#B6CBF4"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.17 3.92-.74c.4-.08.54-.25.32-.4l-1.17-.7a1.92 1.92 0 0 0-1.12-.1l-3.87.7c-.41.07-.58.25-.37.39l1.13.74c.22.14.74.2 1.16.11Z",
    fill: "#B7CCF5"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.16 3.92-.75c.4-.07.54-.25.32-.38l-1.17-.71a1.92 1.92 0 0 0-1.12-.11l-3.87.7c-.41.08-.58.25-.37.4l1.13.73c.22.15.74.2 1.16.12Z",
    fill: "#B8CDF6"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 46.15 3.92-.75c.4-.07.55-.25.32-.39l-1.17-.7a1.92 1.92 0 0 0-1.11-.11l-3.87.7c-.42.08-.59.25-.38.39l1.13.74c.22.15.74.2 1.16.12Z",
    fill: "#B9CEF7"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "m54.04 41.87 2.73-.56c.28-.05.3-.19.02-.3l-1.4-.55c-.25-.1-.7-.15-.97-.1l-2.72.54c-.29.05-.32.19-.06.3l1.39.57c.26.12.72.16 1.01.1Z",
    fill: "#7791BC"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "m54.04 41.86 2.73-.56c.28-.05.3-.19.02-.3l-1.4-.55c-.25-.1-.69-.15-.97-.1l-2.72.54c-.29.05-.32.19-.06.3l1.39.57c.26.12.72.16 1.01.1Z",
    fill: "#7892BD"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "m54.04 41.85 2.73-.56c.28-.05.29-.19.02-.3l-1.4-.55c-.26-.1-.7-.15-.97-.1l-2.72.54c-.3.05-.32.19-.06.3l1.38.57c.27.12.73.16 1.02.1Z",
    fill: "#7993BE"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "m54.04 41.84 2.73-.56c.28-.05.29-.19.02-.3l-1.4-.55c-.26-.1-.7-.15-.98-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58a2 2 0 0 0 1.02.1Z",
    fill: "#7A94BF"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "m54.04 41.83 2.73-.56c.28-.05.29-.19.02-.3l-1.4-.55c-.26-.1-.7-.15-.98-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.12.72.16 1.02.1Z",
    fill: "#7B95C0"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.82 2.73-.56c.29-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.09l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.72.16 1.01.1Z",
    fill: "#7C96C0"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.8 2.73-.55c.29-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.09l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.72.16 1.01.1Z",
    fill: "#7D96C1"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.8 2.73-.56c.28-.06.29-.2.02-.3l-1.4-.55c-.26-.11-.7-.15-.97-.1l-2.72.53c-.29.06-.32.2-.06.3l1.39.58a2 2 0 0 0 1.01.1Z",
    fill: "#7E97C2"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.79 2.73-.56c.28-.06.29-.2.02-.3l-1.4-.56c-.26-.1-.7-.14-.97-.09l-2.72.53c-.29.06-.32.2-.06.3l1.39.58c.26.11.72.15 1.01.1Z",
    fill: "#7F98C3"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.78 2.73-.56c.28-.05.29-.19.02-.3l-1.4-.55c-.26-.1-.7-.15-.97-.1l-2.72.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.73.16 1.02.1Z",
    fill: "#8099C4"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.76 2.72-.55c.28-.06.3-.2.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.73.15 1.02.1Z",
    fill: "#819AC5"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "m54.03 41.76 2.72-.56c.28-.05.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.72.15 1.02.1Z",
    fill: "#829BC6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.74 2.73-.55c.28-.06.3-.2.02-.3l-1.4-.56c-.25-.1-.69-.14-.97-.09l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.1.72.15 1.01.1Z",
    fill: "#839CC7"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.74 2.73-.56c.28-.05.3-.19.02-.3l-1.4-.55c-.25-.1-.69-.15-.97-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.26.11.72.15 1.01.1Z",
    fill: "#849DC7"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.72 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.56c-.26-.1-.7-.14-.97-.09l-2.72.53c-.29.06-.31.2-.05.3l1.38.58c.27.1.72.15 1.01.1Z",
    fill: "#859EC8"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.71 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.56c-.25-.1-.69-.14-.97-.09l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.26.11.72.15 1.01.1Z",
    fill: "#869FC9"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.7 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.55c-.26-.1-.7-.15-.97-.1l-2.72.53c-.29.06-.31.2-.05.3l1.38.58c.26.11.72.15 1.01.1Z",
    fill: "#87A0CA"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.7 2.73-.56c.28-.06.29-.2.02-.3l-1.4-.56c-.26-.1-.7-.14-.97-.09l-2.72.53c-.29.05-.31.19-.05.3l1.38.58c.26.1.72.15 1.01.1Z",
    fill: "#88A0CB"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "m54.02 41.68 2.72-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.97-.09l-2.72.53c-.29.05-.32.19-.06.3l1.38.57c.27.12.72.16 1.02.1Z",
    fill: "#89A1CC"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "m54.01 41.67 2.73-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.09l-2.71.53c-.3.05-.32.19-.06.3l1.38.57c.27.12.72.16 1.01.1Z",
    fill: "#8AA2CD"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "m54.01 41.66 2.73-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.09l-2.71.53c-.3.05-.32.19-.06.3l1.38.57c.27.12.72.16 1.01.1Z",
    fill: "#8BA3CE"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "m54.01 41.65 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.56c-.25-.1-.69-.14-.97-.09l-2.71.53c-.3.05-.32.19-.06.3l1.38.57c.27.12.72.16 1.01.1Z",
    fill: "#8CA4CE"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "m54.01 41.64 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.56c-.26-.1-.7-.14-.97-.1l-2.72.53c-.29.06-.31.2-.05.3l1.37.58c.27.12.73.16 1.02.1Z",
    fill: "#8DA5CF"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.63 2.73-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.97-.1l-2.72.54c-.29.05-.32.18-.06.3l1.38.57a2 2 0 0 0 1.02.1Z",
    fill: "#8EA6D0"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.62 2.73-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.97-.1l-2.72.54c-.29.05-.32.18-.06.3l1.38.57c.27.12.73.16 1.02.1Z",
    fill: "#8FA7D1"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.61 2.73-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.1l-2.71.54c-.3.05-.32.18-.06.3l1.38.57a2 2 0 0 0 1.02.1Z",
    fill: "#90A8D2"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.6 2.73-.56c.28-.05.29-.19.02-.3l-1.4-.55c-.25-.1-.69-.15-.97-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.72.16 1.01.1Z",
    fill: "#91A9D3"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.59 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.56c-.25-.1-.69-.15-.97-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58a2 2 0 0 0 1.01.1Z",
    fill: "#92AAD4"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.58 2.73-.56c.28-.05.29-.19.02-.3l-1.4-.55c-.26-.1-.7-.14-.97-.09l-2.71.53c-.3.05-.32.19-.06.3l1.38.57c.27.11.72.16 1.01.1Z",
    fill: "#93AAD5"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.57 2.73-.55c.28-.06.29-.2.02-.3l-1.4-.56c-.26-.1-.7-.14-.97-.09l-2.71.53c-.3.05-.32.19-.06.3l1.38.57c.27.11.72.16 1.01.1Z",
    fill: "#94ABD6"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.56 2.72-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.09l-2.7.53c-.3.05-.32.19-.06.3l1.38.57c.26.11.72.16 1 .1Z",
    fill: "#95ACD6"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.55 2.72-.55c.28-.06.3-.2.02-.3l-1.39-.56c-.26-.1-.7-.14-.98-.09l-2.7.53c-.3.05-.32.19-.06.3l1.38.57c.26.11.72.16 1 .1Z",
    fill: "#96ADD7"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.54 2.72-.56c.28-.05.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.1l-2.7.53c-.3.06-.33.2-.07.3l1.38.58c.27.11.72.16 1.02.1Z",
    fill: "#97AED8"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.53 2.72-.56c.28-.05.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.1l-2.7.53c-.3.06-.33.2-.07.3l1.38.58c.27.11.72.16 1.02.1Z",
    fill: "#98AFD9"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.51 2.72-.55c.28-.06.29-.2.02-.3l-1.4-.55c-.25-.1-.69-.15-.97-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.27.11.72.16 1.01.1Z",
    fill: "#98B0DA"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.5 2.72-.55c.28-.06.29-.2.02-.3l-1.4-.55c-.26-.1-.7-.15-.97-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58c.26.11.72.16 1.01.1Z",
    fill: "#99B1DB"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "m54 41.5 2.72-.56c.28-.06.29-.2.02-.3l-1.4-.55c-.26-.1-.7-.15-.97-.1l-2.71.53c-.3.06-.32.2-.06.3l1.38.58a2 2 0 0 0 1.01.1Z",
    fill: "#9AB2DC"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "m53.99 41.48 2.72-.55c.28-.05.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.09l-2.7.53c-.3.05-.33.18-.07.3l1.38.57c.27.11.73.15 1.02.1Z",
    fill: "#9BB3DD"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "m53.99 41.48 2.72-.56c.28-.05.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.14-.97-.09l-2.72.53c-.29.05-.31.19-.05.3l1.38.57c.26.11.72.15 1 .1Z",
    fill: "#9CB4DD"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "m53.99 41.46 2.72-.55c.28-.05.29-.19.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.09l-2.7.53c-.3.05-.33.19-.07.3l1.38.57c.27.11.72.15 1.02.1Z",
    fill: "#9DB5DE"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "m53.99 41.45 2.72-.55c.28-.05.29-.19.02-.3l-1.39-.55c-.26-.1-.7-.14-.98-.09l-2.7.53c-.3.05-.33.19-.07.3l1.38.57c.27.1.72.15 1.02.1Z",
    fill: "#9EB5DF"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.45 2.73-.56c.28-.05.29-.18.02-.3l-1.4-.55c-.25-.1-.69-.14-.97-.09l-2.7.53c-.3.06-.33.19-.07.3l1.38.58c.27.1.72.14 1.01.09Z",
    fill: "#9FB6E0"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.43 2.73-.55c.28-.05.29-.19.02-.3l-1.4-.55c-.25-.1-.69-.14-.97-.09l-2.7.53c-.3.06-.33.19-.07.3l1.38.57c.27.1.72.15 1.01.1Z",
    fill: "#A0B7E1"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.42 2.72-.55c.28-.05.3-.19.02-.3l-1.38-.55c-.27-.1-.7-.14-.98-.09l-2.7.53c-.3.06-.33.19-.07.3l1.38.58c.26.1.72.14 1.01.08Z",
    fill: "#A1B8E2"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.41 2.72-.55c.28-.05.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.14-.97-.09l-2.71.53c-.3.06-.32.19-.06.3l1.38.58c.27.1.72.14 1 .08Z",
    fill: "#A2B9E3"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.4 2.72-.55c.28-.05.3-.19.02-.3L55.33 40c-.26-.1-.7-.14-.97-.09l-2.71.53c-.3.05-.32.19-.06.3l1.38.57c.26.1.72.15 1 .1Z",
    fill: "#A3BAE4"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.4 2.72-.56c.28-.05.29-.19.02-.3L55.33 40c-.26-.1-.7-.14-.98-.09l-2.7.53c-.3.05-.32.18-.06.3l1.38.57c.26.1.72.15 1 .1Z",
    fill: "#A4BBE5"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "m53.98 41.38 2.72-.55c.28-.06.29-.2.02-.3l-1.39-.55c-.26-.1-.7-.15-.98-.1l-2.7.53c-.3.06-.32.2-.06.3l1.38.58c.26.1.71.15 1 .09Z",
    fill: "#A5BCE5"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.37 2.73-.55c.28-.06.29-.19.02-.3l-1.4-.55c-.25-.1-.7-.15-.97-.09l-2.7.52c-.3.06-.33.2-.07.3l1.38.58c.27.1.72.15 1.01.1Z",
    fill: "#A6BDE6"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.36 2.73-.55c.28-.06.29-.19.02-.3l-1.4-.55c-.25-.1-.7-.15-.97-.1l-2.7.53c-.3.06-.33.2-.07.3l1.38.58c.27.1.72.15 1.01.09Z",
    fill: "#A7BEE7"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.35 2.72-.55c.28-.06.3-.2.02-.3l-1.38-.55c-.26-.1-.7-.15-.98-.1l-2.7.53c-.3.06-.33.19-.07.3l1.38.58c.26.1.72.15 1.01.09Z",
    fill: "#A8BFE8"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.34 2.72-.55c.28-.06.3-.19.02-.3l-1.39-.55c-.26-.1-.7-.15-.97-.09l-2.71.52c-.3.06-.32.2-.06.3l1.38.58c.26.1.72.15 1 .09Z",
    fill: "#A9BFE9"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.33 2.72-.55c.28-.06.29-.2.02-.3l-1.39-.55a2 2 0 0 0-.97-.1l-2.71.53c-.3.06-.32.19-.06.3l1.38.58c.26.1.72.15 1 .09Z",
    fill: "#AAC0EA"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.32 2.72-.55c.28-.06.29-.2.02-.3l-1.4-.55a2 2 0 0 0-.97-.1l-2.7.53c-.3.06-.32.19-.07.3l1.38.58c.27.1.73.15 1.02.09Z",
    fill: "#ABC1EB"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "m53.97 41.3 2.72-.54c.28-.06.29-.2.02-.3l-1.4-.55a2 2 0 0 0-.97-.1l-2.7.53c-.3.06-.32.2-.07.3l1.38.58c.27.1.72.15 1.02.09Z",
    fill: "#ACC2EC"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.3 2.72-.55c.28-.06.3-.2.02-.3l-1.38-.55a2 2 0 0 0-.98-.1l-2.7.53c-.3.06-.33.19-.07.3l1.38.57c.27.11.72.16 1.01.1Z",
    fill: "#ADC3EC"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.29 2.72-.55c.28-.06.3-.2.02-.3l-1.38-.55a2 2 0 0 0-.98-.1l-2.7.53c-.3.06-.32.2-.07.3l1.38.58c.27.1.72.15 1.01.09Z",
    fill: "#AEC4ED"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.28 2.72-.55c.28-.06.3-.2.02-.3l-1.39-.55a2 2 0 0 0-.97-.1l-2.7.53c-.3.06-.33.19-.07.3l1.38.57c.27.11.72.16 1.01.1Z",
    fill: "#AFC5EE"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.27 2.72-.56c.28-.05.3-.18.02-.3l-1.39-.55a2 2 0 0 0-.97-.08l-2.7.52c-.3.05-.33.19-.07.3l1.38.57c.27.11.72.15 1.01.1Z",
    fill: "#B0C6EF"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.26 2.72-.55c.28-.06.29-.2.02-.3l-1.39-.55a2 2 0 0 0-.98-.1l-2.7.53c-.3.06-.32.19-.06.3l1.38.57c.26.11.72.16 1 .1Z",
    fill: "#B1C7F0"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.25 2.72-.55c.28-.06.28-.2.02-.3l-1.4-.55a2 2 0 0 0-.97-.1l-2.7.53c-.3.06-.32.19-.06.3l1.37.57c.27.11.73.16 1.02.1Z",
    fill: "#B2C8F1"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "m53.96 41.24 2.72-.55c.28-.06.28-.2.02-.3l-1.4-.55a2 2 0 0 0-.97-.1l-2.7.53c-.3.06-.32.19-.06.3l1.37.57c.27.11.72.16 1.02.1Z",
    fill: "#B3C9F2"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "m53.95 41.22 2.72-.55c.28-.05.29-.19.02-.3l-1.38-.55a2 2 0 0 0-.98-.09l-2.7.53c-.3.05-.32.18-.06.3l1.37.57c.27.11.72.15 1.01.1Z",
    fill: "#B4C9F3"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "m53.95 41.22 2.72-.56c.28-.05.29-.18.02-.3l-1.38-.55a2 2 0 0 0-.98-.09l-2.7.53c-.3.05-.32.19-.06.3l1.37.57c.27.11.72.15 1.01.1Z",
    fill: "#B5CAF3"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "m53.95 41.2 2.72-.55c.28-.05.29-.19.02-.3l-1.38-.55a2 2 0 0 0-.98-.09l-2.7.53c-.3.05-.32.18-.06.3l1.37.57c.27.11.72.15 1.01.1Z",
    fill: "#B6CBF4"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "m53.95 41.2 2.72-.56c.28-.05.29-.19.02-.3l-1.38-.54a2 2 0 0 0-.98-.1l-2.7.53c-.3.06-.32.19-.06.3l1.37.57c.26.11.72.15 1.01.1Z",
    fill: "#B7CCF5"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "m53.95 41.18 2.72-.55c.28-.05.29-.18.02-.3l-1.39-.54a2 2 0 0 0-.97-.1l-2.71.53c-.29.06-.32.19-.06.3l1.38.57c.26.11.72.15 1 .1Z",
    fill: "#B8CDF6"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "m53.95 41.17 2.71-.55c.28-.05.3-.18.02-.3l-1.38-.54a2 2 0 0 0-.98-.1l-2.7.53c-.3.06-.32.19-.06.3l1.37.57c.27.11.73.15 1.02.1Z",
    fill: "#B9CEF7"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "m49.36 42.82 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.71-.15-1-.1l-2.89.57c-.3.06-.35.2-.1.31l1.38.61c.26.12.73.16 1.04.1Z",
    fill: "#7791BC"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "m49.36 42.81 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.71-.15-1-.1l-2.89.57c-.3.06-.35.2-.1.31l1.38.61c.26.12.73.16 1.04.1Z",
    fill: "#7892BD"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.8 2.9-.59c.3-.06.32-.2.06-.31l-1.38-.59c-.26-.1-.71-.15-1.01-.1l-2.88.57c-.3.06-.35.2-.1.31l1.37.61c.27.12.73.16 1.04.1Z",
    fill: "#7993BE"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.79 2.9-.59c.3-.06.32-.2.06-.31l-1.38-.59c-.26-.1-.71-.15-1.01-.1l-2.88.57c-.3.06-.35.2-.1.31l1.37.61a2 2 0 0 0 1.04.1Z",
    fill: "#7A94BF"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.78 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.7-.15-1-.1l-2.88.57c-.3.06-.35.2-.1.31l1.37.61a2 2 0 0 0 1.04.1Z",
    fill: "#7B95C0"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.77 2.9-.6c.3-.05.32-.2.05-.3l-1.38-.59c-.26-.11-.7-.15-1-.1l-2.88.56c-.31.07-.36.2-.1.32l1.37.6c.26.13.73.17 1.04.1Z",
    fill: "#7C96C0"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.76 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.7-.15-1-.1l-2.88.57c-.31.06-.36.2-.1.31l1.37.61c.26.12.73.16 1.04.1Z",
    fill: "#7D96C1"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.75 2.9-.6c.3-.05.32-.2.05-.3l-1.38-.59c-.26-.11-.7-.15-1-.1l-2.89.56c-.3.07-.35.2-.1.32l1.38.6c.26.13.73.17 1.04.1Z",
    fill: "#7E97C2"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.74 2.9-.6c.3-.05.32-.2.05-.3l-1.38-.6c-.26-.1-.7-.14-1-.09l-2.89.56c-.3.06-.35.2-.1.32l1.38.6c.26.13.73.17 1.04.1Z",
    fill: "#7F98C3"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.73 2.9-.6c.29-.06.31-.2.05-.3l-1.38-.6c-.26-.1-.71-.14-1.01-.09l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.13.74.17 1.05.1Z",
    fill: "#8099C4"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "m49.35 42.72 2.9-.6c.29-.05.31-.2.05-.3l-1.38-.59c-.26-.1-.71-.15-1.01-.1l-2.88.57c-.3.05-.35.2-.1.31l1.37.6a2 2 0 0 0 1.05.1Z",
    fill: "#819AC5"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.7 2.9-.58c.3-.06.32-.2.05-.32l-1.38-.58c-.26-.1-.7-.15-1-.1l-2.88.57c-.3.05-.35.2-.1.31l1.37.6c.27.12.73.17 1.04.1Z",
    fill: "#829BC6"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.7 2.9-.6c.3-.06.32-.2.05-.3l-1.38-.6c-.26-.1-.7-.14-1-.09l-2.88.56c-.3.06-.35.2-.1.32l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#839CC7"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.69 2.9-.6c.3-.06.32-.2.05-.3l-1.38-.59c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.73.17 1.04.1Z",
    fill: "#849DC7"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.68 2.9-.6c.3-.06.32-.2.05-.3l-1.38-.59c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.73.17 1.04.1Z",
    fill: "#859EC8"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.66 2.9-.58c.3-.07.32-.2.05-.32l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#869FC9"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.65 2.9-.58c.29-.06.32-.2.05-.32l-1.38-.58c-.26-.1-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#87A0CA"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.64 2.9-.59c.29-.06.32-.2.05-.3l-1.38-.6c-.26-.1-.71-.14-1-.09l-2.88.56c-.3.06-.35.2-.1.32l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#88A0CB"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.63 2.89-.59c.3-.06.32-.2.05-.3l-1.38-.6c-.26-.1-.7-.14-1-.09l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.74.17 1.05.1Z",
    fill: "#89A1CC"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.62 2.89-.58c.3-.07.32-.2.05-.32l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.74.17 1.05.1Z",
    fill: "#8AA2CD"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "m49.34 42.61 2.89-.59c.3-.06.32-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.73.16 1.05.1Z",
    fill: "#8BA3CE"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.6 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.73.16 1.04.1Z",
    fill: "#8CA4CE"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.6 2.9-.6c.3-.06.32-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.27.12.73.16 1.04.1Z",
    fill: "#8DA5CF"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.58 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.7-.15-1-.09l-2.88.56c-.3.06-.35.2-.1.31l1.37.61a2 2 0 0 0 1.04.1Z",
    fill: "#8EA6D0"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.57 2.9-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.7-.15-1-.09l-2.88.56c-.3.06-.35.2-.1.31l1.37.6c.26.13.73.17 1.04.1Z",
    fill: "#8FA7D1"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.56 2.9-.59c.29-.06.31-.2.05-.31l-1.38-.59c-.26-.1-.71-.15-1-.09l-2.88.56c-.3.06-.35.2-.1.31l1.37.6c.26.13.73.17 1.04.1Z",
    fill: "#90A8D2"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.55 2.9-.59c.29-.06.31-.2.05-.31l-1.38-.59c-.26-.1-.71-.15-1-.09l-2.88.56c-.3.06-.35.2-.1.31l1.37.6c.26.13.73.17 1.04.1Z",
    fill: "#91A9D3"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.54 2.89-.6c.3-.05.32-.2.05-.3l-1.37-.59c-.26-.1-.71-.15-1-.1l-2.88.57c-.3.05-.35.2-.1.3l1.37.61c.26.12.73.17 1.04.1Z",
    fill: "#92AAD4"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.53 2.89-.59c.3-.06.32-.2.05-.31l-1.37-.59c-.26-.1-.71-.15-1-.1l-2.88.57c-.3.05-.35.2-.1.3l1.37.61a2 2 0 0 0 1.04.1Z",
    fill: "#93AAD5"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.52 2.89-.59c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.7-.15-1-.1l-2.87.57c-.31.05-.36.2-.1.31l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#94ABD6"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.5 2.89-.58c.3-.06.32-.2.05-.31l-1.38-.59c-.26-.1-.7-.15-1-.1l-2.87.57c-.31.05-.36.2-.1.31l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#95ACD6"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "m49.33 42.5 2.89-.6c.3-.05.32-.2.05-.3L50.9 41c-.26-.11-.7-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.32l1.37.6c.26.12.72.17 1.04.1Z",
    fill: "#96ADD7"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "m49.32 42.48 2.89-.58c.3-.06.32-.2.06-.32L50.89 41c-.26-.1-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#97AED8"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "m49.32 42.47 2.89-.58c.3-.06.32-.2.06-.32L50.89 41c-.26-.1-.7-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#98AFD9"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "m49.32 42.46 2.89-.58c.3-.06.32-.2.05-.32l-1.37-.58c-.26-.1-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#98B0DA"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "m49.32 42.45 2.89-.58c.3-.06.32-.2.05-.32l-1.37-.58c-.26-.1-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#99B1DB"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "m49.32 42.44 2.89-.58c.3-.07.32-.2.05-.32l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#9AB2DC"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "m49.32 42.43 2.89-.58c.3-.07.32-.2.05-.32l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#9BB3DD"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.42 2.9-.58c.3-.07.31-.2.05-.32l-1.38-.58c-.26-.11-.7-.15-1-.1L47 41.4c-.3.06-.35.2-.1.32l1.37.6c.27.12.74.16 1.04.1Z",
    fill: "#9CB4DD"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.41 2.9-.59c.3-.06.31-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1L47 41.4c-.3.06-.35.2-.1.31l1.37.6c.27.13.73.17 1.04.11Z",
    fill: "#9DB5DE"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.4 2.9-.59c.29-.06.31-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.31l1.37.6c.26.13.72.17 1.03.11Z",
    fill: "#9EB5DF"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.39 2.9-.59c.29-.06.31-.2.05-.3l-1.38-.6c-.26-.1-.7-.14-1-.09l-2.88.56c-.3.06-.35.2-.1.31l1.37.61a2 2 0 0 0 1.04.1Z",
    fill: "#9FB6E0"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.38 2.9-.59c.29-.06.31-.2.05-.3l-1.38-.6c-.26-.1-.7-.14-1-.09l-2.88.56c-.3.06-.35.2-.1.31l1.37.61c.27.12.73.16 1.04.1Z",
    fill: "#A0B7E1"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.37 2.89-.58c.3-.07.32-.2.05-.32l-1.37-.58c-.26-.11-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#A1B8E2"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "m49.31 42.36 2.89-.59c.3-.06.32-.2.05-.31l-1.37-.58c-.26-.11-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#A2B9E3"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.35 2.9-.59c.3-.06.31-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#A3BAE4"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.34 2.9-.59c.3-.06.31-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.31l1.37.6c.26.13.73.17 1.04.1Z",
    fill: "#A4BBE5"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.33 2.9-.59c.29-.06.31-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#A5BCE5"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.31 2.9-.58c.29-.06.31-.2.05-.31l-1.38-.58c-.26-.11-.7-.15-1-.1L47 41.3c-.3.06-.35.2-.1.31l1.37.6c.26.12.72.17 1.03.1Z",
    fill: "#A6BDE6"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.3 2.9-.58c.29-.06.31-.2.05-.31l-1.38-.58c-.26-.1-.7-.15-1-.1L47 41.3c-.3.06-.35.2-.1.32l1.37.6c.26.11.72.16 1.03.1Z",
    fill: "#A7BEE7"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.3 2.89-.59c.3-.06.32-.2.05-.31l-1.37-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.31l1.36.61c.27.11.73.16 1.04.1Z",
    fill: "#A8BFE8"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.28 2.89-.58c.3-.06.32-.2.05-.31l-1.37-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.31l1.36.6c.27.12.73.16 1.04.1Z",
    fill: "#A9BFE9"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.27 2.88-.58c.3-.06.33-.2.06-.31l-1.37-.58c-.26-.11-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.31l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#AAC0EA"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.26 2.88-.58c.3-.06.33-.2.06-.31l-1.37-.58c-.26-.11-.71-.15-1-.1l-2.88.56c-.3.06-.35.2-.1.31l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#ABC1EB"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.25 2.88-.58c.3-.06.32-.2.06-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.3.05-.35.2-.1.3l1.37.61a2 2 0 0 0 1.04.1Z",
    fill: "#ACC2EC"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.24 2.88-.58c.3-.06.32-.2.06-.31l-1.38-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.3.05-.35.2-.1.31l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#ADC3EC"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.23 2.88-.58c.3-.06.32-.2.06-.31l-1.38-.58c-.25-.11-.7-.15-1-.1l-2.87.56c-.3.05-.35.2-.1.31l1.37.6c.26.12.73.17 1.04.1Z",
    fill: "#AEC4ED"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.22 2.88-.58c.3-.07.32-.2.06-.32l-1.38-.58c-.26-.1-.7-.15-1-.09l-2.87.55c-.3.06-.35.2-.1.32l1.37.6c.26.12.72.16 1.03.1Z",
    fill: "#AFC5EE"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.21 2.88-.58c.3-.07.32-.2.05-.32l-1.37-.58c-.26-.1-.7-.15-1-.09l-2.87.55c-.3.06-.35.2-.1.32l1.37.6c.26.12.72.16 1.03.1Z",
    fill: "#B0C6EF"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.2 2.88-.58c.3-.07.32-.2.05-.32l-1.37-.57c-.26-.11-.71-.16-1-.1l-2.87.55c-.31.06-.35.2-.1.32l1.36.6c.27.12.73.16 1.04.1Z",
    fill: "#B1C7F0"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 42.19 2.88-.59c.3-.06.32-.2.05-.3l-1.37-.59c-.26-.1-.71-.15-1-.1l-2.87.56c-.31.06-.35.2-.1.32l1.36.6c.27.12.73.16 1.04.1Z",
    fill: "#B2C8F1"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "m49.29 42.18 2.88-.59c.3-.06.32-.2.06-.3l-1.38-.59c-.25-.1-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#B3C9F2"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "m49.29 42.17 2.88-.59c.3-.06.32-.2.06-.3l-1.38-.59c-.25-.1-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#B4C9F3"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "m49.29 42.16 2.88-.59c.3-.06.32-.2.06-.3l-1.38-.59c-.26-.1-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.32l1.37.6c.26.12.73.16 1.04.1Z",
    fill: "#B5CAF3"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "m49.29 42.15 2.88-.59c.3-.06.32-.2.06-.31l-1.38-.58c-.26-.1-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.31l1.37.6a2 2 0 0 0 1.04.1Z",
    fill: "#B6CBF4"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "m49.29 42.14 2.88-.59c.3-.06.32-.2.06-.31l-1.38-.58c-.26-.1-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.31l1.36.6c.27.12.74.17 1.05.1Z",
    fill: "#B7CCF5"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "m49.28 42.12 2.89-.58c.3-.06.32-.2.05-.31l-1.37-.58c-.26-.11-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.31l1.36.6c.27.12.74.17 1.04.1Z",
    fill: "#B8CDF6"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "m49.28 42.12 2.89-.59c.3-.06.32-.2.05-.3l-1.37-.59c-.26-.1-.7-.15-1-.1l-2.87.56c-.3.06-.35.2-.1.31l1.36.6c.27.12.73.17 1.04.1Z",
    fill: "#B9CEF7"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.84 3.08-.63c.31-.06.36-.21.09-.33l-1.36-.61a2.02 2.02 0 0 0-1.04-.1l-3.05.6c-.33.06-.4.2-.14.33l1.35.64c.26.12.74.16 1.07.1Z",
    fill: "#7791BC"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.83 3.08-.63c.31-.07.36-.22.09-.33l-1.36-.62a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.07-.4.21-.14.33l1.35.64c.26.13.74.18 1.07.1Z",
    fill: "#7892BD"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.82 3.08-.63c.31-.06.36-.21.09-.33l-1.36-.61a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.4.2-.14.33l1.35.64a2 2 0 0 0 1.07.1Z",
    fill: "#7993BE"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.8 3.07-.62c.32-.07.36-.22.1-.33l-1.37-.62a2.01 2.01 0 0 0-1.03-.1l-3.05.6c-.33.07-.4.21-.14.33l1.35.64c.26.12.74.17 1.07.1Z",
    fill: "#7A94BF"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.8 3.07-.63c.32-.06.36-.21.1-.33l-1.37-.62a2.01 2.01 0 0 0-1.03-.1l-3.05.6c-.33.07-.4.21-.14.33l1.35.64a2 2 0 0 0 1.07.1Z",
    fill: "#7B95C0"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.78 3.07-.62c.32-.06.36-.21.1-.33l-1.37-.62a2.02 2.02 0 0 0-1.03-.1l-3.05.6c-.33.07-.4.21-.14.33l1.35.64a2 2 0 0 0 1.07.1Z",
    fill: "#7C96C0"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "m44.38 43.77 3.07-.63c.32-.06.36-.2.1-.33l-1.37-.61a2.01 2.01 0 0 0-1.03-.1l-3.06.6c-.32.06-.39.2-.13.33l1.35.64c.26.12.74.17 1.07.1Z",
    fill: "#7D96C1"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.76 3.08-.62c.32-.07.36-.22.1-.34l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.06.59c-.33.06-.39.21-.13.33l1.34.64c.27.12.74.17 1.07.1Z",
    fill: "#7E97C2"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.75 3.08-.62c.32-.07.36-.22.1-.34l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.06.59c-.33.06-.39.21-.13.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#7F98C3"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.74 3.08-.63c.32-.06.36-.2.1-.33l-1.37-.61a2.01 2.01 0 0 0-1.03-.1l-3.06.6c-.33.06-.39.2-.13.33l1.34.64a2 2 0 0 0 1.07.1Z",
    fill: "#8099C4"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.73 3.08-.63c.32-.06.36-.2.1-.33l-1.37-.61a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.4.2-.14.33l1.35.64a2 2 0 0 0 1.07.1Z",
    fill: "#819AC5"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.72 3.08-.63c.32-.06.36-.2.1-.33l-1.37-.61a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.4.2-.14.33l1.35.63c.26.13.74.18 1.07.1Z",
    fill: "#829BC6"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.7 3.08-.62c.32-.06.36-.21.1-.33l-1.37-.61a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.4.2-.14.32l1.35.64c.26.13.74.18 1.07.1Z",
    fill: "#839CC7"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.7 3.07-.63c.32-.06.36-.2.1-.33l-1.37-.61a2.01 2.01 0 0 0-1.03-.1l-3.05.6c-.33.06-.4.2-.14.33l1.35.63a2 2 0 0 0 1.07.1Z",
    fill: "#849DC7"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.69 3.08-.63c.31-.06.35-.21.09-.33l-1.36-.61a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.4.2-.14.32l1.35.64c.26.13.74.17 1.07.1Z",
    fill: "#859EC8"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.68 3.07-.63c.32-.06.36-.21.1-.33l-1.36-.61a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.39.2-.13.32l1.34.64c.26.13.74.17 1.07.1Z",
    fill: "#869FC9"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.66 3.07-.62c.32-.07.36-.21.1-.33l-1.36-.62a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.39.21-.13.33l1.34.64c.26.13.74.17 1.07.1Z",
    fill: "#87A0CA"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.65 3.07-.62c.32-.07.36-.21.1-.33l-1.37-.62a2.01 2.01 0 0 0-1.03-.1l-3.05.6c-.33.06-.4.21-.14.33l1.35.64c.26.13.74.17 1.07.1Z",
    fill: "#88A0CB"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.64 3.07-.62c.32-.07.36-.22.1-.34l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.05.59c-.33.06-.4.2-.14.33l1.35.64c.26.12.74.17 1.07.1Z",
    fill: "#89A1CC"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "m44.37 43.63 3.07-.62c.32-.07.36-.21.1-.34l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.05.59c-.33.06-.4.2-.14.33l1.35.64c.26.12.74.17 1.07.1Z",
    fill: "#8AA2CD"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.62 3.08-.62c.31-.06.36-.21.09-.33l-1.36-.62a2.01 2.01 0 0 0-1.03-.1l-3.06.6c-.32.06-.39.21-.13.33l1.34.64c.26.13.75.17 1.07.1Z",
    fill: "#8BA3CE"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.61 3.08-.62c.31-.07.36-.22.09-.34l-1.36-.6a2.01 2.01 0 0 0-1.03-.1l-3.06.59c-.32.06-.39.2-.13.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#8CA4CE"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.6 3.08-.63c.31-.06.36-.2.09-.33l-1.36-.6a2.01 2.01 0 0 0-1.03-.1l-3.06.59c-.32.06-.39.2-.13.33l1.34.64a2 2 0 0 0 1.07.1Z",
    fill: "#8DA5CF"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.59 3.07-.63c.32-.06.36-.2.1-.33l-1.36-.6a2.01 2.01 0 0 0-1.04-.1l-3.05.59c-.33.06-.39.2-.13.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#8EA6D0"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.58 3.07-.63c.32-.06.36-.2.1-.33l-1.36-.6a2.01 2.01 0 0 0-1.04-.1l-3.05.59c-.33.06-.39.2-.13.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#8FA7D1"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.57 3.07-.63c.32-.06.36-.21.1-.33L46.17 42a2.01 2.01 0 0 0-1.04-.1l-3.05.6c-.33.06-.39.2-.13.33l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#90A8D2"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.56 3.07-.63c.32-.06.36-.2.1-.33l-1.36-.6a2.01 2.01 0 0 0-1.04-.1l-3.05.59c-.32.06-.39.2-.13.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#91A9D3"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.55 3.07-.63c.32-.06.36-.21.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.06-.39.2-.13.33l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#92AAD4"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.54 3.07-.63c.32-.06.36-.2.1-.33l-1.37-.6a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.39.21-.13.33l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#93AAD5"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.53 3.07-.63c.31-.06.36-.2.1-.33l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.05.59c-.33.06-.4.21-.14.33l1.35.64c.26.12.74.16 1.07.1Z",
    fill: "#94ABD6"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.52 3.07-.63c.31-.06.36-.2.1-.33l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.05.59c-.33.06-.4.21-.14.33l1.35.64c.26.12.74.16 1.07.1Z",
    fill: "#95ACD6"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.5 3.07-.62c.31-.06.36-.21.1-.33l-1.37-.6a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.4.2-.14.33l1.35.64c.26.12.74.16 1.07.1Z",
    fill: "#96ADD7"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 43.5 3.07-.63c.31-.06.36-.21.1-.33l-1.37-.6a2.01 2.01 0 0 0-1.03-.1l-3.05.59c-.33.06-.4.2-.14.33l1.35.63c.26.12.74.17 1.07.1Z",
    fill: "#97AED8"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.48 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.04-.1l-3.05.59c-.32.06-.38.2-.13.33l1.34.63c.26.12.75.17 1.07.1Z",
    fill: "#98AFD9"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.47 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.61a2 2 0 0 0-1.04-.1l-3.05.6c-.32.06-.38.2-.13.33l1.34.63c.26.12.74.17 1.07.1Z",
    fill: "#98B0DA"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.46 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.06-.4.2-.14.32l1.35.64c.26.12.73.17 1.06.1Z",
    fill: "#99B1DB"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.45 3.07-.62c.32-.07.36-.22.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.05.59c-.32.06-.38.21-.13.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#9AB2DC"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.44 3.07-.62c.32-.07.36-.21.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.32.06-.38.2-.13.32l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#9BB3DD"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.43 3.07-.62c.32-.07.36-.22.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.04.59c-.33.06-.4.21-.14.33l1.35.64a2 2 0 0 0 1.06.1Z",
    fill: "#9CB4DD"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.42 3.07-.63c.32-.06.36-.2.1-.32l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.39.21-.14.33l1.35.64c.25.12.73.16 1.06.1Z",
    fill: "#9DB5DE"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.41 3.07-.62c.32-.07.36-.21.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.04.59c-.33.06-.4.21-.14.33l1.35.64c.25.12.73.17 1.06.1Z",
    fill: "#9EB5DF"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.4 3.07-.63c.31-.06.36-.2.09-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.59c-.32.06-.38.2-.13.33l1.34.63c.26.13.74.18 1.07.1Z",
    fill: "#9FB6E0"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.38 3.07-.62c.31-.06.36-.21.09-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.58c-.32.07-.38.22-.13.34l1.34.63a2 2 0 0 0 1.07.1Z",
    fill: "#A0B7E1"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.37 3.06-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.39.2-.13.33l1.34.63a2 2 0 0 0 1.07.1Z",
    fill: "#A1B8E2"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.36 3.06-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.39.2-.13.33l1.34.63a2 2 0 0 0 1.07.1Z",
    fill: "#A2B9E3"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "m44.35 43.36 3.06-.63c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.39.2-.13.33l1.34.63a2 2 0 0 0 1.07.1Z",
    fill: "#A3BAE4"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.34 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.58c-.33.07-.39.22-.14.34l1.34.63c.27.13.75.17 1.07.1Z",
    fill: "#A4BBE5"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.33 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.06-.39.2-.14.32l1.34.64c.26.12.75.17 1.07.1Z",
    fill: "#A5BCE5"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.32 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.06-.39.2-.14.32l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#A6BDE6"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.31 3.07-.62c.32-.06.36-.21.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.06-.39.2-.14.32l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#A7BEE7"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.3 3.07-.62c.31-.06.36-.21.1-.33l-1.37-.6a2 2 0 0 0-1.03-.1l-3.04.58c-.33.07-.39.22-.14.33l1.34.64a2 2 0 0 0 1.07.1Z",
    fill: "#A8BFE8"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.29 3.07-.62c.31-.06.36-.21.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.04.6c-.33.06-.39.2-.14.32l1.34.64a2 2 0 0 0 1.07.1Z",
    fill: "#A9BFE9"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.28 3.07-.62c.31-.07.35-.21.09-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.04.6c-.33.06-.4.2-.14.32l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#AAC0EA"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.27 3.06-.62c.32-.07.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.58c-.32.07-.38.22-.13.33l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#ABC1EB"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.26 3.06-.62c.32-.07.36-.22.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.32.06-.38.2-.13.32l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#ACC2EC"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.25 3.06-.62c.32-.07.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.05.58c-.32.07-.38.22-.13.33l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#ADC3EC"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.24 3.06-.62c.32-.07.36-.22.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.06-.39.2-.13.32l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#AEC4ED"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.23 3.06-.63c.32-.06.36-.2.1-.32l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.59c-.33.06-.39.21-.13.33l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#AFC5EE"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "m44.34 43.22 3.06-.63c.32-.06.36-.2.1-.32l-1.36-.61a2 2 0 0 0-1.03-.1l-3.05.6c-.33.05-.39.2-.13.32l1.34.64c.26.12.74.16 1.07.1Z",
    fill: "#B0C6EF"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.2 3.07-.61c.32-.07.36-.22.1-.33l-1.37-.61a2 2 0 0 0-1.03-.1l-3.04.6c-.33.05-.39.2-.14.32l1.35.64c.26.12.74.16 1.06.1Z",
    fill: "#B1C7F0"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.2 3.07-.63c.31-.06.35-.2.1-.33l-1.37-.6a2 2 0 0 0-1.03-.1l-3.04.59c-.33.06-.39.2-.14.33l1.34.63c.27.12.75.17 1.07.1Z",
    fill: "#B2C8F1"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.18 3.07-.62c.31-.06.35-.2.1-.33l-1.37-.6a2 2 0 0 0-1.03-.1l-3.04.59c-.33.06-.39.2-.14.33l1.34.63c.27.12.74.17 1.07.1Z",
    fill: "#B3C9F2"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.17 3.07-.62c.31-.06.36-.21.1-.33l-1.37-.6a2 2 0 0 0-1.03-.1l-3.04.58c-.32.07-.39.22-.13.33l1.34.64c.25.12.73.17 1.06.1Z",
    fill: "#B4C9F3"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.16 3.07-.62c.31-.06.35-.21.09-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.04.59c-.32.06-.39.2-.13.32l1.34.64c.25.12.73.17 1.06.1Z",
    fill: "#B5CAF3"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.15 3.06-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.04.58c-.33.07-.39.22-.14.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#B6CBF4"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.14 3.06-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.04.58c-.33.07-.39.21-.14.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#B7CCF5"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.13 3.06-.62c.32-.06.36-.21.1-.33l-1.36-.6a2 2 0 0 0-1.03-.1l-3.04.58c-.33.07-.4.21-.14.33l1.34.64c.26.12.74.17 1.07.1Z",
    fill: "#B8CDF6"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "m44.33 43.12 3.06-.62c.32-.07.36-.21.1-.33l-1.36-.61a2 2 0 0 0-1.03-.1l-3.04.59c-.33.06-.4.21-.14.33l1.34.63c.26.13.74.17 1.07.1Z",
    fill: "#B9CEF7"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.91 3.28-.66c.34-.07.4-.23.14-.35l-1.35-.65a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.36l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#7791BC"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.9 3.28-.66c.34-.07.4-.23.14-.35l-1.35-.65a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.34.07-.43.23-.18.36l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#7892BD"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.9 3.28-.67c.34-.07.4-.23.14-.35l-1.35-.65a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.36l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#7993BE"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.88 3.28-.66c.34-.07.4-.23.14-.35l-1.35-.65a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.35l1.32.68c.26.13.75.18 1.1.1Z",
    fill: "#7A94BF"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.87 3.28-.66c.34-.07.4-.23.14-.35l-1.35-.65a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.35l1.32.68c.26.13.75.17 1.1.1Z",
    fill: "#7B95C0"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.86 3.28-.67c.34-.06.4-.22.14-.35l-1.35-.64a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.18.35l1.32.68a2 2 0 0 0 1.1.1Z",
    fill: "#7C96C0"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.85 3.28-.67c.34-.06.4-.22.14-.35l-1.35-.64a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.18.35l1.32.68c.26.12.75.17 1.1.1Z",
    fill: "#7D96C1"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.84 3.27-.67c.34-.07.4-.22.14-.35l-1.34-.64a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.19.35l1.33.67a2 2 0 0 0 1.1.1Z",
    fill: "#7E97C2"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.83 3.27-.67c.34-.07.4-.22.14-.35l-1.34-.64a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.19.35l1.33.67c.26.13.75.18 1.1.1Z",
    fill: "#7F98C3"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.82 3.27-.67c.34-.07.4-.22.14-.35l-1.34-.64a2.02 2.02 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.19.35l1.33.67c.25.13.75.18 1.1.1Z",
    fill: "#8099C4"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.8 3.27-.66c.34-.07.4-.22.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.18.35l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#819AC5"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.8 3.27-.67c.34-.07.4-.23.14-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.36l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#829BC6"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.78 3.28-.66c.33-.07.4-.23.13-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.07-.44.23-.19.36l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#839CC7"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.77 3.27-.66c.34-.07.4-.23.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.25.62c-.35.07-.43.23-.18.36l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#849DC7"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.76 3.27-.66c.34-.07.4-.23.14-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.35l1.32.68c.25.13.75.18 1.1.1Z",
    fill: "#859EC8"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.75 3.27-.67c.34-.06.4-.22.14-.34l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.22-.18.35l1.32.67c.25.14.75.18 1.1.11Z",
    fill: "#869FC9"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.74 3.27-.66c.34-.07.4-.23.14-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.35.07-.43.23-.18.35l1.32.67c.25.13.75.18 1.1.11Z",
    fill: "#87A0CA"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.73 3.27-.66c.34-.07.4-.23.14-.35l-1.35-.65a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.07-.43.23-.19.35l1.33.67c.25.13.75.18 1.1.11Z",
    fill: "#88A0CB"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.72 3.27-.67c.34-.07.4-.22.14-.35l-1.35-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.07-.43.22-.19.35l1.33.67c.25.13.75.18 1.1.1Z",
    fill: "#89A1CC"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.7 3.27-.66c.34-.07.4-.22.14-.35l-1.35-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.06-.43.22-.19.35l1.33.67c.25.13.75.18 1.1.1Z",
    fill: "#8AA2CD"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.7 3.27-.67c.34-.07.4-.22.13-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.06-.44.22-.19.35l1.32.67c.26.13.76.18 1.1.1Z",
    fill: "#8BA3CE"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.69 3.27-.67c.33-.07.4-.22.13-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.06-.44.22-.19.35l1.32.67c.26.13.76.18 1.1.1Z",
    fill: "#8CA4CE"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.67 3.27-.66c.33-.07.4-.22.13-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.06-.43.22-.19.35l1.32.67c.26.13.76.18 1.1.1Z",
    fill: "#8DA5CF"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.66 3.27-.66c.33-.07.4-.23.13-.35L41.14 43a2.01 2.01 0 0 0-1.06-.1l-3.24.62c-.35.07-.43.23-.19.35l1.32.68c.26.13.76.17 1.1.1Z",
    fill: "#8EA6D0"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.65 3.27-.66c.33-.07.4-.23.13-.35L41.14 43a2.01 2.01 0 0 0-1.06-.1l-3.24.62c-.35.07-.43.23-.19.35l1.32.68c.26.13.76.17 1.1.1Z",
    fill: "#8FA7D1"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.64 3.27-.66c.33-.07.4-.23.13-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.62c-.35.07-.43.23-.19.35l1.32.68a2 2 0 0 0 1.1.1Z",
    fill: "#90A8D2"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "m39.08 44.63 3.27-.66c.33-.07.4-.23.13-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.07-.43.23-.19.35l1.32.67c.26.14.75.18 1.1.11Z",
    fill: "#91A9D3"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.62 3.27-.66c.34-.07.4-.23.14-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.34.07-.43.23-.18.35l1.32.67c.26.13.75.18 1.1.11Z",
    fill: "#92AAD4"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.61 3.27-.66c.34-.07.4-.23.14-.35l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.34.07-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.11Z",
    fill: "#93AAD5"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.6 3.27-.67c.34-.06.4-.22.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.34.06-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#94ABD6"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.59 3.27-.67c.34-.06.4-.22.14-.34l-1.34-.65a2 2 0 0 0-1.06-.1l-3.25.63c-.34.06-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#95ACD6"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.58 3.27-.67c.34-.07.4-.22.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.34.06-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#96ADD7"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.57 3.27-.67c.34-.07.4-.22.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.25.63c-.34.06-.43.22-.18.35l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#97AED8"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.55 3.27-.66c.34-.07.4-.22.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.06-.44.22-.19.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#98AFD9"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.55 3.27-.67c.34-.07.4-.22.14-.35l-1.35-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.34.06-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#98B0DA"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.54 3.27-.67c.34-.07.4-.22.14-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.35.06-.44.22-.19.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#99B1DB"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.52 3.27-.66c.34-.07.4-.22.14-.35l-1.34-.64a2 2 0 0 0-1.06-.1l-3.24.63c-.35.06-.44.22-.19.34l1.32.68a2 2 0 0 0 1.1.1Z",
    fill: "#9AB2DC"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.51 3.27-.66c.33-.07.4-.23.13-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.62c-.34.07-.43.23-.18.35l1.32.67c.26.13.75.18 1.1.11Z",
    fill: "#9BB3DD"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.5 3.27-.66c.33-.07.4-.23.13-.35l-1.34-.64a2.01 2.01 0 0 0-1.06-.1l-3.24.62c-.34.07-.43.23-.18.35l1.32.67c.26.13.75.18 1.1.11Z",
    fill: "#9CB4DD"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.49 3.27-.66c.33-.07.4-.23.13-.35l-1.34-.64a2 2 0 0 0-1.06-.1l-3.24.62c-.34.07-.43.23-.18.35l1.32.67c.26.13.75.18 1.1.11Z",
    fill: "#9DB5DE"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.48 3.27-.67c.33-.06.4-.22.13-.34l-1.34-.65a2.01 2.01 0 0 0-1.06-.1l-3.24.63c-.34.07-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#9EB5DF"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.47 3.26-.67c.34-.07.4-.22.14-.35l-1.34-.64a2 2 0 0 0-1.06-.1l-3.24.63c-.35.06-.43.22-.18.35l1.32.67c.26.13.75.18 1.1.1Z",
    fill: "#9FB6E0"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.46 3.27-.67c.33-.06.4-.22.13-.34l-1.34-.64a2 2 0 0 0-1.06-.1l-3.24.62c-.34.07-.43.23-.18.35l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#A0B7E1"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.45 3.27-.67c.33-.07.4-.22.13-.34l-1.34-.64a2 2 0 0 0-1.05-.1l-3.24.62c-.35.07-.44.23-.19.35l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#A1B8E2"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.43 3.27-.66c.33-.07.4-.22.13-.34l-1.34-.64a2 2 0 0 0-1.05-.1l-3.24.62c-.35.07-.44.23-.19.35l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#A2B9E3"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.42 3.27-.66c.33-.07.4-.22.13-.34l-1.34-.64a2 2 0 0 0-1.05-.1l-3.24.62c-.35.07-.44.23-.19.35l1.32.67c.25.13.75.18 1.1.1Z",
    fill: "#A3BAE4"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.41 3.27-.66c.33-.07.4-.22.13-.34l-1.34-.65a1.98 1.98 0 0 0-1.05-.1l-3.24.63c-.35.07-.44.23-.19.35l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#A4BBE5"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.4 3.26-.66c.34-.07.4-.22.14-.34l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.62c-.35.07-.43.23-.18.35l1.32.67c.25.13.74.17 1.1.1Z",
    fill: "#A5BCE5"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.4 3.26-.67c.34-.07.4-.22.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.63c-.35.07-.43.23-.18.35l1.31.67c.26.13.75.17 1.1.1Z",
    fill: "#A6BDE6"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.38 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.63c-.35.07-.43.22-.18.35l1.31.67c.26.12.75.17 1.1.1Z",
    fill: "#A7BEE7"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.37 3.26-.66c.34-.07.4-.22.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.63c-.35.06-.43.22-.18.35l1.31.67a2 2 0 0 0 1.1.1Z",
    fill: "#A8BFE8"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.36 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.62c-.35.07-.43.23-.18.35l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#A9BFE9"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.35 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.62c-.35.07-.43.23-.18.35l1.31.67a2 2 0 0 0 1.1.1Z",
    fill: "#AAC0EA"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "m39.07 44.34 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.24.62c-.34.07-.43.23-.18.35l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#ABC1EB"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.33 3.27-.67c.33-.06.4-.22.13-.34l-1.34-.64a1.98 1.98 0 0 0-1.05-.1l-3.24.62c-.35.07-.43.22-.18.35l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#ACC2EC"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.31 3.27-.66c.33-.07.4-.22.13-.34l-1.34-.64a1.98 1.98 0 0 0-1.05-.1l-3.24.62c-.35.07-.43.22-.18.35l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#ADC3EC"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.3 3.27-.66c.33-.07.4-.22.13-.35l-1.34-.64a1.98 1.98 0 0 0-1.05-.1l-3.24.63c-.35.07-.43.22-.18.35l1.31.67a2 2 0 0 0 1.1.1Z",
    fill: "#AEC4ED"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.3 3.27-.67c.33-.07.4-.22.13-.34l-1.34-.64a1.98 1.98 0 0 0-1.05-.1l-3.24.62c-.35.07-.43.22-.18.35l1.31.67a2 2 0 0 0 1.1.1Z",
    fill: "#AFC5EE"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.29 3.27-.67c.33-.06.4-.22.13-.34l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.62c-.35.07-.43.22-.19.35l1.32.67c.26.13.75.17 1.1.1Z",
    fill: "#B0C6EF"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.27 3.27-.66c.33-.07.4-.22.13-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.06-.43.22-.19.35l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#B1C7F0"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.26 3.27-.66c.33-.07.4-.23.13-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.06-.43.22-.19.35l1.32.66a2 2 0 0 0 1.1.11Z",
    fill: "#B2C8F1"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.25 3.26-.66c.34-.07.4-.22.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.07-.43.22-.19.35l1.32.67c.26.12.75.17 1.1.1Z",
    fill: "#B3C9F2"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.24 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.07-.43.22-.19.35l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#B4C9F3"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.23 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.07-.43.22-.19.35l1.32.67a2 2 0 0 0 1.1.1Z",
    fill: "#B5CAF3"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.22 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.06-.43.22-.18.34l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#B6CBF4"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.2 3.26-.65c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.06-.43.22-.18.34l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#B7CCF5"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.2 3.26-.66c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.06-.43.22-.18.34l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#B8CDF6"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "m39.06 44.18 3.26-.65c.34-.07.4-.23.14-.35l-1.34-.64a1.98 1.98 0 0 0-1.06-.1l-3.23.63c-.35.06-.43.22-.18.34l1.31.67c.26.13.75.18 1.1.1Z",
    fill: "#B9CEF7"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 46.07 3.5-.72c.35-.07.43-.24.18-.37l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.46.67c-.37.08-.48.24-.23.38l1.29.7c.25.14.76.2 1.14.12Z",
    fill: "#7791BC"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 46.06 3.5-.71c.35-.08.43-.24.18-.37l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.46.67c-.37.07-.48.24-.23.37l1.29.7c.25.14.76.2 1.14.12Z",
    fill: "#7892BD"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 46.04 3.5-.7c.36-.08.44-.25.19-.38l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.46.67c-.37.07-.47.24-.23.38l1.29.7c.25.14.76.2 1.13.11Z",
    fill: "#7993BE"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 46.03 3.5-.7c.36-.08.44-.25.19-.38l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.46.67c-.37.07-.47.24-.23.38l1.29.7c.25.14.76.2 1.13.11Z",
    fill: "#7A94BF"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 46.02 3.5-.7c.36-.08.44-.25.19-.38l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.46.67c-.37.07-.47.24-.23.37l1.29.71c.25.14.76.19 1.13.11Z",
    fill: "#7B95C0"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 46.01 3.5-.71c.35-.07.43-.24.18-.37l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.45.67c-.38.07-.48.24-.24.37l1.3.71c.24.14.75.19 1.13.11Z",
    fill: "#7C96C0"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 46 3.5-.71c.36-.08.44-.24.19-.37l-1.32-.68a1.98 1.98 0 0 0-1.1-.1l-3.45.67c-.38.07-.48.24-.24.37l1.29.71c.25.14.76.19 1.13.11Z",
    fill: "#7D96C1"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.99 3.49-.71c.36-.08.44-.24.19-.37l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.3.71c.24.14.75.19 1.13.11Z",
    fill: "#7E97C2"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.98 3.49-.72c.36-.07.44-.24.19-.37l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.3.71c.24.14.75.2 1.13.12Z",
    fill: "#7F98C3"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.97 3.49-.71c.36-.08.44-.24.19-.37l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.08-.48.24-.24.38l1.29.7c.25.14.76.2 1.14.12Z",
    fill: "#8099C4"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.96 3.49-.72c.36-.07.44-.24.19-.37l-1.32-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.71c.25.14.76.2 1.14.12Z",
    fill: "#819AC5"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.94 3.49-.7c.36-.08.44-.25.19-.38l-1.32-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.38l1.29.7c.25.14.76.2 1.14.11Z",
    fill: "#829BC6"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.93 3.49-.7c.36-.08.44-.24.19-.38l-1.32-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.38l1.29.7c.25.14.76.2 1.14.11Z",
    fill: "#839CC7"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.92 3.49-.7c.36-.08.44-.24.19-.38l-1.32-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.38l1.29.7c.25.14.76.2 1.14.11Z",
    fill: "#849DC7"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.91 3.49-.7c.36-.08.44-.25.19-.38l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.71c.25.14.76.19 1.14.11Z",
    fill: "#859EC8"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.9 3.49-.7c.35-.08.44-.25.18-.38l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.71c.25.14.76.19 1.14.11Z",
    fill: "#869FC9"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.9 3.49-.72c.35-.07.44-.24.18-.37l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.71a2 2 0 0 0 1.14.11Z",
    fill: "#87A0CA"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.88 3.49-.71c.35-.08.44-.24.18-.37l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.71c.25.14.76.18 1.14.1Z",
    fill: "#88A0CB"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.87 3.49-.71c.35-.08.44-.24.18-.37l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.7c.25.14.76.2 1.14.12Z",
    fill: "#89A1CC"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.85 3.49-.7c.35-.08.44-.25.18-.38l-1.31-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.08-.48.24-.24.37l1.29.71c.25.14.76.2 1.14.11Z",
    fill: "#8AA2CD"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.85 3.49-.71c.35-.08.44-.24.18-.37l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.76.2 1.14.12Z",
    fill: "#8BA3CE"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.83 3.49-.7c.35-.08.44-.25.18-.38l-1.31-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.08-.48.24-.24.38l1.29.7c.25.14.76.2 1.14.11Z",
    fill: "#8CA4CE"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.82 3.49-.7c.35-.08.44-.25.18-.38l-1.31-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.71c.25.14.76.19 1.14.11Z",
    fill: "#8DA5CF"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.81 3.49-.7c.35-.08.44-.25.18-.38l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.71c.25.14.76.19 1.14.11Z",
    fill: "#8EA6D0"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.8 3.48-.7c.36-.08.45-.24.2-.38l-1.33-.67a1.97 1.97 0 0 0-1.09-.1l-3.45.66c-.37.08-.48.24-.24.37l1.29.71c.25.14.76.19 1.14.11Z",
    fill: "#8FA7D1"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.79 3.48-.71c.36-.07.45-.24.2-.37l-1.33-.68a1.97 1.97 0 0 0-1.09-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.7c.25.15.76.2 1.14.12Z",
    fill: "#90A8D2"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.78 3.48-.71c.36-.07.45-.24.2-.37l-1.33-.68a1.97 1.97 0 0 0-1.09-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.7c.25.15.76.2 1.14.12Z",
    fill: "#91A9D3"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.77 3.48-.71c.36-.08.45-.24.2-.37L35.78 44a1.97 1.97 0 0 0-1.09-.1l-3.45.67c-.37.07-.48.24-.24.37l1.29.7c.25.14.76.2 1.14.12Z",
    fill: "#92AAD4"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 45.76 3.5-.71c.35-.08.43-.24.18-.37L35.8 44a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.23-.24.37l1.3.7c.24.14.75.2 1.12.12Z",
    fill: "#93AAD5"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 45.74 3.5-.7c.35-.08.43-.24.18-.38L35.8 44a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.37l1.3.71c.24.14.75.2 1.12.11Z",
    fill: "#94ABD6"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 45.73 3.5-.7c.35-.08.43-.24.18-.38l-1.31-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.37l1.3.71c.24.14.75.19 1.12.11Z",
    fill: "#95ACD6"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 45.72 3.5-.7c.35-.08.43-.24.18-.37l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.37l1.3.71c.24.14.75.19 1.12.11Z",
    fill: "#96ADD7"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 45.71 3.5-.7c.35-.08.43-.24.18-.37l-1.31-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.24.37l1.3.71c.24.14.75.19 1.12.11Z",
    fill: "#97AED8"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.7 3.48-.7c.36-.08.45-.24.2-.37l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.23.37l1.29.71c.24.14.75.19 1.13.11Z",
    fill: "#98AFD9"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.69 3.48-.7c.36-.08.45-.25.2-.38l-1.32-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.23.37l1.29.7c.24.15.75.2 1.13.12Z",
    fill: "#98B0DA"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.68 3.48-.7c.36-.08.45-.24.2-.38l-1.32-.67a1.97 1.97 0 0 0-1.1-.1l-3.45.66c-.37.07-.48.24-.23.37l1.29.7c.24.15.75.2 1.13.12Z",
    fill: "#99B1DB"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.67 3.48-.71c.36-.08.45-.24.2-.37l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.23-.23.37l1.29.7c.24.14.75.2 1.13.12Z",
    fill: "#9AB2DC"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.66 3.48-.71c.36-.08.45-.24.2-.37l-1.32-.68a1.97 1.97 0 0 0-1.1-.1l-3.45.67c-.37.07-.48.23-.23.37l1.28.7c.25.14.76.2 1.14.12Z",
    fill: "#9BB3DD"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.64 3.48-.7c.36-.08.45-.24.2-.37l-1.32-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.66c-.37.08-.48.24-.24.37l1.29.71c.25.14.75.2 1.13.11Z",
    fill: "#9CB4DD"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.63 3.48-.7c.36-.08.45-.24.2-.37l-1.32-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.66c-.37.08-.48.24-.24.38l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#9DB5DE"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.62 3.48-.7c.36-.08.45-.24.2-.37l-1.32-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#9EB5DF"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.61 3.48-.7c.36-.08.45-.24.2-.37l-1.32-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#9FB6E0"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.6 3.48-.7c.36-.08.44-.25.19-.38l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7c.25.15.75.2 1.13.12Z",
    fill: "#A0B7E1"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.59 3.48-.7c.36-.08.44-.25.19-.38l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.08-.48.24-.24.37l1.29.71c.25.13.75.19 1.13.1Z",
    fill: "#A1B8E2"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.58 3.48-.7c.36-.08.44-.25.19-.38l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.08-.48.24-.24.37l1.29.71c.25.13.75.18 1.13.1Z",
    fill: "#A2B9E3"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.57 3.48-.71c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.71c.25.14.75.18 1.13.1Z",
    fill: "#A3BAE4"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.56 3.48-.71c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.71a2 2 0 0 0 1.13.1Z",
    fill: "#A4BBE5"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.55 3.48-.71c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.19 1.13.12Z",
    fill: "#A5BCE5"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.53 3.48-.7c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.11l-3.45.67c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#A6BDE6"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.52 3.48-.7c.36-.08.44-.24.19-.37l-1.32-.68a1.96 1.96 0 0 0-1.08-.1l-3.45.67c-.37.07-.48.23-.24.37l1.29.7a2 2 0 0 0 1.13.11Z",
    fill: "#A7BEE7"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.51 3.48-.7c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7a2 2 0 0 0 1.13.11Z",
    fill: "#A8BFE8"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.5 3.48-.7c.36-.08.44-.24.19-.37l-1.32-.68a1.96 1.96 0 0 0-1.09-.1l-3.44.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#A9BFE9"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.49 3.48-.7c.36-.08.44-.24.19-.37l-1.32-.68a1.96 1.96 0 0 0-1.09-.1l-3.44.66c-.37.08-.48.24-.24.37l1.29.7c.25.14.75.2 1.13.12Z",
    fill: "#AAC0EA"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.48 3.48-.7c.36-.08.44-.24.19-.37l-1.32-.68a1.96 1.96 0 0 0-1.09-.1l-3.44.67c-.37.07-.48.23-.24.37l1.29.7a2 2 0 0 0 1.13.11Z",
    fill: "#ABC1EB"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.47 3.48-.7c.36-.08.44-.24.19-.37l-1.32-.68a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.08-.48.24-.24.37l1.29.7c.25.14.75.2 1.13.12Z",
    fill: "#ACC2EC"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.46 3.48-.7c.36-.08.44-.24.19-.38l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.2 1.13.12Z",
    fill: "#ADC3EC"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.45 3.48-.7c.36-.08.44-.25.19-.38l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.2 1.13.12Z",
    fill: "#AEC4ED"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.43 3.48-.7c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#AFC5EE"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.42 3.48-.7c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#B0C6EF"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.41 3.48-.7c.36-.08.44-.24.19-.37l-1.32-.68a1.96 1.96 0 0 0-1.08-.1l-3.45.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#B1C7F0"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.4 3.48-.7c.35-.08.44-.24.18-.37l-1.3-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#B2C8F1"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.4 3.48-.71c.35-.08.44-.24.18-.37l-1.3-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.67c-.37.07-.48.23-.24.37l1.29.7c.25.14.75.18 1.13.11Z",
    fill: "#B3C9F2"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.38 3.48-.7c.35-.08.44-.24.18-.37l-1.3-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.66c-.37.08-.48.24-.24.37l1.29.7c.25.15.75.2 1.13.12Z",
    fill: "#B4C9F3"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.37 3.48-.7c.35-.08.44-.24.18-.37l-1.3-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.66c-.37.08-.48.24-.24.37l1.29.7c.25.14.75.2 1.13.12Z",
    fill: "#B5CAF3"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.36 3.48-.7c.35-.08.44-.24.18-.37l-1.3-.68a1.96 1.96 0 0 0-1.1-.1l-3.44.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.2 1.13.12Z",
    fill: "#B6CBF4"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.34 3.48-.7c.35-.07.44-.24.18-.37l-1.3-.67a1.96 1.96 0 0 0-1.1-.1l-3.44.66c-.37.07-.48.24-.24.37l1.29.7c.25.14.75.19 1.13.11Z",
    fill: "#B7CCF5"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.34 3.48-.7c.36-.08.44-.25.19-.38l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.23.37l1.28.7c.25.14.75.2 1.13.12Z",
    fill: "#B8CDF6"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "m33.44 45.32 3.48-.7c.36-.07.44-.24.19-.37l-1.32-.67a1.96 1.96 0 0 0-1.08-.1l-3.45.66c-.37.07-.48.24-.23.37l1.28.7c.25.14.75.19 1.13.11Z",
    fill: "#B9CEF7"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.3 3.73-.76c.39-.08.5-.26.24-.4l-1.28-.71a1.94 1.94 0 0 0-1.13-.11l-3.7.72c-.4.07-.53.25-.3.4l1.26.74c.25.15.77.2 1.17.12Z",
    fill: "#7791BC"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.29 3.73-.77c.39-.07.5-.25.25-.39l-1.3-.72a1.94 1.94 0 0 0-1.11-.1l-3.7.71c-.4.08-.53.26-.3.4l1.25.75c.25.14.77.2 1.18.12Z",
    fill: "#7892BD"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.27 3.73-.76c.39-.08.5-.25.25-.39l-1.3-.72a1.94 1.94 0 0 0-1.11-.1l-3.7.71c-.4.08-.53.26-.3.4l1.25.75c.25.14.77.2 1.18.11Z",
    fill: "#7993BE"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.26 3.73-.76c.39-.08.5-.25.25-.39l-1.29-.72a1.94 1.94 0 0 0-1.12-.1l-3.7.71c-.4.08-.53.26-.3.4l1.26.75c.24.14.76.2 1.17.11Z",
    fill: "#7A94BF"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.25 3.73-.76c.39-.08.5-.25.25-.4l-1.29-.7a1.94 1.94 0 0 0-1.12-.12l-3.7.72c-.4.08-.53.25-.3.4l1.26.75c.24.14.76.2 1.17.11Z",
    fill: "#7B95C0"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.24 3.74-.76c.38-.08.49-.25.24-.4l-1.29-.7a1.94 1.94 0 0 0-1.12-.12l-3.7.72c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.17.12Z",
    fill: "#7C96C0"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.23 3.74-.76c.38-.08.49-.26.24-.4l-1.29-.71a1.94 1.94 0 0 0-1.12-.11l-3.7.71c-.4.08-.53.26-.3.4l1.26.75c.24.15.76.2 1.17.12Z",
    fill: "#7D96C1"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.22 3.73-.76c.39-.08.5-.26.25-.4l-1.29-.71a1.94 1.94 0 0 0-1.12-.11l-3.7.72c-.4.07-.53.25-.3.4l1.26.74c.24.15.77.2 1.17.12Z",
    fill: "#7E97C2"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.2 3.73-.75c.39-.08.5-.26.25-.4l-1.29-.71a1.94 1.94 0 0 0-1.12-.11l-3.7.71c-.4.08-.53.26-.3.4l1.26.75c.24.15.77.2 1.17.12Z",
    fill: "#7F98C3"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.2 3.73-.77c.39-.07.5-.25.25-.39l-1.29-.72a1.94 1.94 0 0 0-1.12-.1l-3.7.71c-.4.08-.53.25-.3.4l1.26.75c.24.15.77.2 1.17.12Z",
    fill: "#8099C4"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.19 3.74-.77c.38-.07.49-.25.24-.39l-1.29-.72a1.94 1.94 0 0 0-1.12-.1l-3.7.71c-.4.08-.53.25-.3.4l1.26.75c.24.14.77.2 1.17.12Z",
    fill: "#819AC5"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.17 3.74-.76c.38-.08.49-.25.24-.4l-1.29-.7a1.94 1.94 0 0 0-1.12-.12l-3.7.72c-.4.08-.53.25-.3.4l1.26.75c.24.14.77.2 1.17.11Z",
    fill: "#829BC6"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.16 3.74-.76c.38-.08.49-.25.24-.4l-1.29-.7a1.94 1.94 0 0 0-1.12-.12l-3.7.72c-.4.08-.53.25-.3.4l1.26.74c.24.15.77.2 1.17.12Z",
    fill: "#839CC7"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.15 3.74-.76c.38-.08.49-.26.24-.4l-1.28-.7a1.94 1.94 0 0 0-1.13-.12l-3.69.72c-.4.08-.53.25-.3.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#849DC7"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.14 3.74-.76c.38-.08.5-.26.24-.4l-1.28-.7a1.94 1.94 0 0 0-1.13-.12l-3.69.72c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.16.12Z",
    fill: "#859EC8"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.13 3.74-.76c.38-.08.49-.26.24-.4l-1.29-.71a1.94 1.94 0 0 0-1.12-.11l-3.7.72c-.39.07-.52.25-.29.39l1.25.75c.25.15.77.2 1.17.12Z",
    fill: "#869FC9"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.12 3.74-.76c.38-.08.49-.25.24-.4l-1.29-.71a1.94 1.94 0 0 0-1.12-.11l-3.7.72c-.39.07-.52.25-.29.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#87A0CA"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.1 3.74-.75c.38-.08.49-.25.24-.4l-1.29-.71a1.94 1.94 0 0 0-1.12-.11l-3.7.72c-.39.07-.52.25-.29.4l1.25.74c.25.14.77.2 1.17.12Z",
    fill: "#88A0CB"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.1 3.74-.77c.38-.07.5-.25.24-.39l-1.28-.71a1.94 1.94 0 0 0-1.13-.11l-3.69.71c-.4.08-.53.26-.3.4l1.26.75c.24.14.76.2 1.17.11Z",
    fill: "#89A1CC"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.08 3.74-.76c.38-.08.5-.25.24-.4l-1.28-.7a1.94 1.94 0 0 0-1.13-.12l-3.69.72c-.4.08-.53.26-.3.4l1.26.75c.24.14.76.2 1.17.11Z",
    fill: "#8AA2CD"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.07 3.74-.76c.38-.08.5-.25.24-.4l-1.28-.7a1.94 1.94 0 0 0-1.13-.12l-3.69.72c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.17.12Z",
    fill: "#8BA3CE"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.06 3.74-.76c.38-.08.5-.25.24-.4l-1.28-.7a1.94 1.94 0 0 0-1.12-.12l-3.7.72c-.4.08-.52.25-.29.4l1.25.74c.24.15.77.2 1.17.12Z",
    fill: "#8CA4CE"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.05 3.74-.76c.38-.08.49-.25.24-.4l-1.29-.7a1.94 1.94 0 0 0-1.12-.12l-3.69.72c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.17.12Z",
    fill: "#8DA5CF"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.04 3.74-.76c.38-.08.5-.25.24-.4l-1.28-.7a1.94 1.94 0 0 0-1.12-.12l-3.7.72c-.4.08-.52.25-.29.4l1.25.74c.24.15.77.2 1.17.12Z",
    fill: "#8EA6D0"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.03 3.74-.76c.38-.08.49-.25.24-.4l-1.28-.71a1.93 1.93 0 0 0-1.12-.11l-3.7.72c-.39.07-.52.25-.29.39l1.25.75c.24.14.77.2 1.17.12Z",
    fill: "#8FA7D1"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47.01 3.74-.75c.38-.08.49-.26.24-.4l-1.28-.71a1.93 1.93 0 0 0-1.12-.11l-3.7.71c-.39.08-.52.26-.29.4l1.25.74c.24.16.77.2 1.17.12Z",
    fill: "#90A8D2"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "m27.4 47 3.74-.76c.38-.07.49-.25.24-.39l-1.28-.71a1.93 1.93 0 0 0-1.12-.11l-3.7.71c-.39.08-.52.25-.29.4l1.25.74c.24.15.77.2 1.17.12Z",
    fill: "#91A9D3"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 47 3.73-.77c.39-.08.5-.25.24-.39l-1.28-.72a1.93 1.93 0 0 0-1.12-.1l-3.69.71c-.4.08-.53.25-.3.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#92AAD4"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.98 3.73-.76c.39-.08.5-.25.24-.39l-1.28-.71a1.93 1.93 0 0 0-1.12-.11l-3.69.71c-.4.08-.53.25-.3.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#93AAD5"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.97 3.73-.76c.38-.08.5-.25.24-.39l-1.28-.71a1.93 1.93 0 0 0-1.12-.11l-3.69.71c-.4.08-.53.25-.3.4l1.26.74c.23.15.76.2 1.16.12Z",
    fill: "#94ABD6"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.96 3.73-.76c.38-.08.49-.25.24-.39l-1.28-.72a1.95 1.95 0 0 0-1.12-.1l-3.69.71c-.4.08-.53.25-.3.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#95ACD6"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.95 3.73-.76c.39-.08.5-.26.24-.4l-1.28-.7a1.95 1.95 0 0 0-1.12-.12l-3.69.72c-.4.07-.52.25-.29.39l1.25.75c.24.15.76.2 1.16.12Z",
    fill: "#96ADD7"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.93 3.73-.75c.39-.08.5-.26.24-.4l-1.28-.71a1.95 1.95 0 0 0-1.12-.11l-3.69.71c-.4.08-.52.26-.29.4l1.25.75c.24.14.76.2 1.16.11Z",
    fill: "#97AED8"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.93 3.73-.76c.39-.08.5-.26.24-.4l-1.28-.7a1.95 1.95 0 0 0-1.12-.12l-3.69.72c-.4.07-.52.25-.29.39l1.25.75c.24.14.76.2 1.16.12Z",
    fill: "#98AFD9"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.91 3.73-.75c.39-.08.5-.26.24-.4l-1.28-.7a1.95 1.95 0 0 0-1.12-.12l-3.69.72c-.4.07-.52.25-.29.39l1.25.75c.24.14.76.2 1.16.11Z",
    fill: "#98B0DA"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "m27.41 46.9 3.73-.75c.39-.08.5-.26.24-.4l-1.28-.7a1.95 1.95 0 0 0-1.12-.12l-3.69.72c-.4.07-.52.25-.29.4l1.25.74c.24.14.76.2 1.16.11Z",
    fill: "#99B1DB"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.89 3.72-.76c.39-.07.5-.25.25-.39l-1.28-.7a1.95 1.95 0 0 0-1.12-.12l-3.7.72c-.39.07-.52.25-.29.39l1.25.75c.24.14.77.2 1.17.1Z",
    fill: "#9AB2DC"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.88 3.72-.76c.39-.07.5-.25.25-.39l-1.29-.7a1.96 1.96 0 0 0-1.12-.12l-3.68.72c-.4.07-.53.25-.3.39l1.25.75c.24.14.76.2 1.17.1Z",
    fill: "#9BB3DD"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.87 3.72-.76c.39-.08.5-.25.24-.4l-1.28-.7a1.95 1.95 0 0 0-1.12-.11l-3.68.71c-.4.08-.53.25-.3.4l1.25.74c.24.15.77.2 1.17.12Z",
    fill: "#9CB4DD"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.86 3.72-.76c.39-.08.5-.25.24-.39L30.1 45a1.95 1.95 0 0 0-1.12-.11l-3.68.71c-.4.08-.53.26-.3.4l1.25.74c.24.15.77.2 1.17.12Z",
    fill: "#9DB5DE"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.84 3.72-.75c.39-.08.5-.26.25-.4L30.1 45a1.98 1.98 0 0 0-1.12-.12l-3.68.72c-.4.08-.53.25-.3.4l1.25.74c.24.14.77.2 1.17.11Z",
    fill: "#9EB5DF"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.83 3.72-.75c.39-.08.5-.26.25-.4l-1.29-.7a1.98 1.98 0 0 0-1.12-.11l-3.68.71c-.4.08-.53.25-.3.4l1.25.74c.24.14.77.2 1.17.11Z",
    fill: "#9FB6E0"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.82 3.72-.75c.39-.08.5-.25.25-.4l-1.29-.7a1.98 1.98 0 0 0-1.12-.11l-3.68.71c-.4.08-.53.25-.3.4l1.25.74c.25.14.77.2 1.17.11Z",
    fill: "#A0B7E1"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.81 3.72-.76c.39-.07.5-.25.25-.39l-1.29-.7a1.98 1.98 0 0 0-1.12-.12l-3.68.72c-.4.07-.53.25-.3.39l1.25.75c.25.14.77.2 1.17.11Z",
    fill: "#A1B8E2"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.8 3.73-.76c.38-.07.49-.25.24-.39l-1.28-.71a1.98 1.98 0 0 0-1.12-.11l-3.69.71c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.16.12Z",
    fill: "#A2B9E3"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.79 3.73-.76c.38-.08.49-.25.24-.39l-1.28-.71a1.98 1.98 0 0 0-1.12-.11l-3.69.71c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.16.12Z",
    fill: "#A3BAE4"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.78 3.72-.76c.39-.08.5-.25.25-.39l-1.28-.71a1.98 1.98 0 0 0-1.12-.11l-3.69.71c-.4.08-.53.25-.3.4l1.26.74c.24.14.76.2 1.16.12Z",
    fill: "#A4BBE5"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.76 3.72-.75c.39-.08.5-.26.25-.4l-1.28-.7a1.98 1.98 0 0 0-1.12-.12l-3.69.72c-.4.07-.53.25-.3.39l1.26.75c.24.14.76.2 1.16.11Z",
    fill: "#A5BCE5"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.75 3.72-.75c.39-.08.5-.26.25-.4l-1.28-.7a1.98 1.98 0 0 0-1.12-.12l-3.69.72c-.4.07-.53.25-.3.39l1.26.75c.24.14.76.2 1.16.11Z",
    fill: "#A6BDE6"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.74 3.73-.75c.38-.08.49-.26.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.12-.11l-3.69.7c-.4.08-.53.26-.3.4l1.26.75c.24.14.76.2 1.16.11Z",
    fill: "#A7BEE7"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.73 3.73-.75c.38-.08.49-.26.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.12-.12l-3.69.72c-.4.07-.53.25-.3.39l1.26.74c.24.15.76.2 1.16.12Z",
    fill: "#A8BFE8"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.72 3.73-.76c.38-.07.49-.25.24-.39l-1.28-.7a1.97 1.97 0 0 0-1.12-.12l-3.69.71c-.4.08-.53.26-.3.4l1.26.74c.24.15.76.2 1.16.12Z",
    fill: "#A9BFE9"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "m27.42 46.7 3.73-.75c.38-.07.49-.25.24-.39l-1.28-.71a1.97 1.97 0 0 0-1.12-.11l-3.69.71c-.4.08-.53.25-.3.4l1.26.74c.24.15.76.2 1.16.12Z",
    fill: "#AAC0EA"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.7 3.72-.76c.38-.07.49-.25.24-.39l-1.28-.7a1.97 1.97 0 0 0-1.12-.12l-3.68.71c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.17.12Z",
    fill: "#ABC1EB"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.69 3.72-.76c.38-.07.49-.25.24-.39l-1.28-.71a1.97 1.97 0 0 0-1.12-.1l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.17.12Z",
    fill: "#ACC2EC"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.67 3.72-.75c.38-.08.49-.25.24-.39l-1.28-.71a1.97 1.97 0 0 0-1.12-.11l-3.68.71c-.4.08-.53.25-.3.4l1.25.74c.24.14.76.2 1.17.11Z",
    fill: "#ADC3EC"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.66 3.72-.75c.38-.08.49-.25.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.12-.11l-3.68.7c-.4.09-.53.26-.3.4l1.25.75c.24.14.77.2 1.17.11Z",
    fill: "#AEC4ED"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.65 3.72-.75c.38-.08.49-.25.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.12-.11l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#AFC5EE"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.64 3.72-.75c.38-.08.49-.25.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.12-.11l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.25.15.77.2 1.17.12Z",
    fill: "#B0C6EF"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.63 3.72-.75c.38-.08.49-.26.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.11-.11l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B1C7F0"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.62 3.72-.76c.38-.07.49-.25.24-.39l-1.28-.7a1.97 1.97 0 0 0-1.11-.12l-3.68.72c-.4.07-.53.25-.3.39l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B2C8F1"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.6 3.72-.75c.39-.07.5-.25.24-.39l-1.28-.7a1.97 1.97 0 0 0-1.11-.12l-3.68.71c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B3C9F2"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.6 3.72-.76c.38-.08.49-.25.24-.39l-1.28-.71a1.97 1.97 0 0 0-1.11-.1l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.24.14.76.2 1.16.11Z",
    fill: "#B4C9F3"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.58 3.72-.75c.38-.08.49-.25.24-.39l-1.28-.7a1.97 1.97 0 0 0-1.11-.12l-3.68.71c-.4.08-.53.25-.3.4l1.25.74c.24.14.76.2 1.16.11Z",
    fill: "#B5CAF3"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.57 3.72-.75c.38-.08.49-.25.24-.4l-1.28-.7A1.97 1.97 0 0 0 29 44.6l-3.68.7c-.4.09-.53.26-.3.4l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B6CBF4"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.56 3.72-.75c.38-.08.49-.26.24-.4l-1.28-.7A1.97 1.97 0 0 0 29 44.6l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B7CCF5"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.55 3.72-.75c.38-.08.5-.25.24-.4l-1.27-.7a1.97 1.97 0 0 0-1.12-.11l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B8CDF6"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 46.54 3.72-.75c.38-.08.5-.26.24-.4l-1.28-.7a1.97 1.97 0 0 0-1.11-.11l-3.68.7c-.4.08-.53.26-.3.4l1.25.74c.24.15.76.2 1.16.12Z",
    fill: "#B9CEF7"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "m20.92 48.61 4.01-.81c.41-.09.55-.27.3-.42L24 46.62c-.23-.14-.75-.2-1.16-.11l-3.96.76c-.42.09-.59.27-.36.43l1.2.8c.24.15.78.2 1.21.11Z",
    fill: "#7791BC"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "m20.92 48.6 4.01-.81c.41-.09.55-.27.3-.42L24 46.6c-.23-.14-.75-.2-1.16-.11l-3.95.76c-.43.09-.6.28-.37.43l1.2.8c.24.15.78.2 1.21.11Z",
    fill: "#7892BD"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.6 4-.83c.41-.08.55-.27.3-.41L24 46.6c-.23-.15-.75-.2-1.16-.12l-3.96.77c-.42.08-.59.27-.36.42l1.2.8c.24.15.78.21 1.22.12Z",
    fill: "#7993BE"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.58 4-.81c.41-.09.55-.27.3-.42L24 46.59c-.23-.14-.75-.2-1.16-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.16.79.21 1.22.12Z",
    fill: "#7A94BF"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.57 4-.82c.41-.08.55-.27.3-.42L24 46.58c-.23-.15-.75-.2-1.16-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.25.15.79.2 1.22.12Z",
    fill: "#7B95C0"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.56 4-.82c.42-.08.55-.27.31-.42L24 46.57c-.24-.15-.75-.2-1.16-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.15.78.2 1.21.12Z",
    fill: "#7C96C0"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.55 4-.82c.42-.08.55-.27.31-.42L24 46.55c-.24-.14-.75-.19-1.16-.11l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.15.78.2 1.21.12Z",
    fill: "#7D96C1"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.54 4-.82c.42-.08.56-.27.31-.42L24 46.55c-.23-.15-.75-.2-1.15-.12l-3.96.77c-.43.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#7E97C2"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "m20.93 48.52 4-.81c.42-.09.56-.27.31-.42L24 46.53c-.23-.14-.75-.2-1.15-.11l-3.96.76c-.43.09-.59.28-.36.42l1.2.8c.23.16.77.2 1.2.12Z",
    fill: "#7F98C3"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.51 4-.81c.41-.09.55-.27.3-.42L24 46.52c-.23-.14-.75-.2-1.15-.11l-3.96.76c-.43.09-.59.28-.36.42l1.2.8c.23.16.77.2 1.2.12Z",
    fill: "#8099C4"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.5 4-.82c.41-.08.55-.27.3-.41L24 46.5c-.23-.15-.75-.2-1.15-.12l-3.96.77c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#819AC5"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.49 4-.82c.41-.08.55-.27.3-.41L24 46.5c-.23-.15-.75-.2-1.15-.12l-3.96.77c-.42.08-.59.27-.36.42l1.2.8c.23.15.78.2 1.2.12Z",
    fill: "#829BC6"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.48 4-.82c.41-.08.55-.27.3-.42L24 46.5c-.23-.15-.75-.2-1.15-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.23.15.78.2 1.2.12Z",
    fill: "#839CC7"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.46 4-.81c.41-.08.55-.27.3-.42L24 46.47c-.23-.14-.75-.2-1.15-.11l-3.95.77c-.43.08-.6.27-.37.41l1.2.8c.24.16.78.21 1.2.12Z",
    fill: "#849DC7"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.46 4-.82c.41-.08.55-.27.3-.42l-1.23-.76c-.24-.14-.75-.19-1.16-.11l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.15.78.2 1.21.12Z",
    fill: "#859EC8"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.44 4-.81c.41-.09.55-.27.3-.42l-1.23-.76c-.24-.14-.75-.19-1.16-.11l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.14.78.2 1.21.11Z",
    fill: "#869FC9"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.43 4-.81c.41-.09.55-.27.3-.42l-1.23-.75c-.24-.15-.75-.2-1.16-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.14.78.2 1.21.11Z",
    fill: "#87A0CA"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 48.42 4-.81c.42-.09.55-.28.3-.42l-1.23-.76c-.24-.14-.75-.2-1.16-.11l-3.95.77c-.43.08-.59.27-.36.42l1.2.79c.23.15.77.2 1.2.12Z",
    fill: "#88A0CB"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.4 4-.8c.4-.1.54-.28.3-.42l-1.24-.76c-.23-.14-.75-.2-1.16-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#89A1CC"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.4 4-.82c.4-.08.54-.27.3-.41l-1.24-.76c-.23-.14-.75-.2-1.16-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#8AA2CD"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.38 4-.81c.41-.08.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.23.15.78.2 1.2.11Z",
    fill: "#8BA3CE"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.37 4-.81c.41-.09.54-.27.3-.42l-1.24-.75c-.23-.15-.75-.2-1.15-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.15.78.2 1.2.11Z",
    fill: "#8CA4CE"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.36 4-.81c.41-.08.55-.27.3-.42l-1.24-.75c-.23-.15-.75-.2-1.15-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.8c.24.14.78.2 1.21.11Z",
    fill: "#8DA5CF"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.35 4-.81c.41-.09.54-.27.3-.42l-1.24-.75c-.23-.15-.75-.2-1.15-.12l-3.95.77c-.43.08-.6.27-.37.42l1.2.79c.24.15.78.2 1.21.12Z",
    fill: "#8EA6D0"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.34 4-.81c.41-.09.54-.27.3-.42l-1.24-.76c-.23-.14-.75-.19-1.15-.11L18.9 47c-.43.08-.6.27-.37.41l1.2.8c.24.15.78.2 1.21.12Z",
    fill: "#8FA7D1"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.33 4-.82c.41-.08.55-.27.3-.41l-1.24-.76c-.23-.14-.75-.19-1.15-.11l-3.95.76c-.42.09-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#90A8D2"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "m20.95 48.31 4-.8c.41-.1.55-.28.3-.42l-1.24-.76c-.23-.14-.75-.2-1.15-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.11Z",
    fill: "#91A9D3"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.3 4-.8c.4-.1.54-.28.3-.42l-1.24-.76c-.24-.14-.75-.2-1.16-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.11Z",
    fill: "#92AAD4"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.3 4-.82c.4-.09.54-.27.3-.42l-1.24-.75c-.24-.15-.75-.2-1.16-.12l-3.95.77c-.42.08-.59.27-.36.42l1.2.8c.23.14.78.2 1.2.11Z",
    fill: "#93AAD5"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.28 4-.81c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.15-.75-.2-1.16-.12l-3.94.77c-.43.08-.6.27-.37.42l1.2.8c.24.14.78.2 1.2.11Z",
    fill: "#94ABD6"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.27 4-.81c.4-.09.54-.28.3-.42l-1.24-.76c-.24-.14-.75-.19-1.16-.11l-3.95.76c-.42.09-.59.27-.36.42l1.2.8c.24.15.78.2 1.2.12Z",
    fill: "#95ACD6"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.26 4-.81c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.15-.75-.2-1.16-.12l-3.94.77c-.43.08-.6.27-.37.42l1.2.79c.24.15.78.2 1.21.12Z",
    fill: "#96ADD7"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.25 4-.82c.4-.08.54-.27.3-.41l-1.24-.76c-.23-.14-.75-.19-1.15-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#97AED8"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.24 4-.82c.41-.08.54-.27.3-.41l-1.24-.76c-.23-.14-.75-.19-1.15-.11l-3.95.76c-.42.08-.58.27-.36.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#98AFD9"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 48.22 4-.81c.41-.08.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.12l-3.95.77c-.42.08-.58.27-.36.42l1.2.79c.23.16.77.2 1.2.12Z",
    fill: "#98B0DA"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.21 4-.81c.4-.08.54-.27.3-.42l-1.24-.75c-.24-.14-.75-.2-1.16-.12l-3.94.77c-.43.08-.59.27-.37.42l1.2.79c.23.16.77.2 1.2.12Z",
    fill: "#99B1DB"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.2 4-.81c.4-.09.54-.27.3-.42l-1.24-.76c-.24-.14-.75-.19-1.16-.11l-3.94.76c-.43.09-.59.27-.37.42l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#9AB2DC"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.19 3.99-.81c.41-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.12l-3.95.77c-.42.08-.58.27-.36.42l1.2.79c.24.15.78.2 1.2.12Z",
    fill: "#9BB3DD"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.18 4-.81c.4-.09.54-.27.3-.42l-1.24-.75c-.24-.14-.75-.2-1.16-.12l-3.94.77c-.43.08-.59.26-.37.41l1.2.8c.24.15.78.2 1.2.12Z",
    fill: "#9CB4DD"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.16 4-.8c.4-.09.54-.28.3-.42l-1.24-.75c-.24-.14-.75-.2-1.16-.12l-3.94.76c-.42.09-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.11Z",
    fill: "#9DB5DE"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.15 4-.8c.4-.1.54-.28.3-.42l-1.24-.76c-.23-.14-.75-.19-1.15-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.11Z",
    fill: "#9EB5DF"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.14 4-.8c.4-.1.54-.28.3-.42l-1.24-.76c-.23-.14-.75-.19-1.15-.11l-3.95.76c-.42.08-.59.27-.36.42l1.2.79c.23.15.77.21 1.2.12Z",
    fill: "#9FB6E0"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.13 4-.8c.4-.1.54-.28.3-.42l-1.24-.76c-.23-.14-.75-.19-1.15-.11l-3.94.76c-.43.08-.6.27-.37.42l1.2.79c.23.15.77.2 1.2.12Z",
    fill: "#A0B7E1"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "m20.97 48.12 4-.81c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.12l-3.94.77c-.43.08-.6.27-.37.41l1.2.8c.24.15.78.2 1.2.12Z",
    fill: "#A1B8E2"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.1 3.99-.8c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.12l-3.94.77c-.43.08-.6.26-.37.41l1.2.8c.24.15.78.2 1.2.12Z",
    fill: "#A2B9E3"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.1 3.99-.82c.4-.08.54-.26.3-.41l-1.24-.75c-.23-.15-.75-.2-1.15-.12l-3.94.76c-.43.09-.6.27-.37.42l1.2.8c.24.15.78.2 1.2.11Z",
    fill: "#A3BAE4"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.08 3.99-.8c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.74-.2-1.15-.12l-3.94.76c-.42.09-.59.27-.36.42l1.2.8c.23.15.77.2 1.2.11Z",
    fill: "#A4BBE5"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.07 3.99-.8c.4-.1.54-.28.3-.42l-1.24-.76c-.23-.14-.74-.19-1.15-.11l-3.94.76c-.42.08-.59.27-.36.42l1.2.79c.23.16.77.2 1.2.12Z",
    fill: "#A5BCE5"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.06 4-.8c.4-.1.54-.27.3-.42l-1.24-.76c-.24-.14-.75-.19-1.16-.11l-3.94.76c-.42.08-.59.27-.36.42l1.2.79c.23.16.77.2 1.2.12Z",
    fill: "#A6BDE6"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.05 4-.81c.4-.08.54-.27.3-.42l-1.24-.75c-.24-.14-.75-.2-1.16-.11l-3.94.76c-.42.08-.59.27-.36.41l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#A7BEE7"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.04 4-.81c.4-.09.54-.27.3-.42l-1.25-.75c-.23-.14-.74-.2-1.15-.11l-3.94.76c-.42.08-.59.27-.36.41l1.2.8c.23.15.77.2 1.2.12Z",
    fill: "#A8BFE8"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.03 4-.81c.4-.09.54-.27.3-.42l-1.25-.75c-.23-.14-.74-.2-1.15-.11l-3.94.76c-.42.08-.59.27-.36.42l1.2.79c.24.15.77.2 1.2.12Z",
    fill: "#A9BFE9"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "m20.98 48.01 4-.8c.4-.1.54-.27.3-.42l-1.25-.75c-.23-.14-.74-.2-1.15-.12l-3.94.77c-.42.08-.59.27-.36.41l1.2.8c.24.15.77.2 1.2.11Z",
    fill: "#AAC0EA"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "m20.99 48 3.98-.8c.41-.1.55-.27.3-.42l-1.23-.75c-.24-.14-.75-.2-1.16-.12l-3.93.77c-.43.08-.6.26-.37.41l1.2.8c.24.15.78.2 1.2.11Z",
    fill: "#ABC1EB"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "m20.99 47.99 3.98-.81c.41-.08.55-.27.3-.41L24.05 46c-.24-.14-.75-.19-1.16-.1l-3.93.75c-.43.08-.6.27-.37.42l1.2.79c.24.15.78.2 1.2.12Z",
    fill: "#ACC2EC"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "m20.99 47.98 3.99-.8c.4-.09.54-.28.3-.42L24.04 46c-.23-.15-.75-.2-1.15-.12l-3.94.76c-.43.09-.59.27-.37.42l1.2.79c.24.15.78.2 1.2.12Z",
    fill: "#ADC3EC"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "m20.99 47.97 3.99-.81c.4-.08.54-.27.3-.41l-1.24-.76c-.23-.14-.75-.19-1.15-.1l-3.94.75c-.43.08-.59.27-.37.42l1.2.79c.24.15.78.2 1.2.12Z",
    fill: "#AEC4ED"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.96 3.98-.81c.4-.08.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.19-1.15-.11l-3.94.76c-.42.08-.59.27-.36.42l1.2.79c.23.15.77.2 1.2.12Z",
    fill: "#AFC5EE"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.94 3.98-.8c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.11l-3.94.76c-.43.08-.59.27-.37.41l1.2.8c.24.15.78.2 1.21.11Z",
    fill: "#B0C6EF"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.93 3.98-.8c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.19-1.15-.11l-3.94.76c-.42.08-.58.27-.36.42l1.2.79c.24.15.77.2 1.2.11Z",
    fill: "#B1C7F0"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.92 3.98-.8c.4-.09.54-.27.3-.42l-1.24-.75c-.23-.14-.75-.2-1.15-.11l-3.93.76c-.43.08-.6.27-.37.41l1.2.8c.23.14.77.2 1.2.11Z",
    fill: "#B2C8F1"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.91 3.98-.8c.41-.09.55-.28.3-.42l-1.24-.75c-.23-.14-.74-.2-1.15-.11l-3.93.76c-.43.08-.59.27-.36.41l1.2.8c.23.14.77.2 1.2.11Z",
    fill: "#B3C9F2"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.9 3.98-.8c.41-.1.55-.28.3-.42l-1.24-.75c-.23-.14-.74-.2-1.15-.12l-3.93.77c-.43.08-.59.26-.36.41l1.2.79c.23.15.77.2 1.2.12Z",
    fill: "#B4C9F3"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.89 3.98-.81c.41-.08.55-.27.3-.41l-1.24-.75c-.23-.15-.74-.2-1.15-.12l-3.93.76c-.43.09-.59.27-.36.42l1.2.79c.23.15.77.2 1.2.12Z",
    fill: "#B5CAF3"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.87 3.98-.8c.41-.08.55-.27.3-.42l-1.23-.75c-.24-.14-.75-.19-1.15-.1l-3.94.75c-.42.08-.59.27-.36.42l1.2.79c.23.15.77.2 1.2.11Z",
    fill: "#B6CBF4"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.86 3.98-.8c.41-.09.55-.27.3-.42l-1.23-.75c-.24-.14-.75-.19-1.15-.11l-3.94.76c-.42.08-.59.27-.36.42l1.2.79c.23.15.77.2 1.2.11Z",
    fill: "#B7CCF5"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.85 3.98-.8c.41-.09.55-.27.3-.42l-1.23-.75c-.23-.14-.75-.19-1.15-.11l-3.94.76c-.42.08-.58.27-.36.42l1.2.79c.23.15.77.2 1.2.11Z",
    fill: "#B8CDF6"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.84 3.98-.8c.41-.09.55-.28.3-.42l-1.23-.75c-.23-.14-.75-.2-1.15-.11l-3.93.76c-.43.08-.6.26-.37.41l1.2.8c.23.14.77.2 1.2.1Z",
    fill: "#B9CEF7"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "m57.3 43.22 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.06 2.06 0 0 0-1.01-.09l-2.73.56c-.3.07-.31.2-.04.32l1.46.61c.28.12.75.17 1.05.1Z",
    fill: "#7791BC"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "m57.3 43.21 2.74-.6c.28-.05.28-.2 0-.3l-1.48-.6a2.06 2.06 0 0 0-1-.09l-2.74.56c-.29.07-.3.2-.03.32l1.46.61c.28.12.75.17 1.04.1Z",
    fill: "#7892BD"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "m57.3 43.2 2.74-.6c.28-.05.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1.01-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6a2 2 0 0 0 1.04.11Z",
    fill: "#7993BE"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "m57.3 43.2 2.73-.6c.29-.06.28-.2 0-.32l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.32l1.46.6a2 2 0 0 0 1.04.11Z",
    fill: "#7A94BF"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "m57.29 43.18 2.74-.6c.28-.05.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.32l1.46.61a2 2 0 0 0 1.04.1Z",
    fill: "#7B95C0"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "m57.29 43.17 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.06 2.06 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.32l1.46.61c.27.12.74.17 1.04.1Z",
    fill: "#7C96C0"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "m57.29 43.16 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.06 2.06 0 0 0-1-.1l-2.74.57c-.3.06-.3.2-.03.32l1.45.61c.28.12.75.17 1.05.1Z",
    fill: "#7D96C1"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "m57.28 43.15 2.75-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.74.57c-.3.06-.31.2-.04.32l1.46.6a2 2 0 0 0 1.04.1Z",
    fill: "#7E97C2"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "m57.28 43.14 2.75-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.74.57c-.3.06-.31.2-.04.32l1.46.6c.28.13.75.17 1.04.1Z",
    fill: "#7F98C3"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "m57.28 43.13 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6c.28.13.75.17 1.04.1Z",
    fill: "#8099C4"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "m57.28 43.12 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.32l1.46.6a2 2 0 0 0 1.04.1Z",
    fill: "#819AC5"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "m57.28 43.1 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.6a2.06 2.06 0 0 0-1-.09l-2.74.57c-.29.06-.3.2-.03.32l1.46.6c.27.13.74.17 1.04.1Z",
    fill: "#829BC6"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "m57.28 43.1 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.6a2.05 2.05 0 0 0-1-.09l-2.74.57c-.3.06-.3.2-.03.32l1.45.6c.28.13.75.17 1.05.1Z",
    fill: "#839CC7"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 43.09 2.75-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1l-2.74.57c-.3.06-.31.2-.04.32l1.46.6c.28.13.75.17 1.04.1Z",
    fill: "#849DC7"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 43.08 2.75-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1.01-.1l-2.73.57c-.3.06-.3.2-.03.32l1.45.6c.28.13.75.17 1.04.1Z",
    fill: "#859EC8"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 43.06 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.06 2.06 0 0 0-1-.09l-2.73.57c-.3.06-.31.2-.04.31l1.46.61c.28.12.75.17 1.04.1Z",
    fill: "#869FC9"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 43.05 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.06 2.06 0 0 0-1-.09l-2.74.57c-.29.06-.3.2-.03.31l1.45.61c.29.12.76.17 1.05.1Z",
    fill: "#87A0CA"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 43.04 2.74-.59c.28-.06.28-.2 0-.32l-1.47-.58a2.06 2.06 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.31l1.45.61c.28.12.75.17 1.05.1Z",
    fill: "#88A0CB"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 43.03 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.06 2.06 0 0 0-1-.09l-2.74.57c-.3.06-.3.2-.03.31l1.45.61c.28.12.75.17 1.05.1Z",
    fill: "#89A1CC"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "m57.26 43.02 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.06 2.06 0 0 0-1-.1L54.8 42c-.3.06-.31.2-.04.32l1.46.6c.28.12.75.17 1.04.1Z",
    fill: "#8AA2CD"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "m57.26 43.01 2.74-.59c.28-.06.28-.2 0-.32l-1.47-.58a2.05 2.05 0 0 0-1-.1L54.8 42c-.3.06-.31.2-.04.32l1.46.6c.28.12.75.17 1.04.1Z",
    fill: "#8BA3CE"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "m57.26 43 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.05 2.05 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6c.28.12.75.17 1.04.1Z",
    fill: "#8CA4CE"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "m57.26 43 2.74-.6c.28-.06.28-.2 0-.32l-1.47-.58a2.05 2.05 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.31l1.45.61c.29.12.76.16 1.05.1Z",
    fill: "#8DA5CF"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "m57.26 42.98 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.05 2.05 0 0 0-1-.09l-2.74.57c-.29.06-.3.2-.03.31l1.45.61c.29.12.75.16 1.05.1Z",
    fill: "#8EA6D0"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "m57.26 42.97 2.73-.6c.29-.05.28-.2 0-.3l-1.46-.6a2.05 2.05 0 0 0-1-.09l-2.74.57c-.29.06-.3.2-.03.31l1.45.61c.28.12.75.16 1.05.1Z",
    fill: "#8FA7D1"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25 42.96 2.74-.6c.29-.05.28-.2 0-.3l-1.46-.6a2.05 2.05 0 0 0-1-.09l-2.74.57c-.3.06-.3.2-.03.31l1.45.61c.28.12.75.16 1.04.1Z",
    fill: "#90A8D2"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25 42.95 2.74-.6c.29-.05.28-.2 0-.3l-1.46-.6a2.05 2.05 0 0 0-1-.09l-2.74.57c-.3.06-.3.2-.03.31l1.45.61c.28.12.75.16 1.04.1Z",
    fill: "#91A9D3"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25 42.94 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.05 2.05 0 0 0-1-.09l-2.73.56c-.3.07-.31.2-.04.32l1.46.61c.28.12.75.16 1.04.1Z",
    fill: "#92AAD4"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25 42.93 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.05 2.05 0 0 0-1-.09l-2.73.56c-.3.07-.31.2-.04.32l1.46.61c.28.12.74.16 1.04.1Z",
    fill: "#93AAD5"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25 42.92 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6a2 2 0 0 0 1.04.1Z",
    fill: "#94ABD6"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25 42.9 2.73-.59c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.32l1.45.6c.28.13.75.17 1.05.1Z",
    fill: "#95ACD6"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "m57.24 42.9 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.3.2-.03.32l1.45.6c.28.13.75.17 1.04.1Z",
    fill: "#96ADD7"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "m57.24 42.89 2.74-.6c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.3.2-.03.32l1.45.6c.28.13.75.17 1.04.1Z",
    fill: "#97AED8"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "m57.24 42.87 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.31l1.46.61c.28.12.75.17 1.04.1Z",
    fill: "#98AFD9"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "m57.24 42.87 2.73-.6c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6c.28.12.75.17 1.04.1Z",
    fill: "#98B0DA"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "m57.24 42.85 2.73-.59c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6c.28.12.74.17 1.04.1Z",
    fill: "#99B1DB"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "m57.24 42.84 2.73-.6c.29-.05.28-.2 0-.3l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.74.57c-.29.06-.3.2-.03.31l1.45.61c.28.12.75.16 1.05.1Z",
    fill: "#9AB2DC"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "m57.23 42.83 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.3.2-.03.32l1.45.6c.28.12.75.17 1.04.1Z",
    fill: "#9BB3DD"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "m57.23 42.82 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.3.2-.03.31l1.45.61c.28.12.75.17 1.04.1Z",
    fill: "#9CB4DD"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "m57.23 42.81 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.46.6c.28.12.75.17 1.04.1Z",
    fill: "#9DB5DE"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "m57.23 42.8 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.31l1.45.61c.29.12.76.17 1.05.1Z",
    fill: "#9EB5DF"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "m57.23 42.79 2.73-.6c.29-.05.28-.2 0-.3l-1.46-.6a2.08 2.08 0 0 0-1-.09l-2.73.57c-.3.06-.31.2-.04.31l1.46.61c.28.12.74.16 1.04.1Z",
    fill: "#9FB6E0"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "m57.23 42.78 2.73-.59c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.32l1.45.6c.28.12.75.17 1.05.1Z",
    fill: "#A0B7E1"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "m57.22 42.77 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.29.06-.3.2-.03.32l1.45.6c.28.12.75.16 1.04.1Z",
    fill: "#A1B8E2"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "m57.22 42.76 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.6a2.08 2.08 0 0 0-1-.09l-2.72.57c-.3.06-.31.2-.04.31l1.45.6a2 2 0 0 0 1.04.1Z",
    fill: "#A2B9E3"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "m57.22 42.75 2.73-.6c.29-.05.28-.2 0-.3l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.29.06-.3.2-.03.31l1.45.61c.28.12.75.16 1.04.1Z",
    fill: "#A3BAE4"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "m57.22 42.74 2.73-.6c.29-.05.28-.2 0-.3l-1.46-.6a2.08 2.08 0 0 0-1-.09l-2.73.57c-.3.06-.3.2-.03.31l1.45.61c.28.12.75.16 1.04.1Z",
    fill: "#A4BBE5"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "m57.22 42.73 2.73-.6c.29-.05.28-.2 0-.3l-1.46-.6a2.08 2.08 0 0 0-1-.09l-2.73.57c-.3.06-.3.2-.03.31l1.45.61c.28.12.74.16 1.04.1Z",
    fill: "#A5BCE5"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "m57.22 42.72 2.73-.6c.28-.05.28-.2 0-.3l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.04.31l1.46.61c.27.11.74.16 1.04.1Z",
    fill: "#A6BDE6"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "m57.21 42.7 2.74-.58c.28-.06.28-.2 0-.32l-1.47-.58a2.08 2.08 0 0 0-1-.1l-2.72.57c-.3.06-.31.2-.04.31l1.45.61c.28.11.75.16 1.04.1Z",
    fill: "#A7BEE7"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "m57.21 42.7 2.74-.6c.28-.05.28-.2 0-.3l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.72.57c-.3.06-.31.2-.04.32l1.45.6c.28.12.75.16 1.04.1Z",
    fill: "#A8BFE8"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "m57.21 42.68 2.73-.59c.29-.06.28-.2 0-.31l-1.46-.58a2.08 2.08 0 0 0-1-.1l-2.73.56c-.29.07-.3.2-.03.32l1.45.6c.28.12.75.17 1.04.1Z",
    fill: "#A9BFE9"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.67 2.74-.59c.28-.06.28-.2 0-.31l-1.46-.58a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.03.31l1.45.6c.28.12.74.17 1.04.1Z",
    fill: "#AAC0EA"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.66 2.74-.59c.28-.06.28-.2 0-.31l-1.46-.58a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.31.2-.03.31l1.45.6c.28.12.74.17 1.04.1Z",
    fill: "#ABC1EB"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.65 2.74-.59c.28-.06.28-.2 0-.31l-1.46-.58a2.08 2.08 0 0 0-1-.1l-2.73.56c-.3.06-.31.2-.04.32l1.46.6c.28.12.74.17 1.04.1Z",
    fill: "#ACC2EC"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.64 2.74-.59c.28-.06.28-.2 0-.3l-1.47-.6a2.08 2.08 0 0 0-1-.09l-2.72.56c-.3.06-.31.2-.04.32l1.45.6c.28.12.75.17 1.04.1Z",
    fill: "#ADC3EC"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.63 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.58a2.08 2.08 0 0 0-1-.1l-2.72.56c-.3.06-.31.2-.04.32l1.45.6c.28.12.75.17 1.04.1Z",
    fill: "#AEC4ED"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.62 2.74-.59c.28-.06.28-.2 0-.31l-1.47-.58a2.08 2.08 0 0 0-1-.1l-2.73.56c-.29.06-.3.2-.03.32l1.45.6c.28.12.75.16 1.04.1Z",
    fill: "#AFC5EE"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.61 2.73-.59c.28-.06.28-.2 0-.31l-1.46-.58a2.08 2.08 0 0 0-1-.1l-2.73.56c-.3.06-.3.2-.03.31l1.45.61a2 2 0 0 0 1.04.1Z",
    fill: "#B0C6EF"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.6 2.73-.59c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.29.06-.3.2-.03.31l1.45.61a2 2 0 0 0 1.04.1Z",
    fill: "#B1C7F0"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.59 2.73-.59c.28-.06.28-.2 0-.31l-1.47-.59a2.08 2.08 0 0 0-1-.09l-2.72.56c-.3.06-.31.2-.04.31l1.45.61c.29.12.75.16 1.04.1Z",
    fill: "#B2C8F1"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.58 2.72-.59c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.09l-2.72.56c-.3.06-.31.2-.04.31l1.45.61c.28.12.75.16 1.04.1Z",
    fill: "#B3C9F2"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 42.57 2.72-.59c.29-.06.28-.2 0-.31l-1.46-.59a2.08 2.08 0 0 0-1-.09l-2.72.56c-.3.06-.31.2-.04.31l1.45.61c.28.12.75.16 1.04.1Z",
    fill: "#B4C9F3"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "m57.19 42.56 2.73-.6c.28-.05.28-.2 0-.3l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.29.06-.3.2-.03.31l1.45.6c.28.13.75.17 1.04.1Z",
    fill: "#B5CAF3"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "m57.19 42.55 2.73-.6c.28-.05.28-.2 0-.3l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.73.57c-.3.06-.3.2-.03.31l1.45.6c.28.13.75.17 1.04.1Z",
    fill: "#B6CBF4"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "m57.19 42.54 2.73-.6c.28-.06.28-.2 0-.3l-1.46-.6a2.08 2.08 0 0 0-1-.09l-2.73.56c-.3.07-.3.2-.03.32l1.45.6a2 2 0 0 0 1.04.1Z",
    fill: "#B7CCF5"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "m57.19 42.53 2.73-.6c.28-.05.28-.2 0-.3l-1.47-.59a2.08 2.08 0 0 0-1-.1l-2.72.57c-.3.05-.31.2-.04.31l1.45.6a2 2 0 0 0 1.05.1Z",
    fill: "#B8CDF6"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "m57.18 42.52 2.73-.6c.29-.06.28-.2 0-.3l-1.46-.59a2.08 2.08 0 0 0-1-.1l-2.72.56c-.3.06-.31.2-.04.32l1.45.6c.28.13.75.17 1.04.1Z",
    fill: "#B9CEF7"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "m52.58 44.25 2.92-.63c.3-.07.31-.22.03-.34l-1.46-.61a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.06-.35.21-.08.33l1.45.65a2 2 0 0 0 1.07.1Z",
    fill: "#7791BC"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "m52.58 44.24 2.92-.63c.3-.07.31-.22.03-.34l-1.46-.61a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.06-.35.21-.08.33l1.45.65a2 2 0 0 0 1.07.1Z",
    fill: "#7892BD"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "m52.58 44.23 2.91-.64c.3-.06.32-.21.03-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.65c.28.12.77.16 1.08.1Z",
    fill: "#7993BE"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "m52.58 44.22 2.91-.64c.3-.06.32-.21.03-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.65c.28.12.76.16 1.08.1Z",
    fill: "#7A94BF"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "m52.58 44.2 2.91-.63c.3-.07.31-.21.03-.33l-1.46-.62a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.07-.35.22-.07.34l1.44.64c.28.13.76.17 1.08.1Z",
    fill: "#7B95C0"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.2 2.92-.64c.3-.07.31-.21.03-.33l-1.46-.62a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.07-.35.22-.07.34l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#7C96C0"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.18 2.92-.63c.3-.06.31-.21.03-.33l-1.46-.62a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.07-.35.22-.07.34l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#7D96C1"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.17 2.91-.63c.3-.06.32-.21.04-.33l-1.46-.62a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.07-.35.22-.08.34l1.45.64c.28.12.76.17 1.07.1Z",
    fill: "#7E97C2"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.16 2.91-.63c.3-.06.32-.21.04-.33l-1.46-.62a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.31.07-.35.22-.08.34l1.45.64c.28.12.76.17 1.07.1Z",
    fill: "#7F98C3"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.15 2.91-.63c.3-.06.31-.21.03-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64c.28.12.77.17 1.08.1Z",
    fill: "#8099C4"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.14 2.91-.63c.3-.06.31-.21.03-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64c.28.12.77.17 1.08.1Z",
    fill: "#819AC5"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.13 2.91-.63c.3-.06.31-.21.03-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64a2 2 0 0 0 1.08.1Z",
    fill: "#829BC6"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "m52.57 44.12 2.91-.63c.3-.06.31-.21.03-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64c.28.12.76.17 1.08.1Z",
    fill: "#839CC7"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.11 2.92-.63c.3-.06.31-.21.03-.33l-1.46-.62a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#849DC7"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.1 2.92-.63c.3-.07.31-.22.03-.34l-1.46-.61a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.65a2 2 0 0 0 1.07.1Z",
    fill: "#859EC8"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.09 2.91-.63c.3-.07.31-.22.03-.34l-1.45-.61a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.06-.34.21-.07.33l1.45.64a2 2 0 0 0 1.07.1Z",
    fill: "#869FC9"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.08 2.91-.63c.3-.07.31-.22.03-.34l-1.45-.61a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.06-.34.21-.07.33l1.45.64c.28.13.76.17 1.07.1Z",
    fill: "#87A0CA"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.07 2.91-.63c.3-.07.31-.22.03-.34l-1.45-.61a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.13.77.17 1.08.1Z",
    fill: "#88A0CB"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.06 2.9-.63c.3-.07.32-.22.04-.34l-1.46-.61a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.13.76.17 1.08.1Z",
    fill: "#89A1CC"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "m52.56 44.04 2.9-.63c.3-.06.32-.21.04-.33l-1.46-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64a2 2 0 0 0 1.08.1Z",
    fill: "#8AA2CD"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 44.03 2.91-.63c.3-.06.32-.21.04-.33l-1.46-.61a2.06 2.06 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#8BA3CE"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 44.02 2.91-.63c.3-.06.32-.21.04-.33l-1.46-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#8CA4CE"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 44.01 2.91-.63c.3-.06.31-.21.03-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#8DA5CF"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 44 2.91-.63c.3-.06.31-.22.03-.33l-1.45-.62a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#8EA6D0"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 43.99 2.9-.63c.3-.06.32-.22.04-.33l-1.45-.62a2.05 2.05 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.06.34l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#8FA7D1"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 43.98 2.9-.63c.3-.06.32-.22.04-.33l-1.45-.62a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.06.34l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#90A8D2"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 43.97 2.9-.63c.3-.06.32-.21.04-.33l-1.45-.62a2.05 2.05 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.45.64c.27.12.75.17 1.07.1Z",
    fill: "#91A9D3"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "m52.55 43.96 2.9-.63c.3-.06.32-.21.04-.33l-1.45-.62a2.05 2.05 0 0 0-1.04-.1l-2.9.6c-.3.07-.34.22-.07.34l1.45.64c.27.12.75.17 1.07.1Z",
    fill: "#92AAD4"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.95 2.91-.63c.3-.07.31-.22.03-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.64c.28.12.76.16 1.07.1Z",
    fill: "#93AAD5"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.94 2.9-.63c.3-.07.32-.22.04-.34l-1.45-.6a2.06 2.06 0 0 0-1.04-.1l-2.9.6c-.3.06-.34.2-.06.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#94ABD6"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.93 2.91-.63c.3-.07.31-.22.03-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#95ACD6"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.92 2.9-.63c.3-.07.32-.22.04-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.64c.28.12.76.16 1.07.1Z",
    fill: "#96ADD7"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.9 2.9-.62c.3-.07.32-.22.04-.33l-1.45-.62a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.07-.34.22-.07.34l1.44.64c.27.12.76.16 1.07.1Z",
    fill: "#97AED8"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.9 2.9-.64c.3-.06.32-.21.04-.33l-1.46-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.06.33l1.44.65c.27.12.75.16 1.07.1Z",
    fill: "#98AFD9"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "m52.54 43.88 2.9-.63c.3-.06.32-.2.04-.33l-1.46-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.22-.06.34l1.44.64c.27.12.75.16 1.07.1Z",
    fill: "#98B0DA"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.87 2.91-.62c.3-.07.31-.22.03-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.05-.34.2-.07.33l1.44.64c.28.12.76.16 1.07.1Z",
    fill: "#99B1DB"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.86 2.91-.62c.3-.07.31-.22.03-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.05-.34.2-.07.33l1.44.64c.28.11.76.16 1.07.1Z",
    fill: "#9AB2DC"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.85 2.9-.62c.3-.07.32-.22.04-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.64c.28.11.76.16 1.07.1Z",
    fill: "#9BB3DD"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.84 2.9-.63c.3-.06.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#9CB4DD"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.83 2.9-.63c.3-.06.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.04-.1l-2.89.6c-.3.06-.34.21-.07.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#9DB5DE"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.82 2.9-.63c.3-.06.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.04-.1l-2.89.6c-.3.06-.34.2-.07.33l1.44.63c.27.13.76.17 1.07.1Z",
    fill: "#9EB5DF"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "m52.53 43.8 2.9-.62c.3-.06.31-.21.03-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.63c.28.13.76.18 1.08.1Z",
    fill: "#9FB6E0"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.8 2.9-.63c.31-.06.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.63c.28.13.76.18 1.07.1Z",
    fill: "#A0B7E1"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.79 2.9-.63c.31-.07.32-.22.04-.33l-1.45-.62a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.13.76.17 1.07.1Z",
    fill: "#A1B8E2"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.78 2.9-.63c.3-.07.32-.22.04-.33L54 42.2a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.13.76.17 1.07.1Z",
    fill: "#A2B9E3"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.77 2.9-.63c.3-.07.32-.22.04-.33L54 42.19a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#A3BAE4"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.76 2.9-.63c.3-.07.32-.22.04-.33L54 42.18a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.07.33l1.44.64c.28.13.76.17 1.07.1Z",
    fill: "#A4BBE5"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.74 2.9-.62c.3-.07.32-.22.04-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.59c-.3.06-.34.21-.07.33l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#A5BCE5"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.73 2.9-.63c.3-.06.31-.21.03-.33L54 42.16a2.05 2.05 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.21-.07.33l1.44.64c.27.13.75.17 1.07.1Z",
    fill: "#A6BDE6"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "m52.52 43.72 2.9-.63c.3-.06.31-.21.03-.33L54 42.15a2.05 2.05 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.21-.07.33l1.44.64c.27.13.75.17 1.07.1Z",
    fill: "#A7BEE7"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "m52.51 43.71 2.91-.63c.3-.06.31-.2.03-.33L54 42.14a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.21-.06.33l1.44.64a2 2 0 0 0 1.06.1Z",
    fill: "#A8BFE8"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "m52.51 43.7 2.9-.63c.31-.06.32-.21.04-.33L54 42.13a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.33.2-.06.33l1.43.64c.28.12.76.17 1.07.1Z",
    fill: "#A9BFE9"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "m52.51 43.7 2.9-.64c.3-.06.32-.2.04-.33L54 42.12a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.64c.28.12.76.17 1.07.1Z",
    fill: "#AAC0EA"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.68 2.91-.63c.3-.06.32-.21.04-.33L54 42.1a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.63c.28.13.76.18 1.07.1Z",
    fill: "#ABC1EB"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.67 2.91-.63c.3-.06.31-.21.03-.33L54 42.1a2.05 2.05 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.2-.07.33l1.44.64a2 2 0 0 0 1.07.1Z",
    fill: "#ACC2EC"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.66 2.9-.63c.3-.06.32-.21.04-.33L54 42.09a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.33.2-.06.33l1.43.63c.28.13.77.17 1.08.1Z",
    fill: "#ADC3EC"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.65 2.9-.63c.3-.06.32-.2.04-.33L54 42.08a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.33.2-.06.33l1.43.64c.28.12.76.16 1.08.1Z",
    fill: "#AEC4ED"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.64 2.9-.63c.3-.06.32-.2.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.34.2-.07.33l1.44.64c.28.12.76.16 1.07.1Z",
    fill: "#AFC5EE"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.63 2.9-.63c.3-.06.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.33.2-.06.33l1.43.63a2 2 0 0 0 1.07.1Z",
    fill: "#B0C6EF"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.61 2.9-.62c.3-.07.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.04-.1l-2.88.6c-.31.06-.35.2-.08.33l1.44.63c.28.13.76.17 1.07.1Z",
    fill: "#B1C7F0"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.6 2.9-.62c.3-.06.32-.21.04-.33l-1.45-.61a2.05 2.05 0 0 0-1.04-.1l-2.88.6c-.31.06-.35.2-.08.33l1.44.63c.28.12.76.17 1.07.1Z",
    fill: "#B2C8F1"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.6 2.9-.63c.3-.06.31-.21.03-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.2-.07.33l1.44.64c.28.12.76.16 1.07.1Z",
    fill: "#B3C9F2"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.58 2.9-.62c.3-.07.31-.21.03-.33l-1.45-.61a2.05 2.05 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.2-.07.33l1.44.63c.28.13.76.17 1.07.1Z",
    fill: "#B4C9F3"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.57 2.9-.62c.3-.07.31-.22.03-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.2-.07.32l1.44.64c.27.12.75.17 1.07.1Z",
    fill: "#B5CAF3"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.56 2.9-.62c.3-.07.3-.22.03-.34l-1.45-.6a2.05 2.05 0 0 0-1.03-.1l-2.9.6c-.3.06-.33.2-.06.32l1.43.64c.28.12.76.17 1.07.1Z",
    fill: "#B6CBF4"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.55 2.9-.62c.3-.07.3-.22.03-.34l-1.45-.6a2.04 2.04 0 0 0-1.03-.1l-2.89.6c-.3.06-.34.2-.07.32l1.44.64c.27.12.75.17 1.06.1Z",
    fill: "#B7CCF5"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 43.54 2.9-.63c.3-.06.3-.2.03-.33l-1.45-.6a2.04 2.04 0 0 0-1.03-.1l-2.89.59c-.3.06-.34.21-.07.33l1.44.64c.27.12.75.17 1.06.1Z",
    fill: "#B8CDF6"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "m52.49 43.53 2.9-.63c.3-.06.31-.2.03-.33l-1.44-.6a2.04 2.04 0 0 0-1.03-.1l-2.9.59c-.3.06-.33.2-.06.33l1.43.64c.28.12.76.17 1.07.1Z",
    fill: "#B9CEF7"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49.06 3.8-.82c.38-.08.49-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.16-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.16.8.21 1.21.13Z",
    fill: "#7791BC"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49.05 3.8-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.16-.11l-3.75.77c-.4.09-.53.27-.28.43l1.33.8c.26.15.8.2 1.21.11Z",
    fill: "#7892BD"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49.04 3.8-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.16-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.16.8.21 1.21.12Z",
    fill: "#7993BE"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49.03 3.8-.82c.38-.09.49-.27.22-.42l-1.36-.76c-.26-.15-.78-.2-1.16-.12l-3.76.78c-.4.08-.53.27-.28.42l1.34.8c.25.15.8.2 1.2.12Z",
    fill: "#7A94BF"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49.02 3.8-.82c.38-.09.48-.28.22-.42l-1.36-.76c-.26-.15-.78-.2-1.16-.12l-3.76.78c-.4.08-.53.27-.28.42l1.34.8c.25.16.8.2 1.2.12Z",
    fill: "#7B95C0"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49 3.8-.81c.38-.09.48-.28.22-.43L33.03 47c-.26-.14-.78-.19-1.16-.11l-3.76.77c-.4.09-.53.28-.28.43l1.34.8c.25.15.8.2 1.2.12Z",
    fill: "#7C96C0"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 49 3.8-.83c.38-.08.48-.27.22-.42L33.03 47c-.26-.14-.78-.2-1.16-.11l-3.76.77c-.4.09-.53.28-.28.42l1.34.8c.25.16.8.22 1.2.13Z",
    fill: "#7D96C1"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 48.98 3.8-.82c.38-.08.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.11l-3.76.77c-.4.09-.53.27-.28.42l1.34.8c.25.16.8.21 1.2.12Z",
    fill: "#7E97C2"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 48.97 3.8-.82c.38-.08.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.12l-3.76.78c-.4.08-.53.27-.28.42l1.34.8c.25.16.8.21 1.2.12Z",
    fill: "#7F98C3"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "m30.37 48.96 3.8-.82c.38-.09.48-.27.22-.42l-1.37-.76c-.25-.15-.77-.2-1.16-.12l-3.75.78c-.4.08-.53.27-.28.42l1.34.8c.25.16.8.21 1.2.12Z",
    fill: "#8099C4"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.95 3.79-.82c.38-.09.48-.28.22-.42l-1.37-.76c-.25-.15-.77-.2-1.15-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#819AC5"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.94 3.79-.82c.38-.09.48-.28.22-.42l-1.37-.76c-.25-.15-.77-.2-1.15-.12l-3.75.77c-.4.09-.53.28-.28.43l1.33.8c.26.16.8.2 1.2.12Z",
    fill: "#829BC6"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.93 3.79-.82c.38-.09.48-.28.22-.43l-1.37-.76c-.25-.14-.77-.19-1.15-.11l-3.75.77c-.4.09-.53.28-.28.42l1.33.8c.26.16.8.21 1.2.13Z",
    fill: "#839CC7"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.91 3.79-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.15-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.16.8.21 1.2.12Z",
    fill: "#849DC7"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.9 3.79-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.19-1.15-.11l-3.75.77c-.4.09-.53.28-.28.42l1.33.8c.26.16.8.21 1.2.13Z",
    fill: "#859EC8"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.9 3.79-.83c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.15-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.16.8.21 1.2.12Z",
    fill: "#869FC9"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.88 3.79-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.15-.11l-3.75.77c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#87A0CA"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.87 3.79-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.15-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#88A0CB"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.86 3.79-.82c.38-.09.48-.28.22-.42l-1.37-.76c-.25-.15-.77-.2-1.15-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#89A1CC"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.85 3.79-.82c.38-.09.48-.28.22-.42l-1.37-.76c-.25-.15-.77-.2-1.15-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#8AA2CD"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.83 3.79-.81c.38-.09.48-.28.22-.42l-1.37-.76c-.25-.15-.77-.2-1.15-.12l-3.75.77c-.4.09-.53.27-.28.43l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#8BA3CE"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.82 3.79-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.19-1.15-.11l-3.75.77c-.4.09-.53.27-.28.42l1.33.8c.26.16.8.21 1.2.12Z",
    fill: "#8CA4CE"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.8 3.79-.81c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.2-1.15-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.16.8.2 1.2.12Z",
    fill: "#8DA5CF"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.8 3.79-.82c.38-.08.48-.27.22-.42l-1.37-.76c-.25-.14-.77-.19-1.15-.11l-3.75.77c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#8EA6D0"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.79 3.79-.82c.39-.09.49-.28.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.21.12Z",
    fill: "#8FA7D1"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.78 3.79-.82c.38-.09.48-.28.22-.42l-1.37-.76c-.25-.14-.77-.2-1.15-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.21.12Z",
    fill: "#90A8D2"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.76 3.79-.82c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.15-.78-.2-1.16-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.21.11Z",
    fill: "#91A9D3"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.75 3.79-.82c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.15-.78-.2-1.16-.12l-3.75.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.21.11Z",
    fill: "#92AAD4"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.74 3.79-.82c.38-.08.48-.27.22-.42l-1.36-.75c-.26-.15-.78-.2-1.16-.12l-3.75.77c-.4.09-.53.28-.28.43l1.33.8c.26.15.8.2 1.21.11Z",
    fill: "#93AAD5"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.73 3.79-.82c.38-.09.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.21.12Z",
    fill: "#94ABD6"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.72 3.79-.82c.38-.08.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.11l-3.75.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.21.12Z",
    fill: "#95ACD6"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.7 3.79-.81c.39-.09.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.2-1.16-.12l-3.74.77c-.4.09-.53.28-.28.43l1.33.8c.25.15.8.2 1.2.12Z",
    fill: "#96ADD7"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.7 3.79-.82c.38-.09.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.12l-3.74.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#97AED8"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.68 3.79-.81c.38-.09.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.12l-3.74.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#98AFD9"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.67 3.79-.81c.38-.09.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.12l-3.74.78c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#98B0DA"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.66 3.79-.82c.38-.08.48-.27.22-.42l-1.36-.75c-.26-.15-.78-.2-1.16-.12l-3.74.77c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#99B1DB"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "m30.38 48.65 3.79-.82c.38-.08.48-.27.22-.42l-1.36-.75c-.26-.15-.78-.2-1.16-.12l-3.74.77c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#9AB2DC"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.64 3.78-.82c.39-.09.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.2-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#9BB3DD"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.63 3.78-.82c.39-.08.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.2-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#9CB4DD"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.61 3.78-.81c.39-.09.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.2-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#9DB5DE"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.6 3.78-.81c.38-.09.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.2-1.16-.12l-3.74.78c-.4.08-.53.27-.28.41l1.33.8c.26.16.8.21 1.2.12Z",
    fill: "#9EB5DF"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.6 3.78-.83c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.15-.78-.2-1.16-.12l-3.74.77c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#9FB6E0"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.58 3.78-.82c.38-.08.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.19-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#A0B7E1"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.57 3.78-.82c.38-.08.48-.27.22-.42l-1.36-.76c-.26-.14-.78-.19-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#A1B8E2"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.55 3.78-.81c.39-.09.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.2-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.79c.26.16.8.21 1.2.12Z",
    fill: "#A2B9E3"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.54 3.78-.81c.39-.09.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.19-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#A3BAE4"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.53 3.78-.81c.39-.09.49-.27.22-.42l-1.36-.76c-.26-.14-.77-.19-1.16-.11l-3.74.77c-.4.08-.53.27-.28.41l1.33.8c.26.16.8.21 1.2.12Z",
    fill: "#A4BBE5"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.52 3.78-.81c.39-.09.49-.28.22-.42l-1.36-.76c-.26-.14-.77-.19-1.16-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.79c.26.16.8.2 1.2.12Z",
    fill: "#A5BCE5"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.5 3.78-.8c.38-.1.48-.28.22-.43l-1.36-.75c-.26-.15-.78-.2-1.16-.12l-3.74.77c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#A6BDE6"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.5 3.78-.82c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.14-.78-.2-1.16-.11l-3.74.77c-.4.08-.53.27-.28.41l1.33.8c.26.15.8.2 1.2.12Z",
    fill: "#A7BEE7"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "m30.39 48.49 3.78-.82c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.14-.78-.2-1.16-.11l-3.73.77c-.4.08-.53.27-.28.41l1.32.8a2 2 0 0 0 1.21.12Z",
    fill: "#A8BFE8"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.47 3.77-.81c.39-.09.49-.27.22-.42l-1.36-.75c-.25-.15-.77-.2-1.15-.12l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.25.15.8.2 1.2.11Z",
    fill: "#A9BFE9"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.46 3.77-.81c.39-.09.49-.27.22-.42l-1.36-.75c-.25-.15-.77-.2-1.15-.12l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.25.15.8.2 1.2.11Z",
    fill: "#AAC0EA"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.45 3.77-.81c.39-.09.49-.27.22-.42l-1.36-.76c-.25-.14-.77-.19-1.15-.1l-3.74.76c-.4.08-.53.27-.28.42l1.33.8c.25.15.8.2 1.2.11Z",
    fill: "#ABC1EB"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.44 3.77-.82c.39-.08.49-.27.22-.41l-1.36-.76c-.25-.14-.77-.19-1.15-.1l-3.74.76c-.4.08-.53.27-.28.42l1.33.8c.26.14.8.2 1.2.1Z",
    fill: "#ACC2EC"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.43 3.77-.81c.38-.09.48-.28.22-.42l-1.36-.76c-.26-.14-.77-.19-1.16-.1l-3.73.76c-.4.08-.53.27-.28.42l1.32.8c.27.14.8.2 1.21.1Z",
    fill: "#ADC3EC"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.42 3.77-.82c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.14-.77-.19-1.16-.11l-3.73.77c-.4.08-.53.27-.28.42l1.33.79c.26.15.8.2 1.2.12Z",
    fill: "#AEC4ED"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.4 3.77-.81c.38-.08.48-.27.22-.42l-1.36-.75c-.26-.15-.77-.2-1.16-.11l-3.73.76c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#AFC5EE"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.4 3.77-.82c.39-.08.49-.27.22-.42l-1.36-.75c-.25-.14-.77-.2-1.15-.11l-3.74.76c-.4.09-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#B0C6EF"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.38 3.77-.81c.39-.09.49-.27.22-.42l-1.36-.75c-.25-.15-.77-.2-1.15-.12l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#B1C7F0"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.37 3.77-.82c.39-.08.49-.27.22-.41l-1.36-.76c-.25-.14-.77-.19-1.15-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.14.8.2 1.2.1Z",
    fill: "#B2C8F1"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.36 3.77-.82c.39-.08.49-.27.22-.41l-1.36-.76c-.25-.14-.77-.19-1.15-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.8c.26.14.8.2 1.2.1Z",
    fill: "#B3C9F2"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.35 3.77-.82c.39-.08.49-.27.22-.41l-1.36-.76c-.25-.14-.77-.2-1.15-.11l-3.74.77c-.4.08-.53.27-.28.42l1.33.79c.26.15.8.2 1.2.12Z",
    fill: "#B4C9F3"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.34 3.77-.82c.38-.08.48-.27.22-.41l-1.36-.76c-.26-.14-.77-.2-1.16-.11l-3.73.77c-.4.08-.53.27-.28.42l1.33.79c.26.15.8.2 1.2.12Z",
    fill: "#B5CAF3"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.32 3.77-.81c.38-.09.48-.27.22-.42l-1.36-.75c-.26-.14-.77-.2-1.15-.12l-3.74.77c-.4.08-.52.27-.28.42l1.33.8c.26.15.8.2 1.2.11Z",
    fill: "#B6CBF4"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.31 3.77-.8c.39-.1.48-.28.22-.42l-1.36-.76c-.25-.14-.77-.2-1.15-.11l-3.73.76c-.4.08-.53.27-.28.42l1.32.8c.26.15.8.2 1.2.11Z",
    fill: "#B7CCF5"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.3 3.77-.81c.39-.08.48-.27.22-.42l-1.36-.75c-.25-.14-.77-.2-1.15-.11l-3.73.76c-.4.08-.53.27-.28.42l1.32.8c.26.14.8.2 1.2.11Z",
    fill: "#B8CDF6"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "m30.4 48.29 3.77-.81c.39-.09.48-.27.22-.42l-1.36-.75c-.25-.14-.77-.2-1.15-.12l-3.73.77c-.4.08-.53.27-.28.42l1.32.79c.26.15.8.2 1.2.12Z",
    fill: "#B9CEF7"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.5 4.07-.9c.42-.08.54-.28.29-.44l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4.02.84c-.43.08-.6.29-.35.44l1.28.85c.26.17.82.23 1.26.13Z",
    fill: "#7791BC"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.48 4.07-.88c.42-.1.55-.3.29-.45l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4.02.84c-.43.09-.59.29-.35.45l1.29.85c.25.16.8.22 1.25.12Z",
    fill: "#7892BD"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.47 4.07-.88c.42-.1.55-.3.29-.45l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4.02.83c-.43.1-.59.3-.35.45l1.29.85c.25.17.8.23 1.25.13Z",
    fill: "#7993BE"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.46 4.07-.89c.42-.09.55-.29.3-.45l-1.33-.8c-.25-.15-.79-.2-1.2-.12l-4.02.83c-.44.09-.6.3-.35.45l1.28.85c.25.17.81.22 1.25.13Z",
    fill: "#7A94BF"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.45 4.07-.89c.42-.09.55-.29.3-.45l-1.33-.8c-.25-.15-.79-.2-1.2-.12l-4.02.83c-.44.09-.6.3-.35.45l1.28.85c.25.17.81.22 1.25.13Z",
    fill: "#7B95C0"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.43 4.07-.88c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.15-.79-.2-1.2-.12l-4.02.83c-.44.09-.6.29-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#7C96C0"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.42 4.07-.88c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.16-.78-.2-1.2-.13l-4.02.84c-.43.09-.6.29-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#7D96C1"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.41 4.07-.88c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.16-.78-.2-1.2-.12l-4.02.83c-.43.09-.6.29-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#7E97C2"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.4 4.07-.89c.42-.08.55-.29.3-.44l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4.02.83c-.43.1-.6.3-.35.45l1.28.85c.25.17.82.22 1.25.13Z",
    fill: "#7F98C3"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.38 4.08-.88c.42-.09.54-.29.29-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4.02.83c-.43.09-.59.3-.35.45l1.29.85c.25.16.8.22 1.25.12Z",
    fill: "#8099C4"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.37 4.08-.88c.42-.09.54-.29.29-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4.02.83c-.43.09-.59.29-.35.45l1.29.84c.25.17.8.23 1.25.13Z",
    fill: "#819AC5"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.36 4.08-.88c.42-.09.55-.3.29-.45l-1.33-.8c-.24-.15-.78-.2-1.2-.12l-4.01.83c-.44.09-.6.29-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#829BC6"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.35 4.08-.88c.42-.1.54-.3.29-.45l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4.02.83c-.43.1-.59.3-.35.45l1.29.85c.25.17.81.23 1.25.13Z",
    fill: "#839CC7"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8 50.34 4.08-.88c.42-.1.54-.3.29-.45l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4.01.83c-.44.1-.6.3-.35.45l1.28.85c.25.17.81.22 1.25.13Z",
    fill: "#849DC7"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "m23.81 50.33 4.07-.88c.42-.1.54-.3.29-.45l-1.33-.8c-.24-.16-.78-.21-1.2-.13l-4.01.83c-.43.1-.6.3-.35.45l1.28.85c.25.17.81.22 1.25.13Z",
    fill: "#859EC8"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "m23.81 50.32 4.07-.88c.42-.1.55-.3.29-.45l-1.33-.8c-.24-.16-.78-.21-1.19-.13l-4.02.83c-.43.1-.59.3-.35.45l1.29.85c.24.17.8.22 1.24.13Z",
    fill: "#869FC9"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "m23.81 50.3 4.07-.88c.42-.09.55-.29.29-.44l-1.32-.81c-.25-.15-.79-.2-1.2-.12l-4.02.83c-.43.09-.59.29-.35.45l1.29.85c.24.16.8.22 1.24.12Z",
    fill: "#87A0CA"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "m23.81 50.29 4.07-.88c.42-.09.55-.3.29-.45l-1.32-.8c-.25-.15-.79-.2-1.2-.12l-4.02.83c-.43.09-.59.29-.35.45l1.29.84c.24.17.8.22 1.24.13Z",
    fill: "#88A0CB"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "m23.81 50.28 4.07-.88c.42-.1.55-.3.29-.45l-1.32-.8c-.25-.16-.79-.21-1.2-.13l-4.02.83c-.43.1-.59.3-.35.45l1.29.85c.25.17.8.23 1.24.13Z",
    fill: "#89A1CC"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.27 4.06-.88c.42-.1.55-.3.29-.45l-1.32-.8c-.25-.16-.79-.21-1.2-.13l-4.02.83c-.43.1-.59.3-.35.45l1.29.85c.25.17.8.22 1.25.13Z",
    fill: "#8AA2CD"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.26 4.06-.88c.42-.1.55-.3.29-.45l-1.32-.8c-.25-.16-.79-.21-1.2-.13l-4.01.83c-.44.1-.6.3-.35.45l1.28.85c.25.16.8.22 1.25.13Z",
    fill: "#8BA3CE"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.25 4.06-.88c.42-.1.55-.3.29-.45l-1.32-.8c-.25-.16-.79-.2-1.2-.13l-4.01.83c-.44.1-.6.3-.35.45l1.28.85c.25.16.81.22 1.25.13Z",
    fill: "#8CA4CE"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.23 4.07-.88c.41-.09.54-.3.28-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4.01.83c-.43.09-.6.29-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#8DA5CF"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.22 4.07-.88c.41-.1.54-.3.28-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4.01.83c-.43.09-.6.29-.35.45l1.28.84c.25.17.81.22 1.25.13Z",
    fill: "#8EA6D0"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.2 4.07-.87c.41-.1.54-.3.29-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.44.09-.6.29-.36.45l1.29.84c.24.17.8.22 1.24.13Z",
    fill: "#8FA7D1"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.2 4.07-.88c.41-.1.54-.3.29-.45l-1.33-.8c-.25-.16-.78-.21-1.2-.13l-4 .83c-.44.1-.6.3-.36.45l1.28.85c.26.16.81.22 1.25.13Z",
    fill: "#90A8D2"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.18 4.07-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.16-.78-.21-1.2-.13l-4 .83c-.44.09-.6.3-.36.45l1.28.85c.26.16.82.22 1.25.12Z",
    fill: "#91A9D3"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.17 4.07-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.16-.78-.21-1.2-.13l-4 .83c-.44.09-.6.3-.36.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#92AAD4"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 50.16 4.07-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.16-.78-.21-1.2-.13l-4 .83c-.44.09-.6.29-.36.45l1.28.84c.26.17.82.23 1.25.13Z",
    fill: "#93AAD5"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.15 4.06-.88c.42-.09.55-.3.29-.45l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4.01.83c-.43.09-.6.28-.35.45l1.28.84c.25.17.8.22 1.25.13Z",
    fill: "#94ABD6"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.14 4.06-.88c.42-.09.55-.3.29-.45l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4.01.83c-.43.09-.6.29-.35.45l1.28.84c.25.17.8.22 1.25.13Z",
    fill: "#95ACD6"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.12 4.06-.87c.42-.1.55-.3.29-.45l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4.01.82c-.43.1-.6.3-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#96ADD7"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.11 4.06-.88c.42-.08.54-.29.29-.44l-1.32-.8c-.25-.16-.79-.21-1.2-.13l-4.01.83c-.43.1-.6.29-.35.45l1.28.85c.25.16.81.22 1.25.12Z",
    fill: "#97AED8"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.1 4.06-.88c.42-.09.54-.29.29-.44l-1.32-.8c-.25-.16-.79-.21-1.2-.13l-4 .83c-.44.09-.6.29-.36.45l1.28.84c.25.17.81.23 1.25.13Z",
    fill: "#98AFD9"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.09 4.06-.88c.42-.09.54-.29.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.44.09-.6.29-.36.44l1.28.85c.25.17.81.22 1.25.13Z",
    fill: "#98B0DA"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.08 4.06-.88c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4 .82c-.44.1-.6.3-.36.45l1.29.85c.25.16.8.22 1.24.13Z",
    fill: "#99B1DB"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.07 4.06-.88c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4 .82c-.44.1-.6.3-.36.45l1.29.85c.25.16.8.22 1.24.13Z",
    fill: "#9AB2DC"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.05 4.07-.87c.41-.1.54-.3.28-.45l-1.32-.8c-.25-.16-.78-.2-1.2-.12l-4 .82c-.43.1-.6.3-.35.45l1.28.85c.25.16.8.22 1.24.12Z",
    fill: "#9BB3DD"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.04 4.07-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.16-.78-.2-1.2-.12l-4 .82c-.43.1-.6.3-.35.45l1.28.85c.25.16.8.22 1.24.12Z",
    fill: "#9CB4DD"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "m23.83 50.03 4.06-.88c.42-.09.55-.28.3-.44l-1.33-.8c-.25-.16-.78-.2-1.2-.12l-4 .82c-.44.1-.6.3-.36.45l1.29.85c.25.16.8.22 1.24.12Z",
    fill: "#9DB5DE"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 50.02 4.06-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.16-.78-.2-1.2-.12l-4 .83c-.43.08-.6.28-.35.44l1.28.85c.25.16.8.21 1.25.12Z",
    fill: "#9EB5DF"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 50 4.05-.87c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.15-.78-.2-1.19-.12l-4 .83c-.44.1-.6.29-.36.45l1.28.84c.25.16.81.22 1.25.13Z",
    fill: "#9FB6E0"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 50 4.06-.88c.41-.1.54-.3.29-.45l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4 .83c-.44.09-.6.29-.36.44l1.29.85c.24.16.8.22 1.24.12Z",
    fill: "#A0B7E1"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.98 4.06-.87c.41-.1.54-.3.29-.45l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4 .83c-.44.09-.6.29-.36.45l1.29.84c.24.16.8.22 1.24.12Z",
    fill: "#A1B8E2"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.97 4.06-.88c.41-.09.54-.28.29-.44l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4 .83c-.44.09-.6.28-.36.44l1.29.85c.25.16.8.21 1.24.12Z",
    fill: "#A2B9E3"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.96 4.06-.88c.42-.08.54-.28.29-.44l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.43.09-.6.28-.35.44l1.28.85c.24.16.8.21 1.24.12Z",
    fill: "#A3BAE4"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.95 4.06-.88c.41-.09.54-.29.29-.44l-1.33-.8c-.24-.16-.78-.2-1.19-.12l-4 .82c-.44.1-.6.3-.35.45l1.28.84c.25.16.8.22 1.24.13Z",
    fill: "#A4BBE5"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.94 4.06-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.24-.16-.78-.2-1.19-.12l-4 .82c-.43.1-.6.3-.35.45l1.28.84c.25.16.8.22 1.24.13Z",
    fill: "#A5BCE5"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.92 4.06-.87c.42-.1.54-.3.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.43.09-.6.29-.35.45l1.28.84c.25.16.8.22 1.24.12Z",
    fill: "#A6BDE6"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "m23.84 49.91 4.06-.88c.42-.09.54-.28.29-.44l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.43.08-.6.28-.35.44l1.28.84c.25.17.8.22 1.24.13Z",
    fill: "#A7BEE7"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.9 4.05-.87c.42-.1.55-.3.3-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.43.09-.59.29-.35.44l1.29.85c.24.16.8.22 1.24.12Z",
    fill: "#A8BFE8"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 49.89 27.9 49c.42-.09.55-.29.3-.44l-1.33-.8c-.25-.15-.78-.2-1.2-.12l-4 .82c-.43.1-.59.3-.35.45l1.29.84c.24.17.8.22 1.24.13Z",
    fill: "#A9BFE9"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 49.87 27.9 49c.42-.1.54-.29.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.11l-4 .82c-.43.09-.59.29-.35.45l1.28.84c.25.16.81.22 1.25.12Z",
    fill: "#AAC0EA"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 49.86 27.9 49c.42-.09.55-.29.3-.45l-1.33-.8c-.25-.15-.78-.2-1.2-.11l-4 .82c-.43.09-.59.29-.35.45l1.29.84c.24.16.8.22 1.24.12Z",
    fill: "#ABC1EB"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.85 4.05-.87c.42-.1.54-.3.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.43.09-.58.29-.34.44l1.28.85c.24.16.8.22 1.24.12Z",
    fill: "#ACC2EC"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.84 4.06-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.15-.78-.2-1.19-.12l-4 .82c-.43.1-.59.3-.35.45l1.28.84c.25.17.8.22 1.24.13Z",
    fill: "#ADC3EC"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.83 4.06-.88c.41-.09.54-.28.28-.44l-1.32-.8c-.25-.15-.78-.2-1.19-.12l-4 .83c-.43.08-.59.28-.35.44l1.28.84c.25.17.8.22 1.24.13Z",
    fill: "#AEC4ED"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.82 4.06-.88c.41-.09.54-.29.28-.44l-1.32-.8c-.25-.16-.78-.21-1.19-.12l-4 .82c-.43.1-.59.29-.35.45l1.28.84c.25.16.8.22 1.24.13Z",
    fill: "#AFC5EE"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.8 4.06-.87c.41-.1.54-.29.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.11l-4 .82c-.43.09-.59.29-.35.44l1.28.85c.25.16.8.22 1.24.12Z",
    fill: "#B0C6EF"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.8 4.05-.88c.42-.09.55-.29.3-.44l-1.33-.8c-.24-.16-.78-.2-1.19-.12l-4 .82c-.43.09-.59.29-.35.44l1.28.85c.25.16.8.22 1.24.12Z",
    fill: "#B1C7F0"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 49.78 4.05-.87c.42-.1.55-.3.3-.45l-1.33-.8c-.24-.15-.78-.2-1.19-.12l-4 .83c-.43.09-.59.28-.35.44l1.28.85c.25.16.8.22 1.24.12Z",
    fill: "#B2C8F1"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.77 4.05-.88c.41-.09.54-.29.29-.44l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .82c-.43.1-.58.3-.34.45l1.28.84c.24.16.8.22 1.24.13Z",
    fill: "#B3C9F2"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.76 4.05-.87c.41-.1.54-.3.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .83c-.43.09-.58.29-.34.44l1.28.85c.24.15.8.21 1.24.12Z",
    fill: "#B4C9F3"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.74 4.05-.87c.42-.09.54-.29.29-.44l-1.32-.8c-.25-.15-.78-.2-1.2-.12l-4 .82c-.42.1-.58.3-.34.45l1.28.84c.25.16.8.22 1.24.13Z",
    fill: "#B5CAF3"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.73 4.05-.87c.42-.1.54-.29.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.11l-4 .82c-.42.09-.58.29-.34.45l1.28.84c.25.16.8.22 1.24.12Z",
    fill: "#B6CBF4"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.72 4.05-.87c.42-.1.54-.29.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.11l-4 .82c-.42.09-.58.29-.34.44l1.28.85c.25.16.8.22 1.24.12Z",
    fill: "#B7CCF5"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.71 4.05-.87c.42-.1.54-.3.29-.45l-1.32-.8c-.25-.15-.78-.2-1.2-.11l-4 .82c-.42.09-.58.29-.34.44l1.28.84c.25.17.8.22 1.24.13Z",
    fill: "#B8CDF6"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "m23.86 49.7 4.05-.88c.42-.09.54-.29.29-.44l-1.32-.8c-.25-.15-.78-.2-1.19-.12l-4 .82c-.43.1-.59.3-.35.45l1.28.84c.25.16.8.22 1.24.13Z",
    fill: "#B9CEF7"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.74 14.18-3.08c.32-.07.35-.22.07-.35l-1.44-.65a2.04 2.04 0 0 0-1.07-.1l-14.07 2.91c-.38.08-.48.26-.22.4l1.37.75c.27.15.8.2 1.18.12Z",
    fill: "#7791BC"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.73 14.19-3.08c.32-.07.35-.23.07-.35l-1.45-.65a2.04 2.04 0 0 0-1.06-.1l-14.07 2.9c-.38.09-.48.26-.22.4l1.37.76c.27.15.8.2 1.17.12Z",
    fill: "#7892BD"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.72 14.17-3.08c.32-.07.36-.23.08-.35l-1.45-.65a2.04 2.04 0 0 0-1.06-.1l-14.07 2.9c-.38.09-.48.26-.22.4l1.37.76a2 2 0 0 0 1.18.12Z",
    fill: "#7993BE"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.7 14.18-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.04 2.04 0 0 0-1.06-.1l-14.07 2.9c-.38.08-.48.26-.22.4l1.37.76c.27.15.8.2 1.17.11Z",
    fill: "#7A94BF"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.7 14.17-3.08c.32-.07.35-.23.07-.35l-1.44-.65a2.04 2.04 0 0 0-1.06-.1l-14.07 2.9c-.38.09-.48.26-.22.4l1.37.76a2 2 0 0 0 1.18.11Z",
    fill: "#7B95C0"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.68 14.18-3.08c.32-.06.35-.22.07-.35l-1.44-.65a2.04 2.04 0 0 0-1.07-.1l-14.06 2.91c-.38.08-.48.26-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#7C96C0"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.67 14.18-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.04 2.04 0 0 0-1.07-.1l-14.06 2.9c-.38.08-.48.26-.22.4l1.37.76a2 2 0 0 0 1.17.11Z",
    fill: "#7D96C1"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.66 14.18-3.07c.32-.07.35-.23.07-.36l-1.44-.65a2.04 2.04 0 0 0-1.07-.1L34.16 46.4c-.38.08-.48.26-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#7E97C2"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.65 14.18-3.08c.32-.07.35-.22.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.07 2.9c-.37.09-.47.26-.22.4l1.37.76c.27.15.8.2 1.17.12Z",
    fill: "#7F98C3"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.64 14.17-3.08c.32-.07.35-.22.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.07 2.9c-.37.09-.47.26-.22.4l1.37.76c.27.15.8.2 1.18.12Z",
    fill: "#8099C4"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.63 14.17-3.08c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.07 2.9c-.37.09-.47.26-.22.4l1.37.76c.27.15.8.2 1.18.12Z",
    fill: "#819AC5"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.62 14.16-3.07c.32-.07.36-.23.08-.36l-1.45-.64a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.08-.47.26-.22.4l1.37.75c.27.15.8.2 1.18.12Z",
    fill: "#829BC6"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.6 14.17-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.09-.47.26-.22.4l1.37.76c.27.14.8.2 1.17.11Z",
    fill: "#839CC7"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.6 14.16-3.08c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.08-.47.26-.22.4l1.37.75c.27.15.8.2 1.18.12Z",
    fill: "#849DC7"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.58 14.16-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.08-.47.26-.22.4l1.37.75c.27.15.8.2 1.18.12Z",
    fill: "#859EC8"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.57 14.17-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.08-.47.26-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#869FC9"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "m36.49 47.56 14.16-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.08-.47.26-.22.4l1.37.75c.27.15.8.2 1.18.12Z",
    fill: "#87A0CA"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.55 14.17-3.07c.32-.07.35-.23.07-.36l-1.44-.64a2.03 2.03 0 0 0-1.06-.1l-14.06 2.9c-.37.08-.47.25-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#88A0CB"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.54 14.16-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.38.08-.48.26-.22.4l1.37.75a2 2 0 0 0 1.17.12Z",
    fill: "#89A1CC"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.52 14.16-3.06c.32-.07.35-.23.08-.36l-1.45-.64a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.37.07-.47.25-.22.4l1.37.75c.27.15.8.2 1.17.11Z",
    fill: "#8AA2CD"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.51 14.16-3.06c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.38.07-.48.25-.22.4l1.37.75c.27.14.8.2 1.17.11Z",
    fill: "#8BA3CE"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.5 14.16-3.07c.32-.06.35-.22.07-.35l-1.44-.64a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.38.07-.48.25-.22.39l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#8CA4CE"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.5 14.16-3.08c.32-.06.35-.22.07-.35l-1.44-.64a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.37.07-.47.25-.22.39l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#8DA5CF"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.48 14.16-3.07c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.38.08-.48.26-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#8EA6D0"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.47 14.16-3.07c.32-.07.35-.22.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.05 2.9c-.37.08-.47.26-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#8FA7D1"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.45 14.16-3.06c.31-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.07-.1l-14.04 2.9c-.38.08-.48.25-.22.4l1.37.75c.27.15.8.2 1.17.11Z",
    fill: "#90A8D2"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.44 14.16-3.06c.31-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.07-.1l-14.04 2.9c-.37.08-.47.25-.22.4l1.37.75c.27.14.8.2 1.17.11Z",
    fill: "#91A9D3"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.43 14.15-3.06c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.04 2.9c-.38.07-.48.25-.22.4l1.37.74c.27.15.8.2 1.17.12Z",
    fill: "#92AAD4"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.42 14.15-3.06c.32-.07.35-.23.07-.35l-1.44-.65a2.03 2.03 0 0 0-1.06-.1l-14.04 2.9c-.38.07-.48.25-.22.4l1.37.74c.27.15.8.2 1.17.12Z",
    fill: "#93AAD5"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.41 14.15-3.06c.32-.07.35-.23.07-.35l-1.43-.65a2.03 2.03 0 0 0-1.07-.1l-14.04 2.9c-.37.08-.47.25-.22.4l1.37.75c.27.14.8.2 1.17.11Z",
    fill: "#94ABD6"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.4 14.15-3.06c.32-.07.35-.23.07-.35l-1.44-.65a2.06 2.06 0 0 0-1.06-.1l-14.04 2.9c-.37.07-.47.25-.22.39l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#95ACD6"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.39 14.15-3.06c.32-.07.35-.23.07-.35l-1.44-.65a2.06 2.06 0 0 0-1.06-.1l-14.04 2.9c-.37.07-.47.25-.22.39l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#96ADD7"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.38 14.15-3.07c.32-.06.35-.22.07-.35l-1.44-.64a2.06 2.06 0 0 0-1.06-.1L34.16 46.1c-.37.08-.47.25-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#97AED8"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.37 14.15-3.07c.32-.06.35-.22.07-.35l-1.44-.64a2.06 2.06 0 0 0-1.06-.1L34.16 46.1c-.37.08-.47.25-.22.4l1.37.75c.27.15.8.2 1.17.12Z",
    fill: "#98AFD9"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.35 14.14-3.05c.32-.07.35-.23.07-.36l-1.43-.64a2.06 2.06 0 0 0-1.07-.1l-14.03 2.89c-.38.08-.48.26-.22.4l1.37.75c.27.14.8.2 1.17.11Z",
    fill: "#98B0DA"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.34 14.14-3.06c.32-.07.35-.22.07-.35l-1.43-.64a2.06 2.06 0 0 0-1.07-.1l-14.03 2.89c-.37.07-.47.25-.22.4l1.37.74c.27.15.8.2 1.17.12Z",
    fill: "#99B1DB"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.33 14.14-3.06c.32-.07.35-.23.07-.35l-1.43-.64a2.06 2.06 0 0 0-1.07-.1l-14.03 2.89c-.37.07-.47.25-.22.4l1.37.74c.27.15.8.2 1.17.12Z",
    fill: "#9AB2DC"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.32 14.14-3.06c.32-.07.35-.23.07-.35l-1.44-.64a2.06 2.06 0 0 0-1.06-.1l-14.03 2.89c-.38.07-.48.25-.22.4l1.37.74c.27.15.8.2 1.17.12Z",
    fill: "#9BB3DD"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.3 14.14-3.05c.32-.07.35-.22.07-.35l-1.44-.64a2.06 2.06 0 0 0-1.06-.1l-14.03 2.89c-.38.08-.48.26-.22.4l1.37.75c.27.14.8.2 1.17.1Z",
    fill: "#9CB4DD"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.3 14.14-3.06c.32-.07.35-.23.07-.35l-1.44-.64a2.06 2.06 0 0 0-1.06-.1l-14.03 2.89c-.38.08-.48.25-.22.4l1.37.74c.27.15.8.2 1.17.12Z",
    fill: "#9DB5DE"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.29 14.14-3.06c.32-.07.35-.23.07-.35l-1.44-.64a2.05 2.05 0 0 0-1.06-.1l-14.03 2.89c-.37.07-.47.25-.22.4l1.37.74a2 2 0 0 0 1.17.12Z",
    fill: "#9EB5DF"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.27 14.14-3.05c.31-.07.34-.23.07-.35l-1.44-.65a2.05 2.05 0 0 0-1.06-.1l-14.03 2.9c-.37.07-.47.25-.22.39l1.37.75c.26.14.8.2 1.17.11Z",
    fill: "#9FB6E0"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.26 14.14-3.05c.31-.07.34-.23.07-.35l-1.44-.65a2.05 2.05 0 0 0-1.06-.1l-14.03 2.9c-.37.07-.47.25-.22.39l1.37.75c.26.14.79.2 1.17.11Z",
    fill: "#A0B7E1"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.25 14.14-3.05c.31-.07.34-.23.07-.35l-1.44-.65a2.02 2.02 0 0 0-1.06-.1L34.16 46c-.37.07-.47.25-.22.39l1.37.75c.26.14.79.2 1.17.11Z",
    fill: "#A1B8E2"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.24 14.13-3.05c.32-.07.35-.23.07-.35l-1.43-.65a2.02 2.02 0 0 0-1.06-.1L34.16 46c-.37.07-.47.25-.22.39l1.37.75c.26.14.79.2 1.17.1Z",
    fill: "#A2B9E3"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.23 14.13-3.06c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14.03 2.89c-.37.08-.47.25-.22.4l1.37.74a2 2 0 0 0 1.17.12Z",
    fill: "#A3BAE4"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.22 14.13-3.06c.32-.06.35-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14.02 2.89c-.37.08-.47.25-.22.4l1.37.75a2 2 0 0 0 1.17.1Z",
    fill: "#A4BBE5"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.2 14.13-3.05c.32-.07.35-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14.02 2.89c-.37.07-.47.25-.22.4l1.37.74c.26.14.79.2 1.17.11Z",
    fill: "#A5BCE5"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.2 14.13-3.06c.32-.06.35-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14.02 2.89c-.37.08-.47.25-.22.4l1.37.75c.26.14.79.19 1.17.1Z",
    fill: "#A6BDE6"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.18 14.13-3.05c.32-.07.35-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14.02 2.89c-.37.07-.47.25-.22.4l1.37.74c.26.14.79.2 1.17.11Z",
    fill: "#A7BEE7"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.17 14.13-3.05c.31-.07.34-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1L34.16 45.9c-.37.08-.47.26-.22.4l1.37.75a2 2 0 0 0 1.17.11Z",
    fill: "#A8BFE8"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.16 14.12-3.05c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1L34.16 45.9c-.37.08-.47.26-.22.4l1.37.75c.26.14.79.2 1.17.11Z",
    fill: "#A9BFE9"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48 47.15 50.6 44.1c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14.02 2.88c-.37.08-.47.25-.22.4l1.37.75c.26.14.79.19 1.17.1Z",
    fill: "#AAC0EA"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.14 14.12-3.05c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14.02 2.88c-.37.08-.47.26-.22.4l1.37.75c.26.14.79.2 1.17.11Z",
    fill: "#ABC1EB"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.12 14.12-3.04c.32-.07.35-.23.07-.35l-1.43-.65a2.02 2.02 0 0 0-1.06-.1l-14.02 2.89c-.37.08-.47.25-.22.4l1.37.74a2 2 0 0 0 1.17.11Z",
    fill: "#ACC2EC"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.12 14.12-3.05c.32-.07.35-.23.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.07-.48.25-.23.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#ADC3EC"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.1 14.12-3.05c.32-.07.35-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.08-.48.26-.23.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#AEC4ED"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.1 14.12-3.05c.32-.07.35-.23.07-.35l-1.44-.65a2.02 2.02 0 0 0-1.06-.1l-14 2.89c-.38.07-.48.25-.23.39l1.37.75c.26.14.79.2 1.17.11Z",
    fill: "#AFC5EE"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.08 14.12-3.04c.31-.07.34-.23.07-.35l-1.44-.65a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.08-.48.26-.23.4l1.37.75c.26.14.79.2 1.17.11Z",
    fill: "#B0C6EF"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.07 14.12-3.05c.31-.07.34-.22.07-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.08-.48.26-.23.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#B1C7F0"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48 47.06 50.59 44c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.08-.48.25-.23.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#B2C8F1"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48 47.05 50.59 44c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.08-.48.25-.23.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#B3C9F2"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.04 14.11-3.05c.32-.07.35-.22.07-.35L49.23 43a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.08-.48.25-.23.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#B4C9F3"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.02 14.11-3.04c.32-.07.35-.22.07-.35L49.23 43a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.07-.48.25-.23.4l1.37.74c.26.14.79.2 1.17.11Z",
    fill: "#B5CAF3"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47.01 14.11-3.04c.32-.07.35-.22.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.07-.48.25-.23.4l1.37.74c.26.14.79.2 1.17.11Z",
    fill: "#B6CBF4"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47 14.1-3.04c.33-.07.36-.23.08-.35l-1.44-.65a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.37.08-.47.25-.22.4l1.37.74c.26.15.79.2 1.17.12Z",
    fill: "#B7CCF5"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 47 14.1-3.05c.32-.07.35-.22.08-.35l-1.44-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.88c-.38.07-.47.25-.22.39l1.37.75c.26.14.79.2 1.16.11Z",
    fill: "#B8CDF6"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "m36.48 46.98 14.1-3.04c.32-.07.35-.23.07-.35l-1.43-.64a2.02 2.02 0 0 0-1.06-.1l-14 2.87c-.38.08-.47.26-.22.4l1.37.75a2 2 0 0 0 1.16.1Z",
    fill: "#B9CEF7"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.82 20.37-5.36c.32-.08.3-.26-.03-.41l-7.71-3.36a2.05 2.05 0 0 0-1.09-.1l-19.93 4.43c-.4.1-.5.3-.23.45l7.3 4.21c.32.18.91.24 1.32.14Z",
    fill: "#7791BC"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.8 20.37-5.35c.32-.08.3-.26-.03-.4l-7.7-3.37a2.05 2.05 0 0 0-1.1-.1l-19.93 4.44c-.4.09-.5.29-.23.44l7.3 4.21a2 2 0 0 0 1.32.14Z",
    fill: "#7892BD"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.8 20.37-5.35c.31-.08.3-.27-.03-.41l-7.71-3.36a2.05 2.05 0 0 0-1.09-.1L34.11 49c-.4.1-.5.3-.23.45l7.3 4.2a2 2 0 0 0 1.32.14Z",
    fill: "#7993BE"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.8 20.37-5.36c.31-.08.3-.27-.03-.41l-7.71-3.36a2.05 2.05 0 0 0-1.09-.1L34.11 49c-.4.1-.5.3-.23.45l7.3 4.2a2 2 0 0 0 1.32.14Z",
    fill: "#7A94BF"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.79 20.37-5.35c.31-.08.3-.27-.04-.41l-7.7-3.36a2.05 2.05 0 0 0-1.1-.1L34.12 49c-.4.09-.5.29-.23.44l7.3 4.21c.32.19.91.25 1.32.14Z",
    fill: "#7B95C0"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.78 20.36-5.35c.32-.08.3-.26-.03-.41l-7.7-3.36a2.05 2.05 0 0 0-1.1-.1l-19.92 4.43c-.4.1-.5.3-.23.45l7.3 4.2c.32.19.91.25 1.32.14Z",
    fill: "#7C96C0"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.78 20.36-5.36c.32-.08.3-.26-.03-.4l-7.7-3.36a2.05 2.05 0 0 0-1.1-.1l-19.91 4.43c-.4.09-.5.29-.23.44l7.3 4.21c.31.18.9.24 1.31.14Z",
    fill: "#7D96C1"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.77 20.36-5.35c.32-.08.3-.27-.03-.41l-7.7-3.36a2.05 2.05 0 0 0-1.1-.1l-19.91 4.43c-.4.09-.5.29-.23.44l7.3 4.21c.31.19.9.24 1.32.14Z",
    fill: "#7E97C2"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.76 20.36-5.35c.32-.08.3-.26-.03-.41l-7.7-3.36a2.05 2.05 0 0 0-1.1-.1l-19.91 4.43c-.4.1-.5.3-.23.45l7.3 4.2c.31.19.9.25 1.32.14Z",
    fill: "#7F98C3"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.75 20.36-5.35c.32-.08.3-.26-.03-.4l-7.7-3.36a2.05 2.05 0 0 0-1.1-.1l-19.9 4.43c-.4.09-.51.28-.24.44l7.3 4.2c.31.19.9.25 1.32.14Z",
    fill: "#8099C4"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.74 20.36-5.34c.31-.08.3-.27-.03-.41l-7.7-3.36a2.04 2.04 0 0 0-1.1-.1l-19.9 4.43c-.4.09-.5.28-.24.44l7.3 4.2c.31.2.9.25 1.32.14Z",
    fill: "#819AC5"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.74 20.36-5.35c.31-.08.3-.26-.03-.4l-7.7-3.37a2.04 2.04 0 0 0-1.1-.1l-19.9 4.43c-.4.1-.5.29-.24.45l7.3 4.2a2 2 0 0 0 1.32.14Z",
    fill: "#829BC6"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.73 20.36-5.34c.31-.08.3-.27-.04-.41l-7.7-3.36a2.04 2.04 0 0 0-1.08-.1l-19.91 4.43c-.4.09-.5.28-.23.44l7.3 4.2a2 2 0 0 0 1.3.14Z",
    fill: "#839CC7"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.72 20.35-5.34c.32-.08.3-.27-.03-.41l-7.7-3.36a2.04 2.04 0 0 0-1.08-.1l-19.92 4.43c-.4.09-.5.28-.23.44l7.3 4.2a2 2 0 0 0 1.32.14Z",
    fill: "#849DC7"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.72 20.35-5.35c.32-.08.3-.26-.03-.4l-7.7-3.36a2.04 2.04 0 0 0-1.08-.1l-19.91 4.42c-.4.1-.5.29-.23.45l7.3 4.2a2 2 0 0 0 1.3.14Z",
    fill: "#859EC8"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.7 20.35-5.33c.32-.08.3-.27-.03-.41l-7.7-3.36a2.04 2.04 0 0 0-1.09-.1l-19.9 4.43c-.4.09-.5.28-.23.44l7.29 4.2a2 2 0 0 0 1.32.14Z",
    fill: "#869FC9"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.7 20.35-5.34c.31-.08.3-.27-.03-.41l-7.7-3.35a2.04 2.04 0 0 0-1.09-.1l-19.9 4.42c-.4.1-.5.29-.24.45l7.3 4.2c.31.18.9.24 1.32.13Z",
    fill: "#87A0CA"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.7 20.35-5.34c.31-.09.3-.27-.03-.41l-7.7-3.36a2.04 2.04 0 0 0-1.09-.1l-19.9 4.43c-.4.09-.5.28-.23.44l7.3 4.2c.3.18.9.24 1.3.13Z",
    fill: "#88A0CB"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.69 20.35-5.34c.3-.08.3-.27-.03-.4l-7.7-3.36a2.04 2.04 0 0 0-1.09-.1l-19.9 4.42c-.4.1-.5.29-.23.45l7.29 4.2c.31.17.9.24 1.32.13Z",
    fill: "#89A1CC"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.68 20.34-5.34c.32-.08.3-.26-.03-.4l-7.7-3.36a2.07 2.07 0 0 0-1.08-.1l-19.9 4.43c-.4.08-.5.28-.23.44l7.29 4.2c.31.18.9.24 1.32.13Z",
    fill: "#8AA2CD"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.67 20.34-5.33c.32-.08.3-.27-.03-.41l-7.7-3.35a2.07 2.07 0 0 0-1.08-.1l-19.9 4.42c-.4.09-.5.28-.23.44l7.3 4.2c.3.18.9.24 1.3.13Z",
    fill: "#8BA3CE"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.67 20.34-5.34c.31-.08.3-.27-.03-.4l-7.7-3.36a2.07 2.07 0 0 0-1.08-.1l-19.9 4.42c-.4.09-.5.29-.23.44l7.29 4.2a2 2 0 0 0 1.32.14Z",
    fill: "#8CA4CE"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.66 20.34-5.34c.31-.08.3-.26-.03-.4l-7.7-3.36a2.07 2.07 0 0 0-1.08-.1l-19.9 4.42c-.4.1-.5.29-.23.45l7.3 4.2c.3.17.9.23 1.3.13Z",
    fill: "#8DA5CF"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.65 20.34-5.33c.31-.09.3-.27-.03-.41l-7.7-3.35a2.07 2.07 0 0 0-1.08-.1l-19.9 4.41c-.4.1-.5.3-.23.45l7.3 4.2a2 2 0 0 0 1.3.13Z",
    fill: "#8EA6D0"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.64 20.33-5.33c.32-.08.3-.26-.03-.4l-7.69-3.36a2.07 2.07 0 0 0-1.08-.1l-19.9 4.42c-.4.1-.5.29-.23.45l7.3 4.19c.3.18.9.24 1.3.13Z",
    fill: "#8FA7D1"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.64 20.33-5.33c.32-.09.3-.27-.03-.41l-7.69-3.35a2.07 2.07 0 0 0-1.08-.1l-19.9 4.42c-.4.08-.5.28-.22.44l7.28 4.2c.32.17.9.23 1.32.13Z",
    fill: "#90A8D2"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.63 20.33-5.33c.31-.08.3-.27-.03-.4l-7.7-3.36a2.07 2.07 0 0 0-1.08-.1l-19.89 4.42c-.4.09-.5.28-.23.44l7.3 4.2c.3.17.9.24 1.3.13Z",
    fill: "#91A9D3"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.62 20.33-5.33c.31-.08.3-.26-.03-.4l-7.7-3.35a2.07 2.07 0 0 0-1.08-.1l-19.89 4.41c-.4.09-.5.29-.22.44l7.28 4.2c.32.18.9.24 1.32.13Z",
    fill: "#92AAD4"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.61 20.33-5.33c.31-.08.3-.26-.03-.4l-7.7-3.35a2.07 2.07 0 0 0-1.08-.1l-19.89 4.41c-.4.1-.5.29-.22.44l7.28 4.2c.32.18.9.24 1.32.13Z",
    fill: "#93AAD5"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.6 20.33-5.32c.31-.08.3-.27-.03-.4l-7.7-3.36a2.07 2.07 0 0 0-1.08-.1l-19.89 4.42c-.4.09-.5.28-.22.44l7.28 4.19a2 2 0 0 0 1.32.14Z",
    fill: "#94ABD6"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.6 20.33-5.33c.31-.08.3-.26-.03-.4l-7.7-3.35a2.07 2.07 0 0 0-1.08-.1l-19.88 4.41c-.4.09-.5.29-.23.44l7.28 4.2a2 2 0 0 0 1.32.13Z",
    fill: "#95ACD6"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.6 20.33-5.33c.3-.08.3-.27-.04-.4l-7.68-3.35a2.07 2.07 0 0 0-1.09-.11l-19.88 4.42c-.4.09-.5.28-.23.44l7.28 4.19a2 2 0 0 0 1.32.13Z",
    fill: "#96ADD7"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.59 20.32-5.33c.32-.08.3-.26-.03-.4L55.1 44.5a2.07 2.07 0 0 0-1.08-.1l-19.88 4.4c-.4.1-.5.3-.23.45l7.28 4.19a2 2 0 0 0 1.32.14Z",
    fill: "#97AED8"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.58 20.32-5.33c.31-.08.3-.26-.03-.4L55.1 44.5a2.07 2.07 0 0 0-1.08-.1L34.14 48.8c-.4.09-.5.29-.23.44l7.28 4.2a2 2 0 0 0 1.32.13Z",
    fill: "#98AFD9"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.57 20.32-5.32c.31-.08.3-.27-.03-.4L55.1 44.5a2.1 2.1 0 0 0-1.08-.1l-19.88 4.4c-.4.1-.5.3-.23.45l7.28 4.19a2 2 0 0 0 1.32.13Z",
    fill: "#98B0DA"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.56 20.32-5.32c.31-.08.3-.26-.03-.4l-7.69-3.35a2.1 2.1 0 0 0-1.08-.1L34.14 48.8c-.4.09-.5.29-.23.44l7.28 4.19c.32.18.9.24 1.32.13Z",
    fill: "#99B1DB"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.56 20.32-5.32c.31-.08.3-.27-.03-.41l-7.69-3.35a2.1 2.1 0 0 0-1.08-.1l-19.88 4.41c-.4.09-.5.29-.23.44l7.28 4.19a2 2 0 0 0 1.32.14Z",
    fill: "#9AB2DC"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.55 20.31-5.32c.32-.08.3-.26-.03-.4l-7.68-3.35a2.1 2.1 0 0 0-1.09-.1l-19.87 4.4c-.4.1-.5.3-.23.45l7.28 4.18a2 2 0 0 0 1.32.14Z",
    fill: "#9BB3DD"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.54 20.31-5.32c.32-.08.3-.26-.03-.4l-7.68-3.35a2.1 2.1 0 0 0-1.09-.1l-19.87 4.4c-.4.1-.5.3-.23.45l7.28 4.18c.32.19.9.25 1.32.14Z",
    fill: "#9CB4DD"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.53 20.31-5.31c.32-.08.3-.27-.03-.4l-7.68-3.35a2.1 2.1 0 0 0-1.09-.1l-19.87 4.4c-.4.09-.5.29-.23.44l7.28 4.19a2 2 0 0 0 1.32.13Z",
    fill: "#9DB5DE"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.53 20.31-5.32c.31-.08.3-.26-.03-.4l-7.68-3.35a2.1 2.1 0 0 0-1.09-.1l-19.87 4.4c-.4.1-.5.3-.23.45l7.28 4.18c.32.18.9.24 1.32.14Z",
    fill: "#9EB5DF"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.52 20.31-5.31c.31-.09.3-.27-.03-.41l-7.68-3.34a2.09 2.09 0 0 0-1.09-.1l-19.87 4.4c-.4.09-.5.29-.22.44l7.27 4.19a2 2 0 0 0 1.32.13Z",
    fill: "#9FB6E0"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.51 20.3-5.31c.32-.08.3-.27-.02-.41l-7.68-3.34a2.09 2.09 0 0 0-1.09-.1l-19.86 4.4c-.4.09-.5.29-.23.44l7.28 4.18c.3.19.9.25 1.3.14Z",
    fill: "#A0B7E1"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.5 20.3-5.3c.32-.09.3-.27-.03-.41l-7.68-3.35a2.09 2.09 0 0 0-1.08-.1l-19.86 4.4c-.4.1-.5.3-.23.45l7.28 4.18a2 2 0 0 0 1.3.14Z",
    fill: "#A1B8E2"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.5 20.3-5.31c.32-.08.3-.27-.03-.4l-7.68-3.35a2.08 2.08 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.29-.23.44l7.27 4.18a2 2 0 0 0 1.32.14Z",
    fill: "#A2B9E3"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.5 20.3-5.32c.31-.08.3-.26-.03-.4l-7.68-3.35a2.08 2.08 0 0 0-1.08-.1l-19.86 4.4c-.4.1-.5.3-.23.45l7.27 4.18c.32.18.9.24 1.32.13Z",
    fill: "#A3BAE4"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.48 20.3-5.3c.31-.08.3-.27-.03-.41l-7.68-3.34a2.06 2.06 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.29-.23.44l7.27 4.18c.32.18.9.24 1.32.13Z",
    fill: "#A4BBE5"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.47 20.3-5.3c.31-.08.3-.27-.03-.41l-7.68-3.34a2.06 2.06 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.29-.23.44l7.28 4.18c.31.18.9.24 1.3.13Z",
    fill: "#A5BCE5"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.47 20.3-5.31c.31-.08.3-.27-.03-.4l-7.68-3.35a2.06 2.06 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.29-.23.44l7.27 4.18a2 2 0 0 0 1.32.14Z",
    fill: "#A6BDE6"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.46 20.3-5.3c.31-.09.3-.27-.03-.41l-7.68-3.34a2.06 2.06 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.29-.23.44l7.27 4.18a2 2 0 0 0 1.32.13Z",
    fill: "#A7BEE7"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.46 20.3-5.3c.3-.1.3-.27-.04-.42l-7.67-3.33a2.06 2.06 0 0 0-1.08-.1l-19.86 4.4c-.4.08-.5.28-.23.44l7.28 4.17c.3.18.9.24 1.3.14Z",
    fill: "#A8BFE8"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.45 20.3-5.3c.3-.09.3-.27-.04-.41L55.1 44.4a2.06 2.06 0 0 0-1.08-.1l-19.86 4.4c-.4.08-.5.28-.23.44l7.28 4.17c.3.18.9.24 1.3.14Z",
    fill: "#A9BFE9"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.44 20.3-5.3c.3-.08.3-.27-.04-.41l-7.67-3.34a2.05 2.05 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.28-.22.44l7.27 4.18c.3.18.9.24 1.3.13Z",
    fill: "#AAC0EA"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.43 20.3-5.3c.3-.08.29-.27-.04-.4l-7.67-3.35a2.05 2.05 0 0 0-1.08-.1l-19.86 4.4c-.4.09-.5.29-.22.45l7.27 4.17c.3.18.9.24 1.3.13Z",
    fill: "#ABC1EB"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.43 20.29-5.3c.31-.09.3-.27-.03-.41l-7.67-3.34a2.05 2.05 0 0 0-1.09-.1l-19.85 4.4c-.4.08-.5.28-.22.44l7.27 4.17a2 2 0 0 0 1.3.14Z",
    fill: "#ACC2EC"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.42 20.29-5.3c.31-.08.3-.27-.03-.41l-7.67-3.34a2.06 2.06 0 0 0-1.09-.1l-19.84 4.4c-.4.09-.5.28-.23.44l7.27 4.17a2 2 0 0 0 1.3.14Z",
    fill: "#ADC3EC"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.41 20.29-5.3c.31-.08.3-.26-.03-.4l-7.68-3.34a2.06 2.06 0 0 0-1.08-.1l-19.85 4.4c-.4.08-.5.28-.22.43l7.26 4.18c.32.18.91.24 1.32.13Z",
    fill: "#AEC4ED"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.4 20.29-5.3c.31-.08.3-.26-.03-.4l-7.67-3.33a2.06 2.06 0 0 0-1.09-.1l-19.84 4.4c-.4.08-.5.28-.23.43l7.27 4.17c.3.18.9.24 1.3.13Z",
    fill: "#AFC5EE"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.4 20.28-5.3c.32-.08.3-.26-.03-.4l-7.67-3.34a2.06 2.06 0 0 0-1.08-.1l-19.84 4.4c-.4.08-.5.28-.23.43l7.27 4.18c.3.17.9.24 1.3.13Z",
    fill: "#B0C6EF"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.39 20.28-5.3c.32-.08.3-.26-.03-.4l-7.67-3.34a2.06 2.06 0 0 0-1.08-.1l-19.84 4.4c-.4.08-.5.28-.23.44l7.27 4.17c.31.17.9.23 1.3.13Z",
    fill: "#B1C7F0"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.38 20.28-5.3c.32-.08.3-.26-.03-.4l-7.67-3.33a2.06 2.06 0 0 0-1.08-.1l-19.84 4.4c-.4.08-.5.27-.23.43l7.27 4.17c.31.18.9.24 1.3.13Z",
    fill: "#B2C8F1"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.37 20.28-5.29c.31-.08.3-.26-.03-.4l-7.67-3.33a2.06 2.06 0 0 0-1.08-.1l-19.84 4.38c-.4.1-.5.29-.23.44l7.27 4.17a2 2 0 0 0 1.3.13Z",
    fill: "#B3C9F2"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.37 20.28-5.3c.31-.07.3-.26-.03-.4l-7.67-3.33a2.06 2.06 0 0 0-1.08-.1l-19.84 4.39c-.4.09-.5.28-.23.44l7.27 4.17c.31.17.9.23 1.3.13Z",
    fill: "#B4C9F3"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.36 20.28-5.3c.31-.07.3-.25-.03-.4l-7.67-3.33a2.06 2.06 0 0 0-1.08-.1l-19.84 4.39c-.4.09-.5.28-.23.44l7.27 4.17c.31.18.9.24 1.3.13Z",
    fill: "#B5CAF3"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.35 20.27-5.29c.32-.08.3-.26-.03-.4l-7.66-3.33a2.05 2.05 0 0 0-1.08-.1L34.16 48.6c-.4.09-.5.29-.23.44l7.27 4.17a2 2 0 0 0 1.3.13Z",
    fill: "#B6CBF4"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.34 20.27-5.28c.32-.09.3-.27-.03-.41l-7.66-3.33a2.05 2.05 0 0 0-1.09-.1L34.16 48.6c-.4.1-.5.29-.23.44l7.27 4.17a2 2 0 0 0 1.3.13Z",
    fill: "#B7CCF5"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.34 20.27-5.29c.31-.08.3-.26-.03-.4l-7.66-3.34a2.06 2.06 0 0 0-1.09-.1L34.16 48.6c-.4.09-.5.28-.22.44l7.26 4.17c.31.17.9.24 1.3.13Z",
    fill: "#B8CDF6"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 53.33 20.27-5.29c.31-.08.3-.26-.03-.4l-7.66-3.33a2.06 2.06 0 0 0-1.09-.1l-19.83 4.38c-.4.09-.5.29-.22.44l7.26 4.17c.31.18.9.24 1.3.13Z",
    fill: "#B9CEF7"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.44c-.23-.02-.42.13-.38.31l2.92 15.66 2.93 15.66c.29 1.57 2.77 13.47 5.5 12.91l-4.02-22.1-4-22.13-2.95-.3Z",
    fill: "#F2F0FC"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "m17.21 2.68 2.93 15.68 2.92 15.7c.29 1.57 2.77 13.46 5.5 12.9l-4.02-22.1-4-22.1-.14-.03-2.67-.35-.13-.02c-.23-.02-.42.14-.39.32Z",
    fill: "#F1EFFB"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "m17.3 2.6 2.93 15.72 2.92 15.72c.29 1.57 2.77 13.46 5.49 12.9l-4-22.09-4.02-22.1-.12-.04-2.68-.4-.13-.02c-.23-.02-.42.13-.38.32Z",
    fill: "#F0EFFA"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "m17.4 2.54 2.92 15.74 2.92 15.74c.28 1.58 2.77 13.46 5.48 12.91l-4-22.08-4-22.09c-.01-.02-.1-.04-.12-.06l-2.68-.47-.14-.02c-.23-.02-.41.14-.38.33Z",
    fill: "#EFEEF9"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 2.47 2.91 15.77L23.33 34c.28 1.57 2.76 13.46 5.48 12.9l-4-22.07-4-22.07c-.01-.03-.09-.06-.11-.08L18 2.15a.8.8 0 0 0-.12-.01c-.23-.02-.42.14-.39.33Z",
    fill: "#EFEDF9"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "m17.59 2.4 2.91 15.8L23.42 34c.28 1.57 2.77 13.45 5.48 12.9l-4-22.07-4-22.06c0-.03-.07-.07-.1-.1l-2.7-.6a.8.8 0 0 0-.13-.02c-.23 0-.42.15-.38.34Z",
    fill: "#EEECF8"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "m17.68 2.32 2.91 15.83 2.92 15.83c.28 1.57 2.76 13.45 5.47 12.9l-4-22.06-4-22.05c0-.04-.04-.08-.08-.1l-2.7-.68a.6.6 0 0 0-.14-.01c-.23 0-.41.15-.38.34Z",
    fill: "#EDECF7"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 1.92c-.29-.08-.57.1-.53.33l2.91 15.86 2.92 15.85c.28 1.58 2.76 13.45 5.47 12.9l-4-22.04-4-22.05a.2.2 0 0 0-.07-.12l-2.7-.73Z",
    fill: "#ECEBF6"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "m41.26 1.3 5.38 30.65c.64 3.73 2.9 7 6.26 9.13l-23.56 5.7c-3 .62-5.38-11.3-5.66-12.88L17.8 2.42c-.07-.37.26-.7.72-.72l2.66.7c.67.17 1.36.04 1.83-.35l1.05-.87c.58-.48 1.5-.55 2.23-.17l1.33.69c.7.36 1.56.31 2.14-.13l1.1-.84c.57-.43 1.4-.48 2.08-.13l1.41.73c.68.36 1.52.3 2.07-.15l.98-.8c.52-.43 1.3-.5 1.96-.19.84.4 1.86.92 1.9 1.11Z",
    fill: "url(#a)"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-25.1 5.27c-.38.08-.66.32-.62.53.2 1.17.7 4.55-1.04 4.94l24.4-5.6c-.01 0 2.5-.68 2.36-5.14Z",
    fill: "#F2F0FC"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M55.32 36.23 30.28 41.5c-.36.08-.67.3-.64.51.18 1.1.68 4.57-1.07 4.97l24.38-5.6s2.5-.68 2.37-5.14Z",
    fill: "#F1EFFB"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-25 5.25c-.33.07-.67.3-.64.49.17 1.02.68 4.6-1.1 5l24.37-5.6s2.5-.68 2.37-5.14Z",
    fill: "#F0EEFA"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.94 5.24c-.31.06-.7.29-.66.47.16.94.67 4.61-1.13 5.02l24.36-5.6s2.5-.67 2.37-5.13Z",
    fill: "#EFEDF9"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.89 5.23c-.28.06-.7.28-.67.44.14.88.66 4.65-1.16 5.06l24.35-5.6s2.5-.67 2.37-5.13Z",
    fill: "#EEECF8"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M55.32 36.23 30.5 41.45c-.27.05-.72.27-.7.42.14.8.67 4.67-1.18 5.09l24.34-5.6s2.5-.67 2.37-5.13Z",
    fill: "#EDEBF7"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.78 5.2c-.24.06-.73.27-.7.4.12.74.65 4.7-1.22 5.12l24.33-5.58s2.5-.68 2.37-5.14Z",
    fill: "#ECEAF6"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.73 5.2c-.22.04-.74.25-.72.38.11.65.65 4.72-1.24 5.14l24.32-5.58s2.5-.68 2.37-5.14Z",
    fill: "#EBE9F5"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.68 5.19c-.19.04-.75.25-.73.35.1.59.65 4.75-1.27 5.18l24.3-5.58s2.51-.68 2.38-5.14Z",
    fill: "#EBE9F5"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M55.32 36.23 30.7 41.41c-.17.03-.76.23-.75.33.09.51.64 4.77-1.3 5.2l24.3-5.57s2.5-.68 2.37-5.14Z",
    fill: "#EAE8F4"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M55.32 36.23 30.75 41.4c-.14.03-.77.23-.76.3.07.45.63 4.8-1.33 5.24l24.29-5.57s2.5-.68 2.37-5.14Z",
    fill: "#E9E7F3"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M55.32 36.23 30.8 41.4c-.12.02-.78.22-.77.29.06.36.63 4.82-1.36 5.26l24.28-5.57s2.5-.68 2.37-5.14Z",
    fill: "#E8E6F2"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.47 5.15c-.1.02-.8.2-.78.26.05.3.62 4.85-1.39 5.3l24.27-5.58s2.5-.67 2.37-5.13Z",
    fill: "#E7E5F1"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.41 5.14c-.07.01-.8.2-.8.24.04.22.61 4.87-1.41 5.32l24.25-5.57s2.5-.67 2.37-5.13Z",
    fill: "#E6E4F0"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.36 5.13c-.05 0-.82.19-.81.22.03.14.6 4.9-1.44 5.35l24.24-5.56s2.5-.68 2.37-5.14Z",
    fill: "#E5E3EF"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-24.3 5.12c-.03 0-.84.18-.83.2.01.07.6 4.91-1.47 5.38l24.23-5.56s2.5-.68 2.37-5.14Z",
    fill: "#E4E2EE"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.23-25.1 5.28s.6 4.95-1.5 5.42l24.23-5.56s2.5-.68 2.37-5.14Z",
    fill: "#E3E1ED"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "m55.32 36.24-25.1 5.28s1.04 4.88-1.05 5.35l23.78-5.47s2.5-.7 2.37-5.16Z",
    fill: "url(#b)"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "m26.68 12.74 12.84-1.96c.62-.11 1.01-.83.9-1.45l-.06-.26a1.2 1.2 0 0 0-1.35-.95L26.26 9.96c-.64.1-1.06.86-.98 1.56l.01.1c.1.63.75 1.23 1.4 1.12Z",
    fill: "#3794C7"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "m26.69 12.73 12.83-1.96c.62-.1 1.01-.82.9-1.44l-.06-.26a1.2 1.2 0 0 0-1.35-.95L26.26 9.96c-.64.1-1.06.86-.97 1.55l.01.1c.1.64.75 1.24 1.39 1.12Z",
    fill: "#3895C7"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "m26.7 12.73 12.82-1.96c.62-.11 1.01-.82.89-1.45l-.05-.25a1.2 1.2 0 0 0-1.34-.95L26.27 9.96c-.64.1-1.06.85-.97 1.55v.1c.1.64.75 1.24 1.4 1.12Z",
    fill: "#3996C8"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "m26.7 12.73 12.82-1.96c.62-.12 1.01-.82.9-1.45l-.06-.25a1.2 1.2 0 0 0-1.34-.95L26.27 9.96c-.63.1-1.05.85-.97 1.54l.02.11c.1.64.74 1.23 1.38 1.12Z",
    fill: "#3A97C8"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "m26.7 12.72 12.82-1.96c.62-.1 1.01-.81.9-1.44l-.06-.25a1.2 1.2 0 0 0-1.34-.95L26.28 9.96c-.64.1-1.06.85-.97 1.54l.01.11c.1.64.75 1.23 1.38 1.11Z",
    fill: "#3B98C9"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "m26.7 12.72 12.82-1.96c.62-.11 1.01-.82.89-1.44l-.05-.25a1.2 1.2 0 0 0-1.34-.95L26.28 9.96c-.64.1-1.05.84-.97 1.53l.02.12c.1.64.74 1.22 1.38 1.1Z",
    fill: "#3C99C9"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "m26.71 12.71 12.81-1.96c.62-.1 1.01-.8.89-1.43l-.05-.25a1.2 1.2 0 0 0-1.34-.95L26.29 9.96c-.63.1-1.06.84-.97 1.52l.02.13c.1.63.73 1.22 1.37 1.1Z",
    fill: "#3D9ACA"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "m26.72 12.7 12.8-1.95c.62-.11 1.01-.81.89-1.43l-.05-.25a1.2 1.2 0 0 0-1.34-.95L26.29 9.96c-.63.1-1.05.83-.97 1.52l.02.12c.1.64.74 1.22 1.38 1.1Z",
    fill: "#3E9BCA"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "m26.72 12.7 12.8-1.95c.62-.12 1.01-.81.89-1.43l-.05-.25a1.2 1.2 0 0 0-1.34-.95L26.3 9.96c-.63.1-1.05.83-.97 1.51l.02.13c.1.64.74 1.22 1.37 1.1Z",
    fill: "#3F9CCB"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "m26.73 12.7 12.8-1.96c.61-.1 1-.8.88-1.42l-.05-.25a1.2 1.2 0 0 0-1.34-.95L26.31 9.96c-.64.1-1.06.82-.97 1.5l.02.14c.1.64.73 1.21 1.37 1.1Z",
    fill: "#409DCB"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "m26.73 12.7 12.8-1.96c.61-.11 1-.8.88-1.42l-.05-.26a1.2 1.2 0 0 0-1.34-.95L26.31 9.95c-.63.1-1.05.83-.96 1.51l.01.14c.1.64.74 1.2 1.37 1.1Z",
    fill: "#419ECC"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "m26.74 12.69 12.78-1.96c.62-.1 1-.8.89-1.42l-.05-.25a1.2 1.2 0 0 0-1.34-.95l-12.7 1.84c-.64.1-1.06.82-.97 1.5l.02.14c.1.65.73 1.21 1.37 1.1Z",
    fill: "#429FCC"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "m26.74 12.68 12.78-1.95c.62-.11 1-.8.89-1.42l-.05-.25a1.2 1.2 0 0 0-1.34-.95l-12.7 1.84c-.63.1-1.05.82-.96 1.5l.02.15c.1.63.73 1.2 1.36 1.08Z",
    fill: "#43A0CD"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "m26.75 12.68 12.77-1.96c.62-.1 1-.8.89-1.4l-.05-.26a1.2 1.2 0 0 0-1.33-.95l-12.7 1.84c-.63.1-1.05.82-.96 1.5l.01.15c.1.63.73 1.2 1.37 1.08Z",
    fill: "#44A1CD"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "m26.75 12.67 12.77-1.95c.62-.11 1-.8.89-1.41l-.05-.25a1.2 1.2 0 0 0-1.33-.95l-12.7 1.84c-.63.1-1.05.81-.96 1.49l.02.16c.1.63.73 1.19 1.36 1.07Z",
    fill: "#45A2CE"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "m26.76 12.67 12.76-1.95c.62-.11 1-.8.89-1.41l-.05-.25a1.2 1.2 0 0 0-1.33-.95L26.34 9.95c-.63.1-1.05.8-.96 1.48l.02.16c.1.64.73 1.2 1.36 1.08Z",
    fill: "#46A3CE"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "m26.76 12.66 12.76-1.95c.62-.1 1-.78.89-1.4l-.05-.25a1.2 1.2 0 0 0-1.33-.95L26.35 9.95c-.63.1-1.05.8-.96 1.48l.02.16c.1.64.72 1.19 1.35 1.07Z",
    fill: "#47A4CE"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "m26.77 12.66 12.75-1.95c.62-.1 1-.78.88-1.4l-.04-.25a1.2 1.2 0 0 0-1.33-.95L26.35 9.95c-.63.1-1.05.8-.96 1.47l.02.17c.1.64.73 1.18 1.36 1.07Z",
    fill: "#48A5CF"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "m26.77 12.65 12.76-1.94c.6-.11 1-.79.88-1.4l-.05-.25a1.2 1.2 0 0 0-1.33-.95L26.36 9.95c-.63.1-1.05.8-.96 1.47l.02.17c.1.63.72 1.18 1.35 1.06Z",
    fill: "#49A6CF"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "m26.78 12.65 12.74-1.95c.62-.1 1-.78.88-1.4l-.04-.24a1.2 1.2 0 0 0-1.33-.95L26.36 9.95c-.63.1-1.05.8-.96 1.46l.02.18c.1.63.73 1.17 1.36 1.06Z",
    fill: "#4AA7D0"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "m26.78 12.64 12.75-1.94c.6-.11 1-.78.87-1.4l-.04-.24a1.2 1.2 0 0 0-1.32-.95L26.37 9.94c-.63.1-1.05.8-.96 1.46l.02.19c.1.63.73 1.17 1.35 1.05Z",
    fill: "#4BA8D0"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "m26.79 12.64 12.74-1.95c.6-.1 1-.77.87-1.39l-.04-.24a1.2 1.2 0 0 0-1.32-.95L26.37 9.94c-.62.1-1.04.8-.95 1.46l.02.19c.1.63.72 1.16 1.35 1.05Z",
    fill: "#4CA9D1"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8 12.64 12.73-1.95c.6-.11 1-.77.87-1.39l-.04-.24a1.19 1.19 0 0 0-1.32-.95L26.38 9.94c-.62.1-1.04.79-.95 1.45l.02.2c.1.63.72 1.16 1.34 1.05Z",
    fill: "#4DAAD1"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8 12.63 12.73-1.94c.6-.11 1-.77.88-1.39l-.05-.24a1.19 1.19 0 0 0-1.32-.95L26.38 9.94c-.62.1-1.04.79-.95 1.45l.02.2c.1.63.72 1.15 1.35 1.04Z",
    fill: "#4EABD2"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8 12.63 12.73-1.95c.6-.1 1-.77.87-1.38l-.04-.24a1.19 1.19 0 0 0-1.32-.95L26.39 9.94c-.62.1-1.04.78-.95 1.44l.02.2c.1.63.72 1.16 1.34 1.05Z",
    fill: "#4FACD2"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8 12.62 12.73-1.94c.6-.11 1-.77.87-1.38l-.04-.24a1.19 1.19 0 0 0-1.32-.95L26.4 9.94c-.63.1-1.05.78-.96 1.44l.03.2c.1.63.71 1.15 1.34 1.04Z",
    fill: "#50ADD3"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "m26.81 12.62 12.72-1.94c.6-.11 1-.77.87-1.38l-.04-.24a1.19 1.19 0 0 0-1.32-.95L26.4 9.94c-.62.1-1.04.77-.95 1.43l.02.21c.1.63.72 1.15 1.34 1.04Z",
    fill: "#51AED3"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "m26.82 12.61 12.7-1.94c.62-.1 1-.76.88-1.37l-.04-.24a1.19 1.19 0 0 0-1.32-.95L26.41 9.94c-.62.1-1.04.77-.95 1.43l.02.2c.1.64.72 1.15 1.34 1.04Z",
    fill: "#52AFD4"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "m26.82 12.6 12.7-1.93c.62-.11 1-.76.88-1.37l-.04-.24a1.18 1.18 0 0 0-1.32-.95L26.41 9.94c-.62.1-1.04.77-.95 1.42l.03.22c.1.63.71 1.14 1.33 1.03Z",
    fill: "#53B0D4"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "m26.83 12.6 12.7-1.94c.6-.1 1-.75.87-1.37l-.04-.23a1.18 1.18 0 0 0-1.31-.95L26.42 9.94c-.62.1-1.04.76-.95 1.41l.03.23c.1.63.7 1.13 1.33 1.02Z",
    fill: "#54B1D5"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "m26.83 12.6 12.7-1.94c.6-.1 1-.75.87-1.37l-.04-.23a1.19 1.19 0 0 0-1.32-.95L26.42 9.94c-.62.1-1.04.76-.94 1.41l.02.23c.1.62.71 1.13 1.33 1.02Z",
    fill: "#54B1D5"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "m26.84 12.6 12.69-1.95c.6-.1 1-.75.87-1.36l-.04-.23a1.19 1.19 0 0 0-1.31-.95L26.43 9.93c-.62.1-1.04.76-.94 1.41l.02.24c.1.62.7 1.12 1.33 1.01Z",
    fill: "#55B2D5"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "m26.84 12.59 12.69-1.94c.6-.1.99-.75.87-1.36l-.04-.23a1.18 1.18 0 0 0-1.31-.95L26.44 9.94c-.62.1-1.04.75-.95 1.4l.02.24c.1.62.71 1.12 1.33 1Z",
    fill: "#56B3D6"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "m26.85 12.58 12.68-1.93c.6-.11 1-.75.87-1.36l-.04-.23c-.12-.6-.7-1.04-1.31-.95L26.44 9.94c-.62.1-1.04.75-.95 1.4l.03.24c.1.62.7 1.12 1.33 1Z",
    fill: "#57B4D6"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "m26.86 12.58 12.67-1.94c.6-.1.99-.74.87-1.35l-.04-.23c-.12-.6-.7-1.04-1.31-.95l-12.6 1.83c-.62.1-1.04.74-.95 1.4l.03.24c.1.62.7 1.11 1.33 1Z",
    fill: "#58B5D7"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "m26.86 12.57 12.67-1.93c.6-.11.99-.74.87-1.35l-.04-.24c-.12-.6-.71-1.03-1.31-.94l-12.6 1.82c-.62.1-1.04.75-.94 1.4l.02.24c.1.63.71 1.12 1.33 1Z",
    fill: "#59B6D7"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "m26.87 12.57 12.66-1.94c.6-.1 1-.74.87-1.35l-.04-.23c-.12-.6-.7-1.03-1.3-.94l-12.6 1.82c-.62.1-1.03.74-.94 1.39l.03.25c.1.62.7 1.1 1.32 1Z",
    fill: "#5AB7D8"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "m26.87 12.57 12.66-1.94c.6-.1 1-.73.87-1.34l-.04-.23c-.12-.61-.7-1.04-1.3-.95l-12.6 1.82c-.61.1-1.03.74-.94 1.38l.03.26c.1.62.7 1.1 1.32 1Z",
    fill: "#5BB8D8"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "m26.88 12.56 12.65-1.93c.6-.11.99-.74.87-1.35l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.47 9.93c-.61.1-1.03.73-.94 1.38l.03.26c.1.62.7 1.1 1.32.99Z",
    fill: "#5CB9D9"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "m26.88 12.56 12.65-1.94c.6-.1.99-.73.87-1.34l-.04-.22c-.12-.6-.7-1.04-1.3-.95L26.48 9.93c-.62.1-1.03.73-.94 1.37l.03.27c.1.62.7 1.1 1.31.99Z",
    fill: "#5DBAD9"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "m26.89 12.55 12.64-1.93c.6-.11.99-.73.87-1.34l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.48 9.93c-.61.09-1.03.72-.94 1.36l.03.27c.1.63.7 1.1 1.32.99Z",
    fill: "#5EBBDA"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 12.55 12.63-1.93c.6-.11.99-.73.87-1.34l-.04-.22c-.12-.6-.7-1.04-1.3-.95L26.49 9.93c-.62.1-1.03.72-.94 1.36l.03.27c.1.63.7 1.1 1.31.99Z",
    fill: "#5FBCDA"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 12.54 12.63-1.93c.6-.1.99-.72.87-1.33l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.49 9.93c-.61.1-1.03.72-.93 1.35l.03.28c.1.63.69 1.1 1.3.98Z",
    fill: "#60BDDB"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 12.54 12.63-1.93c.6-.11.99-.72.87-1.33l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.5 9.93c-.61.1-1.03.72-.94 1.35l.03.28c.1.62.7 1.09 1.31.98Z",
    fill: "#61BEDB"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 12.53 12.63-1.93c.6-.1.99-.71.87-1.32l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.5 9.93c-.61.09-1.03.71-.93 1.34l.03.29c.1.62.69 1.08 1.3.97Z",
    fill: "#62BFDB"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "m26.91 12.53 12.62-1.93c.6-.1.98-.72.87-1.32l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.51 9.92c-.61.1-1.03.72-.94 1.35l.03.29c.1.62.7 1.08 1.31.97Z",
    fill: "#63C0DC"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "m26.91 12.52 12.62-1.92c.6-.11.98-.72.87-1.32l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.51 9.92c-.6.1-1.03.71-.93 1.34l.03.3c.1.62.7 1.07 1.3.96Z",
    fill: "#64C1DC"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "m26.92 12.52 12.61-1.93c.6-.1.98-.71.86-1.31l-.03-.23c-.12-.6-.7-1.03-1.3-.94L26.52 9.92c-.61.1-1.03.7-.93 1.34l.03.3c.1.62.69 1.07 1.3.96Z",
    fill: "#65C2DD"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "m26.92 12.51 12.61-1.92c.6-.1.98-.71.87-1.31l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.53 9.92c-.61.1-1.03.7-.94 1.33l.04.3c.1.63.68 1.07 1.3.96Z",
    fill: "#66C3DD"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "m26.93 12.5 12.6-1.92c.6-.1.98-.7.86-1.3l-.03-.23c-.12-.6-.7-1.03-1.3-.94L26.53 9.92c-.61.1-1.03.7-.93 1.33l.03.3c.1.62.69 1.07 1.3.96Z",
    fill: "#67C4DE"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "m26.93 12.5 12.6-1.92c.6-.1.98-.7.87-1.3l-.04-.23c-.12-.6-.7-1.03-1.3-.94L26.55 9.9c-.61.1-1.03.7-.93 1.33l.03.31c.1.62.68 1.06 1.3.95Z",
    fill: "#68C5DE"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "m26.94 12.5 12.6-1.92c.59-.11.97-.7.85-1.3l-.03-.23c-.12-.6-.7-1.03-1.3-.94L26.55 9.92c-.6.1-1.02.7-.93 1.32l.03.31c.1.62.69 1.06 1.3.95Z",
    fill: "#69C6DF"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "m26.94 12.5 12.6-1.93c.59-.1.97-.7.85-1.3l-.03-.22c-.12-.6-.7-1.03-1.3-.94l-12.51 1.8c-.6.1-1.03.7-.93 1.32l.03.32c.1.62.69 1.05 1.3.94Z",
    fill: "#6AC7DF"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "m26.95 12.49 12.59-1.92c.59-.1.97-.7.85-1.3l-.03-.22c-.12-.6-.7-1.03-1.3-.94l-12.5 1.8c-.61.1-1.03.7-.93 1.31l.03.33c.1.62.68 1.05 1.29.94Z",
    fill: "#6BC8E0"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "m26.95 12.48 12.59-1.92c.59-.1.97-.69.85-1.3l-.03-.21c-.12-.6-.7-1.03-1.29-.94L26.56 9.9c-.6.1-1.02.69-.93 1.3l.04.34c.1.61.68 1.04 1.28.93Z",
    fill: "#6CC9E0"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "m26.96 12.48 12.58-1.92c.59-.1.97-.7.85-1.3l-.03-.21c-.12-.6-.7-1.03-1.29-.94l-12.5 1.8c-.6.1-1.03.68-.93 1.3l.03.34c.1.61.68 1.04 1.29.93Z",
    fill: "#6DCAE1"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "m26.97 12.47 12.57-1.91c.59-.11.97-.7.85-1.3l-.03-.21c-.12-.6-.7-1.03-1.29-.94l-12.5 1.8c-.6.1-1.02.68-.93 1.3l.04.33c.1.62.68 1.04 1.29.93Z",
    fill: "#6ECBE1"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "m26.97 12.47 12.57-1.92c.59-.1.97-.69.85-1.29l-.03-.21c-.12-.6-.7-1.03-1.29-.94l-12.5 1.8c-.6.1-1.01.68-.92 1.29l.04.35c.1.61.67 1.03 1.28.92Z",
    fill: "#6FCCE2"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "m26.98 12.47 12.56-1.92c.59-.1.97-.69.85-1.28l-.03-.22c-.12-.6-.7-1.03-1.29-.94l-12.49 1.8c-.6.1-1.02.68-.92 1.29l.03.35c.1.6.68 1.02 1.29.92Z",
    fill: "#70CDE2"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "m26.98 12.47 12.56-1.92c.59-.1.96-.75.84-1.35l-.02-.1c-.11-.6-.7-1.08-1.29-.99l-12.49 1.8c-.6.1-1.02.67-.92 1.28l.04.35c.1.62.67 1.03 1.28.93Z",
    fill: "url(#c)"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "m34.94 14.02 5.63-.89c.27-.05.44-.36.38-.64l-.02-.11a.53.53 0 0 0-.6-.41l-5.58.84c-.28.04-.47.38-.43.68v.04c.06.28.34.55.62.5Z",
    fill: "#3794C7"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "m34.94 14.02 5.62-.89c.28-.05.45-.36.4-.64l-.03-.1a.53.53 0 0 0-.6-.42l-5.58.84c-.28.04-.46.38-.42.68v.04c.05.28.33.54.61.5Z",
    fill: "#3895C7"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "m34.95 14.02 5.61-.9c.28-.04.45-.35.39-.63l-.02-.1a.53.53 0 0 0-.6-.42l-5.58.84c-.28.04-.46.37-.42.68v.04c.05.28.33.54.62.49Z",
    fill: "#3996C8"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "m34.95 14.02 5.61-.9c.28-.04.45-.36.39-.63l-.02-.11a.53.53 0 0 0-.6-.41l-5.58.84c-.28.04-.46.37-.42.68v.04c.05.28.34.54.62.49Z",
    fill: "#3A97C8"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "m34.95 14.02 5.62-.9c.27-.04.44-.35.38-.63l-.02-.1a.53.53 0 0 0-.6-.42l-5.57.84c-.28.04-.47.37-.42.68v.05c.05.27.33.53.61.48Z",
    fill: "#3B98C9"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "m34.95 14.02 5.62-.9c.27-.04.44-.35.38-.63l-.02-.11a.53.53 0 0 0-.59-.41l-5.58.84c-.28.04-.46.37-.42.67v.05c.05.28.33.54.61.49Z",
    fill: "#3C99C9"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "m34.95 14.01 5.61-.89c.28-.05.45-.36.39-.63l-.02-.11a.53.53 0 0 0-.6-.41l-5.57.84c-.28.04-.46.37-.42.67v.05c.05.28.34.53.61.48Z",
    fill: "#3D9ACA"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "m34.96 14.01 5.6-.89c.28-.05.45-.36.4-.63l-.03-.1a.53.53 0 0 0-.59-.42l-5.57.84c-.28.04-.46.37-.42.67v.05c.05.28.33.53.6.48Z",
    fill: "#3E9BCA"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "m34.96 14 5.6-.88c.28-.05.45-.36.4-.63l-.03-.11a.53.53 0 0 0-.59-.41l-5.57.83c-.28.05-.46.37-.42.67v.06c.05.28.33.53.6.48Z",
    fill: "#3F9CCB"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "m34.96 14 5.6-.88c.28-.05.45-.36.4-.63l-.03-.11a.53.53 0 0 0-.59-.41l-5.57.83c-.28.05-.46.37-.42.67v.06c.05.28.33.53.61.48Z",
    fill: "#409DCB"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "m34.96 14 5.6-.89c.28-.04.45-.35.4-.62l-.03-.11a.53.53 0 0 0-.59-.42l-5.57.84c-.27.05-.46.37-.42.67l.01.06c.05.28.33.53.6.47Z",
    fill: "#419ECC"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "m34.97 14 5.6-.89c.27-.04.44-.35.38-.62l-.02-.11a.53.53 0 0 0-.59-.41l-5.57.83c-.27.05-.45.37-.41.67v.06c.05.28.33.52.6.47Z",
    fill: "#429FCC"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "m34.97 14 5.6-.89c.27-.05.43-.35.38-.62l-.02-.11a.53.53 0 0 0-.59-.41l-5.57.83c-.27.05-.45.36-.41.66v.07c.05.28.33.52.6.47Z",
    fill: "#43A0CD"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "m34.97 14 5.6-.89c.26-.05.43-.35.38-.62l-.02-.11a.53.53 0 0 0-.59-.41l-5.56.83c-.28.05-.46.36-.42.66v.07c.05.28.33.52.6.47Z",
    fill: "#44A1CD"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "m34.97 14 5.6-.9c.27-.04.44-.34.38-.61l-.02-.11a.52.52 0 0 0-.59-.41l-5.56.83c-.27.05-.46.36-.42.66l.01.07c.05.28.32.52.6.47Z",
    fill: "#45A2CE"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "m34.97 14 5.6-.9c.27-.04.44-.34.38-.61l-.02-.11a.52.52 0 0 0-.59-.41l-5.56.83c-.27.05-.46.36-.41.66v.07c.05.27.33.51.6.46Z",
    fill: "#46A3CE"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "m34.98 14 5.59-.9c.26-.04.43-.34.38-.61l-.02-.11a.52.52 0 0 0-.59-.41l-5.56.83c-.27.05-.45.36-.41.65v.08c.05.27.33.51.6.46Z",
    fill: "#47A4CE"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "m34.98 13.99 5.59-.89c.27-.05.43-.34.38-.61l-.02-.11a.52.52 0 0 0-.58-.41l-5.56.83c-.28.05-.46.36-.42.65l.01.08c.05.27.32.51.6.46Z",
    fill: "#48A5CF"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "m34.98 13.99 5.59-.89c.27-.05.43-.34.38-.62l-.02-.1a.52.52 0 0 0-.59-.41l-5.55.83c-.28.04-.46.35-.42.65l.01.07c.05.28.32.52.6.47Z",
    fill: "#49A6CF"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "m34.98 13.99 5.59-.89c.27-.05.44-.34.38-.61l-.02-.11a.52.52 0 0 0-.59-.41l-5.55.83c-.27.05-.45.35-.41.65v.08c.05.27.33.5.6.46Z",
    fill: "#4AA7D0"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "m34.99 13.98 5.58-.88c.27-.05.43-.34.38-.61l-.02-.11a.52.52 0 0 0-.58-.41l-5.55.83c-.28.05-.46.35-.42.65l.01.08c.04.27.32.5.6.45Z",
    fill: "#4BA8D0"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "m34.99 13.98 5.58-.88c.27-.05.43-.34.38-.62l-.02-.1a.52.52 0 0 0-.58-.41l-5.55.83c-.27.04-.46.35-.41.64v.08c.05.28.32.51.6.46Z",
    fill: "#4CA9D1"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "m34.99 13.98 5.58-.89c.27-.04.43-.34.38-.6l-.02-.11a.52.52 0 0 0-.58-.41l-5.55.83c-.27.04-.46.35-.42.64l.02.08c.04.28.31.5.59.46Z",
    fill: "#4DAAD1"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.98 5.57-.89c.27-.05.43-.34.38-.6l-.02-.11a.52.52 0 0 0-.58-.42l-5.55.84c-.27.04-.46.34-.41.63v.09c.05.28.33.5.6.46Z",
    fill: "#4EABD2"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.97 5.57-.88c.26-.05.43-.34.38-.6l-.02-.11a.53.53 0 0 0-.58-.41l-5.55.83c-.27.04-.45.34-.41.63v.1c.06.27.33.5.6.44Z",
    fill: "#4FACD2"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.97 5.57-.88c.26-.05.43-.34.38-.6l-.02-.11a.52.52 0 0 0-.58-.41l-5.54.83c-.28.04-.46.34-.42.63l.01.1c.05.27.32.5.6.44Z",
    fill: "#50ADD3"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.97 5.57-.88c.26-.05.43-.34.38-.6l-.02-.11a.52.52 0 0 0-.58-.41l-5.54.83c-.27.05-.46.34-.41.63v.1c.05.27.33.5.6.44Z",
    fill: "#51AED3"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.97 5.57-.88c.27-.05.43-.34.38-.6l-.02-.11a.52.52 0 0 0-.58-.41l-5.54.83c-.27.04-.45.34-.4.63v.1c.05.26.32.49.6.44Z",
    fill: "#52AFD4"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.97 5.57-.89c.26-.04.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.41l-5.53.83c-.28.04-.46.34-.42.62l.01.1c.05.27.32.5.6.45Z",
    fill: "#53B0D4"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.96 5.57-.88c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-5.53.84c-.27.04-.46.33-.41.62v.1c.05.27.32.5.6.44Z",
    fill: "#54B1D5"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13.96 5.57-.88c.27-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.41l-5.53.83c-.27.04-.45.33-.41.62l.01.1c.05.27.31.5.59.44Z",
    fill: "#54B1D5"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "m35.01 13.96 5.56-.88c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-5.53.83c-.27.05-.45.34-.41.62l.01.1c.05.28.32.5.59.45Z",
    fill: "#55B2D5"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "m35.01 13.96 5.56-.88c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-5.53.83c-.27.05-.45.34-.4.62v.1c.05.28.32.5.6.45Z",
    fill: "#56B3D6"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "m35.01 13.96 5.56-.88c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.41l-5.52.83c-.27.04-.45.33-.41.61v.1c.05.28.32.5.6.45Z",
    fill: "#57B4D6"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "m35.02 13.95 5.55-.88c.27-.04.43-.32.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-5.52.82c-.27.05-.45.33-.41.62l.01.1c.05.28.31.5.59.44Z",
    fill: "#58B5D7"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "m35.02 13.95 5.55-.88c.26-.05.43-.32.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-5.52.83c-.27.04-.45.32-.4.6v.11c.05.28.32.5.59.44Z",
    fill: "#59B6D7"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "m35.02 13.95 5.55-.88c.26-.05.43-.32.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-5.52.82c-.26.05-.45.33-.4.61v.11c.05.28.32.49.59.44Z",
    fill: "#5AB7D8"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "m35.02 13.95 5.55-.88c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-5.51.82c-.27.05-.45.33-.41.61l.01.11c.04.28.31.49.58.44Z",
    fill: "#5BB8D8"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "m35.02 13.95 5.55-.88c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.57-.4l-5.52.82c-.27.05-.45.33-.4.6v.12c.05.28.31.49.58.44Z",
    fill: "#5CB9D9"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "m35.03 13.94 5.54-.87c.26-.05.43-.33.37-.6l-.01-.1a.52.52 0 0 0-.58-.4l-5.5.82c-.28.05-.46.33-.42.6l.01.12c.05.28.32.49.59.43Z",
    fill: "#5DBAD9"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "m35.03 13.94 5.54-.88c.26-.05.43-.32.38-.59l-.02-.1a.52.52 0 0 0-.57-.4l-5.51.82c-.27.04-.46.32-.41.6l.01.12c.04.28.3.48.58.43Z",
    fill: "#5EBBDA"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "m35.03 13.94 5.54-.88c.26-.05.43-.32.38-.58l-.02-.1a.52.52 0 0 0-.57-.41l-5.51.82c-.27.05-.45.32-.4.6v.12c.05.28.31.48.58.43Z",
    fill: "#5FBCDA"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "m35.03 13.94 5.54-.88c.26-.05.43-.32.38-.59l-.02-.1a.51.51 0 0 0-.57-.4l-5.5.82c-.28.05-.46.32-.42.6l.02.12c.04.28.3.48.57.43Z",
    fill: "#60BDDB"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "m35.04 13.94 5.53-.88a.5.5 0 0 0 .38-.58l-.02-.1a.51.51 0 0 0-.57-.41l-5.5.82c-.28.05-.46.32-.41.6v.12c.05.28.32.48.59.43Z",
    fill: "#61BEDB"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "m35.04 13.93 5.53-.87a.49.49 0 0 0 .38-.59l-.02-.1a.52.52 0 0 0-.57-.4l-5.5.82c-.27.04-.45.32-.41.6l.01.12c.05.27.31.47.58.42Z",
    fill: "#62BFDB"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "m35.04 13.93 5.53-.88a.5.5 0 0 0 .38-.58l-.02-.1a.52.52 0 0 0-.57-.4l-5.5.82c-.27.04-.45.32-.4.6v.12c.05.27.31.47.58.42Z",
    fill: "#63C0DC"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "m35.04 13.93 5.53-.88a.49.49 0 0 0 .38-.58l-.02-.1a.52.52 0 0 0-.57-.4l-5.5.82c-.27.05-.45.31-.4.6l.01.12c.04.27.3.47.57.42Z",
    fill: "#64C1DC"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "m35.05 13.93 5.52-.88a.49.49 0 0 0 .38-.58l-.02-.1a.51.51 0 0 0-.57-.4l-5.5.82a.51.51 0 0 0-.4.59l.01.13c.05.27.3.47.58.42Z",
    fill: "#65C2DD"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "m35.05 13.93 5.52-.88a.48.48 0 0 0 .38-.58l-.02-.1a.51.51 0 0 0-.57-.4l-5.5.82a.51.51 0 0 0-.4.59l.02.13c.04.27.3.47.57.42Z",
    fill: "#66C3DD"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "m35.05 13.92 5.52-.87a.49.49 0 0 0 .37-.58l-.01-.1a.51.51 0 0 0-.57-.4l-5.49.82a.5.5 0 0 0-.4.58l.01.14c.04.27.3.46.57.41Z",
    fill: "#67C4DE"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "m35.05 13.92 5.52-.87a.48.48 0 0 0 .38-.58l-.02-.1a.51.51 0 0 0-.57-.4l-5.49.82a.5.5 0 0 0-.4.58l.01.14c.05.27.3.46.57.41Z",
    fill: "#68C5DE"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "m35.05 13.92 5.52-.88a.48.48 0 0 0 .37-.57l-.01-.1a.51.51 0 0 0-.57-.4l-5.49.82a.5.5 0 0 0-.4.58l.02.14c.04.27.3.46.56.4Z",
    fill: "#69C6DF"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "m35.06 13.92 5.51-.88c.26-.04.43-.3.37-.57l-.01-.1a.51.51 0 0 0-.57-.4l-5.48.82a.5.5 0 0 0-.4.58v.14c.05.27.3.46.58.4Z",
    fill: "#6AC7DF"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "m35.06 13.91 5.51-.87c.26-.05.43-.3.37-.57l-.01-.1a.51.51 0 0 0-.57-.4l-5.48.82a.5.5 0 0 0-.4.57l.01.15c.04.27.3.45.57.4Z",
    fill: "#6BC8E0"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "m35.06 13.91 5.51-.87c.26-.05.43-.3.38-.57l-.02-.1a.51.51 0 0 0-.57-.4l-5.48.82a.5.5 0 0 0-.4.57l.02.15c.04.26.3.45.56.4Z",
    fill: "#6CC9E0"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "m35.06 13.91 5.51-.87c.26-.05.43-.3.37-.57l-.01-.1a.51.51 0 0 0-.57-.4l-5.48.82a.5.5 0 0 0-.4.57l.01.15c.05.26.3.45.57.4Z",
    fill: "#6DCAE1"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "m35.06 13.9 5.51-.86c.26-.05.43-.3.37-.57l-.01-.1a.51.51 0 0 0-.57-.4l-5.48.82a.5.5 0 0 0-.4.57l.02.15c.04.26.3.45.56.4Z",
    fill: "#6ECBE1"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "m35.07 13.9 5.5-.87c.26-.04.43-.3.38-.56l-.02-.1a.51.51 0 0 0-.57-.4l-5.47.82a.5.5 0 0 0-.4.56l.01.15c.05.27.3.46.57.4Z",
    fill: "#6FCCE2"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "m35.07 13.9 5.5-.87c.26-.04.43-.3.38-.56l-.02-.1a.51.51 0 0 0-.56-.4l-5.48.82a.5.5 0 0 0-.4.56l.02.15c.04.27.3.45.56.4Z",
    fill: "#70CDE2"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "m35.07 13.9 5.5-.87c.26-.04.42-.33.37-.59v-.05c-.06-.26-.32-.47-.58-.43l-5.47.83a.5.5 0 0 0-.4.56l.02.15c.04.27.3.45.56.4Z",
    fill: "url(#d)"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 14.72 2.7-.45c.28-.05.45-.37.4-.64l-.03-.11a.53.53 0 0 0-.6-.42l-2.67.4c-.28.04-.46.38-.42.68v.04c.05.29.34.55.62.5Z",
    fill: "#3794C7"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 14.71 2.7-.44c.28-.05.45-.37.4-.64l-.03-.11a.53.53 0 0 0-.6-.42l-2.66.4c-.28.04-.46.37-.42.68v.04c.04.28.33.54.6.5Z",
    fill: "#3895C7"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 14.71 2.7-.44c.28-.05.45-.37.4-.64l-.03-.11a.53.53 0 0 0-.6-.42l-2.66.4c-.28.04-.46.37-.42.68v.05c.05.27.33.53.61.48Z",
    fill: "#3996C8"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 14.7 2.7-.44c.28-.05.45-.36.4-.63l-.03-.11a.53.53 0 0 0-.6-.42l-2.66.4c-.28.04-.46.37-.42.67v.05c.05.28.33.54.61.49Z",
    fill: "#3A97C8"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 14.7 2.7-.44c.28-.05.45-.36.4-.63l-.03-.11a.53.53 0 0 0-.6-.42l-2.66.4c-.28.04-.46.37-.42.67v.05c.05.28.33.54.62.49Z",
    fill: "#3B98C9"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 14.7 2.7-.44c.28-.05.45-.36.4-.63l-.03-.11a.53.53 0 0 0-.6-.42l-2.65.4c-.28.04-.46.37-.42.67v.05c.05.28.33.54.6.49Z",
    fill: "#3C99C9"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "m30.61 14.7 2.7-.44c.27-.05.44-.36.38-.63l-.02-.11a.53.53 0 0 0-.6-.42l-2.65.4c-.28.04-.46.37-.42.67v.05c.05.28.33.53.61.48Z",
    fill: "#3D9ACA"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "m30.61 14.7 2.7-.44c.27-.05.44-.36.38-.63l-.02-.11a.53.53 0 0 0-.6-.42l-2.65.4c-.28.04-.46.37-.42.67v.05c.05.28.33.53.61.48Z",
    fill: "#3E9BCA"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "m30.61 14.7 2.7-.44c.27-.05.43-.36.38-.63l-.02-.11a.53.53 0 0 0-.6-.42l-2.65.4c-.28.04-.46.36-.42.66v.06c.05.28.34.53.61.48Z",
    fill: "#3F9CCB"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "m30.62 14.7 2.69-.45c.27-.05.44-.35.38-.62l-.02-.11a.53.53 0 0 0-.59-.42l-2.65.4c-.28.04-.46.36-.42.66v.06c.05.28.33.53.6.48Z",
    fill: "#409DCB"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "m30.62 14.7 2.68-.45c.28-.05.44-.35.39-.62l-.02-.11a.53.53 0 0 0-.6-.42l-2.64.4c-.28.04-.46.36-.42.66v.06c.05.28.33.53.6.48Z",
    fill: "#419ECC"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "m30.62 14.7 2.68-.45c.28-.05.44-.35.39-.62l-.02-.11a.53.53 0 0 0-.6-.42l-2.64.4c-.28.04-.46.36-.42.66v.06c.05.28.33.53.61.48Z",
    fill: "#429FCC"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "m30.62 14.7 2.69-.45c.27-.05.43-.35.38-.62l-.02-.11a.53.53 0 0 0-.59-.42l-2.65.4c-.28.04-.46.35-.42.65l.01.07c.05.28.33.52.6.47Z",
    fill: "#43A0CD"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "m30.63 14.69 2.68-.44c.27-.05.43-.35.38-.63l-.02-.1a.53.53 0 0 0-.59-.42l-2.64.4c-.28.04-.46.35-.42.65v.07c.05.28.33.52.6.47Z",
    fill: "#44A1CD"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "m30.63 14.69 2.68-.44c.26-.05.43-.35.38-.62l-.02-.11a.52.52 0 0 0-.59-.41l-2.64.38c-.28.05-.46.36-.42.66v.07c.05.28.33.52.6.47Z",
    fill: "#45A2CE"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "m30.63 14.69 2.67-.44c.27-.05.44-.35.39-.62l-.02-.11a.52.52 0 0 0-.59-.41l-2.64.38c-.28.05-.46.36-.42.66v.07c.06.28.33.52.6.47Z",
    fill: "#46A3CE"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "m30.63 14.68 2.68-.44c.27-.05.43-.35.38-.62l-.02-.1a.52.52 0 0 0-.59-.42l-2.64.39c-.27.04-.46.36-.42.65l.01.08c.05.27.33.51.6.46Z",
    fill: "#47A4CE"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "m30.63 14.68 2.68-.44c.27-.05.43-.35.38-.62l-.02-.1a.52.52 0 0 0-.59-.42l-2.63.39c-.28.04-.46.35-.42.65v.08c.05.27.33.51.6.46Z",
    fill: "#48A5CF"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 14.68 2.67-.44c.27-.05.43-.34.38-.62l-.02-.1a.52.52 0 0 0-.59-.42l-2.63.4c-.28.04-.46.35-.42.64v.08c.05.27.33.51.6.46Z",
    fill: "#49A6CF"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 14.68 2.67-.44c.27-.05.44-.35.38-.62l-.02-.1a.52.52 0 0 0-.59-.42l-2.63.4c-.28.04-.46.34-.42.64l.01.08c.05.27.32.5.6.46Z",
    fill: "#4AA7D0"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 14.67 2.67-.43c.27-.05.43-.35.38-.62l-.02-.1a.52.52 0 0 0-.59-.42l-2.63.4c-.27.04-.45.34-.42.64l.01.08c.05.27.32.5.6.45Z",
    fill: "#4BA8D0"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "m30.64 14.67 2.67-.44c.26-.05.43-.34.38-.61l-.02-.1a.52.52 0 0 0-.58-.42l-2.64.39c-.27.04-.45.35-.41.64l.01.08c.04.28.32.51.6.46Z",
    fill: "#4CA9D1"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 14.67 2.66-.44c.26-.05.43-.34.38-.6l-.02-.11a.52.52 0 0 0-.59-.42l-2.62.39c-.28.04-.46.35-.42.64l.01.08c.05.28.32.51.6.46Z",
    fill: "#4DAAD1"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 14.67 2.66-.44c.26-.05.43-.34.38-.61l-.02-.1a.52.52 0 0 0-.59-.42l-2.62.39c-.28.04-.46.35-.41.64v.08c.05.28.32.51.6.46Z",
    fill: "#4EABD2"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 14.67 2.66-.44c.26-.05.43-.34.38-.61l-.02-.1a.53.53 0 0 0-.59-.42l-2.62.39c-.27.04-.45.35-.41.64v.09c.05.27.32.5.6.45Z",
    fill: "#4FACD2"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 14.66 2.66-.43c.26-.05.43-.34.38-.61l-.02-.1a.52.52 0 0 0-.58-.42l-2.63.39c-.27.04-.45.34-.41.63v.1c.06.27.33.5.6.44Z",
    fill: "#50ADD3"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "m30.65 14.66 2.66-.43c.26-.05.43-.34.38-.61l-.02-.1a.52.52 0 0 0-.58-.42l-2.62.39c-.28.04-.46.34-.42.63l.01.1c.05.27.32.5.6.44Z",
    fill: "#51AED3"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 14.66 2.65-.44c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-2.62.39c-.27.04-.46.34-.42.63l.01.1c.05.27.32.49.6.44Z",
    fill: "#52AFD4"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 14.66 2.65-.44c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-2.62.39c-.27.04-.45.34-.41.63v.1c.05.26.32.49.6.44Z",
    fill: "#53B0D4"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 14.66 2.65-.44c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-2.61.39c-.28.04-.46.33-.42.62l.01.1c.05.27.32.5.6.45Z",
    fill: "#54B1D5"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 14.65 2.65-.43c.26-.05.43-.34.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-2.61.39c-.28.04-.46.34-.42.62l.01.1c.05.27.32.5.6.44Z",
    fill: "#54B1D5"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "m30.66 14.65 2.65-.43c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.42l-2.61.39c-.27.04-.46.33-.41.62v.1c.05.28.32.5.6.44Z",
    fill: "#55B2D5"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "m30.67 14.65 2.64-.44c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.41l-2.61.38c-.27.05-.45.34-.41.62l.01.1c.05.28.32.5.59.45Z",
    fill: "#56B3D6"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "m30.67 14.65 2.64-.44c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.41l-2.6.38c-.28.05-.46.34-.42.62l.02.1c.04.28.3.5.58.45Z",
    fill: "#57B4D6"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "m30.67 14.65 2.64-.44c.26-.05.43-.33.37-.6l-.01-.1a.52.52 0 0 0-.58-.41l-2.6.38c-.28.05-.46.34-.42.62l.01.1c.05.28.32.5.6.45Z",
    fill: "#58B5D7"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "m30.67 14.64 2.64-.43c.26-.05.43-.33.37-.6l-.01-.1a.52.52 0 0 0-.58-.4l-2.6.38c-.27.04-.46.33-.41.6v.12c.06.27.32.48.6.43Z",
    fill: "#59B6D7"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "m30.68 14.64 2.63-.43c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-2.6.38c-.27.04-.45.32-.41.6l.01.12c.05.27.31.48.59.43Z",
    fill: "#5AB7D8"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "m30.68 14.64 2.63-.43c.26-.05.43-.33.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-2.6.37c-.27.05-.45.33-.4.61v.11c.05.28.32.49.59.44Z",
    fill: "#5BB8D8"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "m30.68 14.64 2.63-.44c.26-.04.43-.32.38-.59l-.02-.1a.52.52 0 0 0-.58-.4l-2.6.37c-.26.05-.45.33-.4.61l.01.11c.04.28.3.49.58.44Z",
    fill: "#5CB9D9"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "m30.68 14.63 2.63-.43c.26-.05.43-.32.38-.6l-.02-.1a.52.52 0 0 0-.58-.4l-2.6.38c-.26.04-.44.32-.4.6l.01.12c.05.28.31.48.58.43Z",
    fill: "#5DBAD9"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "m30.68 14.63 2.63-.43c.26-.05.43-.32.38-.59l-.02-.1a.52.52 0 0 0-.58-.4l-2.59.37c-.27.05-.45.33-.4.6v.12c.05.28.31.48.58.43Z",
    fill: "#5EBBDA"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "m30.69 14.63 2.62-.43c.26-.05.43-.32.38-.59l-.02-.1a.52.52 0 0 0-.57-.4l-2.6.37c-.27.05-.45.32-.4.6v.12c.05.28.32.48.59.43Z",
    fill: "#5FBCDA"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "m30.69 14.63 2.62-.43c.26-.05.43-.32.38-.59l-.02-.1a.51.51 0 0 0-.57-.4l-2.6.37c-.26.05-.45.32-.4.6l.01.12c.05.28.3.48.58.43Z",
    fill: "#60BDDB"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.63 2.61-.43c.26-.05.43-.32.38-.59l-.02-.1a.51.51 0 0 0-.57-.4l-2.6.37c-.26.05-.44.32-.4.6l.01.12c.05.28.31.48.58.43Z",
    fill: "#61BEDB"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.62 2.61-.43a.5.5 0 0 0 .38-.58l-.02-.1a.52.52 0 0 0-.57-.41l-2.59.38c-.27.04-.45.31-.4.6v.12c.05.27.31.47.58.42Z",
    fill: "#62BFDB"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.62 2.61-.43c.26-.05.43-.32.38-.58l-.02-.1a.52.52 0 0 0-.57-.41l-2.58.38c-.27.04-.45.31-.41.59l.01.13c.04.27.3.47.58.42Z",
    fill: "#63C0DC"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.62 2.61-.43a.49.49 0 0 0 .38-.58l-.02-.1a.52.52 0 0 0-.57-.41l-2.58.38c-.27.04-.45.31-.4.59v.13c.05.27.31.47.58.42Z",
    fill: "#64C1DC"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.62 2.6-.43a.49.49 0 0 0 .38-.58l-.01-.1a.51.51 0 0 0-.57-.4l-2.58.37c-.27.05-.45.31-.4.59v.13c.05.27.31.47.58.42Z",
    fill: "#65C2DD"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.62 2.6-.43a.49.49 0 0 0 .38-.58l-.01-.1a.51.51 0 0 0-.57-.4l-2.58.37a.51.51 0 0 0-.4.59v.13c.05.27.31.47.58.42Z",
    fill: "#66C3DD"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.62 2.61-.43a.49.49 0 0 0 .38-.58l-.02-.1a.51.51 0 0 0-.57-.41l-2.57.38a.5.5 0 0 0-.41.58l.02.14c.04.27.3.47.57.42Z",
    fill: "#67C4DE"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.61 2.61-.43a.49.49 0 0 0 .38-.57l-.02-.1a.51.51 0 0 0-.57-.41l-2.57.38a.5.5 0 0 0-.4.58v.14c.05.27.31.46.58.41Z",
    fill: "#68C5DE"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7 14.61 2.61-.43a.48.48 0 0 0 .37-.57l-.01-.1a.51.51 0 0 0-.57-.41l-2.57.38a.5.5 0 0 0-.4.58v.14c.05.27.31.46.58.41Z",
    fill: "#69C6DF"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "m30.71 14.6 2.6-.42c.26-.05.43-.31.37-.57l-.01-.1a.51.51 0 0 0-.57-.41l-2.57.38a.5.5 0 0 0-.4.58l.01.14c.05.27.3.46.57.4Z",
    fill: "#6AC7DF"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "m30.71 14.6 2.6-.42c.26-.05.43-.31.37-.57l-.01-.1a.51.51 0 0 0-.57-.41l-2.56.38a.5.5 0 0 0-.4.57v.15c.05.27.3.46.57.4Z",
    fill: "#6BC8E0"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "m30.72 14.6 2.6-.42c.25-.05.42-.31.36-.57l-.01-.1a.51.51 0 0 0-.57-.41l-2.56.38a.5.5 0 0 0-.4.57l.01.15c.04.27.3.46.57.4Z",
    fill: "#6CC9E0"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "m30.72 14.6 2.6-.42c.25-.05.42-.31.36-.57l-.01-.1a.51.51 0 0 0-.57-.41l-2.56.38a.5.5 0 0 0-.4.57v.15c.05.27.31.45.58.4Z",
    fill: "#6DCAE1"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "m30.72 14.6 2.6-.43c.25-.04.42-.3.36-.56l-.01-.1a.51.51 0 0 0-.57-.41l-2.56.38a.5.5 0 0 0-.4.57l.01.14c.05.28.3.46.57.41Z",
    fill: "#6ECBE1"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "m30.72 14.6 2.6-.43c.25-.05.42-.3.36-.57l-.01-.1c-.05-.25-.31-.44-.57-.4l-2.56.37a.5.5 0 0 0-.4.57l.02.15c.04.28.3.46.56.4Z",
    fill: "#6FCCE2"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "m30.72 14.6 2.6-.43c.25-.05.42-.3.36-.57l-.01-.09a.51.51 0 0 0-.57-.41l-2.55.38a.5.5 0 0 0-.4.56l.01.15c.04.27.3.46.56.4Z",
    fill: "#70CDE2"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "m30.72 14.6 2.6-.43c.25-.05.41-.33.36-.6v-.04c-.06-.26-.32-.47-.58-.43l-2.55.37a.5.5 0 0 0-.4.57l.01.15c.04.27.3.46.56.4Z",
    fill: "url(#e)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.07 19.75 6.38-1.05c.31-.05.5-.41.44-.72l-.03-.13a.6.6 0 0 0-.68-.47l-6.34 1c-.32.04-.52.42-.48.77l.01.05c.06.32.38.61.7.55Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.14 19.68 6.32-1.03c.3-.06.49-.38.42-.69l-.02-.12a.59.59 0 0 0-.66-.46l-6.28.98c-.3.05-.5.38-.46.7l.01.12c.05.31.36.56.67.5Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.21 19.61 6.25-1.02c.3-.06.48-.35.42-.64l-.02-.11c-.06-.3-.35-.51-.64-.46l-6.22.97c-.3.05-.5.34-.45.64l.02.17c.05.3.34.51.64.45Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.22 19.61 6.24-1.02c.3-.06.47-.38.41-.68v-.05c-.07-.3-.36-.53-.66-.48l-6.2.97c-.3.05-.51.34-.46.64l.02.17c.05.3.34.51.65.45Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.14 20.56 3.07-.52c.31-.06.5-.42.44-.73l-.03-.13a.6.6 0 0 0-.68-.47l-3.03.47c-.32.05-.52.43-.48.78V20c.06.32.39.61.7.55Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.21 20.5 3-.52c.3-.06.5-.38.43-.68l-.02-.12a.59.59 0 0 0-.66-.47l-2.97.46c-.3.05-.51.39-.46.71l.01.11c.05.31.36.56.67.5Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.28 20.42 2.94-.5c.3-.05.48-.34.42-.64l-.02-.1c-.06-.3-.35-.52-.64-.47l-2.9.44c-.3.06-.51.35-.46.65l.02.17c.05.3.34.51.64.45Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.28 20.42 2.94-.5c.3-.05.47-.38.41-.67v-.05c-.07-.3-.36-.54-.65-.49l-2.9.44c-.3.06-.51.34-.46.65l.02.17c.05.3.34.51.64.45Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.7 25.83 3.06-.57c.3-.06.5-.42.42-.73l-.03-.13a.6.6 0 0 0-.68-.46l-3.03.51c-.31.06-.51.45-.46.8v.04c.06.32.4.6.71.54Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.77 25.76 3-.56c.3-.06.48-.39.4-.69l-.01-.12a.6.6 0 0 0-.67-.45l-2.97.5c-.3.05-.5.4-.45.72l.02.1c.05.32.37.56.68.5Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.84 25.69 2.92-.54c.3-.07.48-.36.41-.66l-.02-.1a.58.58 0 0 0-.65-.45l-2.9.48c-.3.06-.5.35-.43.66l.02.17c.05.3.35.5.65.44Z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.84 25.7 2.92-.55c.3-.06.47-.39.4-.69v-.05c-.07-.3-.37-.53-.66-.47l-2.9.48c-.3.06-.5.35-.44.66l.03.17c.05.3.35.5.65.44Z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.12 21.39 3.08-.53c.3-.06.5-.42.43-.73l-.02-.13a.6.6 0 0 0-.68-.46L24.9 20c-.32.05-.53.44-.48.78v.05c.06.32.39.62.7.56Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2 21.32 3-.51c.3-.06.5-.39.43-.69l-.02-.12a.59.59 0 0 0-.66-.46l-2.97.45c-.3.05-.51.39-.46.72v.1c.06.32.37.57.68.5Z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.27 21.25 2.93-.5c.3-.06.49-.35.42-.65l-.01-.1c-.07-.3-.36-.51-.65-.46l-2.9.44c-.3.05-.5.34-.46.64l.02.18c.06.3.35.5.65.45Z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.27 21.25 2.94-.5c.29-.06.47-.38.4-.68v-.05c-.06-.3-.36-.53-.65-.48l-2.9.44c-.3.05-.5.34-.45.64l.02.18c.05.3.34.5.64.45Z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.55 22.46 6.36-1.18c.3-.06.49-.42.42-.73l-.03-.13a.6.6 0 0 0-.69-.45l-6.32 1.12c-.32.06-.51.44-.46.78v.05c.07.32.4.6.72.54Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.62 22.4 6.3-1.17c.3-.06.47-.4.4-.7l-.02-.11a.59.59 0 0 0-.67-.45l-6.26 1.1c-.3.06-.5.4-.45.72l.02.11c.06.31.37.56.68.5Z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.69 22.32 6.22-1.15c.3-.06.48-.35.4-.65l-.01-.1a.58.58 0 0 0-.66-.45l-6.19 1.09c-.3.06-.5.35-.44.65l.02.17c.06.3.36.5.66.44Z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.69 22.32 6.22-1.15c.3-.06.47-.39.4-.68v-.06c-.08-.3-.37-.52-.67-.47l-6.19 1.1c-.3.05-.5.35-.44.65l.02.17c.06.3.36.5.66.44Z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.1 23.65 4.6-.84c.3-.06.49-.42.42-.73l-.02-.13a.6.6 0 0 0-.69-.46l-4.55.78c-.31.06-.52.44-.47.78v.05c.07.32.4.6.71.55Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.18 23.57 4.52-.82c.3-.06.48-.39.42-.69l-.03-.12a.59.59 0 0 0-.66-.45l-4.49.76c-.3.06-.5.4-.45.72l.01.1c.05.32.37.57.68.5Z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.25 23.5 4.45-.8c.3-.07.48-.36.41-.66l-.02-.1a.58.58 0 0 0-.65-.46l-4.42.76c-.3.05-.5.34-.44.65l.02.17c.05.3.35.5.65.44Z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.25 23.5 4.45-.8c.3-.07.47-.39.4-.69v-.05c-.07-.3-.37-.53-.66-.48l-4.42.76c-.3.05-.5.34-.44.65l.02.17c.05.3.35.5.65.45Z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.94 30.7 6.35-1.2c.31-.06.5-.42.42-.73l-.03-.13a.6.6 0 0 0-.69-.45l-6.32 1.14c-.31.06-.5.44-.45.79v.05c.07.31.4.6.72.53Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 30.63 6.3-1.18c.3-.07.48-.4.4-.7l-.02-.11a.6.6 0 0 0-.67-.45l-6.25 1.12c-.31.06-.5.4-.45.73l.01.1c.07.32.38.56.69.5Z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.08 30.56 6.22-1.17c.3-.06.47-.35.4-.65l-.02-.1a.58.58 0 0 0-.66-.45l-6.18 1.11c-.3.06-.5.35-.44.66l.02.17c.06.3.36.5.66.43Z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.08 30.57 6.22-1.17c.29-.07.46-.4.4-.7l-.02-.04c-.07-.3-.36-.53-.66-.47l-6.18 1.11c-.3.06-.5.35-.44.66l.02.17c.06.3.36.5.66.44Z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.03 31.63 3.05-.6c.31-.06.5-.42.42-.73l-.02-.13a.6.6 0 0 0-.7-.45l-3.01.54c-.32.06-.52.44-.46.79v.04c.07.32.4.61.72.54Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.1 31.56 2.99-.58c.3-.07.48-.4.41-.7l-.02-.11a.6.6 0 0 0-.68-.45l-2.95.52c-.31.06-.5.4-.45.72l.01.11c.06.32.38.56.69.5Z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.17 31.5 2.92-.58c.3-.06.47-.36.4-.65l-.02-.1a.58.58 0 0 0-.65-.45l-2.9.51c-.3.06-.5.35-.43.65l.02.18c.06.3.36.5.66.43Z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.17 31.5 2.92-.58c.3-.06.47-.39.4-.68l-.01-.06c-.07-.3-.37-.52-.66-.46l-2.9.5c-.3.06-.49.36-.43.66l.02.17c.06.31.36.5.66.44Z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.03 32.54 3.06-.6c.3-.06.49-.43.42-.73l-.03-.13a.6.6 0 0 0-.69-.45l-3.02.53c-.32.06-.52.45-.46.8V32c.07.32.4.61.72.54Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.1 32.47 3-.58c.3-.07.47-.4.4-.7l-.02-.12a.6.6 0 0 0-.67-.44l-2.96.52c-.31.06-.5.4-.45.72l.01.11c.07.31.38.56.69.5Z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.17 32.4 2.92-.57c.3-.06.48-.36.4-.65l-.02-.11a.58.58 0 0 0-.65-.45l-2.9.52c-.29.05-.49.35-.43.65l.02.17c.06.3.36.5.66.44Z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.17 32.4 2.92-.57c.3-.06.47-.39.4-.69l-.01-.05c-.07-.3-.37-.52-.66-.47l-2.89.52c-.3.05-.5.35-.44.65l.03.17c.05.3.35.5.65.44Z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.44 33.42 6.35-1.23c.31-.06.49-.43.42-.74l-.03-.12a.6.6 0 0 0-.7-.45l-6.3 1.17c-.32.06-.52.45-.46.8v.04c.07.32.4.6.72.53Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.51 33.35 6.29-1.21c.3-.07.48-.4.4-.7l-.02-.12a.59.59 0 0 0-.68-.44l-6.24 1.16c-.31.06-.5.4-.45.72l.02.11c.06.31.37.55.68.48Z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.58 33.28 6.22-1.2c.29-.07.47-.36.4-.66l-.02-.1a.58.58 0 0 0-.66-.45l-6.18 1.15c-.3.06-.5.35-.44.66l.03.17c.06.3.35.5.65.43Z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.58 33.28 6.22-1.2c.29-.07.46-.4.4-.69l-.02-.05c-.07-.3-.37-.52-.66-.46l-6.18 1.14c-.3.06-.5.36-.44.66l.03.17c.06.3.35.5.65.43Z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.03 34.73 4.57-.93c.3-.07.49-.43.41-.74l-.02-.13a.6.6 0 0 0-.7-.44l-4.53.87c-.32.06-.51.44-.46.79l.01.05c.07.31.4.6.72.53Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.1 34.66 4.5-.92c.3-.06.48-.4.41-.7l-.03-.1a.59.59 0 0 0-.67-.45l-4.47.85c-.3.06-.5.4-.44.73l.01.1c.06.32.38.56.69.49Z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.17 34.59 4.43-.9c.3-.07.48-.36.4-.66l-.02-.1a.58.58 0 0 0-.65-.45l-4.4.85c-.3.05-.5.35-.44.65l.02.17c.06.3.36.5.66.44Z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.17 34.59 4.43-.9c.3-.06.47-.4.4-.69l-.01-.05c-.07-.3-.37-.52-.67-.46l-4.4.84c-.3.06-.5.35-.43.66l.02.17c.06.3.36.5.66.43Z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.74 24.89 4.58-.87c.31-.06.5-.42.43-.73l-.03-.13a.6.6 0 0 0-.68-.46l-4.55.8c-.32.07-.52.45-.47.8v.04c.07.32.4.61.72.55Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.8 24.82 4.52-.86c.3-.06.49-.38.42-.69l-.02-.12a.6.6 0 0 0-.67-.45l-4.48.8c-.31.05-.51.39-.45.71l.01.11c.06.32.37.56.68.5Z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.88 24.74 4.45-.83c.3-.07.47-.36.4-.66l-.01-.1a.58.58 0 0 0-.65-.45l-4.42.78c-.3.05-.5.35-.44.65l.02.17c.06.3.35.5.65.44Z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.88 24.74 4.45-.83c.3-.07.47-.4.4-.69v-.05c-.07-.3-.37-.53-.66-.47l-4.42.78c-.3.05-.5.35-.44.65l.02.17c.06.3.35.5.65.44Z",
    fill: "url(#O)"
  }))), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "m72.84 24.95-14.36-3.51c-1.08-.27-1.43-1.16-.8-2.01l3.65-5.02a3.63 3.63 0 0 1 2.94-1.25l16.5 1.13c1.76.12 2.63 1.1 1.86 2.16l-5.27 7.22c-1.22 1.57-2.88 1.69-4.52 1.28Z",
    fill: "#5A73CC"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "m72.85 24.95-14.37-3.52c-1.08-.26-1.43-1.15-.81-2l3.67-5.03a3.6 3.6 0 0 1 2.93-1.24l16.51 1.13c1.75.12 2.61 1.1 1.85 2.15l-5.28 7.23c-1.2 1.56-2.86 1.68-4.5 1.28Z",
    fill: "url(#P)"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "m72.86 24.95-14.39-3.52c-1.08-.27-1.42-1.15-.8-2l3.67-5.04a3.6 3.6 0 0 1 2.92-1.23l16.53 1.13c1.73.12 2.6 1.1 1.83 2.14l-5.28 7.25c-1.2 1.54-2.85 1.67-4.48 1.27Z",
    fill: "url(#Q)"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "m72.87 24.95-14.4-3.53c-1.07-.26-1.42-1.14-.8-1.98l3.68-5.05a3.58 3.58 0 0 1 2.9-1.23l16.55 1.13c1.73.12 2.58 1.09 1.83 2.13l-5.3 7.26c-1.18 1.52-2.84 1.67-4.46 1.27Z",
    fill: "url(#R)"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "m72.87 24.95-14.4-3.53c-1.08-.26-1.42-1.14-.8-1.98l3.68-5.06a3.56 3.56 0 0 1 2.89-1.22l16.56 1.13c1.72.12 2.58 1.08 1.82 2.12l-5.3 7.27c-1.17 1.51-2.83 1.66-4.45 1.27Z",
    fill: "url(#S)"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "m72.88 24.94-14.43-3.53c-1.06-.26-1.4-1.13-.79-1.97l3.7-5.06a3.55 3.55 0 0 1 2.87-1.22l16.57 1.13c1.72.12 2.57 1.08 1.82 2.11l-5.3 7.29c-1.17 1.49-2.83 1.65-4.44 1.25Z",
    fill: "url(#T)"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "m72.89 24.94-14.44-3.53c-1.06-.26-1.4-1.13-.8-1.96l3.71-5.08a3.53 3.53 0 0 1 2.86-1.21l16.6 1.13c1.7.11 2.55 1.07 1.8 2.1l-5.32 7.3c-1.14 1.48-2.8 1.65-4.41 1.25Z",
    fill: "url(#U)"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9 24.94 58.44 21.4c-1.05-.26-1.39-1.12-.78-1.95l3.7-5.09a3.52 3.52 0 0 1 2.85-1.2l16.6 1.13c1.7.11 2.55 1.07 1.8 2.1l-5.32 7.3c-1.13 1.46-2.8 1.64-4.4 1.25Z",
    fill: "url(#V)"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9 24.94 58.44 21.4c-1.05-.26-1.39-1.12-.79-1.95l3.72-5.1a3.5 3.5 0 0 1 2.84-1.2l16.61 1.14c1.7.11 2.53 1.07 1.8 2.08l-5.34 7.32c-1.12 1.45-2.79 1.64-4.38 1.25Z",
    fill: "url(#W)"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "m72.91 24.94-14.48-3.55c-1.04-.25-1.38-1.1-.78-1.93l3.72-5.11a3.5 3.5 0 0 1 2.83-1.2l16.63 1.14c1.69.11 2.52 1.06 1.78 2.07l-5.34 7.34c-1.1 1.43-2.78 1.62-4.36 1.24Z",
    fill: "url(#X)"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "m72.92 24.94-14.5-3.55c-1.04-.26-1.37-1.1-.77-1.93l3.73-5.12a3.47 3.47 0 0 1 2.81-1.19l16.65 1.14c1.68.11 2.5 1.06 1.77 2.07l-5.35 7.34c-1.1 1.41-2.76 1.62-4.34 1.24Z",
    fill: "url(#Y)"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "m72.93 24.93-14.5-3.54c-1.05-.26-1.38-1.1-.78-1.92l3.73-5.13a3.45 3.45 0 0 1 2.8-1.18l16.66 1.13c1.67.11 2.5 1.05 1.77 2.06l-5.37 7.36c-1.07 1.4-2.74 1.6-4.31 1.22Z",
    fill: "url(#Z)"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "m72.93 24.93-14.52-3.55c-1.03-.25-1.36-1.1-.77-1.9l3.75-5.15a3.44 3.44 0 0 1 2.78-1.18l16.68 1.14c1.66.12 2.48 1.05 1.76 2.05l-5.38 7.37c-1.05 1.38-2.73 1.6-4.3 1.22Z",
    fill: "url(#aa)"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "m72.94 24.93-14.53-3.55c-1.03-.25-1.36-1.1-.77-1.9l3.75-5.15a3.42 3.42 0 0 1 2.77-1.18l16.7 1.14c1.65.11 2.47 1.04 1.74 2.04l-5.38 7.38c-1.04 1.37-2.72 1.6-4.28 1.22Z",
    fill: "url(#ab)"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M72.95 24.93 58.4 21.37c-1.02-.25-1.35-1.09-.76-1.9l3.76-5.15a3.4 3.4 0 0 1 2.76-1.17l16.7 1.14c1.65.12 2.47 1.04 1.74 2.03l-5.38 7.4c-1.04 1.34-2.72 1.58-4.27 1.2Z",
    fill: "url(#ac)"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M72.96 24.92 58.4 21.37c-1.02-.25-1.35-1.09-.76-1.9l3.77-5.16a3.38 3.38 0 0 1 2.74-1.16l16.72 1.14c1.64.12 2.45 1.04 1.73 2.02l-5.4 7.4c-1.02 1.34-2.7 1.59-4.24 1.21Z",
    fill: "url(#ad)"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M72.96 24.92 58.4 21.36c-1.01-.25-1.34-1.08-.76-1.88l3.78-5.17a3.38 3.38 0 0 1 2.73-1.16l16.73 1.14c1.64.11 2.45 1.03 1.73 2.01l-5.4 7.42c-1.01 1.32-2.7 1.58-4.24 1.2Z",
    fill: "url(#ae)"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M72.97 24.92 58.4 21.36c-1.02-.25-1.34-1.08-.76-1.87l3.78-5.19a3.36 3.36 0 0 1 2.72-1.15l16.75 1.14c1.63.11 2.43 1.02 1.72 2l-5.42 7.43c-1 1.3-2.68 1.57-4.2 1.2Z",
    fill: "url(#af)"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "m72.98 24.92-14.6-3.57c-1-.25-1.33-1.07-.75-1.86l3.79-5.2a3.33 3.33 0 0 1 2.7-1.14L80.9 14.3c1.62.12 2.42 1.02 1.7 2l-5.42 7.44c-.98 1.28-2.67 1.56-4.19 1.19Z",
    fill: "url(#ag)"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "m72.99 24.91-14.61-3.56c-1-.25-1.33-1.07-.75-1.86l3.8-5.2c.51-.7 1.69-1.2 2.69-1.14l16.78 1.14c1.6.11 2.4 1.01 1.7 1.98l-5.44 7.46C76.2 25 74.5 25.3 73 24.91Z",
    fill: "url(#ah)"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "m73 24.91-14.63-3.57c-1-.24-1.32-1.06-.74-1.85l3.8-5.21a3.3 3.3 0 0 1 2.68-1.14L80.9 14.3c1.6.1 2.4 1 1.7 1.97l-5.45 7.47c-.95 1.26-2.64 1.55-4.16 1.18Z",
    fill: "url(#ai)"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "m73 24.91-14.63-3.57c-1-.24-1.32-1.06-.75-1.84l3.81-5.22a3.3 3.3 0 0 1 2.67-1.13l16.8 1.14c1.6.11 2.4 1 1.7 1.97l-5.46 7.48c-.94 1.24-2.63 1.54-4.14 1.17Z",
    fill: "url(#aj)"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "m73.01 24.9-14.65-3.57c-1-.24-1.3-1.05-.74-1.83l3.82-5.23c.5-.7 1.67-1.2 2.65-1.13l16.82 1.15c1.59.11 2.38 1 1.68 1.95l-5.46 7.5c-.93 1.22-2.62 1.53-4.12 1.17Z",
    fill: "url(#ak)"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "m73.02 24.9-14.67-3.57c-.98-.24-1.3-1.05-.73-1.82l3.82-5.25c.5-.69 1.66-1.18 2.65-1.12l16.83 1.15c1.58.1 2.36 1 1.67 1.94l-5.47 7.5c-.92 1.22-2.61 1.54-4.1 1.17Z",
    fill: "url(#al)"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "m73.02 24.9-14.67-3.58c-.98-.24-1.3-1.04-.73-1.81l3.83-5.25a3.25 3.25 0 0 1 2.63-1.12l16.85 1.15c1.57.1 2.35.99 1.66 1.93l-5.48 7.52c-.9 1.2-2.6 1.52-4.09 1.16Z",
    fill: "url(#am)"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "m73.03 24.9-14.69-3.58c-.98-.24-1.29-1.04-.73-1.8l3.84-5.27a3.23 3.23 0 0 1 2.62-1.1l16.86 1.14c1.57.1 2.34.99 1.66 1.93l-5.49 7.53c-.89 1.17-2.59 1.51-4.07 1.15Z",
    fill: "url(#an)"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "m73.04 24.9-14.7-3.59c-.98-.23-1.28-1.03-.73-1.8l3.85-5.27a3.22 3.22 0 0 1 2.6-1.1l16.88 1.15c1.56.1 2.33.98 1.65 1.92l-5.5 7.54c-.88 1.16-2.58 1.5-4.05 1.15Z",
    fill: "url(#ao)"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M73.05 24.9 58.33 21.3c-.97-.23-1.28-1.03-.72-1.79l3.85-5.28a3.2 3.2 0 0 1 2.6-1.1l16.88 1.16c1.56.1 2.32.97 1.64 1.9l-5.5 7.56c-.86 1.14-2.57 1.5-4.03 1.14Z",
    fill: "url(#ap)"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "m73.06 24.9-14.73-3.6c-.97-.23-1.27-1.02-.72-1.78l3.86-5.29a3.18 3.18 0 0 1 2.57-1.09l16.91 1.15c1.54.11 2.3.97 1.63 1.9l-5.51 7.57c-.85 1.13-2.55 1.49-4.01 1.13Z",
    fill: "url(#aq)"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "m73.06 24.9-14.74-3.6c-.96-.23-1.27-1.02-.71-1.77l3.86-5.3a3.16 3.16 0 0 1 2.57-1.09l16.92 1.15c1.53.11 2.3.97 1.62 1.9l-5.52 7.57c-.84 1.11-2.54 1.49-4 1.13Z",
    fill: "url(#ar)"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "m73.07 24.89-14.76-3.6c-.95-.23-1.26-1-.7-1.76l3.86-5.3a3.16 3.16 0 0 1 2.56-1.1l16.93 1.16c1.53.1 2.29.96 1.62 1.88l-5.54 7.6c-.82 1.09-2.52 1.47-3.97 1.12Z",
    fill: "url(#as)"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "m73.08 24.89-14.77-3.6c-.95-.23-1.26-1-.7-1.76l3.87-5.31a3.14 3.14 0 0 1 2.54-1.08l16.95 1.15c1.52.1 2.27.96 1.6 1.87l-5.54 7.6c-.8 1.09-2.51 1.48-3.95 1.13Z",
    fill: "url(#at)"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "m73.09 24.89-14.79-3.6c-.94-.24-1.24-1-.7-1.75l3.88-5.33a3.12 3.12 0 0 1 2.53-1.07l16.97 1.16c1.51.1 2.26.95 1.6 1.86l-5.56 7.6c-.79 1.07-2.5 1.47-3.93 1.13Z",
    fill: "url(#au)"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "m73.1 24.89-14.8-3.6c-.94-.24-1.24-1-.7-1.75l3.9-5.34a3.1 3.1 0 0 1 2.5-1.06l16.98 1.16c1.51.1 2.25.94 1.6 1.85l-5.56 7.62c-.79 1.05-2.5 1.46-3.93 1.12Z",
    fill: "url(#av)"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "m73.1 24.88-14.81-3.6c-.94-.23-1.24-1-.7-1.74l3.9-5.34a3.09 3.09 0 0 1 2.5-1.07l17 1.16c1.5.1 2.24.94 1.58 1.84L77 23.77c-.77 1.04-2.48 1.46-3.9 1.11Z",
    fill: "url(#aw)"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M73.11 24.88 58.3 21.27c-.94-.23-1.24-.99-.7-1.73l3.9-5.35a3.07 3.07 0 0 1 2.5-1.06l17 1.16c1.5.1 2.23.94 1.58 1.84l-5.58 7.65c-.75 1.01-2.47 1.44-3.88 1.1Z",
    fill: "url(#ax)"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "m73.12 24.88-14.84-3.61c-.93-.23-1.22-.99-.69-1.72l3.91-5.37a3.05 3.05 0 0 1 2.48-1.05L81 14.3c1.49.1 2.22.94 1.57 1.83l-5.59 7.66c-.74 1-2.46 1.44-3.86 1.1Z",
    fill: "url(#ay)"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "m73.12 24.87-14.85-3.6c-.92-.23-1.22-.99-.69-1.72l3.93-5.37a3.04 3.04 0 0 1 2.46-1.05L81 14.29c1.47.1 2.2.93 1.56 1.81l-5.6 7.68c-.73.99-2.44 1.43-3.85 1.1Z",
    fill: "url(#az)"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "m73.13 24.87-14.86-3.61c-.92-.23-1.22-.98-.69-1.7l3.93-5.39a3.02 3.02 0 0 1 2.45-1.04l17.05 1.17c1.48.1 2.2.92 1.56 1.8l-5.61 7.69c-.71.97-2.43 1.42-3.83 1.08Z",
    fill: "url(#aA)"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "m73.14 24.87-14.88-3.62c-.91-.22-1.2-.97-.68-1.7l3.94-5.39a3 3 0 0 1 2.43-1.03l17.07 1.16c1.46.1 2.18.92 1.54 1.8l-5.61 7.7c-.7.95-2.42 1.42-3.8 1.08Z",
    fill: "url(#aB)"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "m73.15 24.87-14.9-3.62c-.9-.22-1.2-.97-.67-1.69l3.94-5.4a3 3 0 0 1 2.43-1.03l17.08 1.17c1.45.1 2.17.9 1.53 1.78l-5.62 7.71c-.69.94-2.41 1.41-3.8 1.08Z",
    fill: "url(#aC)"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "m73.16 24.86-14.9-3.62c-.91-.22-1.2-.96-.68-1.68l3.95-5.41a2.98 2.98 0 0 1 2.4-1.02l17.1 1.16c1.45.1 2.16.91 1.53 1.78l-5.63 7.73c-.67.92-2.4 1.4-3.77 1.06Z",
    fill: "url(#aD)"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 21.35 58.2 20c-1.18-.1-1.74-.94-1.3-1.9l2.5-5.49c.38-.83 1.53-1.54 2.63-1.63L78.6 9.67c1.74-.14 2.88.67 2.44 1.8l-3.14 7.89c-.78 1.8-2.42 2.15-4.2 2Z",
    fill: "#5B71C1"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 21.35 58.2 20c-1.17-.1-1.73-.94-1.3-1.9l2.52-5.5c.38-.82 1.52-1.53 2.61-1.62L78.6 9.67c1.74-.14 2.87.67 2.43 1.8l-3.14 7.9c-.77 1.77-2.41 2.13-4.18 1.98Z",
    fill: "url(#aE)"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "m73.71 21.35-15.53-1.36c-1.16-.1-1.72-.93-1.29-1.88l2.52-5.51c.37-.82 1.51-1.53 2.6-1.62l16.6-1.31c1.73-.14 2.86.67 2.41 1.78l-3.14 7.92c-.76 1.75-2.4 2.13-4.17 1.98Z",
    fill: "url(#aF)"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M73.72 21.34 58.18 20c-1.16-.1-1.71-.93-1.29-1.87l2.52-5.53c.38-.81 1.5-1.52 2.6-1.6l16.6-1.32c1.73-.14 2.85.66 2.4 1.77l-3.14 7.93c-.75 1.74-2.4 2.12-4.15 1.97Z",
    fill: "url(#aG)"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "m73.73 21.34-15.56-1.35c-1.15-.1-1.7-.93-1.28-1.87l2.53-5.53c.37-.82 1.5-1.52 2.58-1.6l16.62-1.32c1.72-.14 2.84.66 2.4 1.76l-3.15 7.95c-.75 1.72-2.4 2.11-4.14 1.96Z",
    fill: "url(#aH)"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "m73.74 21.34-15.58-1.36c-1.14-.1-1.7-.92-1.27-1.86l2.53-5.54c.37-.81 1.5-1.51 2.57-1.6l16.64-1.32c1.7-.13 2.82.66 2.38 1.76l-3.16 7.96c-.73 1.7-2.37 2.1-4.11 1.96Z",
    fill: "url(#aI)"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "m73.74 21.33-15.58-1.35c-1.15-.1-1.7-.92-1.27-1.85l2.53-5.56c.37-.8 1.49-1.5 2.56-1.59l16.65-1.32c1.7-.13 2.81.66 2.38 1.76l-3.17 7.97c-.72 1.68-2.36 2.1-4.1 1.94Z",
    fill: "url(#aJ)"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "m73.75 21.33-15.6-1.35c-1.14-.1-1.68-.92-1.26-1.84l2.54-5.57c.36-.8 1.47-1.5 2.54-1.58l16.67-1.32c1.7-.14 2.8.65 2.36 1.74l-3.17 7.99c-.71 1.66-2.35 2.08-4.08 1.93Z",
    fill: "url(#aK)"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "m73.76 21.33-15.62-1.36c-1.13-.1-1.67-.91-1.25-1.83l2.54-5.58c.37-.8 1.47-1.49 2.54-1.57l16.68-1.33c1.68-.13 2.78.66 2.35 1.74l-3.18 8c-.7 1.64-2.34 2.08-4.06 1.93Z",
    fill: "url(#aL)"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "m73.77 21.32-15.63-1.35c-1.13-.1-1.67-.9-1.25-1.83l2.54-5.58c.37-.8 1.47-1.49 2.53-1.57l16.69-1.32c1.68-.14 2.77.65 2.34 1.73l-3.18 8c-.7 1.63-2.33 2.07-4.04 1.92Z",
    fill: "url(#aM)"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "m73.77 21.32-15.64-1.36c-1.13-.1-1.66-.9-1.25-1.82l2.56-5.6c.36-.79 1.45-1.47 2.5-1.56l16.71-1.32c1.68-.13 2.76.65 2.34 1.72L77.8 19.4c-.69 1.61-2.32 2.07-4.03 1.92Z",
    fill: "url(#aN)"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "m73.78 21.32-15.66-1.36c-1.12-.1-1.65-.9-1.24-1.81l2.56-5.6c.36-.8 1.45-1.48 2.5-1.56l16.72-1.33c1.67-.13 2.75.65 2.32 1.72L77.8 19.4c-.68 1.6-2.31 2.05-4.01 1.9Z",
    fill: "url(#aO)"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M73.79 21.31 58.1 19.95c-1.1-.1-1.64-.9-1.23-1.8l2.56-5.62c.36-.78 1.45-1.46 2.5-1.54l16.73-1.33c1.66-.13 2.74.64 2.31 1.7l-3.2 8.06c-.67 1.57-2.3 2.04-4 1.9Z",
    fill: "url(#aP)"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "m73.8 21.3-15.7-1.35c-1.1-.1-1.63-.89-1.22-1.8l2.57-5.62c.35-.78 1.43-1.46 2.47-1.54l16.76-1.33c1.65-.13 2.72.64 2.3 1.7l-3.2 8.06c-.67 1.55-2.3 2.04-3.99 1.89Z",
    fill: "url(#aQ)"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "m73.8 21.3-15.7-1.35c-1.1-.1-1.63-.9-1.22-1.8l2.57-5.63c.35-.78 1.43-1.45 2.47-1.53l16.76-1.33c1.65-.13 2.71.63 2.3 1.69l-3.21 8.07c-.66 1.54-2.3 2.03-3.97 1.88Z",
    fill: "url(#aR)"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "m73.8 21.3-15.7-1.36c-1.1-.1-1.63-.88-1.22-1.78l2.57-5.65c.36-.77 1.43-1.44 2.46-1.52l16.78-1.33c1.64-.13 2.7.63 2.28 1.68l-3.22 8.1c-.64 1.5-2.27 2-3.94 1.86Z",
    fill: "url(#aS)"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M73.81 21.3 58.1 19.94c-1.1-.1-1.62-.88-1.22-1.78l2.59-5.66c.35-.76 1.41-1.43 2.44-1.51l16.8-1.33c1.62-.13 2.68.62 2.27 1.67l-3.23 8.1c-.63 1.5-2.26 2.01-3.93 1.87Z",
    fill: "url(#aT)"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "m73.82 21.3-15.74-1.37c-1.09-.09-1.61-.87-1.2-1.76l2.58-5.67c.35-.77 1.4-1.43 2.43-1.51L78.7 9.66c1.62-.13 2.67.62 2.26 1.66l-3.22 8.12c-.63 1.48-2.26 2-3.92 1.85Z",
    fill: "url(#aU)"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "m73.83 21.3-15.76-1.37c-1.08-.09-1.6-.87-1.2-1.75l2.6-5.68c.34-.77 1.4-1.43 2.41-1.5l16.83-1.34c1.61-.13 2.66.62 2.25 1.66l-3.23 8.13c-.62 1.46-2.25 1.99-3.9 1.85Z",
    fill: "url(#aV)"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "m73.84 21.29-15.77-1.36c-1.08-.1-1.6-.87-1.2-1.75l2.6-5.7c.34-.75 1.4-1.41 2.4-1.5l16.84-1.33c1.61-.12 2.65.62 2.24 1.65l-3.23 8.15c-.61 1.44-2.24 1.98-3.88 1.84Z",
    fill: "url(#aW)"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "m73.84 21.29-15.78-1.37c-1.08-.09-1.59-.86-1.2-1.74l2.61-5.7c.34-.75 1.4-1.4 2.4-1.49l16.85-1.34c1.6-.12 2.64.62 2.23 1.65l-3.25 8.15c-.6 1.43-2.22 1.98-3.86 1.84Z",
    fill: "url(#aX)"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "m73.85 21.28-15.8-1.36c-1.07-.1-1.58-.86-1.18-1.74l2.6-5.71c.35-.75 1.39-1.4 2.4-1.48l16.86-1.34c1.6-.13 2.62.62 2.22 1.63l-3.25 8.18c-.6 1.4-2.22 1.96-3.85 1.82Z",
    fill: "url(#aY)"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "m73.86 21.28-15.81-1.36c-1.07-.1-1.58-.86-1.18-1.73l2.6-5.72c.35-.75 1.39-1.4 2.38-1.48l16.88-1.34c1.59-.12 2.62.61 2.21 1.63l-3.26 8.18c-.58 1.39-2.2 1.96-3.82 1.82Z",
    fill: "url(#aZ)"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "m73.86 21.27-15.82-1.36c-1.06-.09-1.57-.85-1.18-1.72l2.62-5.73c.34-.74 1.37-1.39 2.36-1.47l16.9-1.34c1.58-.12 2.6.61 2.2 1.62l-3.26 8.2c-.58 1.36-2.2 1.94-3.82 1.8Z",
    fill: "url(#ba)"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "m73.87 21.27-15.84-1.36c-1.05-.1-1.56-.85-1.17-1.71l2.62-5.75c.34-.74 1.37-1.38 2.35-1.46l16.91-1.34c1.57-.12 2.6.6 2.2 1.61l-3.27 8.21c-.57 1.35-2.19 1.94-3.8 1.8Z",
    fill: "url(#bb)"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M73.88 21.27 58.03 19.9c-1.06-.09-1.56-.85-1.17-1.7l2.63-5.76c.33-.73 1.35-1.37 2.34-1.45l16.92-1.34c1.57-.13 2.58.6 2.18 1.6l-3.27 8.23c-.56 1.33-2.18 1.93-3.78 1.79Z",
    fill: "url(#bc)"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M73.89 21.27 58.02 19.9c-1.05-.09-1.55-.84-1.16-1.7l2.63-5.76c.33-.73 1.35-1.37 2.33-1.45l16.94-1.34c1.55-.12 2.56.6 2.16 1.6l-3.27 8.23c-.55 1.31-2.17 1.92-3.76 1.79Z",
    fill: "url(#bd)"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9 21.26 58 19.9c-1.04-.1-1.54-.84-1.15-1.7l2.63-5.77c.33-.73 1.35-1.36 2.32-1.44l16.95-1.34c1.55-.12 2.55.6 2.16 1.59l-3.28 8.25c-.54 1.3-2.16 1.9-3.75 1.77Z",
    fill: "url(#be)"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9 21.26 58 19.89c-1.03-.09-1.53-.83-1.15-1.68l2.64-5.78c.33-.73 1.34-1.36 2.3-1.44l16.98-1.34c1.54-.13 2.54.59 2.14 1.58l-3.28 8.26c-.53 1.28-2.15 1.9-3.73 1.77Z",
    fill: "url(#bf)"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9 21.25 58 19.9c-1.03-.1-1.53-.84-1.14-1.68l2.64-5.8c.33-.72 1.33-1.34 2.3-1.42l16.97-1.35c1.54-.12 2.53.6 2.14 1.58l-3.3 8.27c-.51 1.26-2.13 1.9-3.7 1.76Z",
    fill: "url(#bg)"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M73.91 21.25 58 19.88c-1.03-.08-1.52-.82-1.14-1.66l2.65-5.8c.33-.73 1.33-1.35 2.28-1.43l17-1.34c1.53-.12 2.51.58 2.12 1.56l-3.3 8.29c-.5 1.24-2.12 1.89-3.69 1.75Z",
    fill: "url(#bh)"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "m73.92 21.25-15.94-1.37c-1.02-.09-1.5-.82-1.13-1.65l2.65-5.82c.33-.72 1.32-1.34 2.27-1.41L78.8 9.65c1.51-.12 2.5.58 2.11 1.56l-3.3 8.3c-.5 1.22-2.12 1.87-3.68 1.74Z",
    fill: "url(#bi)"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "m73.93 21.24-15.95-1.36c-1.02-.1-1.5-.82-1.13-1.65l2.66-5.83c.32-.71 1.3-1.33 2.26-1.4l17.02-1.35c1.51-.12 2.5.58 2.1 1.54l-3.3 8.32c-.5 1.2-2.1 1.87-3.66 1.73Z",
    fill: "url(#bj)"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "m73.93 21.24-15.96-1.37c-1.01-.08-1.5-.81-1.12-1.64l2.66-5.84c.32-.7 1.3-1.32 2.25-1.4L78.8 9.66c1.5-.12 2.47.58 2.1 1.54l-3.33 8.33c-.48 1.18-2.09 1.85-3.64 1.72Z",
    fill: "url(#bk)"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "m73.94 21.24-15.98-1.37c-1-.09-1.49-.81-1.11-1.64l2.66-5.84c.33-.7 1.3-1.32 2.24-1.4L78.8 9.66c1.5-.12 2.46.57 2.08 1.53l-3.32 8.34c-.48 1.16-2.09 1.85-3.63 1.72Z",
    fill: "url(#bl)"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "m73.95 21.24-16-1.37c-1-.1-1.48-.81-1.1-1.63l2.67-5.86c.32-.7 1.29-1.3 2.22-1.38l17.07-1.35c1.49-.12 2.45.57 2.07 1.52l-3.32 8.35c-.47 1.15-2.08 1.84-3.61 1.72Z",
    fill: "url(#bm)"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "m73.96 21.23-16.01-1.37c-1-.09-1.48-.8-1.1-1.62l2.67-5.87c.32-.7 1.29-1.3 2.21-1.37l17.09-1.36c1.48-.12 2.44.57 2.06 1.52l-3.33 8.37c-.46 1.13-2.07 1.83-3.6 1.7Z",
    fill: "url(#bn)"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "m73.96 21.23-16.02-1.37c-.99-.09-1.47-.8-1.1-1.61l2.69-5.89c.31-.69 1.27-1.29 2.2-1.36l17.1-1.36c1.47-.12 2.42.57 2.05 1.51l-3.34 8.38c-.45 1.11-2.06 1.83-3.58 1.7Z",
    fill: "url(#bo)"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "m73.97 21.22-16.03-1.37c-1-.08-1.47-.8-1.1-1.6l2.69-5.9c.31-.68 1.27-1.28 2.19-1.35l17.1-1.36c1.48-.12 2.42.56 2.05 1.5l-3.34 8.4c-.44 1.09-2.05 1.81-3.56 1.68Z",
    fill: "url(#bp)"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "m73.98 21.22-16.05-1.37c-.98-.09-1.46-.8-1.09-1.6l2.7-5.9c.3-.68 1.26-1.28 2.17-1.35l17.13-1.36c1.46-.11 2.4.56 2.03 1.5l-3.35 8.4c-.43 1.07-2.04 1.8-3.54 1.68Z",
    fill: "url(#bq)"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "m73.99 21.22-16.07-1.38c-.98-.08-1.45-.78-1.08-1.58l2.7-5.92c.3-.68 1.25-1.27 2.16-1.34l17.15-1.36c1.45-.12 2.39.56 2.02 1.48l-3.36 8.43c-.42 1.05-2.03 1.8-3.52 1.67Z",
    fill: "url(#br)"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "m74 21.21-16.08-1.37c-.98-.08-1.45-.78-1.08-1.58l2.7-5.92c.3-.68 1.25-1.27 2.15-1.34l17.16-1.36c1.45-.12 2.38.55 2.01 1.48l-3.36 8.43c-.41 1.04-2.02 1.79-3.5 1.66Z",
    fill: "url(#bs)"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "m73.33 17.86-15.77.9c-1.2.07-1.91-.75-1.65-1.85l1.48-6.17c.21-.9 1.2-1.8 2.27-2.06l15.72-3.65c1.63-.38 2.9.28 2.75 1.47L77 15.1c-.15 1.89-1.82 2.68-3.67 2.76Z",
    fill: "#586ABF"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "m73.34 17.86-15.79.9c-1.19.07-1.9-.75-1.65-1.84l1.49-6.18c.21-.91 1.2-1.8 2.26-2.05l15.73-3.66c1.63-.38 2.9.27 2.74 1.46L77 15.11c-.15 1.87-1.81 2.67-3.65 2.75Z",
    fill: "url(#bt)"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "m73.35 17.86-15.8.9c-1.2.07-1.9-.75-1.65-1.83l1.49-6.2c.21-.9 1.2-1.8 2.25-2.04L75.4 5.03c1.62-.38 2.88.27 2.73 1.46l-1.14 8.63c-.15 1.85-1.8 2.65-3.63 2.74Z",
    fill: "url(#bu)"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "m73.35 17.85-15.81.9c-1.19.07-1.9-.75-1.64-1.82l1.5-6.2c.2-.9 1.18-1.8 2.23-2.04L75.4 5.02c1.62-.37 2.87.28 2.72 1.46l-1.14 8.65c-.15 1.83-1.8 2.64-3.62 2.72Z",
    fill: "url(#bv)"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "m73.36 17.84-15.82.91c-1.18.07-1.9-.74-1.63-1.82l1.49-6.22c.21-.89 1.19-1.78 2.23-2.02L75.4 5.02c1.61-.37 2.86.28 2.71 1.45l-1.14 8.66c-.16 1.82-1.8 2.63-3.6 2.71Z",
    fill: "url(#bw)"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "m73.37 17.84-15.84.9c-1.18.08-1.88-.73-1.63-1.8l1.5-6.23c.21-.9 1.18-1.78 2.22-2.02l15.79-3.67c1.6-.37 2.85.27 2.7 1.44l-1.15 8.68c-.16 1.8-1.8 2.62-3.6 2.7Z",
    fill: "url(#bx)"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "m73.37 17.83-15.85.91c-1.17.07-1.87-.74-1.62-1.8l1.5-6.24c.21-.89 1.18-1.77 2.21-2l15.8-3.68c1.6-.37 2.84.27 2.69 1.43l-1.15 8.7c-.15 1.77-1.78 2.6-3.58 2.68Z",
    fill: "url(#by)"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "m73.38 17.83-15.87.91c-1.16.07-1.86-.73-1.6-1.8l1.5-6.25c.2-.88 1.17-1.75 2.2-2l15.8-3.67c1.6-.37 2.83.27 2.68 1.42l-1.15 8.71c-.15 1.76-1.78 2.6-3.56 2.68Z",
    fill: "url(#bz)"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "m73.38 17.82-15.88.92c-1.16.06-1.85-.73-1.6-1.8l1.5-6.26c.21-.88 1.17-1.75 2.2-1.98l15.82-3.68c1.58-.37 2.81.26 2.66 1.42l-1.15 8.72c-.15 1.74-1.77 2.58-3.55 2.66Z",
    fill: "url(#bA)"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "m73.4 17.82-15.9.91c-1.16.07-1.85-.73-1.6-1.78l1.5-6.27c.22-.88 1.17-1.75 2.2-1.98L75.42 5c1.57-.36 2.8.27 2.65 1.41l-1.15 8.74c-.16 1.73-1.77 2.58-3.54 2.66Z",
    fill: "url(#bB)"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "m73.4 17.82-15.91.91c-1.15.07-1.84-.72-1.6-1.77l1.52-6.3c.2-.86 1.15-1.73 2.17-1.96L75.43 5c1.57-.36 2.79.27 2.64 1.4l-1.16 8.76c-.15 1.7-1.75 2.56-3.51 2.65Z",
    fill: "url(#bC)"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "m73.4 17.81-15.92.92c-1.15.06-1.83-.73-1.58-1.77l1.5-6.3c.21-.87 1.16-1.72 2.17-1.96l15.87-3.69c1.56-.36 2.77.27 2.62 1.4l-1.15 8.77c-.16 1.69-1.75 2.55-3.5 2.63Z",
    fill: "url(#bD)"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "m73.41 17.8-15.94.92c-1.14.07-1.82-.72-1.57-1.75l1.51-6.32c.2-.86 1.14-1.71 2.15-1.95L75.45 5c1.55-.35 2.76.27 2.6 1.4l-1.15 8.78c-.16 1.67-1.75 2.54-3.49 2.63Z",
    fill: "url(#bE)"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "m73.42 17.8-15.95.92c-1.14.07-1.82-.71-1.57-1.75l1.51-6.32c.21-.86 1.14-1.71 2.15-1.95L75.46 5c1.54-.35 2.74.27 2.6 1.4l-1.17 8.79c-.15 1.66-1.74 2.53-3.47 2.61Z",
    fill: "url(#bF)"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "m73.42 17.8-15.96.92c-1.13.06-1.81-.72-1.57-1.75l1.52-6.33c.2-.86 1.14-1.7 2.14-1.94L75.45 5c1.55-.36 2.74.26 2.6 1.38l-1.17 8.81c-.15 1.64-1.73 2.52-3.46 2.6Z",
    fill: "url(#bG)"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "m73.43 17.8-15.98.91c-1.13.07-1.8-.7-1.56-1.73l1.53-6.35c.2-.85 1.13-1.7 2.12-1.92L75.46 5c1.54-.36 2.73.25 2.58 1.37l-1.17 8.82c-.15 1.62-1.72 2.51-3.44 2.6Z",
    fill: "url(#bH)"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "m73.44 17.79-16 .92c-1.12.07-1.79-.7-1.55-1.72l1.53-6.36c.2-.85 1.12-1.69 2.11-1.92l15.94-3.7c1.53-.36 2.71.25 2.56 1.36l-1.16 8.84c-.16 1.6-1.72 2.5-3.43 2.58Z",
    fill: "url(#bI)"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "m73.44 17.78-16 .93c-1.12.06-1.8-.7-1.55-1.72l1.53-6.37c.2-.84 1.12-1.68 2.1-1.9L75.47 5c1.52-.35 2.7.26 2.55 1.36l-1.17 8.86c-.15 1.58-1.7 2.48-3.41 2.56Z",
    fill: "url(#bJ)"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "m73.45 17.78-16.02.93c-1.11.06-1.78-.7-1.54-1.72l1.53-6.38c.2-.84 1.12-1.67 2.1-1.9L75.48 5c1.51-.35 2.69.25 2.54 1.35l-1.17 8.87c-.16 1.57-1.7 2.47-3.4 2.56Z",
    fill: "url(#bK)"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "m73.45 17.77-16.03.93c-1.1.07-1.77-.7-1.53-1.7l1.54-6.4c.2-.83 1.1-1.66 2.08-1.89L75.49 5c1.5-.35 2.67.25 2.53 1.34l-1.18 8.89c-.16 1.55-1.7 2.46-3.39 2.54Z",
    fill: "url(#bL)"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "m73.46 17.77-16.05.93c-1.1.06-1.76-.7-1.52-1.7l1.54-6.4c.2-.84 1.1-1.66 2.07-1.89L75.49 5c1.5-.34 2.66.26 2.52 1.34l-1.18 8.9c-.16 1.53-1.7 2.45-3.37 2.54Z",
    fill: "url(#bM)"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "m73.47 17.76-16.07.94c-1.1.06-1.75-.7-1.51-1.7l1.54-6.41c.2-.83 1.1-1.65 2.06-1.87l16-3.72c1.5-.35 2.65.25 2.51 1.33l-1.18 8.91c-.15 1.52-1.69 2.44-3.35 2.52Z",
    fill: "url(#bN)"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "m73.47 17.76-16.07.93c-1.1.07-1.75-.68-1.51-1.68l1.54-6.43c.2-.82 1.1-1.63 2.05-1.86L75.5 5c1.48-.35 2.64.25 2.5 1.32l-1.19 8.93c-.15 1.5-1.68 2.42-3.34 2.5Z",
    fill: "url(#bO)"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "m73.48 17.75-16.1.94c-1.08.06-1.73-.69-1.5-1.68l1.55-6.44c.2-.82 1.09-1.63 2.05-1.85L75.5 5c1.48-.34 2.62.25 2.48 1.32l-1.18 8.94c-.16 1.48-1.68 2.42-3.33 2.5Z",
    fill: "url(#bP)"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "m73.48 17.75-16.1.94c-1.08.06-1.73-.69-1.5-1.67l1.55-6.45c.2-.82 1.08-1.63 2.03-1.85L75.51 5c1.47-.34 2.61.25 2.47 1.31l-1.18 8.96c-.16 1.46-1.67 2.4-3.32 2.49Z",
    fill: "url(#bQ)"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "m73.5 17.74-16.13.94c-1.07.07-1.72-.68-1.48-1.66l1.55-6.46c.2-.81 1.07-1.62 2.02-1.84L75.52 5c1.46-.34 2.6.24 2.46 1.3l-1.2 8.98c-.15 1.44-1.66 2.39-3.29 2.47Z",
    fill: "url(#bR)"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "m73.5 17.74-16.13.94c-1.08.06-1.72-.68-1.48-1.65l1.55-6.48c.2-.8 1.07-1.6 2.01-1.82l16.08-3.74c1.45-.34 2.58.24 2.44 1.3l-1.19 8.98c-.16 1.43-1.66 2.39-3.28 2.47Z",
    fill: "url(#bS)"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "m73.5 17.74-16.14.94c-1.07.06-1.71-.68-1.48-1.65l1.56-6.49c.19-.8 1.06-1.6 2-1.81l16.09-3.74c1.45-.34 2.57.24 2.43 1.3l-1.2 9c-.14 1.4-1.64 2.36-3.26 2.45Z",
    fill: "url(#bT)"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "m73.51 17.73-16.16.94c-1.06.07-1.7-.66-1.47-1.63l1.56-6.5c.2-.8 1.06-1.6 2-1.8l16.1-3.75c1.44-.34 2.56.24 2.42 1.28l-1.2 9.02c-.15 1.39-1.64 2.35-3.25 2.44Z",
    fill: "url(#bU)"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "m73.52 17.72-16.18.95c-1.05.06-1.69-.67-1.46-1.63l1.56-6.51c.2-.8 1.06-1.59 1.99-1.8l16.12-3.75c1.43-.33 2.54.24 2.4 1.28l-1.2 9.03c-.15 1.38-1.63 2.35-3.23 2.43Z",
    fill: "url(#bV)"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "m73.52 17.72-16.19.95c-1.05.06-1.68-.67-1.45-1.63l1.56-6.52c.2-.79 1.05-1.57 1.98-1.79l16.13-3.75c1.42-.33 2.53.24 2.4 1.28l-1.2 9.04c-.16 1.36-1.63 2.33-3.23 2.42Z",
    fill: "url(#bW)"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "m73.53 17.72-16.2.94c-1.05.07-1.68-.65-1.45-1.61l1.57-6.53c.19-.8 1.04-1.57 1.96-1.79l16.14-3.75c1.42-.33 2.53.24 2.39 1.27l-1.2 9.05c-.16 1.34-1.63 2.33-3.21 2.42Z",
    fill: "url(#bX)"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "m73.54 17.71-16.22.95c-1.04.06-1.67-.66-1.44-1.6l1.57-6.55c.19-.79 1.04-1.56 1.95-1.78l16.16-3.75c1.41-.33 2.5.23 2.37 1.26l-1.2 9.07c-.16 1.32-1.62 2.31-3.2 2.4Z",
    fill: "url(#bY)"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "m73.54 17.7-16.23.96c-1.04.06-1.66-.66-1.43-1.6l1.57-6.56c.19-.78 1.04-1.55 1.94-1.76l16.18-3.77c1.4-.32 2.5.24 2.36 1.26l-1.21 9.09c-.16 1.3-1.61 2.3-3.18 2.39Z",
    fill: "url(#bZ)"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "m73.55 17.7-16.25.96c-1.03.06-1.65-.65-1.42-1.6l1.57-6.56c.19-.78 1.03-1.55 1.93-1.76l16.19-3.76c1.4-.33 2.49.23 2.35 1.25l-1.21 9.1c-.15 1.28-1.6 2.29-3.16 2.37Z",
    fill: "url(#ca)"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "m73.55 17.7-16.25.95c-1.03.06-1.65-.65-1.42-1.59l1.58-6.58c.18-.77 1.02-1.53 1.92-1.74l16.2-3.77c1.4-.32 2.47.23 2.34 1.24l-1.21 9.12c-.16 1.27-1.6 2.28-3.16 2.37Z",
    fill: "url(#cb)"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "m73.56 17.7-16.27.95c-1.02.06-1.64-.65-1.41-1.58l1.58-6.6c.18-.76 1.02-1.52 1.9-1.73l16.22-3.77c1.39-.32 2.46.23 2.33 1.24l-1.21 9.13c-.16 1.25-1.6 2.26-3.14 2.35Z",
    fill: "url(#cc)"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "m73.57 17.69-16.29.96c-1.02.06-1.63-.65-1.4-1.58l1.58-6.6c.18-.76 1.01-1.52 1.9-1.73l16.23-3.77c1.38-.32 2.45.23 2.31 1.23l-1.22 9.14c-.15 1.24-1.58 2.26-3.11 2.35Z",
    fill: "url(#cd)"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "m73.57 17.68-16.3.96c-1 .06-1.61-.64-1.4-1.56l1.6-6.62c.18-.76 1-1.5 1.89-1.71L75.6 4.97c1.37-.32 2.43.23 2.3 1.22l-1.22 9.16c-.16 1.22-1.58 2.25-3.1 2.33Z",
    fill: "url(#ce)"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "m73.58 17.68-16.31.96c-1.01.06-1.62-.64-1.4-1.56l1.6-6.62c.17-.76 1-1.5 1.88-1.71L75.6 4.97c1.37-.32 2.42.22 2.3 1.21l-1.23 9.18c-.16 1.2-1.57 2.23-3.1 2.32Z",
    fill: "url(#cf)"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "m73.58 17.68-16.32.96c-1 .06-1.6-.63-1.39-1.55l1.6-6.64c.17-.75 1-1.5 1.87-1.7L75.6 4.97c1.36-.32 2.4.23 2.28 1.2l-1.23 9.2c-.15 1.18-1.57 2.22-3.08 2.3Z",
    fill: "url(#cg)"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "m73.6 17.67-16.35.96c-1 .06-1.6-.63-1.38-1.54l1.6-6.65c.18-.75.99-1.49 1.86-1.7l16.28-3.78c1.35-.31 2.4.23 2.27 1.2l-1.23 9.2c-.15 1.17-1.56 2.22-3.06 2.3Z",
    fill: "url(#ch)"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "m72.33 15.18-16.34 2.64c-1.34.21-2.16-.68-1.88-2l1.52-7.24a3.63 3.63 0 0 1 2.4-2.45l15.45-4.59c1.48-.44 2.68.18 2.62 1.4l-.46 8.97c-.08 1.5-1.6 3-3.31 3.27Z",
    fill: "#515EBD"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "m72.33 15.17-16.35 2.64c-1.33.21-2.15-.68-1.87-1.99l1.53-7.25a3.6 3.6 0 0 1 2.39-2.44l15.45-4.59c1.47-.43 2.67.18 2.6 1.38l-.46 9c-.08 1.49-1.58 2.97-3.3 3.25Z",
    fill: "#525FBE"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M72.33 15.16 55.97 17.8c-1.32.21-2.14-.68-1.86-1.98l1.53-7.27A3.59 3.59 0 0 1 58 6.14l15.47-4.6c1.46-.43 2.64.18 2.58 1.37l-.46 9.01c-.08 1.49-1.57 2.97-3.27 3.24Z",
    fill: "#5360BF"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "m72.32 15.15-16.36 2.64c-1.32.2-2.13-.67-1.85-1.96l1.53-7.3A3.56 3.56 0 0 1 58 6.14l15.48-4.59c1.45-.43 2.63.18 2.56 1.36l-.47 9.03c-.07 1.47-1.56 2.94-3.25 3.22Z",
    fill: "#5461BF"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "m72.32 15.13-16.37 2.65c-1.3.2-2.12-.67-1.84-1.95l1.53-7.3a3.54 3.54 0 0 1 2.34-2.39l15.5-4.6c1.43-.43 2.6.17 2.54 1.35l-.47 9.04c-.08 1.47-1.55 2.93-3.23 3.2Z",
    fill: "#5562C0"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "m72.32 15.12-16.39 2.65c-1.3.2-2.1-.66-1.83-1.94l1.55-7.31c.2-1.01 1.23-2.05 2.32-2.37l15.5-4.6c1.44-.43 2.6.17 2.54 1.33l-.48 9.06c-.08 1.46-1.54 2.91-3.2 3.18Z",
    fill: "#5663C1"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "m72.32 15.11-16.4 2.65c-1.29.2-2.09-.65-1.82-1.92l1.55-7.34a3.5 3.5 0 0 1 2.3-2.35l15.52-4.6c1.42-.43 2.58.17 2.52 1.33l-.48 9.07c-.08 1.45-1.53 2.9-3.19 3.16Z",
    fill: "#5764C2"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M72.32 15.1 55.9 17.74c-1.29.2-2.07-.65-1.8-1.91l1.54-7.35c.2-1 1.21-2.01 2.3-2.33l15.52-4.62c1.4-.42 2.55.17 2.5 1.33l-.49 9.09c-.07 1.44-1.52 2.87-3.16 3.13Z",
    fill: "#5865C3"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M72.32 15.08 55.9 17.74c-1.28.2-2.06-.65-1.8-1.9l1.55-7.36c.21-1 1.2-2 2.28-2.32l15.54-4.62c1.4-.42 2.54.17 2.48 1.32l-.48 9.1c-.08 1.44-1.52 2.86-3.15 3.12Z",
    fill: "#5965C4"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "m72.31 15.07-16.43 2.66c-1.26.2-2.04-.64-1.78-1.89l1.55-7.38c.21-.97 1.2-1.98 2.26-2.3l15.55-4.62c1.4-.41 2.52.17 2.46 1.3l-.48 9.14c-.07 1.41-1.5 2.83-3.13 3.1Z",
    fill: "#5A66C4"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "m72.31 15.06-16.44 2.66c-1.26.2-2.03-.64-1.77-1.87l1.56-7.4a3.4 3.4 0 0 1 2.24-2.29l15.56-4.62c1.39-.4 2.51.17 2.45 1.3l-.49 9.14c-.07 1.41-1.5 2.82-3.1 3.08Z",
    fill: "#5B67C5"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M72.31 15.05 55.86 17.7c-1.25.2-2.02-.63-1.76-1.86l1.56-7.41a3.38 3.38 0 0 1 2.23-2.27l15.57-4.63c1.37-.4 2.49.17 2.43 1.29l-.5 9.16c-.07 1.4-1.48 2.8-3.08 3.06Z",
    fill: "#5C68C6"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M72.31 15.03 55.84 17.7c-1.24.2-2-.63-1.74-1.85l1.56-7.42a3.35 3.35 0 0 1 2.22-2.26l15.58-4.63c1.36-.4 2.47.17 2.4 1.28L75.39 12c-.08 1.39-1.48 2.77-3.07 3.03Z",
    fill: "#5D69C7"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3 15.02 55.84 17.7c-1.23.2-2-.63-1.74-1.84l1.57-7.44a3.33 3.33 0 0 1 2.2-2.24l15.6-4.63c1.35-.4 2.45.16 2.39 1.26l-.5 9.2c-.07 1.38-1.46 2.76-3.04 3.01Z",
    fill: "#5E6AC8"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 15-16.48 2.68c-1.23.2-1.98-.62-1.73-1.82l1.57-7.46a3.3 3.3 0 0 1 2.19-2.22l15.6-4.64c1.35-.4 2.44.17 2.38 1.26l-.5 9.21c-.07 1.38-1.45 2.74-3.02 3Z",
    fill: "#5F6BC9"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 15-16.5 2.67c-1.21.2-1.96-.61-1.7-1.8l1.57-7.48c.2-.94 1.14-1.9 2.16-2.2l15.62-4.65c1.34-.4 2.42.16 2.36 1.25l-.5 9.23c-.07 1.36-1.45 2.72-3 2.98Z",
    fill: "#5F6CC9"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.98-16.5 2.68c-1.21.2-1.96-.6-1.7-1.8l1.57-7.48a3.26 3.26 0 0 1 2.15-2.2l15.63-4.64c1.32-.39 2.4.16 2.34 1.24l-.5 9.25c-.08 1.35-1.44 2.7-2.99 2.95Z",
    fill: "#606DCA"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.97-16.52 2.68c-1.2.2-1.94-.6-1.69-1.78l1.58-7.5a3.23 3.23 0 0 1 2.14-2.18l15.64-4.65c1.32-.4 2.38.16 2.32 1.23l-.5 9.26c-.08 1.35-1.43 2.69-2.97 2.94Z",
    fill: "#616ECB"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.96-16.53 2.69c-1.2.19-1.93-.6-1.68-1.78l1.58-7.52A3.2 3.2 0 0 1 57.8 6.2l15.65-4.65c1.3-.39 2.37.16 2.3 1.23l-.5 9.28c-.07 1.33-1.41 2.66-2.94 2.9Z",
    fill: "#626FCC"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.95-16.54 2.69c-1.19.19-1.92-.6-1.67-1.77l1.59-7.53a3.18 3.18 0 0 1 2.1-2.15l15.66-4.65c1.3-.38 2.35.16 2.3 1.22l-.52 9.3c-.07 1.32-1.4 2.64-2.92 2.89Z",
    fill: "#6370CD"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.93-16.56 2.7c-1.17.19-1.9-.6-1.65-1.75l1.6-7.55c.18-.9 1.1-1.84 2.08-2.13l15.67-4.65c1.29-.39 2.33.15 2.27 1.2l-.5 9.31c-.08 1.31-1.4 2.63-2.91 2.87Z",
    fill: "#6471CE"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.92-16.57 2.7c-1.17.19-1.89-.6-1.64-1.74l1.6-7.57c.18-.9 1.09-1.82 2.06-2.1l15.69-4.66c1.27-.38 2.3.15 2.25 1.2l-.51 9.32c-.07 1.3-1.39 2.6-2.88 2.85Z",
    fill: "#6572CE"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.9-16.58 2.7c-1.16.2-1.88-.58-1.63-1.72l1.6-7.58a3.11 3.11 0 0 1 2.05-2.1l15.7-4.66c1.26-.37 2.29.16 2.23 1.19l-.51 9.35c-.08 1.3-1.38 2.59-2.87 2.83Z",
    fill: "#6672CF"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.9-16.6 2.7c-1.14.19-1.85-.58-1.61-1.72l1.6-7.6a3.1 3.1 0 0 1 2.04-2.07l15.7-4.67c1.27-.37 2.28.16 2.23 1.18l-.52 9.36c-.08 1.29-1.37 2.57-2.85 2.81Z",
    fill: "#6773D0"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 14.88-16.6 2.7c-1.15.2-1.85-.57-1.62-1.7l1.6-7.6a3.07 3.07 0 0 1 2.03-2.07l15.72-4.67c1.25-.37 2.26.15 2.2 1.17l-.52 9.38c-.07 1.28-1.35 2.55-2.82 2.8Z",
    fill: "#6874D1"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "m72.29 14.87-16.61 2.7c-1.13.2-1.84-.56-1.6-1.68l1.61-7.63a3.04 3.04 0 0 1 2-2.04l15.74-4.68c1.24-.36 2.24.16 2.18 1.16l-.52 9.4c-.07 1.27-1.35 2.53-2.8 2.77Z",
    fill: "#6975D2"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "m72.29 14.86-16.62 2.7c-1.13.19-1.82-.56-1.59-1.67l1.61-7.64a3.02 3.02 0 0 1 2-2.03l15.73-4.68c1.23-.37 2.23.15 2.17 1.15l-.52 9.41c-.07 1.26-1.34 2.52-2.78 2.76Z",
    fill: "#6A76D3"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "m72.29 14.85-16.63 2.71c-1.12.18-1.81-.56-1.58-1.66l1.62-7.66a3 3 0 0 1 1.97-2.01l15.75-4.68c1.22-.37 2.21.14 2.15 1.14l-.52 9.43c-.07 1.25-1.33 2.5-2.76 2.73Z",
    fill: "#6B77D3"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "m72.28 14.83-16.64 2.72c-1.1.18-1.79-.56-1.56-1.65l1.62-7.68a2.97 2.97 0 0 1 1.96-2l15.76-4.68c1.21-.36 2.2.15 2.14 1.13l-.53 9.45c-.07 1.24-1.32 2.48-2.75 2.71Z",
    fill: "#6C78D4"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "m72.28 14.82-16.65 2.72c-1.1.18-1.78-.56-1.55-1.64l1.62-7.69a2.95 2.95 0 0 1 1.95-1.98l15.77-4.69c1.2-.36 2.17.15 2.12 1.12L75 12.13c-.08 1.23-1.32 2.46-2.73 2.69Z",
    fill: "#6D79D5"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "m72.28 14.82-16.65 2.72c-1.1.18-1.78-.56-1.55-1.64l1.62-7.69a2.95 2.95 0 0 1 1.95-1.98l15.77-4.69c1.2-.36 2.17.15 2.12 1.12L75 12.13c-.14 1.22-1.4 2.45-2.73 2.69Z",
    fill: "url(#ci)"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "m58.82 8.85-1.38.33c-.17.04-.28-.08-.24-.26l.2-1.02c.04-.18.2-.37.37-.42l1.37-.39c.18-.05.3.06.27.25l-.2 1.08c-.03.2-.2.4-.4.43Z",
    fill: "#A1AEE6"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "m58.8 8.85-1.37.33c-.16.04-.27-.08-.23-.27l.2-1.01c.03-.19.2-.37.36-.42l1.37-.4c.18-.04.3.07.27.26L59.2 8.4a.6.6 0 0 1-.4.44Z",
    fill: "#A8B5E8"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "m58.8 8.85-1.37.32c-.16.04-.27-.08-.23-.26l.2-1.01c.03-.18.2-.37.36-.41l1.36-.4c.18-.05.3.06.27.25l-.19 1.07c-.03.2-.21.4-.4.44Z",
    fill: "#AFBCEA"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "m58.8 8.84-1.37.33c-.16.04-.27-.08-.23-.27l.2-1c.04-.19.2-.37.36-.42l1.35-.39c.18-.05.3.06.27.25l-.19 1.07a.58.58 0 0 1-.4.43Z",
    fill: "#B6C3EC"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "m58.79 8.84-1.36.32c-.16.04-.26-.08-.23-.26l.2-1c.03-.18.2-.37.36-.42l1.34-.38c.18-.05.3.06.27.25l-.2 1.06c-.02.2-.2.39-.38.43Z",
    fill: "#BDCAEE"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "m58.78 8.83-1.35.32c-.16.04-.26-.08-.23-.26l.2-1c.04-.18.2-.36.36-.4l1.34-.39c.17-.05.3.06.26.25l-.19 1.06a.59.59 0 0 1-.39.42Z",
    fill: "#C4D1F0"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "m58.77 8.83-1.34.32c-.16.04-.26-.08-.23-.26l.2-1c.03-.18.2-.36.36-.4l1.32-.39c.18-.05.3.06.27.25l-.19 1.05c-.03.2-.2.39-.39.43Z",
    fill: "#CCD7F2"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "m58.76 8.83-1.33.32c-.16.03-.26-.08-.23-.27l.2-.99c.03-.18.2-.36.35-.4l1.32-.38c.18-.05.3.06.27.24l-.2 1.05c-.02.2-.2.39-.38.43Z",
    fill: "#D3DEF4"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "m58.76 8.82-1.33.32c-.16.04-.26-.08-.22-.26l.2-1c.03-.17.18-.35.34-.4l1.32-.37c.17-.05.3.06.26.24l-.19 1.05c-.03.19-.2.38-.38.42Z",
    fill: "#DAE5F6"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "m58.75 8.82-1.32.31c-.16.04-.26-.08-.22-.26l.2-.98c.03-.18.18-.36.34-.4l1.31-.38c.18-.05.3.06.26.24l-.18 1.05a.58.58 0 0 1-.39.42Z",
    fill: "#E1ECF8"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "m58.74 8.82-1.3.31c-.17.04-.27-.08-.23-.26l.2-.98c.03-.17.18-.35.34-.4l1.3-.37c.18-.05.3.05.26.24l-.18 1.04a.57.57 0 0 1-.39.42Z",
    fill: "#E8F3FA"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "m58.74 8.81-1.31.31c-.16.04-.26-.08-.22-.25l.19-.98c.03-.18.19-.36.35-.4l1.29-.37c.17-.05.29.06.26.24l-.19 1.03a.56.56 0 0 1-.37.42Z",
    fill: "#EFFAFC"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "m58.74 8.81-1.31.31c-.16.04-.26-.08-.22-.25l.19-.98c.03-.18.19-.36.35-.4l1.29-.37c.17-.05.29.06.26.24l-.19 1.03a.56.56 0 0 1-.37.42Z",
    fill: "#E4F2F4"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.49-1.76c.15-.05.27.03.26.16l-.02.24c-.01.14-.15.28-.31.32Z",
    fill: "#8792DD"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.49-1.76c.15-.05.27.03.26.16l-.02.24c-.01.14-.15.28-.31.32Z",
    fill: "#8893DD"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.48-1.76c.16-.04.28.03.27.16l-.02.24c-.01.14-.15.28-.31.32Z",
    fill: "#8994DE"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.48-1.76c.16-.04.28.03.27.16l-.02.24c-.02.14-.16.28-.31.32Z",
    fill: "#8A95DE"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.48-1.76c.16-.04.28.03.27.16l-.02.24c-.02.14-.16.28-.31.32Z",
    fill: "#8B96DE"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.48-1.76c.16-.04.28.03.27.17l-.03.23c0 .14-.15.28-.3.32Z",
    fill: "#8C97DF"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.04-.21c.01-.13.14-.26.28-.3l6.48-1.76c.16-.04.28.03.27.17l-.03.23c0 .14-.15.28-.3.32Z",
    fill: "#8D98DF"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M66.51 5.9 60 7.62c-.14.03-.24-.04-.22-.17l.03-.21c.02-.13.15-.26.29-.3l6.48-1.76c.15-.04.28.03.26.17l-.02.23c0 .14-.15.28-.3.32Z",
    fill: "#8E99DF"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "m66.51 5.9-6.5 1.72c-.15.03-.24-.05-.23-.18l.03-.2c.02-.13.15-.27.29-.3l6.48-1.76c.16-.04.28.03.27.16l-.03.24c-.01.14-.15.28-.3.32Z",
    fill: "#8F9AE0"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "m66.51 5.9-6.5 1.72c-.15.03-.24-.05-.23-.17l.03-.21c.02-.13.15-.26.29-.3l6.48-1.76c.15-.04.27.03.26.17l-.02.23c-.01.14-.15.28-.3.32Z",
    fill: "#8F9BE0"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "m66.51 5.9-6.5 1.72c-.15.03-.24-.05-.23-.17l.04-.21c.02-.13.14-.26.28-.3l6.48-1.76c.16-.04.27.03.26.17l-.02.23c-.01.14-.15.28-.3.32Z",
    fill: "#909CE0"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "m66.51 5.9-6.5 1.72c-.15.03-.24-.05-.23-.17l.04-.21c.02-.13.14-.26.28-.3l6.48-1.76c.16-.04.27.04.26.17l-.02.24c-.01.13-.15.27-.31.3Z",
    fill: "#919DE1"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "m66.51 5.9-6.5 1.71c-.15.04-.24-.04-.23-.17l.04-.2c.02-.13.14-.26.28-.3l6.48-1.76c.16-.04.27.03.26.17l-.02.23c-.01.14-.15.28-.31.32Z",
    fill: "#929EE1"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "m66.51 5.9-6.5 1.71c-.15.04-.24-.04-.23-.17l.04-.2c.02-.13.14-.26.28-.3l6.48-1.76c.15-.04.27.03.26.17l-.02.23c-.02.14-.15.28-.31.32Z",
    fill: "#939FE1"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.24-.04-.22-.17l.04-.2c.01-.13.14-.26.28-.3l6.47-1.76c.16-.04.28.03.27.17l-.03.23c0 .14-.14.28-.3.32Z",
    fill: "#94A0E1"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.17l.04-.2c.02-.13.14-.26.28-.3l6.48-1.76c.15-.04.27.03.26.17l-.02.23c-.02.14-.16.28-.31.32Z",
    fill: "#95A1E2"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.16l.04-.21c.02-.13.14-.26.28-.3l6.48-1.76c.15-.04.27.04.26.17l-.02.24c-.02.13-.16.27-.31.3Z",
    fill: "#96A2E2"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.24-.04-.22-.16l.04-.21c.01-.13.14-.26.28-.3l6.47-1.76c.16-.04.28.04.26.17l-.02.23c0 .14-.15.28-.3.32Z",
    fill: "#97A3E2"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.16l.04-.21c.02-.13.14-.26.28-.3l6.47-1.76c.16-.04.28.04.27.17l-.03.23c0 .14-.15.28-.3.32Z",
    fill: "#98A4E3"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.16l.04-.21c.02-.13.14-.26.28-.3l6.47-1.76c.16-.04.28.04.27.17l-.03.23c-.01.14-.15.28-.3.32Z",
    fill: "#99A5E3"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.24-.04-.22-.17l.04-.2c.01-.13.14-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#9AA6E3"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.24-.04-.22-.17l.04-.2c.01-.13.14-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#9BA7E4"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.17l.04-.2c.02-.13.14-.26.28-.3l6.47-1.76c.16-.04.28.04.26.17l-.02.23c-.01.14-.15.28-.3.31Z",
    fill: "#9CA8E4"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.17l.04-.2c.02-.13.14-.26.28-.3l6.47-1.76c.16-.04.28.04.26.17l-.02.23c-.01.14-.15.28-.3.31Z",
    fill: "#9DA9E4"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.24-.03-.22-.16l.04-.2c.01-.13.14-.26.28-.3l6.47-1.76c.15-.04.27.03.26.16l-.02.24c-.02.13-.15.28-.3.31Z",
    fill: "#9EAAE5"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.03-.24-.04-.22-.17l.04-.2c.01-.13.14-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.02.14-.15.28-.3.31Z",
    fill: "#9FABE5"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.03-.23-.04-.22-.17l.04-.2c.02-.13.14-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.02.14-.16.28-.3.31Z",
    fill: "#A0ACE5"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.03-.23-.04-.22-.17l.03-.2c.02-.13.15-.26.29-.3l6.47-1.76c.15-.04.27.04.26.17l-.03.23c0 .14-.15.28-.3.31Z",
    fill: "#A0ADE6"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.03-.23-.04-.22-.17l.03-.2c.02-.13.15-.26.29-.3l6.46-1.76c.16-.04.28.04.26.17l-.02.23c0 .14-.15.28-.3.31Z",
    fill: "#A1AEE6"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.03-.22-.16l.04-.2c.02-.13.14-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.03.23c-.01.13-.15.27-.3.31Z",
    fill: "#A2AFE6"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.03-.22-.16l.03-.2c.02-.13.15-.26.28-.3l6.47-1.75c.16-.04.27.03.26.16l-.02.23c-.01.13-.15.28-.3.31Z",
    fill: "#A3B0E7"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.27.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#A4B1E7"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.27.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#A5B2E7"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#A6B3E8"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#A7B4E8"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.03.23c0 .13-.14.27-.3.31Z",
    fill: "#A8B5E8"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.03.23c0 .13-.14.27-.3.31Z",
    fill: "#A9B6E9"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.89 60 7.61c-.14.03-.23-.05-.22-.17l.03-.2c.02-.13.15-.26.28-.3l6.47-1.76c.15-.04.27.04.26.17l-.03.23c0 .13-.14.27-.3.31Z",
    fill: "#AAB7E9"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.16l.03-.2c.02-.13.15-.26.28-.3l6.47-1.75c.15-.04.27.03.26.16l-.03.23c0 .13-.14.27-.3.31Z",
    fill: "#ABB8E9"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 5.9 60 7.6c-.14.04-.23-.04-.22-.16l.03-.2c.02-.13.15-.26.28-.3l6.46-1.75c.16-.04.28.03.27.16l-.03.23c0 .13-.14.27-.3.31Z",
    fill: "#ACB9EA"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.04-.22-.04-.2-.17l.02-.2c.02-.12.15-.25.28-.3l6.46-1.75c.16-.04.28.04.27.17l-.03.23c-.01.13-.14.27-.3.31Z",
    fill: "#ADBAEA"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.04-.22-.04-.2-.17l.02-.2c.02-.12.15-.25.28-.3l6.46-1.75c.16-.04.27.04.27.17l-.03.23c-.01.13-.15.27-.3.31Z",
    fill: "#AEBBEA"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.04-.22-.04-.2-.17l.02-.2c.02-.12.15-.25.28-.3l6.46-1.75c.16-.04.27.04.26.17l-.02.23c-.01.13-.15.27-.3.31Z",
    fill: "#AFBCEA"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.04-.22-.04-.2-.17l.02-.2c.02-.12.15-.25.28-.3l6.46-1.75c.16-.04.27.04.26.17l-.02.22c-.01.14-.15.28-.3.32Z",
    fill: "#B0BDEB"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.03-.22-.04-.2-.17l.03-.2c.01-.12.14-.25.27-.29l6.46-1.75c.16-.04.27.03.26.16l-.02.23c-.01.13-.15.27-.3.3Z",
    fill: "#B1BEEB"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.03-.22-.04-.2-.17l.03-.2c.01-.12.14-.25.27-.29l6.46-1.75c.16-.04.27.03.26.16l-.02.23c-.01.13-.15.27-.3.3Z",
    fill: "#B1BFEB"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.6c-.14.03-.23-.04-.22-.17l.03-.2a.4.4 0 0 1 .28-.29l6.46-1.75c.15-.04.27.03.25.16l-.02.23c0 .13-.14.27-.3.3Z",
    fill: "#B2C0EC"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.03-.22-.04-.2-.17l.03-.2a.4.4 0 0 1 .27-.29l6.46-1.75c.15-.04.27.03.26.16l-.02.23c-.01.13-.15.27-.3.3Z",
    fill: "#B3C1EC"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "m66.49 5.89-6.5 1.71c-.13.04-.22-.04-.2-.17l.03-.2a.4.4 0 0 1 .27-.29l6.46-1.75c.15-.04.27.03.26.17l-.02.22c-.02.13-.15.27-.3.31Z",
    fill: "#B4C2EC"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.6c-.14.04-.23-.04-.22-.17l.03-.2a.4.4 0 0 1 .28-.29l6.46-1.75c.15-.04.27.03.25.17l-.02.22c0 .13-.14.27-.3.31Z",
    fill: "#B5C3ED"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.6c-.14.04-.23-.04-.22-.17l.03-.2a.4.4 0 0 1 .28-.29l6.46-1.75c.15-.04.27.03.25.17l-.02.22c0 .13-.14.27-.3.31Z",
    fill: "#B6C4ED"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.59c-.14.04-.23-.03-.21-.16l.03-.2a.4.4 0 0 1 .27-.29l6.46-1.75c.15-.04.27.03.26.16l-.02.23c-.02.13-.15.27-.3.3Z",
    fill: "#B7C5ED"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.59c-.14.04-.23-.03-.21-.16l.03-.2a.4.4 0 0 1 .27-.29l6.46-1.75c.15-.04.27.03.26.16l-.02.23c-.02.13-.16.27-.3.3Z",
    fill: "#B8C6EE"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.59c-.14.04-.23-.03-.22-.16l.03-.2a.4.4 0 0 1 .28-.29l6.46-1.75c.15-.04.27.03.25.16l-.02.23c-.01.13-.15.27-.3.3Z",
    fill: "#B9C6EE"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.6c-.14.03-.23-.04-.21-.17l.03-.2a.4.4 0 0 1 .27-.29l6.46-1.75c.15-.04.27.03.25.17l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#BAC7EE"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.6c-.14.03-.23-.04-.21-.17l.03-.2a.4.4 0 0 1 .27-.29l6.46-1.75c.15-.04.27.03.25.17l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#BBC8EF"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.89 60 7.59c-.14.04-.23-.04-.22-.16l.03-.2a.4.4 0 0 1 .28-.29l6.45-1.75c.16-.04.27.03.26.16l-.02.23c-.01.13-.15.27-.3.3Z",
    fill: "#BCC9EF"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.88 60 7.6c-.14.03-.23-.05-.22-.17l.03-.2c.02-.12.15-.25.28-.29l6.45-1.75c.15-.04.27.03.26.17l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#BDCAEF"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.88 60 7.6c-.14.03-.23-.05-.21-.17l.03-.2c.02-.12.14-.25.27-.29l6.45-1.75c.15-.04.27.03.26.17l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#BECBF0"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.88 60 7.6c-.14.03-.23-.05-.22-.17l.03-.2c.02-.12.15-.25.28-.29l6.45-1.75c.15-.04.27.03.26.17l-.02.22c-.02.13-.15.27-.3.3Z",
    fill: "#BFCCF0"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.88 60 7.6c-.14.03-.23-.05-.22-.17l.03-.2c.02-.12.15-.25.28-.29l6.45-1.75c.15-.04.27.03.26.17l-.02.22c-.02.13-.15.27-.3.3Z",
    fill: "#C0CDF0"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M66.48 5.88 60 7.6c-.14.03-.23-.05-.21-.17l.03-.2c.02-.12.14-.25.27-.29l6.45-1.75c.15-.04.27.03.26.17l-.02.22c-.02.13-.15.27-.3.3Z",
    fill: "#C1CEF1"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.03-.23-.05-.22-.17l.03-.2c.02-.12.15-.25.28-.29l6.45-1.75c.15-.04.27.03.25.17l-.02.22c0 .13-.14.27-.3.3Z",
    fill: "#C1CFF1"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.03-.23-.05-.21-.17l.03-.2c.01-.12.14-.25.27-.29l6.45-1.75c.15-.04.26.03.25.17l-.02.22c0 .13-.14.27-.3.3Z",
    fill: "#C2D0F1"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.01-.12.14-.25.27-.29l6.45-1.75c.15-.04.26.03.25.17l-.02.22c-.01.13-.14.26-.3.3Z",
    fill: "#C3D1F2"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.01-.12.14-.25.27-.29l6.44-1.75c.16-.04.27.03.26.17l-.02.22c-.01.13-.14.26-.3.3Z",
    fill: "#C4D2F2"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.01-.12.14-.25.27-.28l6.44-1.76c.16-.04.27.04.26.17l-.02.22c-.01.13-.14.27-.3.3Z",
    fill: "#C5D3F2"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.01-.12.14-.25.27-.28l6.44-1.76c.16-.04.27.04.26.17l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#C6D4F2"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.02-.12.14-.25.27-.28l6.45-1.76c.15-.04.26.04.25.17l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#C7D5F3"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.02-.12.14-.25.27-.28l6.44-1.76c.15-.04.27.04.26.17l-.02.22c-.02.13-.15.27-.3.3Z",
    fill: "#C8D6F3"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.6c-.14.04-.23-.04-.21-.16l.03-.2c.02-.12.14-.25.27-.28l6.44-1.76c.15-.04.27.04.26.17l-.02.22c-.02.13-.15.27-.3.3Z",
    fill: "#C9D7F3"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.58c-.14.04-.23-.03-.21-.16l.03-.2c.02-.12.14-.25.27-.28l6.44-1.75c.15-.04.27.03.26.16l-.02.22c-.02.14-.15.27-.3.31Z",
    fill: "#CAD8F4"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.58c-.14.04-.23-.03-.21-.16l.03-.2c.02-.12.14-.25.27-.28l6.44-1.75c.15-.04.27.03.26.16l-.02.22c-.02.14-.15.27-.3.31Z",
    fill: "#CBD9F4"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.58c-.14.04-.23-.03-.21-.16l.03-.2a.4.4 0 0 1 .27-.28l6.44-1.75c.15-.04.27.03.26.16l-.02.22c-.02.14-.15.27-.3.31Z",
    fill: "#CCDAF4"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 5.88 60 7.58c-.14.04-.23-.03-.21-.16l.03-.2a.4.4 0 0 1 .27-.28l6.44-1.75c.15-.04.27.03.26.16l-.02.22c-.02.14-.15.27-.3.31Z",
    fill: "#CDDBF5"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.6c-.13.03-.22-.04-.2-.17l.02-.19a.4.4 0 0 1 .28-.29l6.44-1.75c.15-.04.26.04.25.17l-.02.22c-.01.13-.14.26-.3.3Z",
    fill: "#CEDCF5"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.6c-.14.03-.23-.04-.21-.17l.03-.19a.4.4 0 0 1 .27-.29l6.44-1.75c.15-.04.27.04.25.17l-.02.22c0 .13-.14.26-.3.3Z",
    fill: "#CFDDF5"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.6c-.14.03-.23-.04-.21-.17l.03-.19a.4.4 0 0 1 .27-.29l6.44-1.75c.15-.04.27.04.25.17l-.02.22c-.01.13-.14.26-.3.3Z",
    fill: "#D0DEF6"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.6c-.13.03-.22-.04-.2-.17l.02-.19a.4.4 0 0 1 .28-.29l6.44-1.75c.15-.04.26.04.25.17l-.02.21c-.01.14-.15.27-.3.31Z",
    fill: "#D1DFF6"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.6c-.14.03-.23-.04-.21-.17l.03-.19a.4.4 0 0 1 .27-.29l6.44-1.75c.15-.04.26.04.25.17l-.02.21c-.01.14-.15.27-.3.31Z",
    fill: "#D2E0F6"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.2a.4.4 0 0 1 .27-.28l6.44-1.75c.15-.04.26.03.25.16l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#D2E1F7"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.2c.02-.11.14-.24.27-.28l6.44-1.75c.15-.04.26.03.25.16l-.02.22c-.01.13-.15.27-.3.3Z",
    fill: "#D3E2F7"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "m66.46 5.88-6.47 1.7c-.13.04-.22-.04-.2-.16l.03-.2c.01-.11.13-.24.27-.28l6.43-1.75c.15-.04.27.03.26.16l-.02.22c-.02.13-.15.27-.3.3Z",
    fill: "#D4E3F7"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.2c.02-.11.14-.24.27-.28l6.43-1.75c.15-.04.27.03.26.16l-.03.22c0 .13-.14.27-.3.3Z",
    fill: "#D5E4F8"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.58c-.14.04-.23-.03-.21-.16l.03-.19a.4.4 0 0 1 .27-.28l6.43-1.75c.15-.04.27.03.26.16l-.03.22c0 .13-.14.26-.3.3Z",
    fill: "#D6E5F8"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "m66.46 5.88-6.47 1.7c-.13.04-.22-.04-.2-.16l.03-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.27.03.25.16l-.02.22c0 .12-.14.26-.3.3Z",
    fill: "#D7E6F8"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.27.03.26.16l-.03.22c0 .12-.14.26-.3.3Z",
    fill: "#D8E7F9"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M66.46 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.27.03.25.16l-.02.21c0 .14-.14.27-.3.31Z",
    fill: "#D9E8F9"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "m66.46 5.88-6.47 1.7c-.13.04-.22-.04-.2-.16l.03-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.26.03.25.16l-.02.21c-.01.14-.14.27-.3.31Z",
    fill: "#DAE9F9"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.13.04-.22-.04-.2-.16l.03-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.26.03.25.16l-.02.21c-.01.14-.14.27-.3.31Z",
    fill: "#DBEAFA"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.2a.4.4 0 0 1 .27-.28l6.43-1.75c.15-.04.27.04.26.17l-.02.21c-.02.14-.16.27-.3.3Z",
    fill: "#DCEBFA"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.13.04-.22-.04-.2-.16l.03-.2a.4.4 0 0 1 .27-.28l6.43-1.75c.15-.04.26.04.25.17l-.02.21c-.01.14-.15.27-.3.3Z",
    fill: "#DDECFA"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.13.04-.22-.04-.2-.16l.03-.2a.4.4 0 0 1 .27-.28l6.43-1.75c.15-.04.26.04.25.17l-.02.21c-.01.13-.15.27-.3.3Z",
    fill: "#DEEDFB"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.2a.4.4 0 0 1 .27-.28l6.43-1.75c.15-.04.26.04.25.17l-.02.21c-.02.13-.15.27-.3.3Z",
    fill: "#DFEEFB"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.14-.04.26.03.25.16l-.02.21c-.02.13-.15.27-.3.3Z",
    fill: "#E0EFFB"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.88-6.46 1.7c-.13.04-.22-.04-.2-.16l.02-.19a.4.4 0 0 1 .28-.29L66.5 5.2c.15-.04.27.03.25.16l-.02.21c0 .13-.14.27-.29.3Z",
    fill: "#E1F0FB"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.88-6.46 1.7c-.13.04-.22-.04-.2-.16l.02-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.26.03.25.16l-.02.21c0 .13-.14.27-.29.3Z",
    fill: "#E2F1FC"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M66.45 5.88 60 7.58c-.14.04-.23-.04-.21-.16l.03-.19a.4.4 0 0 1 .27-.29L66.5 5.2c.15-.04.27.03.25.16l-.02.21c0 .13-.14.27-.29.3Z",
    fill: "#E3F2FC"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.88-6.46 1.7c-.13.04-.22-.04-.2-.16l.02-.19a.4.4 0 0 1 .27-.29l6.43-1.74c.15-.04.26.03.25.16l-.02.21c-.01.13-.14.27-.3.3Z",
    fill: "#E3F3FC"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.88-6.46 1.7c-.13.04-.22-.04-.2-.16l.02-.19a.4.4 0 0 1 .27-.28l6.43-1.75c.15-.04.26.04.25.16l-.02.22c-.01.12-.14.26-.3.3Z",
    fill: "#E4F4FD"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.87-6.46 1.71c-.13.03-.22-.04-.2-.16l.02-.2a.4.4 0 0 1 .27-.28l6.43-1.74c.15-.04.26.03.25.16l-.02.21c-.01.13-.14.27-.3.3Z",
    fill: "#E5F5FD"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.87-6.46 1.71c-.13.03-.22-.04-.2-.16l.02-.2a.4.4 0 0 1 .27-.28l6.43-1.74c.15-.04.26.03.25.16l-.02.21c-.01.13-.14.27-.3.3Z",
    fill: "#E6F6FD"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.87-6.46 1.71c-.13.03-.22-.04-.2-.16l.02-.2a.4.4 0 0 1 .27-.28l6.43-1.74c.14-.04.26.03.25.16l-.02.21c-.01.13-.15.27-.3.3Z",
    fill: "#E7F7FE"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "m66.45 5.87-6.46 1.7c-.13.04-.22-.03-.2-.16l.02-.18a.4.4 0 0 1 .27-.29l6.43-1.74c.14-.04.26.03.25.16l-.02.21c-.01.13-.15.27-.3.3Z",
    fill: "#E8F8FE"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M66.44 5.88 60 7.58c-.13.03-.22-.04-.2-.17l.02-.18a.39.39 0 0 1 .27-.28l6.43-1.75c.14-.04.26.04.25.16l-.02.21c-.02.13-.15.27-.3.3Z",
    fill: "#E9F9FE"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M66.44 5.88 60 7.58c-.13.03-.22-.04-.2-.17l.02-.18c.02-.12.14-.25.27-.28l6.43-1.75c.14-.04.26.04.25.16l-.02.21c-.02.13-.15.27-.3.3Z",
    fill: "#EAFAFF"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M66.44 5.88 60 7.58c-.13.03-.22-.04-.2-.17l.02-.18a.39.39 0 0 1 .27-.28L66.5 5.2c.15-.04.26.04.25.16l-.02.21c0 .13-.14.27-.29.3Z",
    fill: "#EBFBFF"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M66.44 5.88 60 7.58c-.13.03-.22-.04-.2-.17l.02-.18a.39.39 0 0 1 .27-.28L66.5 5.2c.15-.04.26.04.25.16l-.02.21c0 .13-.14.27-.29.3Z",
    fill: "#E4F2F4"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.03.14.02.12.09l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#8792DD"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.03.14.02.12.09l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#8893DD"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.03.14.02.12.09l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#8994DE"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.03.14.02.12.09l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#8A95DE"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.03.14.02.12.09l-.02.13c-.01.07-.1.15-.17.17Z",
    fill: "#8B96DE"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.7.16c-.07.02-.12-.02-.1-.1l.02-.1c0-.08.08-.15.15-.17l.7-.18c.08-.03.13.02.12.09l-.02.13c-.01.07-.1.15-.17.17Z",
    fill: "#8C97DF"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.7.16c-.07.02-.12-.02-.1-.1l.02-.1c0-.08.08-.15.15-.17l.7-.18c.08-.02.13.02.12.1l-.03.12c0 .07-.08.15-.16.17Z",
    fill: "#8D98DF"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#8E99DF"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#8F9AE0"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#8F9BE0"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#909CE0"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.69.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12a.26.26 0 0 1-.17.17Z",
    fill: "#919DE1"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.08.02-.13-.02-.12-.1l.03-.1c0-.08.08-.15.15-.17l.7-.18c.08-.02.13.02.12.1l-.03.12c0 .07-.08.15-.17.17Z",
    fill: "#929EE1"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "m60.49 8.23-.7.16c-.07.02-.12-.02-.1-.1l.02-.1c0-.08.08-.15.16-.17l.68-.18c.09-.02.14.02.13.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#939FE1"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.13-.03-.11-.1l.02-.11c.01-.07.08-.14.16-.17l.69-.17c.08-.03.13.02.12.09l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#94A0E1"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.13-.03-.11-.1l.02-.11c.01-.07.08-.14.16-.17l.69-.17c.08-.03.13.02.12.09l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#95A1E2"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.13-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.18.17Z",
    fill: "#96A2E2"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.13-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12a.25.25 0 0 1-.18.17Z",
    fill: "#97A3E2"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.13-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.69-.18c.08-.02.13.02.12.1l-.02.12a.25.25 0 0 1-.18.17Z",
    fill: "#98A4E3"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.08.02-.13-.03-.11-.1l.02-.1c0-.08.08-.15.16-.17l.68-.18c.09-.02.14.02.13.1l-.02.12c-.02.07-.1.15-.18.17Z",
    fill: "#99A5E3"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.08.02-.13-.03-.11-.1l.02-.1c0-.08.08-.15.16-.17l.68-.18c.08-.02.14.02.13.1l-.03.12c0 .07-.09.15-.17.17Z",
    fill: "#9AA6E3"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.12-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.68-.18c.09-.02.14.02.13.1l-.03.12c-.01.07-.09.15-.17.17Z",
    fill: "#9BA7E4"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.12-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.68-.18c.09-.02.14.02.13.1l-.03.12a.25.25 0 0 1-.17.17Z",
    fill: "#9CA8E4"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.12-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.68-.18c.09-.02.14.02.13.1l-.03.12a.25.25 0 0 1-.17.17Z",
    fill: "#9DA9E4"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.02-.12-.03-.11-.1l.02-.1c.01-.08.08-.15.16-.17l.68-.18c.09-.02.14.02.13.1l-.03.12a.25.25 0 0 1-.17.17Z",
    fill: "#9EAAE5"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.08.02-.13-.03-.11-.1l.02-.1a.22.22 0 0 1 .16-.17l.68-.18c.08-.02.14.02.13.1l-.03.12c-.01.07-.09.15-.17.17Z",
    fill: "#9FABE5"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.08.01-.13-.03-.11-.1l.02-.11a.22.22 0 0 1 .15-.16l.69-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#A0ACE5"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.08.01-.13-.03-.11-.1l.02-.11a.22.22 0 0 1 .15-.16l.69-.18c.08-.02.13.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#A0ADE6"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.01-.12-.03-.11-.1l.02-.11a.22.22 0 0 1 .16-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#A1AEE6"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.01-.12-.03-.11-.1l.02-.11a.22.22 0 0 1 .16-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#A2AFE6"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.16c-.07.01-.12-.03-.11-.1l.02-.11a.22.22 0 0 1 .16-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#A3B0E7"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.07.02-.12-.02-.11-.09l.02-.11a.22.22 0 0 1 .16-.17l.68-.17c.08-.03.14.02.12.09l-.02.13c-.01.07-.1.15-.17.17Z",
    fill: "#A4B1E7"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.69-.18c.08-.02.13.02.12.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#A5B2E7"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.69-.18c.08-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#A6B3E8"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.69-.18c.08-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#A7B4E8"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.69-.18c.07-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#A8B5E8"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.07.02-.12-.02-.11-.1l.02-.1c.01-.07.08-.14.16-.16l.68-.18c.08-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#A9B6E9"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.07.02-.12-.02-.11-.1l.02-.1c.01-.07.08-.14.16-.16l.68-.18c.08-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#AAB7E9"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.69-.18c.07-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#ABB8E9"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.69-.18c.07-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#ACB9EA"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.69-.18c.07-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#ADBAEA"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.69-.18c.07-.02.13.02.12.1l-.02.12c-.02.07-.1.15-.17.17Z",
    fill: "#AEBBEA"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "m60.48 8.23-.68.15c-.08.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.68-.18c.08-.02.14.02.13.1l-.03.12c0 .07-.09.15-.16.17Z",
    fill: "#AFBCEA"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.23-.67.15c-.07.02-.12-.02-.11-.1l.02-.1c.01-.07.08-.14.16-.16l.67-.18c.08-.02.14.02.13.1l-.03.12c0 .07-.09.15-.17.17Z",
    fill: "#B0BDEB"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.23-.67.15c-.07.02-.12-.02-.11-.1l.02-.1c.01-.07.08-.14.16-.16l.67-.18c.08-.02.14.02.13.1l-.03.12a.24.24 0 0 1-.17.17Z",
    fill: "#B1BEEB"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.23-.67.15c-.07.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#B1BFEB"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.23-.67.15c-.07.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.14-.17.17Z",
    fill: "#B2C0EC"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.23-.67.15c-.07.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.14-.17.17Z",
    fill: "#B3C1EC"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.17l.68-.17c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.14-.17.16Z",
    fill: "#B4C2EC"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.13-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l.68-.18c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.14-.17.16Z",
    fill: "#B5C3ED"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.12-.02-.1-.1l.01-.1c.01-.07.08-.14.16-.16l.67-.18c.08-.02.14.02.13.1l-.03.12a.24.24 0 0 1-.17.16Z",
    fill: "#B6C4ED"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.12-.02-.1-.1l.01-.1c.01-.07.08-.14.16-.16l.67-.18c.08-.02.14.02.13.1l-.03.11a.24.24 0 0 1-.17.17Z",
    fill: "#B7C5ED"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.13-.02-.11-.1l.02-.1c.01-.07.08-.14.16-.16l.67-.18c.08-.02.14.02.12.1l-.02.11a.24.24 0 0 1-.17.17Z",
    fill: "#B8C6EE"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.13-.02-.11-.1l.02-.1c.01-.07.08-.14.16-.16l.67-.18c.08-.02.14.02.12.1l-.02.11a.24.24 0 0 1-.17.17Z",
    fill: "#B9C6EE"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.13-.02-.11-.1l.02-.1a.22.22 0 0 1 .16-.16l.67-.18c.08-.02.14.02.12.1l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#BAC7EE"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.13-.02-.11-.1l.02-.1a.22.22 0 0 1 .16-.16l.67-.18c.08-.02.14.02.12.1l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#BBC8EF"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.02.11c-.02.08-.1.15-.17.17Z",
    fill: "#BCC9EF"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.1-.1l.01-.1a.23.23 0 0 1 .16-.16l.67-.18c.08-.02.14.02.12.1l-.02.11a.24.24 0 0 1-.17.17Z",
    fill: "#BDCAEF"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.02.11c-.02.08-.1.15-.17.17Z",
    fill: "#BECBF0"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.02.12c-.02.07-.1.14-.17.16Z",
    fill: "#BFCCF0"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#C0CDF0"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#C1CEF1"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#C1CFF1"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#C2D0F1"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.02-.12-.02-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.17c.08-.03.13.02.12.09l-.03.12c0 .07-.08.15-.16.16Z",
    fill: "#C3D1F2"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.18c.08-.02.13.02.12.1l-.03.12c-.01.07-.08.14-.16.16Z",
    fill: "#C4D2F2"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.17c.08-.03.13.02.12.09l-.03.12c-.01.07-.08.14-.16.16Z",
    fill: "#C5D3F2"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.17c.08-.03.13.02.12.09l-.03.12c-.01.07-.08.14-.16.16Z",
    fill: "#C6D4F2"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.17c.08-.03.13.02.12.09l-.03.12c-.01.07-.08.14-.16.16Z",
    fill: "#C7D5F3"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.17c.08-.03.13.02.12.09l-.03.12c-.01.07-.09.14-.16.16Z",
    fill: "#C8D6F3"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.68-.17c.08-.03.13.02.12.09l-.03.12c-.01.07-.09.14-.16.16Z",
    fill: "#C9D7F3"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "m60.47 8.22-.67.16c-.07.01-.12-.03-.11-.1l.02-.1a.22.22 0 0 1 .15-.16l.67-.17c.08-.03.14.02.13.09l-.03.12a.23.23 0 0 1-.16.16Z",
    fill: "#CAD8F4"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.67-.17c.08-.03.13.02.12.09l-.02.12c-.01.07-.09.14-.17.16Z",
    fill: "#CBD9F4"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.67-.17c.08-.03.13.02.12.09l-.02.12c-.01.07-.09.14-.17.16Z",
    fill: "#CCDAF4"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.67-.17c.08-.03.13.02.12.09l-.02.12c-.01.07-.09.14-.17.16Z",
    fill: "#CDDBF5"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.67-.17c.08-.03.13.02.12.09l-.02.12c-.01.07-.09.14-.17.16Z",
    fill: "#CEDCF5"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.67-.17c.08-.03.13.02.12.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#CFDDF5"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1a.23.23 0 0 1 .15-.16l.67-.17c.08-.03.13.02.12.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#D0DEF6"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.08.01-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.67-.17c.08-.03.13.02.12.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#D1DFF6"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1c0-.07.08-.14.15-.16l.67-.17c.08-.03.13.02.12.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#D2E0F6"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1c0-.07.08-.14.15-.16l.67-.17c.08-.03.13.02.12.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#D2E1F7"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.07.01-.12-.03-.11-.1l.02-.1c0-.07.08-.14.15-.16l.67-.17c.08-.03.13.02.12.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#D3E2F7"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.11-.09l.02-.1c0-.07.08-.14.15-.16l.67-.18c.08-.02.13.02.12.1l-.03.11a.22.22 0 0 1-.16.17Z",
    fill: "#D4E3F7"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.11-.09l.02-.1c0-.07.08-.14.15-.16l.67-.17c.08-.03.13.02.12.09l-.03.11c0 .08-.08.15-.16.17Z",
    fill: "#D5E4F8"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.11-.09l.02-.1c0-.07.08-.14.15-.16l.67-.17c.08-.03.13.02.12.09l-.03.11c0 .08-.08.15-.16.17Z",
    fill: "#D6E5F8"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.08.02-.13-.02-.11-.09l.01-.1a.23.23 0 0 1 .16-.16l.66-.17c.08-.03.13.02.12.09l-.02.11c0 .08-.08.15-.16.17Z",
    fill: "#D7E6F8"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.16c-.08.01-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c0 .08-.08.15-.16.17Z",
    fill: "#D8E7F9"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.11-.09l.02-.1a.23.23 0 0 1 .15-.16l.66-.17c.08-.03.14.02.12.09l-.02.11c0 .08-.08.15-.16.17Z",
    fill: "#D9E8F9"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09v-.1a.23.23 0 0 1 .16-.16l.67-.17c.08-.03.13.02.12.09l-.03.11c-.01.08-.08.15-.16.17Z",
    fill: "#DAE9F9"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09v-.1a.23.23 0 0 1 .16-.16l.67-.17c.07-.03.13.02.12.09l-.03.11c-.01.08-.08.15-.16.17Z",
    fill: "#DBEAFA"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09v-.1a.22.22 0 0 1 .16-.16l.67-.17c.07-.02.13.02.12.1l-.03.1c-.01.08-.08.15-.16.17Z",
    fill: "#DCEBFA"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.67-.17c.07-.02.13.02.12.1l-.03.1c0 .08-.08.15-.16.17Z",
    fill: "#DDECFA"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.08.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.08.15-.16.17Z",
    fill: "#DEEDFB"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.08.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#DFEEFB"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#E0EFFB"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#E1F0FB"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#E2F1FC"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "m60.46 8.22-.66.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1a.24.24 0 0 1-.16.17Z",
    fill: "#E3F2FC"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.08.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1a.23.23 0 0 1-.17.17Z",
    fill: "#E3F3FC"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.08.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.17.17Z",
    fill: "#E4F4FD"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.08.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.17.17Z",
    fill: "#E5F5FD"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1a.23.23 0 0 1-.17.17Z",
    fill: "#E6F6FD"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.01.08-.09.15-.17.17Z",
    fill: "#E7F7FE"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1a.24.24 0 0 1-.17.17Z",
    fill: "#E8F8FE"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.1-.09l.01-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1a.24.24 0 0 1-.17.17Z",
    fill: "#E9F9FE"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.02.08-.1.15-.17.17Z",
    fill: "#EAFAFF"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.02.08-.1.15-.17.17Z",
    fill: "#EBFBFF"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "m60.45 8.22-.65.15c-.07.02-.12-.02-.11-.09l.02-.1a.22.22 0 0 1 .15-.16l.66-.17c.08-.02.13.02.12.1l-.02.1c-.02.08-.1.15-.17.17Z",
    fill: "#E4F2F4"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.02-.13-.02-.12-.1l.02-.11c.01-.07.09-.15.16-.17l.85-.22c.08-.02.14.02.13.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#8792DD"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.02-.13-.02-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.09-.02.14.02.13.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#8893DD"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.09-.02.14.02.13.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#8994DE"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.08-.02.14.02.13.1l-.03.13c0 .07-.09.15-.17.16Z",
    fill: "#8A95DE"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.08-.02.14.02.13.1l-.03.13c0 .07-.09.15-.17.16Z",
    fill: "#8B96DE"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.08-.02.14.02.13.1l-.03.13c0 .07-.09.15-.17.16Z",
    fill: "#8C97DF"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.08-.02.14.02.13.1l-.03.13c0 .07-.09.15-.17.16Z",
    fill: "#8D98DF"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.08-.02.14.02.13.1l-.03.13c0 .07-.09.15-.17.16Z",
    fill: "#8E99DF"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.11a.23.23 0 0 1 .16-.17l.85-.22c.08-.02.14.02.13.1l-.03.13c-.01.07-.09.15-.17.16Z",
    fill: "#8F9AE0"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.12a.23.23 0 0 1 .16-.16l.85-.22c.08-.02.14.02.13.1l-.03.12a.24.24 0 0 1-.17.17Z",
    fill: "#8F9BE0"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.12c.01-.07.09-.14.16-.16l.85-.22c.08-.02.14.02.12.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#909CE0"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.12c.01-.07.09-.14.16-.16l.85-.22c.08-.02.14.02.12.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#919DE1"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.12c.01-.07.09-.14.16-.16l.84-.22c.09-.02.15.02.13.1l-.02.12c-.01.08-.1.15-.17.17Z",
    fill: "#929EE1"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.12c.01-.07.09-.14.16-.16l.84-.22c.09-.02.14.02.13.1l-.02.12c-.01.08-.1.15-.17.17Z",
    fill: "#939FE1"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.09l.02-.12c.01-.07.09-.14.16-.16l.84-.22c.09-.02.14.02.13.1l-.02.12c-.01.08-.1.15-.17.17Z",
    fill: "#94A0E1"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.01-.13-.03-.12-.1l.02-.11c.02-.07.09-.15.16-.17l.84-.22c.09-.02.14.02.13.1l-.02.13c-.01.07-.1.14-.17.17Z",
    fill: "#95A1E2"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.01-.13-.03-.12-.1l.02-.11c.01-.07.09-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.01.07-.1.14-.17.17Z",
    fill: "#96A2E2"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.01-.13-.03-.12-.1l.02-.11c.01-.07.09-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.01.07-.1.14-.17.17Z",
    fill: "#97A3E2"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.01-.13-.03-.12-.1l.02-.11c.01-.07.09-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.01.07-.1.14-.17.17Z",
    fill: "#98A4E3"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.88-.84.2c-.08.01-.13-.03-.12-.1l.02-.11c.01-.07.09-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.01.07-.1.14-.17.17Z",
    fill: "#99A5E3"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.02.07-.1.14-.17.16Z",
    fill: "#9AA6E3"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.02.07-.1.14-.17.16Z",
    fill: "#9BA7E4"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "m61.97 7.87-.84.2c-.07.02-.13-.02-.12-.1l.02-.1c.02-.07.09-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.02.07-.1.14-.17.16Z",
    fill: "#9CA8E4"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.02.07-.1.14-.18.16Z",
    fill: "#9DA9E4"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.13c-.02.07-.1.14-.18.16Z",
    fill: "#9EAAE5"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.12a.24.24 0 0 1-.18.17Z",
    fill: "#9FABE5"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.09.15-.17.17Z",
    fill: "#A0ACE5"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.08.15-.17.17Z",
    fill: "#A0ADE6"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.08.15-.17.17Z",
    fill: "#A1AEE6"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.02-.07.09-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.02.12c-.02.08-.1.15-.18.17Z",
    fill: "#A2AFE6"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12a.24.24 0 0 1-.17.17Z",
    fill: "#A3B0E7"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12a.24.24 0 0 1-.17.17Z",
    fill: "#A4B1E7"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12c-.01.07-.09.15-.17.17Z",
    fill: "#A5B2E7"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.84-.22c.08-.02.14.02.13.1l-.03.12c-.01.07-.09.15-.17.17Z",
    fill: "#A6B3E8"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.84-.22c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#A7B4E8"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.84-.22c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#A8B5E8"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.02-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.84-.22c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#A9B6E9"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.84-.22c.08-.02.14.02.12.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#AAB7E9"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.84-.22c.08-.02.14.02.12.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#ABB8E9"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#ACB9EA"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#ADBAEA"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.08.15-.16.17Z",
    fill: "#AEBBEA"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.12.1l-.02.12c0 .08-.08.15-.16.17Z",
    fill: "#AFBCEA"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.08.15-.16.17Z",
    fill: "#B0BDEB"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.08.15-.16.17Z",
    fill: "#B1BEEB"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.03.12c0 .08-.08.15-.16.17Z",
    fill: "#B1BFEB"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.03.12c0 .07-.08.15-.16.17Z",
    fill: "#B2C0EC"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.17l.83-.22c.08-.02.14.02.13.1l-.03.12c0 .07-.08.15-.16.17Z",
    fill: "#B3C1EC"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "m61.96 7.87-.83.2c-.08.02-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .16-.17l.83-.22c.08-.02.14.02.12.1l-.02.12c0 .07-.08.15-.16.17Z",
    fill: "#B4C2EC"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.02-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12c0 .07-.08.15-.17.17Z",
    fill: "#B5C3ED"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.02-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12c0 .07-.08.15-.17.17Z",
    fill: "#B6C4ED"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.02-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .16-.17l.83-.22c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#B7C5ED"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.02-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .16-.17l.83-.22c.08-.02.14.02.12.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#B8C6EE"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.02-.13-.03-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.83-.21c.08-.03.14.01.12.09l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#B9C6EE"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.02-.13-.03-.12-.1l.02-.1c.01-.07.08-.15.16-.17l.83-.21c.08-.03.14.01.12.09l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#BAC7EE"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.09-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#BBC8EF"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.09-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#BCC9EF"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.09-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#BDCAEF"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#BECBF0"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#BFCCF0"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#C0CDF0"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#C1CEF1"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.08-.02.14.02.13.1l-.02.12a.23.23 0 0 1-.17.17Z",
    fill: "#C1CFF1"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.08-.02.14.02.13.1l-.02.12a.23.23 0 0 1-.17.17Z",
    fill: "#C2D0F1"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.08-.02.14.02.13.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#C3D1F2"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.09-.02.14.02.13.1l-.02.12a.24.24 0 0 1-.17.17Z",
    fill: "#C4D2F2"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.11-.1l.01-.1c.02-.08.09-.15.16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12a.25.25 0 0 1-.17.17Z",
    fill: "#C5D3F2"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.11-.1l.01-.1c.02-.08.09-.15.16-.17l.83-.22c.08-.02.13.02.12.1l-.02.12a.25.25 0 0 1-.17.17Z",
    fill: "#C6D4F2"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.08-.02.14.02.13.1l-.03.12c0 .07-.08.15-.16.17Z",
    fill: "#C7D5F3"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.08.08-.15.16-.17l.82-.22c.08-.02.14.02.12.1l-.02.12c0 .07-.08.15-.16.17Z",
    fill: "#C8D6F3"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.07.08-.15.16-.17L62 7.5c.08-.02.14.02.12.09l-.02.12c0 .07-.08.15-.16.17Z",
    fill: "#C9D7F3"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.87-.82.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.07.08-.15.16-.17L62 7.5c.08-.02.14.02.12.09l-.02.12c0 .07-.08.15-.16.17Z",
    fill: "#CAD8F4"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.86-.82.2c-.08.02-.13-.02-.11-.1l.01-.1c.02-.07.09-.14.16-.16l.82-.21c.08-.03.14.01.13.09l-.03.12a.24.24 0 0 1-.16.16Z",
    fill: "#CBD9F4"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.86-.82.2c-.08.02-.13-.02-.11-.1l.01-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.03.12a.24.24 0 0 1-.16.16Z",
    fill: "#CCDAF4"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "m61.95 7.86-.82.2c-.08.02-.13-.02-.11-.1l.01-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.03.12a.24.24 0 0 1-.16.16Z",
    fill: "#CDDBF5"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12c-.01.07-.08.15-.17.16Z",
    fill: "#CEDCF5"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#CFDDF5"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D0DEF6"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D1DFF6"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.07.02-.13-.02-.11-.1l.01-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.12.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#D2E0F6"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.07.02-.13-.02-.11-.1l.01-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.12.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#D2E1F7"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D3E2F7"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D4E3F7"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D5E4F8"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D6E5F8"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.02.12c-.01.07-.09.15-.17.16Z",
    fill: "#D7E6F8"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.07.02-.13-.02-.11-.1l.01-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#D8E7F9"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.07.02-.13-.02-.11-.1l.01-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.13.02.12.1l-.02.11c-.01.07-.1.15-.17.16Z",
    fill: "#D9E8F9"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.02-.13-.02-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.1l-.02.1c-.02.08-.1.15-.17.17Z",
    fill: "#DAE9F9"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.02.12c-.02.07-.1.14-.17.16Z",
    fill: "#DBEAFA"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#DCEBFA"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.16L62 7.5c.08-.02.14.02.13.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#DDECFA"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.16l.81-.21c.08-.03.14.01.13.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#DEEDFB"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.07.01-.13-.03-.11-.1l.01-.1a.22.22 0 0 1 .16-.16l.82-.21c.07-.03.13.01.12.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#DFEEFB"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.16l.81-.21c.08-.02.14.02.13.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#E0EFFB"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.22.22 0 0 1 .16-.16l.81-.21c.08-.02.14.02.13.09l-.03.12c0 .07-.08.14-.16.16Z",
    fill: "#E1F0FB"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.07.08-.14.16-.16l.81-.21c.08-.02.14.02.13.09l-.02.12a.24.24 0 0 1-.17.16Z",
    fill: "#E2F1FC"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1c.01-.07.08-.14.16-.16l.81-.21c.08-.02.14.02.12.09l-.02.12c0 .07-.08.14-.16.16Z",
    fill: "#E3F2FC"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .15-.16l.82-.21c.08-.02.13.02.12.09l-.02.12c0 .07-.08.14-.16.16Z",
    fill: "#E3F3FC"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .15-.16l.82-.21c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.14-.16.16Z",
    fill: "#E4F4FD"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.07.01-.12-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.81-.21c.08-.02.14.02.12.09l-.02.12c-.01.07-.09.14-.16.16Z",
    fill: "#E5F5FD"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .15-.16l.82-.21c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.14-.16.16Z",
    fill: "#E6F6FD"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.12-.1l.02-.1a.23.23 0 0 1 .15-.16l.82-.21c.08-.02.13.02.12.09l-.02.12c-.01.07-.09.14-.16.16Z",
    fill: "#E7F7FE"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16L62 7.5c.08-.02.14.02.12.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#E8F8FE"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.8-.21c.09-.02.14.02.13.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#E9F9FE"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08.01-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.8-.21c.09-.02.14.02.13.1l-.02.1c-.01.08-.09.15-.16.17Z",
    fill: "#EAFAFF"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08 0-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.8-.21c.09-.02.14.02.13.09l-.02.12c-.01.07-.09.14-.16.16Z",
    fill: "#EBFBFF"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "m61.94 7.86-.81.2c-.08 0-.13-.03-.11-.1l.01-.1a.23.23 0 0 1 .16-.16l.8-.21c.09-.02.14.02.13.09l-.02.12c-.01.07-.09.14-.16.16Z",
    fill: "#E4F2F4"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.64-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.1.15-.18.17Z",
    fill: "#8792DD"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.64-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.1.15-.18.17Z",
    fill: "#8893DD"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.64-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.1.15-.18.17Z",
    fill: "#8994DE"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.64-.42c.09-.02.15.02.14.1l-.03.13c0 .07-.08.15-.17.17Z",
    fill: "#8A95DE"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.64-.42c.09-.02.15.02.14.1l-.03.13c0 .07-.08.15-.17.17Z",
    fill: "#8B96DE"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.14-.02-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.64-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.08.15-.17.17Z",
    fill: "#8C97DF"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.64-.42c.09-.02.15.02.14.1l-.03.13c0 .07-.08.15-.17.17Z",
    fill: "#8D98DF"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.64-.42c.09-.02.15.02.14.1l-.03.13c0 .07-.09.15-.17.17Z",
    fill: "#8E99DF"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.09-.02.15.02.14.1l-.03.13c0 .07-.09.15-.17.17Z",
    fill: "#8F9AE0"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.09-.02.15.02.14.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#8F9BE0"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "m64.31 7.3-1.64.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#909CE0"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.14.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#919DE1"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.14.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#929EE1"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#939FE1"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#94A0E1"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#95A1E2"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.02-.12-.1l.02-.1a.23.23 0 0 1 .16-.18l1.64-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#96A2E2"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#97A3E2"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#98A4E3"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#99A5E3"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#9AA6E3"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#9BA7E4"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.02-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#9CA8E4"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.12a.23.23 0 0 1 .15-.16l1.64-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.09.16-.18.18Z",
    fill: "#9DA9E4"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.12a.23.23 0 0 1 .15-.16l1.64-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.16-.17.18Z",
    fill: "#9EAAE5"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.1.15-.18.17Z",
    fill: "#9FABE5"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.1.15-.18.17Z",
    fill: "#A0ACE5"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#A0ADE6"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#A1AEE6"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.09-.02.15.02.14.1l-.02.13c-.02.07-.1.15-.18.17Z",
    fill: "#A2AFE6"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11a.23.23 0 0 1 .16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#A3B0E7"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#A4B1E7"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#A5B2E7"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c.01-.07.08-.15.16-.17l1.63-.42c.08-.02.15.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#A6B3E8"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.12c.01-.07.08-.14.16-.16l1.63-.42c.08-.02.15.02.13.1l-.02.12c0 .08-.09.16-.17.18Z",
    fill: "#A7B4E8"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.12c.01-.07.08-.14.16-.16l1.63-.42c.08-.02.15.02.13.1l-.02.12c0 .08-.09.16-.17.18Z",
    fill: "#A8B5E8"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c0 .07-.09.15-.17.17Z",
    fill: "#A9B6E9"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#AAB7E9"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#ABB8E9"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c-.01.07-.09.15-.17.17Z",
    fill: "#ACB9EA"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.12c.01-.07.08-.14.16-.16l1.63-.42c.08-.02.14.02.13.1l-.02.12c-.01.08-.09.16-.17.18Z",
    fill: "#ADBAEA"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c.01-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c-.01.07-.09.14-.17.17Z",
    fill: "#AEBBEA"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c-.01.07-.09.14-.17.17Z",
    fill: "#AFBCEA"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.13c-.01.07-.09.14-.17.17Z",
    fill: "#B0BDEB"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.62-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.09.14-.17.17Z",
    fill: "#B1BEEB"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.62-.42c.09-.02.15.02.14.1l-.02.13c-.01.07-.09.14-.17.17Z",
    fill: "#B1BFEB"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.62-.42c.09-.02.15.02.14.1l-.02.12c-.01.08-.1.15-.17.18Z",
    fill: "#B2C0EC"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08.01-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12a.26.26 0 0 1-.17.18Z",
    fill: "#B3C1EC"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08 0-.13-.03-.12-.1l.02-.11c0-.07.08-.15.16-.17l1.62-.41c.09-.03.15.02.14.09l-.02.12c-.02.08-.1.15-.18.18Z",
    fill: "#B4C2EC"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08 0-.13-.03-.12-.1l.02-.11c0-.07.08-.15.15-.17l1.63-.41c.09-.03.15.02.14.09l-.02.12c-.02.08-.1.15-.18.18Z",
    fill: "#B5C3ED"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.4c-.08 0-.13-.03-.12-.1l.02-.11c0-.07.08-.15.15-.17l1.63-.41c.09-.03.15.02.14.09l-.02.12c-.02.08-.1.15-.18.18Z",
    fill: "#B6C4ED"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.15-.17.17Z",
    fill: "#B7C5ED"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.16-.17.18Z",
    fill: "#B8C6EE"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.16-.17.18Z",
    fill: "#B9C6EE"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.16-.17.18Z",
    fill: "#BAC7EE"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.16-.17.18Z",
    fill: "#BBC8EF"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.08.16-.17.18Z",
    fill: "#BCC9EF"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12a.24.24 0 0 1-.17.18Z",
    fill: "#BDCAEF"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#BECBF0"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "m64.3 7.3-1.63.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#BFCCF0"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.08.08-.15.15-.17l1.63-.42c.08-.02.14.02.13.1l-.02.12c0 .08-.09.15-.17.17Z",
    fill: "#C0CDF0"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.08.08-.15.16-.17l1.62-.42c.08-.02.14.02.13.1l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#C1CEF1"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.08.08-.15.16-.17l1.62-.41c.08-.02.14.02.13.1l-.02.12a.25.25 0 0 1-.17.16Z",
    fill: "#C1CFF1"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.16-.16l1.62-.42c.08-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#C2D0F1"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.16-.16l1.62-.42c.08-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#C3D1F2"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.16-.16l1.62-.42c.08-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#C4D2F2"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.16-.16l1.62-.42c.08-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#C5D3F2"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.63.39c-.07.02-.12-.02-.11-.1l.02-.1c0-.07.08-.14.15-.16l1.63-.42c.08-.02.14.02.13.1l-.02.12c-.01.07-.09.15-.17.17Z",
    fill: "#C6D4F2"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.63-.42c.08-.02.14.02.13.1l-.02.12c-.01.07-.1.15-.17.17Z",
    fill: "#C7D5F3"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.01-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.17l1.63-.41c.08-.02.14.02.13.1l-.02.11c-.01.08-.1.15-.17.17Z",
    fill: "#C8D6F3"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.01-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.17l1.63-.41c.08-.02.14.02.13.1l-.02.11c-.01.08-.1.15-.17.17Z",
    fill: "#C9D7F3"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.39c-.08.01-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.17l1.63-.41c.08-.02.14.02.13.1l-.02.11c-.01.08-.1.15-.17.17Z",
    fill: "#CAD8F4"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.41c.08-.02.15.02.13.09l-.01.12c-.02.08-.1.15-.17.17Z",
    fill: "#CBD9F4"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.62.39c-.07.01-.12-.03-.11-.1l.01-.1c.01-.07.08-.15.16-.17l1.62-.4c.08-.03.14.01.13.08l-.02.13c0 .07-.08.14-.17.16Z",
    fill: "#CCDAF4"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.62.38c-.07.02-.12-.02-.11-.09l.01-.1c.01-.07.08-.15.16-.17l1.62-.4c.08-.03.14.01.13.08l-.02.13c0 .06-.08.14-.17.16Z",
    fill: "#CDDBF5"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "m64.29 7.3-1.62.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.15.01.13.08l-.01.13c-.02.06-.1.14-.17.16Z",
    fill: "#CEDCF5"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.13c0 .06-.08.14-.17.16Z",
    fill: "#CFDDF5"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.13c0 .06-.08.14-.17.16Z",
    fill: "#D0DEF6"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.13c0 .06-.08.14-.17.16Z",
    fill: "#D1DFF6"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.12c0 .07-.09.15-.17.17Z",
    fill: "#D2E0F6"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.12c0 .07-.09.15-.17.17Z",
    fill: "#D2E1F7"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.12c0 .08-.09.15-.17.17Z",
    fill: "#D3E2F7"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.12c0 .08-.09.15-.17.17Z",
    fill: "#D4E3F7"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#D5E4F8"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.13.08l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#D6E5F8"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.61-.4c.09-.03.14.01.13.08l-.01.12c-.01.08-.09.15-.17.17Z",
    fill: "#D7E6F8"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.07-.14.15-.16l1.61-.41c.09-.02.14.02.13.09l-.01.12c-.01.08-.09.15-.17.17Z",
    fill: "#D8E7F9"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.07-.14.15-.16l1.61-.41c.09-.02.14.02.13.09l-.01.12c-.01.08-.09.15-.17.17Z",
    fill: "#D9E8F9"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.07-.14.15-.16l1.61-.41c.09-.02.14.02.13.09l-.01.12c-.01.08-.09.15-.17.17Z",
    fill: "#DAE9F9"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.62-.41c.08-.02.14.02.13.09l-.02.12c-.01.08-.09.15-.17.17Z",
    fill: "#DBEAFA"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.62-.41c.08-.02.14.02.13.09l-.02.12c-.01.08-.1.15-.17.17Z",
    fill: "#DCEBFA"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.61-.4c.09-.03.14.01.13.08l-.01.12c-.01.08-.09.15-.17.17Z",
    fill: "#DDECFA"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.61-.4c.08-.03.14.01.13.08l-.02.12c0 .08-.08.15-.16.17Z",
    fill: "#DEEDFB"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.61-.4c.08-.03.14.01.13.08l-.02.12c0 .08-.08.15-.16.17Z",
    fill: "#DFEEFB"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.07-.15.15-.17l1.61-.4c.08-.03.14.01.13.08l-.02.12c0 .08-.08.15-.16.17Z",
    fill: "#E0EFFB"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.61-.4c.09-.03.14.01.13.08l-.02.12c0 .08-.08.15-.16.17Z",
    fill: "#E1F0FB"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.12.08l-.01.12c-.02.08-.1.15-.17.17Z",
    fill: "#E2F1FC"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.3-1.61.38c-.08.02-.13-.02-.12-.09l.02-.1c0-.07.08-.15.15-.17l1.62-.4c.08-.03.14.01.12.08l-.01.12c-.02.07-.1.15-.17.17Z",
    fill: "#E3F2FC"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.06.08-.14.15-.16l1.61-.4c.09-.03.14.01.13.08l-.02.12c0 .07-.08.15-.16.17Z",
    fill: "#E3F3FC"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.4c-.08 0-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.16l1.61-.41c.08-.03.14.01.13.09l-.02.12c0 .06-.08.14-.16.16Z",
    fill: "#E4F4FD"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.4c-.08 0-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.16l1.61-.41c.08-.03.14.01.13.09l-.02.12c0 .06-.08.14-.16.16Z",
    fill: "#E5F5FD"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.4c-.08 0-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.16l1.61-.41c.08-.03.14.01.13.09l-.02.12c0 .06-.08.14-.16.16Z",
    fill: "#E6F6FD"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.4c-.08 0-.13-.03-.12-.1l.02-.1c0-.07.08-.15.15-.16l1.61-.41c.09-.03.14.01.13.09l-.02.12c0 .06-.09.14-.16.16Z",
    fill: "#E7F7FE"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "m64.28 7.29-1.61.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.61-.4c.09-.03.14.01.13.08l-.02.12a.24.24 0 0 1-.16.17Z",
    fill: "#E8F8FE"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "m64.27 7.29-1.6.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.61-.4c.08-.03.14.01.13.08l-.02.12c-.01.07-.08.15-.17.17Z",
    fill: "#E9F9FE"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "m64.27 7.29-1.6.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.61-.4c.08-.03.14.01.13.08l-.02.12c-.01.07-.08.15-.17.17Z",
    fill: "#EAFAFF"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "m64.27 7.29-1.6.39c-.08.02-.13-.03-.12-.1l.02-.1c0-.07.08-.14.15-.16l1.6-.4c.1-.03.15.01.14.08l-.02.12c-.01.07-.08.15-.17.17Z",
    fill: "#EBFBFF"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "m64.27 7.29-1.6.39c-.08.02-.13-.02-.12-.1l.02-.1c0-.06.08-.14.15-.16l1.6-.4c.1-.03.15.01.14.09l-.02.11c-.01.07-.08.15-.17.17Z",
    fill: "#E4F2F4"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "m64.8 14.34-8.38 1.65c-.3.05-.5-.16-.44-.46l.1-.5a.9.9 0 0 1 .64-.67l8.31-1.77c.35-.08.6.13.57.45l-.07.58c-.04.33-.37.66-.72.72Z",
    fill: "#3794C7"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "m64.8 14.33-8.38 1.65c-.3.05-.5-.16-.44-.46l.1-.5a.9.9 0 0 1 .64-.66l8.3-1.77c.34-.07.6.13.56.46l-.07.57c-.04.33-.36.65-.72.71Z",
    fill: "#3C99C9"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "m64.78 14.32-8.36 1.65c-.3.05-.5-.16-.44-.46l.1-.5c.05-.3.34-.59.64-.65l8.27-1.77c.35-.07.6.13.57.46l-.07.56c-.04.33-.36.65-.71.71Z",
    fill: "#419ECC"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "m64.77 14.32-8.35 1.64c-.3.05-.5-.16-.44-.46l.1-.48c.06-.3.34-.6.64-.66l8.26-1.76c.35-.07.6.13.56.45l-.07.56c-.04.33-.36.64-.7.7Z",
    fill: "#47A4CE"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "m64.75 14.3-8.33 1.65c-.3.05-.5-.15-.44-.46l.1-.48c.05-.3.34-.59.63-.65l8.25-1.76c.35-.07.6.13.56.45l-.07.55c-.04.33-.35.65-.7.7Z",
    fill: "#4CA9D1"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "m64.73 14.3-8.31 1.64c-.3.05-.49-.15-.43-.45l.09-.47c.06-.3.34-.6.63-.65l8.24-1.76c.34-.07.59.13.55.45l-.07.54c-.04.33-.35.64-.7.7Z",
    fill: "#51AED3"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "m64.72 14.3-8.3 1.63c-.3.05-.49-.15-.43-.45l.09-.47c.05-.3.33-.58.63-.64l8.22-1.76c.34-.07.59.13.55.45l-.07.54c-.04.32-.35.63-.7.7Z",
    fill: "#56B3D6"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "m64.7 14.29-8.28 1.63c-.3.05-.49-.15-.43-.45l.09-.46c.05-.3.33-.58.62-.65l8.22-1.75c.33-.07.58.13.54.45l-.07.53c-.03.33-.35.64-.69.7Z",
    fill: "#5BB8D8"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "m64.69 14.28-8.28 1.63c-.29.05-.48-.15-.42-.44l.09-.46c.05-.3.33-.58.62-.64l8.2-1.75c.33-.07.58.13.54.44l-.07.53c-.03.32-.34.63-.68.7Z",
    fill: "#60BDDB"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "m64.67 14.27-8.26 1.63c-.28.05-.47-.15-.42-.44l.09-.45c.05-.3.33-.58.62-.64l8.18-1.75c.33-.07.58.13.54.44l-.06.53c-.04.31-.35.62-.69.68Z",
    fill: "#66C3DD"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "m64.66 14.27-8.25 1.63c-.28.05-.47-.15-.42-.45l.1-.45c.05-.29.32-.57.6-.63l8.18-1.75c.33-.07.57.13.54.45l-.07.51a.87.87 0 0 1-.68.69Z",
    fill: "#6BC8E0"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "m64.64 14.26-8.23 1.63c-.28.05-.47-.15-.41-.45l.08-.44a.85.85 0 0 1 .61-.63l8.16-1.74c.33-.07.57.13.54.44l-.07.5a.87.87 0 0 1-.68.69Z",
    fill: "#70CDE2"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "m64.64 14.26-8.23 1.63c-.28.05-.47-.15-.41-.45l.08-.44a.85.85 0 0 1 .61-.63l8.16-1.74c.33-.07.57.13.54.44l-.07.5a.87.87 0 0 1-.68.69Z",
    fill: "url(#cj)"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.02-.08.1-.16.17-.18l2.27-.47c.09-.02.15.03.14.11l-.03.15a.24.24 0 0 1-.18.18Z",
    fill: "#69CBE0"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.02-.08.1-.16.17-.18l2.27-.47c.09-.02.15.03.14.11l-.03.15a.24.24 0 0 1-.18.18Z",
    fill: "#6ACBE0"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.01-.08.09-.16.17-.18l2.27-.47c.08-.02.14.03.13.11l-.02.15a.23.23 0 0 1-.18.18Z",
    fill: "#6BCCE0"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.01-.08.09-.16.17-.18l2.27-.47c.08-.02.14.03.13.11l-.02.15a.23.23 0 0 1-.18.18Z",
    fill: "#6CCCE1"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.01-.08.09-.16.17-.18l2.27-.47c.08-.02.14.03.13.11l-.03.15c0 .08-.09.17-.17.18Z",
    fill: "#6DCCE1"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.01-.08.09-.16.17-.18l2.27-.47c.08-.02.14.03.13.11l-.03.15a.23.23 0 0 1-.17.18Z",
    fill: "#6ECDE1"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.81-2.27.46c-.08.01-.14-.04-.12-.12l.02-.13c.01-.08.09-.16.17-.18l2.26-.47c.09-.02.15.03.14.11l-.03.15a.23.23 0 0 1-.17.18Z",
    fill: "#6FCDE1"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.8-2.27.47c-.08 0-.14-.04-.12-.12l.02-.13c.01-.08.09-.16.17-.18l2.26-.47c.09-.02.15.03.14.11l-.03.15c0 .08-.09.16-.17.18Z",
    fill: "#70CEE2"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "m59.35 14.8-2.27.47c-.08 0-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.18l2.27-.47c.08-.02.14.03.13.11l-.02.15a.24.24 0 0 1-.18.18Z",
    fill: "#71CEE2"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.81-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14c0 .08-.09.16-.18.18Z",
    fill: "#72CEE2"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.81-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.27-.48c.08-.02.14.04.13.12l-.03.14c0 .08-.09.16-.18.18Z",
    fill: "#73CFE2"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.81-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.27-.48c.08-.02.14.04.13.12l-.03.14a.24.24 0 0 1-.18.18Z",
    fill: "#74CFE3"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.81-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#75CFE3"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.81-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14c-.01.08-.1.16-.18.18Z",
    fill: "#76D0E3"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.18l2.26-.47c.09-.02.15.03.13.11l-.02.15a.23.23 0 0 1-.18.18Z",
    fill: "#77D0E3"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.22.22 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#78D1E4"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.26.46c-.08.02-.13-.04-.12-.11l.02-.13a.22.22 0 0 1 .17-.17l2.27-.48c.08-.02.14.04.13.12l-.03.14a.23.23 0 0 1-.18.18Z",
    fill: "#79D1E4"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.22.22 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#7AD1E4"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.22.22 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#7BD2E4"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.22.22 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#7CD2E5"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#7DD2E5"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#7ED3E5"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14c-.01.08-.1.16-.18.18Z",
    fill: "#7FD3E5"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#80D3E5"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.26.46c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.02.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#81D4E6"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.01.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#82D4E6"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.01.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#83D5E6"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.01.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#84D5E6"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.09-.01.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#85D5E7"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.11l.02-.13a.23.23 0 0 1 .17-.17l2.26-.48c.08-.01.14.04.13.12l-.02.14c-.02.08-.1.16-.18.18Z",
    fill: "#86D6E7"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .17-.17l2.26-.48c.08-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#87D6E7"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .17-.17l2.26-.48c.08-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#88D6E7"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .17-.17l2.26-.48c.08-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#89D7E8"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.02-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .17-.17l2.26-.48c.08-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#8AD7E8"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.47c.08-.02.14.03.13.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#8BD8E8"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.47c.08-.02.14.03.13.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#8CD8E8"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.47c.08-.02.14.03.13.11l-.02.15a.24.24 0 0 1-.18.17Z",
    fill: "#8DD8E9"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.47c.08-.02.14.03.13.11l-.03.15a.23.23 0 0 1-.17.17Z",
    fill: "#8ED9E9"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.47c.08-.02.14.03.13.11l-.03.15a.23.23 0 0 1-.17.17Z",
    fill: "#8FD9E9"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "m59.34 14.8-2.27.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.26-.47c.08-.02.14.03.13.11l-.03.15a.23.23 0 0 1-.17.17Z",
    fill: "#90D9E9"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.15.03.13.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#91DAEA"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.15.03.13.11l-.02.15c-.01.08-.1.16-.18.17Z",
    fill: "#92DAEA"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.15.03.13.11l-.02.15a.24.24 0 0 1-.18.17Z",
    fill: "#93DBEA"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .17-.17l2.25-.48c.09-.02.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#94DBEA"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .17-.17l2.25-.48c.09-.02.15.04.13.12l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#95DBEA"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.15.03.13.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#96DCEB"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.03.13.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#97DCEB"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.03.13.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#98DCEB"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .16-.17l2.26-.47c.08-.02.14.03.13.11l-.02.15c-.01.08-.1.16-.18.17Z",
    fill: "#99DDEB"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .16-.17l2.26-.47c.08-.02.14.03.13.11l-.03.15c0 .08-.08.16-.17.17Z",
    fill: "#9ADDEC"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#9BDDEC"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#9CDEEC"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.04.13.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#9DDEEC"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#9EDFED"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#9FDFED"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.09-.02.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#A0DFED"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.08-.02.14.04.13.12l-.03.13a.23.23 0 0 1-.17.18Z",
    fill: "#A1E0ED"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.46c-.07.01-.13-.04-.11-.12l.02-.13a.23.23 0 0 1 .17-.17l2.25-.47c.08-.02.14.04.13.12l-.03.13a.23.23 0 0 1-.17.18Z",
    fill: "#A2E0EE"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.09-.01.14.04.13.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#A3E0EE"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.09-.01.14.04.13.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#A4E1EE"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.46c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.09-.01.14.04.13.12l-.02.14a.24.24 0 0 1-.18.17Z",
    fill: "#A5E1EE"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.09-.01.14.04.13.12l-.02.14a.24.24 0 0 1-.18.17Z",
    fill: "#A6E2EF"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.09-.01.14.04.13.12l-.02.14a.24.24 0 0 1-.18.17Z",
    fill: "#A7E2EF"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.45c-.07.02-.13-.03-.11-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.03.14a.23.23 0 0 1-.17.17Z",
    fill: "#A8E2EF"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.45c-.07.02-.13-.03-.11-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.03.14a.23.23 0 0 1-.17.17Z",
    fill: "#A9E3EF"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.26.45c-.07.02-.13-.03-.11-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.03.14a.23.23 0 0 1-.17.17Z",
    fill: "#AAE3F0"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#ABE3F0"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#ACE4F0"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.24.24 0 0 1-.18.18Z",
    fill: "#ADE4F0"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.24.24 0 0 1-.18.18Z",
    fill: "#AEE4F0"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.03-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.24.24 0 0 1-.18.18Z",
    fill: "#AFE5F1"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l2.25-.47c.08-.02.14.04.13.12l-.03.13a.23.23 0 0 1-.17.18Z",
    fill: "#B0E5F1"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l2.25-.47c.08-.02.14.04.13.12l-.03.13a.23.23 0 0 1-.17.18Z",
    fill: "#B1E6F1"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.03.13a.24.24 0 0 1-.17.18Z",
    fill: "#B2E6F1"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.13.12l-.03.13a.24.24 0 0 1-.17.18Z",
    fill: "#B3E6F2"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.12.12l-.02.13a.24.24 0 0 1-.17.18Z",
    fill: "#B4E7F2"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.12.12l-.02.13a.23.23 0 0 1-.17.18Z",
    fill: "#B5E7F2"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.12.12l-.02.13a.23.23 0 0 1-.17.18Z",
    fill: "#B6E7F2"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "m59.33 14.8-2.25.45c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.16l2.25-.48c.08-.01.14.04.12.12l-.02.13a.23.23 0 0 1-.17.18Z",
    fill: "#B7E8F3"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.02-.13-.04-.12-.11l.02-.12a.23.23 0 0 1 .17-.17l2.25-.48c.08-.01.14.04.12.12l-.02.14a.23.23 0 0 1-.18.17Z",
    fill: "#B8E8F3"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.02-.13-.04-.11-.11l.02-.12a.23.23 0 0 1 .16-.17l2.25-.48c.08-.01.14.04.13.12l-.02.14a.22.22 0 0 1-.18.17Z",
    fill: "#B9E9F3"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.22.22 0 0 1-.18.18Z",
    fill: "#BAE9F3"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#BBE9F4"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.16l2.24-.48c.08-.01.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#BCEAF4"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.16l2.24-.48c.08-.01.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#BDEAF4"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.16l2.24-.48c.08-.01.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#BEEAF4"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.16l2.24-.48c.08-.01.14.04.13.12l-.02.13a.24.24 0 0 1-.18.18Z",
    fill: "#BFEBF5"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.16l2.25-.48c.08-.01.14.04.13.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#C0EBF5"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.16l2.25-.48c.08-.01.14.04.12.12l-.02.13c0 .08-.09.16-.17.18Z",
    fill: "#C1EBF5"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.16l2.25-.48c.08-.01.14.04.12.12l-.02.13c0 .08-.09.16-.17.18Z",
    fill: "#C2ECF5"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.13-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.17l2.25-.47c.08-.01.14.04.12.12l-.02.13c0 .08-.09.16-.17.18Z",
    fill: "#C3ECF5"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13a.22.22 0 0 1-.17.18Z",
    fill: "#C4EDF6"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.12a.23.23 0 0 1 .17-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13a.22.22 0 0 1-.17.18Z",
    fill: "#C5EDF6"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.12a.23.23 0 0 1 .17-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13a.23.23 0 0 1-.17.18Z",
    fill: "#C6EDF6"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.17l2.25-.47c.08-.01.14.04.12.12l-.02.13a.22.22 0 0 1-.17.18Z",
    fill: "#C7EEF6"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.17l2.25-.47c.08-.01.14.04.12.12l-.02.13a.22.22 0 0 1-.17.18Z",
    fill: "#C8EEF7"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.17l2.25-.47c.08-.01.14.04.12.12l-.02.13c-.01.08-.09.16-.17.18Z",
    fill: "#C9EEF7"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.11-.12l.02-.12a.23.23 0 0 1 .16-.17l2.25-.47c.08-.01.14.04.12.12l-.02.13c-.01.08-.09.16-.17.18Z",
    fill: "#CAEFF7"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.12a.23.23 0 0 1 .17-.17l2.24-.47c.08-.01.14.04.12.12l-.02.13a.22.22 0 0 1-.17.18Z",
    fill: "#CBEFF7"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.12a.23.23 0 0 1 .17-.17l2.24-.47c.08-.01.14.04.12.12l-.02.13a.23.23 0 0 1-.17.18Z",
    fill: "#CCF0F8"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.03-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13a.24.24 0 0 1-.17.18Z",
    fill: "#CDF0F8"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.24.45c-.08.01-.13-.04-.12-.12l.03-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.14a.24.24 0 0 1-.17.17Z",
    fill: "#CEF0F8"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .17-.17l2.24-.47c.08-.02.14.03.12.11l-.02.14a.23.23 0 0 1-.17.17Z",
    fill: "#CFF1F8"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .17-.17l2.24-.47c.08-.02.14.03.12.11l-.02.14c-.01.07-.1.15-.17.17Z",
    fill: "#D0F1F9"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .17-.17l2.24-.47c.08-.02.14.03.12.11l-.02.14c-.01.07-.1.15-.17.17Z",
    fill: "#D1F1F9"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .17-.17l2.23-.47c.09-.02.14.03.13.11l-.02.14a.23.23 0 0 1-.17.17Z",
    fill: "#D2F2F9"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .17-.17l2.23-.47c.09-.02.14.03.13.11l-.02.14a.23.23 0 0 1-.17.17Z",
    fill: "#D3F2F9"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .17-.17l2.23-.47c.09-.01.14.04.13.12l-.02.13a.22.22 0 0 1-.17.17Z",
    fill: "#D4F3FA"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .17-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.23.23 0 0 1-.17.17Z",
    fill: "#D5F3FA"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "m59.32 14.8-2.25.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .17-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.23.23 0 0 1-.17.17Z",
    fill: "#D6F3FA"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .16-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13c0 .08-.08.16-.17.17Z",
    fill: "#D7F4FA"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .16-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13a.22.22 0 0 1-.17.17Z",
    fill: "#D8F4FA"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .16-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13a.22.22 0 0 1-.17.17Z",
    fill: "#D9F4FB"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .16-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13c0 .08-.08.16-.17.17Z",
    fill: "#DAF5FB"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.03-.1-.11l.01-.12a.22.22 0 0 1 .16-.17l2.24-.47c.08-.01.14.04.13.12l-.03.13c0 .08-.08.16-.17.17Z",
    fill: "#DBF5FB"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.14c0 .07-.08.15-.17.16Z",
    fill: "#DCF5FB"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.14a.22.22 0 0 1-.17.16Z",
    fill: "#DDF6FC"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.14a.22.22 0 0 1-.17.16Z",
    fill: "#DEF6FC"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.14a.23.23 0 0 1-.17.16Z",
    fill: "#DFF7FC"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.13a.23.23 0 0 1-.17.17Z",
    fill: "#E0F7FC"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.22.22 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.13a.23.23 0 0 1-.17.17Z",
    fill: "#E1F7FD"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.23.23 0 0 1 .16-.17l2.24-.47c.08-.02.14.03.13.11l-.03.13a.23.23 0 0 1-.17.17Z",
    fill: "#E2F8FD"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.22.22 0 0 1-.17.17Z",
    fill: "#E3F8FD"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.22.22 0 0 1-.17.17Z",
    fill: "#E4F8FD"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.23.23 0 0 1-.17.17Z",
    fill: "#E5F9FE"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.23.23 0 0 1-.17.17Z",
    fill: "#E6F9FE"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.23.23 0 0 1-.17.17Z",
    fill: "#E7FAFE"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.02-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.22.22 0 0 1-.17.17Z",
    fill: "#E8FAFE"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.01-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.22.22 0 0 1-.17.17Z",
    fill: "#E9FAFF"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.01-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.24-.47c.08-.01.13.04.12.12l-.02.13a.22.22 0 0 1-.17.17Z",
    fill: "#EAFBFF"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.8-2.24.44c-.07.01-.12-.04-.1-.11l.01-.12a.23.23 0 0 1 .16-.17l2.23-.47c.09-.01.14.04.13.12l-.02.12a.22.22 0 0 1-.17.18Z",
    fill: "#EBFBFF"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "m59.31 14.79-2.24.45c-.07.01-.12-.04-.1-.12l.01-.11a.23.23 0 0 1 .16-.17l2.23-.47c.09-.02.14.04.13.11l-.02.13a.22.22 0 0 1-.17.18Z",
    fill: "#EFFAFC"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.96.79c-.08.01-.14-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.02.15c-.01.09-.1.17-.19.18Z",
    fill: "#69CBE0"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.96.79c-.08.01-.14-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.02.15c-.01.09-.1.17-.19.18Z",
    fill: "#6ACBE0"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.96.79c-.08.01-.14-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.02.15c-.01.09-.1.17-.19.18Z",
    fill: "#6BCCE0"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.96.79c-.08.01-.14-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.02.15c-.01.09-.1.17-.19.18Z",
    fill: "#6CCCE1"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.96.79c-.08.01-.14-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.02.15c-.01.09-.1.17-.19.18Z",
    fill: "#6DCCE1"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.96.79c-.08.01-.14-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.02.15a.24.24 0 0 1-.19.18Z",
    fill: "#6ECDE1"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "m64.2 13.83-3.95.79c-.09.01-.14-.04-.13-.12l.02-.14c.01-.08.1-.16.18-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15a.24.24 0 0 1-.19.18Z",
    fill: "#6FCDE1"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.79c-.08.01-.13-.04-.12-.12l.02-.14c.01-.08.1-.16.17-.17l3.94-.8c.1-.03.16.03.15.11l-.03.15c0 .09-.09.17-.18.18Z",
    fill: "#70CEE2"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.79c-.08.01-.13-.04-.12-.12l.02-.14c.01-.08.09-.16.17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.09.17-.18.18Z",
    fill: "#71CEE2"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.79c-.08.01-.13-.04-.12-.12l.02-.14a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.09.17-.18.18Z",
    fill: "#72CEE2"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.79c-.08.01-.13-.04-.12-.12l.02-.14a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.09.17-.18.18Z",
    fill: "#73CFE2"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.79c-.08.01-.13-.04-.12-.12l.02-.14a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.09.17-.18.18Z",
    fill: "#74CFE3"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.79c-.08.01-.13-.04-.12-.12l.02-.14a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.1.17-.18.18Z",
    fill: "#75CFE3"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.1.17-.18.18Z",
    fill: "#76D0E3"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .09-.1.17-.18.18Z",
    fill: "#77D0E3"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c0 .08-.1.17-.18.18Z",
    fill: "#78D1E4"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#79D1E4"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.94-.8c.09-.03.15.03.14.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#7AD1E4"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#7BD2E4"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#7CD2E5"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#7DD2E5"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.18l3.93-.8c.1-.02.16.04.15.12l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#7ED3E5"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#7FD3E5"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#80D3E5"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#81D4E6"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.02-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#82D4E6"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#83D5E6"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "m64.19 13.83-3.95.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.16.03.15.11l-.02.15c-.01.08-.1.17-.18.18Z",
    fill: "#84D5E6"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.15c0 .08-.09.17-.18.18Z",
    fill: "#85D5E7"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.15c0 .08-.09.17-.18.18Z",
    fill: "#86D6E7"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.1-.03.16.03.15.11l-.02.15a.23.23 0 0 1-.19.18Z",
    fill: "#87D6E7"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15c-.01.08-.1.16-.19.18Z",
    fill: "#88D6E7"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15c-.01.08-.1.16-.19.18Z",
    fill: "#89D7E8"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15c-.02.08-.1.16-.19.18Z",
    fill: "#8AD7E8"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15a.24.24 0 0 1-.19.18Z",
    fill: "#8BD8E8"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.15c0 .08-.09.16-.18.18Z",
    fill: "#8CD8E8"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.15c0 .08-.09.16-.18.18Z",
    fill: "#8DD8E9"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15a.25.25 0 0 1-.19.18Z",
    fill: "#8ED9E9"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.16.03.15.11l-.02.15a.25.25 0 0 1-.19.18Z",
    fill: "#8FD9E9"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.14a.24.24 0 0 1-.18.19Z",
    fill: "#90D9E9"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15a.24.24 0 0 1-.18.18Z",
    fill: "#91DAEA"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15a.24.24 0 0 1-.18.18Z",
    fill: "#92DAEA"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.18Z",
    fill: "#93DBEA"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.18Z",
    fill: "#94DBEA"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.14-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.14c0 .1-.1.17-.18.19Z",
    fill: "#95DBEA"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.03.15.03.14.11l-.02.14a.24.24 0 0 1-.18.19Z",
    fill: "#96DCEB"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15a.24.24 0 0 1-.18.18Z",
    fill: "#97DCEB"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15c-.01.08-.1.16-.18.18Z",
    fill: "#98DCEB"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.93-.8c.09-.02.15.03.14.11l-.02.15c-.01.08-.1.16-.18.18Z",
    fill: "#99DDEB"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.16.03.15.11l-.02.15c-.01.08-.1.16-.18.18Z",
    fill: "#9ADDEC"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.16.03.15.11l-.02.15c-.01.08-.1.16-.18.18Z",
    fill: "#9BDDEC"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.16.03.14.11l-.01.15c-.01.08-.1.16-.18.18Z",
    fill: "#9CDEEC"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.16.03.14.11l-.01.15c-.01.08-.1.16-.18.18Z",
    fill: "#9DDEEC"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.16.03.15.11l-.02.15c-.01.08-.1.16-.18.18Z",
    fill: "#9EDFED"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.16.03.15.11l-.02.15a.24.24 0 0 1-.18.18Z",
    fill: "#9FDFED"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "m64.18 13.83-3.94.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.16.03.14.11l-.01.15c-.01.08-.1.16-.18.18Z",
    fill: "#A0DFED"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.83-3.93.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14c0 .09-.09.17-.18.19Z",
    fill: "#A1E0ED"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.83-3.93.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14c0 .09-.09.17-.18.19Z",
    fill: "#A2E0EE"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.83-3.93.78c-.08.01-.13-.04-.12-.12l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.04.14.12l-.02.14c0 .08-.09.16-.18.18Z",
    fill: "#A3E0EE"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.17Z",
    fill: "#A4E1EE"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.17Z",
    fill: "#A5E1EE"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.15.03.14.11l-.01.15a.23.23 0 0 1-.19.17Z",
    fill: "#A6E2EF"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.1-.02.15.03.14.11l-.01.15a.23.23 0 0 1-.19.17Z",
    fill: "#A7E2EF"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.17Z",
    fill: "#A8E2EF"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.17Z",
    fill: "#A9E3EF"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.11l.02-.13a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15c0 .08-.09.16-.18.17Z",
    fill: "#AAE3F0"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.18l3.92-.8c.09-.01.15.04.14.12l-.02.14c0 .09-.09.17-.18.18Z",
    fill: "#ABE3F0"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.02-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.18l3.92-.8c.09-.01.15.04.14.12l-.02.14c0 .09-.09.17-.18.18Z",
    fill: "#ACE4F0"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15a.23.23 0 0 1-.18.17Z",
    fill: "#ADE4F0"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15a.24.24 0 0 1-.18.17Z",
    fill: "#AEE4F0"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15a.24.24 0 0 1-.18.17Z",
    fill: "#AFE5F1"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.92-.8c.08-.02.15.03.14.11l-.02.15c-.01.08-.1.16-.18.17Z",
    fill: "#B0E5F1"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.15c-.01.08-.1.16-.18.17Z",
    fill: "#B1E6F1"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#B2E6F1"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.18l3.92-.8c.09-.01.15.04.14.12l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#B3E6F2"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#B4E7F2"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#B5E7F2"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#B6E7F2"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#B7E8F3"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.08-.02.15.03.14.11l-.02.14c-.01.09-.1.17-.18.18Z",
    fill: "#B8E8F3"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.08-.02.15.03.14.11l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#B9E9F3"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.08-.02.15.03.14.11l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#BAE9F3"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.08-.02.15.03.14.11l-.02.14c-.02.09-.1.17-.18.18Z",
    fill: "#BBE9F4"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.08-.02.15.03.14.11l-.02.14c-.02.09-.1.17-.18.18Z",
    fill: "#BCEAF4"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.92-.8c.09-.02.15.03.14.11l-.02.14a.24.24 0 0 1-.18.18Z",
    fill: "#BDEAF4"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.91-.8c.1-.02.16.03.14.11l-.02.14a.23.23 0 0 1-.17.18Z",
    fill: "#BEEAF4"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.91-.8c.09-.02.16.03.14.11l-.02.14a.23.23 0 0 1-.17.18Z",
    fill: "#BFEBF5"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.91-.8c.09-.02.15.03.14.11l-.02.14c0 .09-.09.17-.17.18Z",
    fill: "#C0EBF5"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "m64.17 13.82-3.93.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.91-.8c.09-.02.15.03.14.11l-.02.14c0 .09-.09.17-.17.18Z",
    fill: "#C1EBF5"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.18l3.91-.8c.09-.01.15.04.14.12l-.02.14c0 .09-.09.17-.18.18Z",
    fill: "#C2ECF5"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.18l3.91-.8c.09-.01.15.04.14.12l-.02.14c0 .09-.09.17-.18.18Z",
    fill: "#C3ECF5"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.18l3.91-.8c.09-.01.15.04.14.12l-.02.14a.22.22 0 0 1-.18.18Z",
    fill: "#C4EDF6"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.18l3.91-.8c.09-.01.15.04.14.12l-.02.14a.22.22 0 0 1-.18.18Z",
    fill: "#C5EDF6"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.91-.8c.09-.02.15.03.14.11l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#C6EDF6"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.91-.8c.09-.02.15.03.14.11l-.02.14a.23.23 0 0 1-.18.18Z",
    fill: "#C7EEF6"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.11l-.02.14c0 .08-.1.16-.18.18Z",
    fill: "#C8EEF7"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.11l-.02.14c0 .08-.1.16-.18.18Z",
    fill: "#C9EEF7"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#CAEFF7"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#CBEFF7"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .16-.17l3.92-.8c.08-.02.15.04.14.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#CCF0F8"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#CDF0F8"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#CEF0F8"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#CFF1F8"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D0F1F9"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08 0-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D1F1F9"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08 0-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D2F2F9"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08 0-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .16-.17l3.91-.8c.09-.02.15.03.14.12l-.02.13c0 .08-.08.16-.17.18Z",
    fill: "#D3F2F9"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08 0-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D4F3FA"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08 0-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D5F3FA"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08 0-.13-.04-.12-.12l.02-.12a.23.23 0 0 1 .17-.17l3.9-.8c.1-.02.16.03.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D6F3FA"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.03-.12-.11l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#D7F4FA"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.78c-.08.01-.13-.04-.12-.12l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.1-.01.15.04.14.12l-.01.14c-.02.08-.1.15-.18.17Z",
    fill: "#D8F4FA"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.15.04.14.12l-.02.13c0 .08-.09.16-.17.18Z",
    fill: "#D9F4FB"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.15.04.14.12l-.02.13c0 .08-.09.16-.17.18Z",
    fill: "#DAF5FB"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.14.12l-.02.13a.24.24 0 0 1-.17.18Z",
    fill: "#DBF5FB"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.14.12l-.02.13a.24.24 0 0 1-.17.18Z",
    fill: "#DCF5FB"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.14.12l-.02.13a.24.24 0 0 1-.17.18Z",
    fill: "#DDF6FC"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.1-.02.16.04.14.12l-.02.13a.24.24 0 0 1-.17.18Z",
    fill: "#DEF6FC"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .17-.17l3.9-.8c.09-.02.15.04.14.12l-.02.13a.23.23 0 0 1-.17.18Z",
    fill: "#DFF7FC"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "m64.16 13.82-3.92.77c-.08.02-.13-.03-.12-.11l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.09-.01.15.04.14.12l-.02.13c0 .08-.09.16-.17.18Z",
    fill: "#E0F7FC"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.02-.14-.03-.13-.11l.02-.12a.22.22 0 0 1 .17-.17l3.9-.8c.09-.01.15.04.14.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#E1F7FD"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.02-.14-.03-.13-.11l.02-.12a.22.22 0 0 1 .16-.17l3.9-.8c.1-.01.16.04.15.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#E2F8FD"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.02-.14-.03-.13-.11l.02-.12a.22.22 0 0 1 .16-.17l3.9-.8c.1-.01.16.04.15.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#E3F8FD"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.01-.14-.04-.13-.12l.02-.11a.22.22 0 0 1 .16-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13c-.01.08-.1.16-.18.18Z",
    fill: "#E4F8FD"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.01-.14-.04-.13-.12l.02-.11a.22.22 0 0 1 .16-.17l3.91-.8c.09-.02.15.04.14.12l-.02.13c-.01.08-.09.16-.18.18Z",
    fill: "#E5F9FE"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.01-.14-.04-.13-.12l.02-.11a.22.22 0 0 1 .16-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13c-.01.08-.09.16-.18.18Z",
    fill: "#E6F9FE"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.9.77c-.09.01-.14-.04-.13-.12l.02-.11a.22.22 0 0 1 .16-.17l3.9-.8c.1-.02.16.04.15.12l-.02.13a.23.23 0 0 1-.18.18Z",
    fill: "#E7FAFE"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.91.77c-.08.01-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .16-.17l3.9-.8c.1-.02.15.04.14.12l-.02.13c0 .08-.08.16-.17.18Z",
    fill: "#E8FAFE"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.91.77c-.08.01-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .16-.17l3.9-.8c.1-.02.15.04.14.12l-.02.13c0 .08-.08.16-.17.18Z",
    fill: "#E9FAFF"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.91.77c-.08.02-.13-.04-.12-.11l.02-.12a.22.22 0 0 1 .16-.17l3.9-.8c.1-.01.15.04.14.12l-.02.13c0 .08-.08.16-.17.18Z",
    fill: "#EAFBFF"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.91.77c-.08.02-.13-.04-.12-.11l.02-.12a.22.22 0 0 1 .16-.17l3.9-.8c.1-.01.15.04.14.12l-.02.13c0 .08-.08.16-.17.18Z",
    fill: "#EBFBFF"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "m64.15 13.82-3.91.77c-.08.01-.13-.04-.12-.12l.02-.11a.22.22 0 0 1 .16-.17l3.9-.8c.1-.01.15.04.14.12l-.02.13c0 .08-.08.16-.17.18Z",
    fill: "#EFFAFC"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M72.35 13.27 70 13.7c-.28.05-.49-.14-.46-.41l.15-1.53a.77.77 0 0 1 .56-.62l2.34-.56c.32-.08.56.1.53.39l-.14 1.65c-.02.3-.3.59-.63.65Z",
    fill: "#BB6694"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M72.34 13.26 70 13.7c-.28.05-.49-.13-.46-.4l.15-1.53a.76.76 0 0 1 .56-.62l2.33-.56c.31-.07.55.1.53.4l-.14 1.64c-.03.3-.31.59-.63.64Z",
    fill: "#BF6B98"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "m72.33 13.26-2.34.42c-.27.05-.48-.13-.45-.4l.15-1.52a.76.76 0 0 1 .55-.61l2.32-.56c.31-.08.55.1.53.39l-.14 1.63c-.03.3-.3.59-.62.65Z",
    fill: "#C46F9C"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "m72.31 13.25-2.32.42c-.27.05-.48-.13-.45-.4l.15-1.51a.76.76 0 0 1 .55-.61l2.3-.56c.32-.08.56.1.53.39l-.14 1.63c-.02.3-.3.58-.62.64Z",
    fill: "#C874A1"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "m72.3 13.24-2.3.42c-.29.05-.49-.13-.46-.4l.15-1.5a.75.75 0 0 1 .55-.62l2.3-.55c.3-.07.54.1.51.39l-.13 1.62c-.03.3-.31.59-.62.64Z",
    fill: "#CC79A5"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "m72.28 13.24-2.29.42c-.28.05-.48-.13-.45-.4l.15-1.5a.75.75 0 0 1 .55-.61l2.28-.55c.3-.08.54.1.52.39l-.14 1.61c-.03.3-.3.58-.62.64Z",
    fill: "#D07DA9"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "m72.27 13.23-2.28.42c-.28.05-.48-.14-.45-.4l.15-1.5a.75.75 0 0 1 .54-.6l2.27-.55c.3-.07.54.1.52.38l-.14 1.61c-.03.3-.3.58-.61.64Z",
    fill: "#D582AD"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "m72.26 13.22-2.27.42c-.27.05-.47-.13-.44-.4l.14-1.5a.74.74 0 0 1 .54-.6l2.26-.54c.3-.07.53.1.5.38l-.13 1.61c-.02.3-.3.58-.6.63Z",
    fill: "#D986B1"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "m72.24 13.22-2.25.4c-.27.06-.47-.12-.44-.4l.14-1.48a.74.74 0 0 1 .54-.6l2.24-.54c.3-.07.54.1.51.39l-.13 1.6c-.03.29-.3.57-.6.63Z",
    fill: "#DD8BB5"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "m72.23 13.21-2.25.41c-.27.05-.46-.13-.43-.4l.14-1.47a.74.74 0 0 1 .54-.6l2.23-.54c.3-.07.53.1.5.39l-.13 1.59c-.03.28-.3.57-.6.62Z",
    fill: "#E190BA"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "m72.22 13.2-2.24.41c-.27.05-.46-.12-.43-.4l.14-1.47a.73.73 0 0 1 .53-.59l2.22-.54c.3-.07.53.1.5.39l-.13 1.58c-.02.29-.3.57-.6.63Z",
    fill: "#E694BE"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "m72.2 13.2-2.22.4c-.26.06-.46-.12-.43-.39l.14-1.47a.73.73 0 0 1 .53-.59l2.2-.53c.3-.07.53.1.5.38l-.13 1.58c-.02.29-.29.57-.59.62Z",
    fill: "#EA99C2"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "m72.2 13.2-2.22.4c-.26.05-.46-.12-.43-.4l.14-1.46a.73.73 0 0 1 .53-.59l2.2-.53c.3-.07.53.1.5.38l-.13 1.58c-.02.28-.29.56-.59.62Z",
    fill: "url(#ck)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 28.42,
    y1: 2.69,
    x2: 39.77,
    y2: 42.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1EFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EDECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E3E5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#DEDEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 41.73,
    y1: 39.31,
    x2: 43.02,
    y2: 44.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E3E1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DDDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CCC7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B0A7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B0A7CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 32.83,
    y1: 7.71,
    x2: 33.16,
    y2: 11.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 37.62,
    y1: 11.81,
    x2: 37.78,
    y2: 13.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 31.83,
    y1: 12.86,
    x2: 31.97,
    y2: 14.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 41.87,
    y1: 17.85,
    x2: 34.46,
    y2: 19.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 41.86,
    y1: 17.83,
    x2: 34.55,
    y2: 19.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 38.1,
    y1: 17.22,
    x2: 38.29,
    y2: 19.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 33.63,
    y1: 19.22,
    x2: 29.53,
    y2: 19.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 33.62,
    y1: 19.19,
    x2: 29.62,
    y2: 19.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 31.53,
    y1: 18.45,
    x2: 31.7,
    y2: 20.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 36.17,
    y1: 24.48,
    x2: 32.07,
    y2: 25.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 36.17,
    y1: 24.45,
    x2: 32.16,
    y2: 25.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 34.06,
    y1: 23.69,
    x2: 34.25,
    y2: 25.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 28.62,
    y1: 20.04,
    x2: 24.51,
    y2: 20.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 28.61,
    y1: 20.01,
    x2: 24.61,
    y2: 20.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 26.52,
    y1: 19.27,
    x2: 26.68,
    y2: 20.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 42.32,
    y1: 20.53,
    x2: 34.92,
    y2: 21.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 42.32,
    y1: 20.5,
    x2: 35.01,
    y2: 21.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 38.53,
    y1: 19.87,
    x2: 38.75,
    y2: 21.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 34.11,
    y1: 22.02,
    x2: 28.48,
    y2: 22.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 34.1,
    y1: 21.99,
    x2: 28.58,
    y2: 22.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 31.23,
    y1: 21.28,
    x2: 31.42,
    y2: 23.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 43.71,
    y1: 28.76,
    x2: 36.3,
    y2: 30.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 43.7,
    y1: 28.73,
    x2: 36.4,
    y2: 29.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 39.91,
    y1: 28.1,
    x2: 40.14,
    y2: 30.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 35.5,
    y1: 30.28,
    x2: 31.39,
    y2: 30.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 35.49,
    y1: 30.25,
    x2: 31.49,
    y2: 30.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 33.37,
    y1: 29.49,
    x2: 33.57,
    y2: 31.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 30.5,
    y1: 31.18,
    x2: 26.4,
    y2: 31.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 30.5,
    y1: 31.16,
    x2: 26.49,
    y2: 31.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 28.37,
    y1: 30.39,
    x2: 28.58,
    y2: 32.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 44.21,
    y1: 31.45,
    x2: 36.8,
    y2: 32.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 44.2,
    y1: 31.42,
    x2: 36.9,
    y2: 32.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 40.4,
    y1: 30.8,
    x2: 40.65,
    y2: 32.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 36.01,
    y1: 33.07,
    x2: 30.39,
    y2: 34.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 36.01,
    y1: 33.03,
    x2: 30.48,
    y2: 33.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 33.11,
    y1: 32.32,
    x2: 33.34,
    y2: 34.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 42.74,
    y1: 23.26,
    x2: 37.11,
    y2: 24.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 42.74,
    y1: 23.23,
    x2: 37.21,
    y2: 24.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 39.85,
    y1: 22.51,
    x2: 40.06,
    y2: 24.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 57.37,
    y1: 19.05,
    x2: 82.88,
    y2: 19.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5C75CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5C75CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 57.38,
    y1: 18.95,
    x2: 82.84,
    y2: 19.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5F78CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5E77CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 57.4,
    y1: 18.85,
    x2: 82.81,
    y2: 19.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#617AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5F78CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 57.41,
    y1: 18.75,
    x2: 82.77,
    y2: 19.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#647DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#617AD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 57.42,
    y1: 18.64,
    x2: 82.73,
    y2: 19.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#667FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#637CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 57.44,
    y1: 18.54,
    x2: 82.69,
    y2: 19.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6981D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#657ED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 57.46,
    y1: 18.44,
    x2: 82.64,
    y2: 19.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B84D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6680D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 57.48,
    y1: 18.34,
    x2: 82.6,
    y2: 20.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6E86D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6881D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 57.51,
    y1: 18.17,
    x2: 82.55,
    y2: 20.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7089D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6A83D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 57.54,
    y1: 18,
    x2: 82.51,
    y2: 20.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#738BD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6C85D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 57.57,
    y1: 17.83,
    x2: 82.47,
    y2: 20.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#758DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D87D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 57.61,
    y1: 17.66,
    x2: 82.42,
    y2: 20.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7890DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6F89D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 57.65,
    y1: 17.49,
    x2: 82.38,
    y2: 20.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7A92DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#718ADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 57.69,
    y1: 17.32,
    x2: 82.33,
    y2: 20.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7D94DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#738CDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 57.73,
    y1: 17.15,
    x2: 82.29,
    y2: 20.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7F97DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#748EDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 57.78,
    y1: 16.98,
    x2: 82.24,
    y2: 20.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8299DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7690DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 57.83,
    y1: 16.81,
    x2: 82.19,
    y2: 20.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#849CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7892DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 57.88,
    y1: 16.64,
    x2: 82.14,
    y2: 20.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#879EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7A93DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 57.94,
    y1: 16.48,
    x2: 82.1,
    y2: 20.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#89A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7B95E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 58,
    y1: 16.31,
    x2: 82.05,
    y2: 20.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8CA3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7D97E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 58.06,
    y1: 16.15,
    x2: 82,
    y2: 20.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8EA5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7F99E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 58.12,
    y1: 15.99,
    x2: 81.95,
    y2: 20.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#91A8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#819BE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 58.19,
    y1: 15.82,
    x2: 81.9,
    y2: 20.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#93AAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#829DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 58.26,
    y1: 15.66,
    x2: 81.85,
    y2: 20.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#96ACE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#849EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 58.33,
    y1: 15.5,
    x2: 81.8,
    y2: 20.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#98AFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#86A0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 58.41,
    y1: 15.35,
    x2: 81.74,
    y2: 20.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9BB1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#88A2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 58.48,
    y1: 15.19,
    x2: 81.69,
    y2: 20.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9DB4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#89A4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 58.56,
    y1: 15.05,
    x2: 81.64,
    y2: 20.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A0B6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8BA6E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 58.63,
    y1: 14.96,
    x2: 81.57,
    y2: 20.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A2B8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA7EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 58.69,
    y1: 14.87,
    x2: 81.5,
    y2: 20.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A5BBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8FA9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 58.76,
    y1: 14.78,
    x2: 81.43,
    y2: 20.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A7BDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#90ABED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 58.83,
    y1: 14.7,
    x2: 81.35,
    y2: 20.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#AABFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#92ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 58.9,
    y1: 14.61,
    x2: 81.28,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ACC2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#94AFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 58.98,
    y1: 14.53,
    x2: 81.2,
    y2: 21.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#AFC4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#96B0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 59.05,
    y1: 14.44,
    x2: 81.13,
    y2: 21.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B1C7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#97B2F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 59.12,
    y1: 14.37,
    x2: 81.05,
    y2: 21.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B4C9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99B4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 59.2,
    y1: 14.28,
    x2: 80.97,
    y2: 21.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B6CBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9BB6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 59.28,
    y1: 14.21,
    x2: 80.89,
    y2: 21.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B9CEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9DB8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 59.36,
    y1: 14.13,
    x2: 80.81,
    y2: 21.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#BBD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9EB9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 59.43,
    y1: 14.06,
    x2: 80.73,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#BED3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A0BBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 59.51,
    y1: 13.99,
    x2: 80.65,
    y2: 21.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C0D5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A2BDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 56.76,
    y1: 15.43,
    x2: 81.11,
    y2: 15.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5D73C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C73C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 56.78,
    y1: 15.35,
    x2: 81.08,
    y2: 15.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F75C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E74C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 56.79,
    y1: 15.27,
    x2: 81.06,
    y2: 15.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6177C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F76C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 56.81,
    y1: 15.18,
    x2: 81.04,
    y2: 15.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#637AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6077C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 56.82,
    y1: 15.1,
    x2: 81.01,
    y2: 15.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#657CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6279C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 56.84,
    y1: 15.02,
    x2: 80.99,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#677ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#637AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 56.85,
    y1: 14.93,
    x2: 80.97,
    y2: 15.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A80CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#647CC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 56.87,
    y1: 14.85,
    x2: 80.94,
    y2: 15.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6C82CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667DCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 56.89,
    y1: 14.77,
    x2: 80.92,
    y2: 15.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6E84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#677FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 56.91,
    y1: 14.68,
    x2: 80.89,
    y2: 15.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7086CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6880CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 56.92,
    y1: 14.6,
    x2: 80.87,
    y2: 15.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7289D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6982CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 56.94,
    y1: 14.52,
    x2: 80.85,
    y2: 15.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#748BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B83CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 56.96,
    y1: 14.43,
    x2: 80.82,
    y2: 15.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#768DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C85D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 56.99,
    y1: 14.35,
    x2: 80.8,
    y2: 15.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#788FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D86D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 57.01,
    y1: 14.27,
    x2: 80.77,
    y2: 15.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7A91D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F88D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 57.03,
    y1: 14.19,
    x2: 80.75,
    y2: 15.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7C93D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7089D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 57.05,
    y1: 14.1,
    x2: 80.72,
    y2: 15.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7E95D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#718BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 57.08,
    y1: 14.03,
    x2: 80.7,
    y2: 15.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8098DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738CD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 57.1,
    y1: 13.94,
    x2: 80.67,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#829ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748ED8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 57.12,
    y1: 13.86,
    x2: 80.64,
    y2: 15.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#849CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 57.15,
    y1: 13.78,
    x2: 80.62,
    y2: 15.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#879EDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7791DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 57.17,
    y1: 13.73,
    x2: 80.59,
    y2: 15.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#89A0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7892DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 57.2,
    y1: 13.69,
    x2: 80.56,
    y2: 15.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8BA2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7994DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 57.22,
    y1: 13.64,
    x2: 80.53,
    y2: 15.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8DA5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B95DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 57.25,
    y1: 13.59,
    x2: 80.5,
    y2: 15.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8FA7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C97DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 57.27,
    y1: 13.54,
    x2: 80.47,
    y2: 15.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#91A9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D98E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 57.3,
    y1: 13.5,
    x2: 80.44,
    y2: 16.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#93ABE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F9AE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 57.32,
    y1: 13.45,
    x2: 80.41,
    y2: 16.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#95ADE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809BE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 57.35,
    y1: 13.4,
    x2: 80.38,
    y2: 16.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#97AFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#819DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 57.37,
    y1: 13.36,
    x2: 80.35,
    y2: 16.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#99B1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#839EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 57.4,
    y1: 13.31,
    x2: 80.31,
    y2: 16.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9BB4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84A0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 57.43,
    y1: 13.26,
    x2: 80.28,
    y2: 16.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9DB6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85A1E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 57.45,
    y1: 13.22,
    x2: 80.25,
    y2: 16.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9FB8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86A3E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 57.48,
    y1: 13.17,
    x2: 80.22,
    y2: 16.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A1BAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 57.51,
    y1: 13.13,
    x2: 80.18,
    y2: 16.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A4BCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 57.54,
    y1: 13.08,
    x2: 80.15,
    y2: 16.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A6BEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA7EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 57.57,
    y1: 13.04,
    x2: 80.11,
    y2: 16.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A8C0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 57.6,
    y1: 12.99,
    x2: 80.08,
    y2: 16.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AAC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DAAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 57.63,
    y1: 12.95,
    x2: 80.05,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ACC5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EACF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 57.66,
    y1: 12.9,
    x2: 80.01,
    y2: 16.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AEC7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90ADF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 57.69,
    y1: 12.86,
    x2: 79.97,
    y2: 16.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B0C9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91AFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 55.85,
    y1: 11.84,
    x2: 78.14,
    y2: 11.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A6CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 55.85,
    y1: 11.84,
    x2: 78.13,
    y2: 11.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A6CC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 55.85,
    y1: 11.84,
    x2: 78.13,
    y2: 11.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D70C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6EC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 55.85,
    y1: 11.84,
    x2: 78.12,
    y2: 11.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E72C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6FC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 55.85,
    y1: 11.83,
    x2: 78.11,
    y2: 11.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6074C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D70C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 55.85,
    y1: 11.83,
    x2: 78.11,
    y2: 11.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6276C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E71C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 55.85,
    y1: 11.83,
    x2: 78.1,
    y2: 11.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6378C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E72C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 55.85,
    y1: 11.83,
    x2: 78.1,
    y2: 11.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#657ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F74C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 55.85,
    y1: 11.83,
    x2: 78.09,
    y2: 11.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6075C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 55.85,
    y1: 11.82,
    x2: 78.08,
    y2: 11.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#687ECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6176C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 55.85,
    y1: 11.82,
    x2: 78.08,
    y2: 11.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6277CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 55.84,
    y1: 11.82,
    x2: 78.07,
    y2: 11.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B81D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6378CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 55.84,
    y1: 11.82,
    x2: 78.07,
    y2: 11.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D83D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#647ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 55.84,
    y1: 11.82,
    x2: 78.06,
    y2: 11.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F85D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657BCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 55.84,
    y1: 11.82,
    x2: 78.05,
    y2: 11.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7087D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667CCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 55.84,
    y1: 11.81,
    x2: 78.05,
    y2: 11.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7289D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#677DCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 55.84,
    y1: 11.81,
    x2: 78.04,
    y2: 11.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 55.84,
    y1: 11.81,
    x2: 78.03,
    y2: 11.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 55.84,
    y1: 11.81,
    x2: 78.03,
    y2: 11.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A81D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 55.84,
    y1: 11.8,
    x2: 78.02,
    y2: 11.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7891DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B82D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 55.84,
    y1: 11.8,
    x2: 78.02,
    y2: 11.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A93DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B83D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 55.84,
    y1: 11.8,
    x2: 78.01,
    y2: 11.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B95DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C84D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 55.84,
    y1: 11.8,
    x2: 78,
    y2: 11.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D97E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D85D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 55.84,
    y1: 11.8,
    x2: 78,
    y2: 11.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F99E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E87D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 55.83,
    y1: 11.79,
    x2: 77.99,
    y2: 11.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#809BE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F88D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 55.83,
    y1: 11.79,
    x2: 77.99,
    y2: 11.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#829DE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7089DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 55.83,
    y1: 11.79,
    x2: 77.98,
    y2: 11.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#839FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#718ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 55.83,
    y1: 11.79,
    x2: 77.97,
    y2: 11.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85A1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#728BDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 55.83,
    y1: 11.79,
    x2: 77.97,
    y2: 11.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87A3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738DDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 55.83,
    y1: 11.78,
    x2: 77.96,
    y2: 11.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748EDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 55.83,
    y1: 11.78,
    x2: 77.96,
    y2: 11.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AA6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 55.83,
    y1: 11.78,
    x2: 77.95,
    y2: 11.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7690E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 55.83,
    y1: 11.78,
    x2: 77.94,
    y2: 11.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7791E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 55.83,
    y1: 11.78,
    x2: 77.94,
    y2: 11.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FACEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7893E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 55.83,
    y1: 11.77,
    x2: 77.93,
    y2: 11.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90AEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7894E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 55.83,
    y1: 11.77,
    x2: 77.92,
    y2: 11.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92B0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7995E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 55.83,
    y1: 11.77,
    x2: 77.92,
    y2: 11.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A96E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 55.82,
    y1: 11.77,
    x2: 77.91,
    y2: 11.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B97E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 55.82,
    y1: 11.77,
    x2: 77.91,
    y2: 11.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C99E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 55.82,
    y1: 11.77,
    x2: 77.9,
    y2: 11.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9AE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 55.82,
    y1: 11.76,
    x2: 77.9,
    y2: 11.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E9BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 54.67,
    y1: 2.11,
    x2: 75.68,
    y2: 14.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#848FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#717FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D79D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 56.38,
    y1: 13.44,
    x2: 65.35,
    y2: 15.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 69.38,
    y1: 12.64,
    x2: 73.13,
    y2: 11.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EA9AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA99C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptsNotFound);
export default __webpack_public_path__ + "static/media/receipts-not-found.8c3c7ef499be1d78ff6f633b3395af6c.svg";
export { ForwardRef as ReactComponent };